import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  de: {
    translation: {
      dashboard: {
        title: "Übersicht",
        previewNotice: "Vorschau",
        subtitle: "Heutiger Hotelstatus",
        arrivalsToday: "Heutige Anreisen",
        departuresToday: "Heutige Abreisen",
        upcomingArrivals: "Kommende Anreisen",
        upcomingDepartures: "Kommende Abreisen",
        allLocations: "Alle Standorte",
        showingUpcomingNotice: "Keine Anreisen heute — Nächste Anreisen:",
        showingUpcomingDepNotice: "Keine Abreisen heute — Nächste Abreisen:",
        quickActions: "Aktuelle & kommende Reservierungen",
        viewAllReservations: "Alle Reservierungen",
        noArrivalsToday: "Keine Anreisen heute",
        noDeparturesToday: "Keine Abreisen heute",
        unassigned: "Nicht zugewiesen (UA)",
        customizeButton: "Dashboard anpassen",
        customizeTitle: "Widgets & Module anpassen",
        customizeSubtitle: "Wähle aus, welche Widgets auf deinem persönlichen Dashboard angezeigt werden.",
        customizing: "Bearbeitungsmodus",
        dragToReorder: "Ziehen zum Neuanordnen",
        dragToResize: "Ziehen zum Vergrößern / Verkleinern",
        toggleSize: "Größe ändern",
        sizeSmall: "Kompakt / 1 Spalte",
        rowsLabel: "{{count}} Zeile(n)",
        sizeMedium: "Mittel / 2 Spalten",
        sizeLarge: "Groß / volle Breite",
        moveUp: "Nach oben",
        moveDown: "Nach unten",
        removeWidget: "Widget entfernen",
        enableWidget: "Aktivieren",
        disableWidget: "Deaktivieren",
        resetDefaults: "Auf Standard zurücksetzen",
        addWidgets: "Widgets hinzufügen",
        saveLayout: "Fertig",
        greetings: {
          morning: "Guten Morgen",
          day: "Guten Tag",
          evening: "Guten Abend",
        },
        kpis: {
          employeeFocus: "Mein Arbeitsbereich",
          hotelOverview: "Hotel-Übersicht",
          personalSubtitle: "Persönliche Aufgaben und Schichtübersicht für {{name}}",
          hotelSubtitle: "Live-Status aller Zimmer und Gäste",
          myTraces: "Meine offenen Traces",
          overdue: "überfällig",
          followUps: "Anschlussbuchungen",
          deptTasks: "Abteilungs-Aufgaben",
          hoursWorkedToday: "Heute gearbeitet",
          overtime: "Überstunden",
          overtimeBalance: "Zeitkonto",
          upcomingEvents: "Kommende Termine",
          nextEvent: "Nächster Termin",
          holiday: "Feiertag",
          vacationUpcoming: "Urlaub",
          daysCount: "in {{days}} T.",
          todayBadge: "Heute",
          tomorrowBadge: "Morgen",
          noEvents: "Keine Termine",
          handoversToConfirm: "Offene Übergaben",
        },
        widgets: {
          jumpToReservation: {
            title: "Zur Reservierung springen",
            desc: "Reservation direkt per ID öffnen.",
          },
          openTickets: {
            title: "Laufende Tickets",
            desc: "Offene Support-Tickets aller Mandanten.",
            allClear: "Keine laufenden Tickets – alles im grünen Bereich.",
            noSubject: "Ohne Betreff",
            moreCount: "{{count}} weitere Tickets",
          },
          timeTracking: {
            title: "Stempeluhr & Zeiterfassung",
            desc: "Erfasse deine Arbeitszeit und verwalte Schichten.",
            clockIn: "Einstempeln",
            clockOut: "Ausstempeln",
            noLogsToday: "Heute noch keine Stempelzeiten",
            todayWorked: "Heute gearbeitet",
            statusIn: "Eingestempelt",
            statusBreak: "In der Pause",
            statusOut: "Ausgestempelt",
            pause: "Pause",
            target: "Soll",
            perDay: "pro Tag",
            vacation: "Resturlaub",
            days: "Tage",
            clockLog: "Stempelzeiten heute",
            viewFullLog: "Zum Stempelprotokoll",
          },
          traces: {
            title: "Meine Traces",
            desc: "Persönliche und abteilungsbezogene Traces im Überblick.",
            myTab: "Meine Traces",
            deptTab: "Abteilung",
            allDone: "Alles erledigt",
            noTasks: "Keine offenen Traces",
            openCount: "offen",
            viewAll: "Alle Traces ansehen",
          },
          myTraces: {
            title: "Meine Traces",
            desc: "Traces, die dir persönlich zugewiesen sind.",
            noTasks: "Keine offenen Traces",
            allDone: "Alles erledigt! Du hast aktuell keine offenen persönlichen Traces.",
            createTask: "Neuer Trace",
            markDone: "Als erledigt markieren",
            openCount: "offen",
            viewAll: "Alle Traces ansehen",
          },
          deptTraces: {
            title: "Abteilungs-Traces",
            desc: "Offene Traces in deinem Arbeitsbereich.",
            noTasks: "Keine Abteilungs-Traces",
            departmentClean: "Keine offenen Traces für {{dept}} vorhanden.",
            assignedTo: "Zugewiesen an",
            openCount: "offene Traces",
            viewDeptTraces: "Abteilungstraces ansehen",
          },
          teamOnDuty: {
            title: "Team im Dienst",
            desc: "Kolleginnen und Kollegen, die aktuell eingestempelt sind.",
            noActive: "Niemand eingestempelt",
            noActiveSubtitle: "Aktuell sind keine weiteren Teammitglieder eingestempelt.",
            onDuty: "Im Dienst",
            clockedIn: "Kollegen aktiv",
            viewHr: "Personalplan",
          },
          handover: {
            title: "Schichtübergabe",
            desc: "Wichtige Notizen und Übergaben aus den vorherigen Schichten.",
            pendingAcknowledgment: "{{count}} Schichtübergabe(n) zur Bestätigung",
            noHandovers: "Keine neuen Übergaben",
            allTransferred: "Alle Schichtnotizen sind auf dem aktuellen Stand.",
            viewHandovers: "Zur Schichtübergabe",
          },
          arrivals: {
            title: "Heutige Anreisen",
            desc: "Kompakte Liste der heute erwarteten Gäste und Check-ins.",
          },
          departures: {
            title: "Heutige Abreisen",
            desc: "Kompakte Liste der heutigen Abreisen und Check-outs.",
          },
          occupancyKpi: {
            title: "Meine Übersicht",
            desc: "Persönliche Aufgaben, Arbeitszeit und anstehende Termine.",
          },
          housekeeping: {
            title: "Housekeeping & Zimmerstatus",
            desc: "Zimmerreinigungsstatus, Prioritätszimmer und Bleiber.",
            summary: "Insgesamt {{total}} Zimmer im Reinigungsplan erfasst.",
            roomsTotal: "Zimmer",
            viewHk: "Zum Housekeeping",
          },
          maintenance: {
            title: "Haustechnik & Reparaturen",
            desc: "Offene Reparaturtickets und Mängelmeldungen.",
            noRepairs: "Keine offenen Reparaturen",
            facilityOk: "Alle gemeldeten Mängel wurden behoben.",
            openTickets: "offene Mängel",
            viewHt: "Zur Haustechnik",
          },
          cashRegister: {
            title: "Kassenbuch & Barbestand",
            desc: "Aktueller Kassenstand und Schichtkassenprüfung.",
            currentBalance: "Aktueller Kassenbestand",
            statusOk: "Kassenabgleich aktiv",
            viewKassenbuch: "Zum Kassenbuch",
          },
          quickActions: {
            title: "Schnellaktionen",
            desc: "Direkter Schnellzugriff auf wichtige Buchungs- und Arbeitsfunktionen.",
          },
        },
        actions: {
          newBooking: "Neue Buchung",
          newTrace: "Neuer Trace",
          chat: "Chat",
          newAbsence: "Abwesenheitsantrag",
          fundsachen: "Fundsachen",
          wartungsfenster: "Wartungsfenster",
          handover: "Schichtübergabe",
        },
      },
      roles: {
        admin: "Administrator",
        management: "Management",
        sales: "Sales",
        reception: "Rezeption",
        rads: "Interne Ressourcen",
        housekeeping: "Housekeeping",
        haustechnik: "Haustechnik",
        ht_leitung: "Leitung Haustechnik",
        hausdame: "Hausdame",
        accountant: "Buchhaltung",
        staff: "Mitarbeiter",
      },
      departments: {
        reception: "Rezeption",
        rezeption: "Rezeption",
        housekeeping: "Housekeeping",
        haustechnik: "Haustechnik",
        sales: "Sales",
        accounting: "Buchhaltung",
        buchhaltung: "Buchhaltung",
        management: "Management",
        mg: "Management",
        fo: "Front Office",
        hk: "Housekeeping",
        ht: "Haustechnik",
        bh: "Buchhaltung",
        sl: "Sales",
        dx: "Direktion",
        direktion: "Direktion",
        ir: "Interne Ressourcen",
        general: "Allgemein",
      },
      holidays: {
        newYear: "Neujahr",
        epiphany: "Heilige Drei Könige",
        womensDay: "Internationaler Frauentag",
        goodFriday: "Karfreitag",
        easterMonday: "Ostermontag",
        laborDay: "Tag der Arbeit",
        ascension: "Christi Himmelfahrt",
        whitMonday: "Pfingstmontag",
        corpusChristi: "Fronleichnam",
        assumption: "Mariä Himmelfahrt",
        childrensDay: "Weltkindertag",
        germanUnity: "Tag der Deutschen Einheit",
        reformationDay: "Reformationstag",
        allSaints: "Allerheiligen",
        repentanceDay: "Buß- und Bettag",
        christmas1: "1. Weihnachtstag",
        christmas2: "2. Weihnachtstag",
      },
      htBereich: {
        allgemein: "Allgemein",
        elektrik: "Elektrik",
        sanitaer: "Sanitär",
        moebel: "Möbel",
        "heizung/klima": "Heizung/Klima",
        aussenbereich: "Außenbereich",
      },
      tabs: {
        dashboard: "Dashboard (Prototyp)",
        internalresources: "Interne Ressourcen",
        reservations: "Reservierungen (Tabelle)",
        analytics: "Reporting",
        traces: "Traces",
        hk: "Housekeeping & Bleiber",
        ht: "Haustechnik",
        fundsachen: "Fundsachen",
        hr: "Personalwesen",
        sales: "Sales & Revenue",
        logs: "System Logs",
        users: "Benutzerverwaltung",
        kassenbuch: "Kassenbuch",
        xrechnung: "XRechnung",
        anleitungen: "Anleitungen",
        inventory: "Inventarverwaltung",
        offers: "Angebote",
        admin: "Admin-Bereich",
        iframe: "Partner-App",
        automations: "Automatisierungen",
        workflows: "Workflows",
        buchhaltung: "Buchhaltung",
        groups: "Gruppen",
        roomrack: "Zimmerplan",
        availability: "Verfügbarkeiten",
        explorer: "Explorer",
        handover: "Schichtübergabe",
        customOrder: "Eigene Anordnung",
        reset: "Zurücksetzen",
        resetOrderTooltip: "Standardreihenfolge wiederherstellen",
        savingGroup: "Gruppe wird gespeichert…",
        groupSaveError:
          "Gruppe konnte nicht gespeichert werden. Bitte erneut versuchen.",
      },
      availability: {
        title: "Verfügbarkeiten",
        subtitle: "Auslastung und freie Zimmer pro Kategorie — alle Properties, ein Blick.",
        filter: {
          allProperties: "Alle Properties",
        },
        nav: {
          back7: "7 Tage zurück",
          today: "Heute",
          forward7: "7 Tage vor",
          windowDays: "{{days}} Tage",
          from: "Von",
        },
        metric: {
          available: "Verfügbar",
          occupancy: "Auslastung",
          sold: "Verkauft",
          sellable: "Verkaufbar",
        },
        density: {
          compact: "Kompakt",
          normal: "Normal",
          wide: "Breit",
        },
        legend: {
          plenty: "viel frei",
          few: "wenige frei",
          soldOut: "ausverkauft",
          overbookable: "ausverkauft, Überbuchung erlaubt",
        },
        grid: {
          roomTypes: "Zimmerkategorien",
          propertyTotal: "Gesamt (Hotel)",
          noRoomTypes: "Keine Zimmerkategorien im Zeitraum.",
        },
        weekdays: {
          mon: "Mo",
          tue: "Di",
          wed: "Mi",
          thu: "Do",
          fri: "Fr",
          sat: "Sa",
          sun: "So",
        },
        metrics: {
          houseCount: "House Count (Zimmer gesamt)",
          sold: "Verkauft",
          outOfOrder: "Außer Betrieb (OOO)",
          outOfInventory: "Außer Inventar",
          blocksDefinite: "Definit geblockt",
          blocksTentative: "Vorläufig geblockt",
          occupancy: "Auslastung",
          sellable: "Verkaufbar",
          allowedOverbooking: "Erlaubte Überbuchung",
        },
        empty: "Keine Properties verfügbar.",
        retry: "Fehler – erneut versuchen",
        error: "Verfügbarkeiten konnten nicht geladen werden.",
        windowLabel: "{{from}} – {{to}}",
        updating: "Zeitraum wird geladen…",
        cellTooltip: "{{name}} · {{date}}: {{free}} frei / {{total}} gesamt",
        loading: "Wird geladen…",
        refresh: "Aktualisieren",
      },
      handover: {
        items: "Punkte",
        noNotes: "Keine Notizen",
        view: {
          title: "Schichtübergabe",
          subtitle: "Strukturierte Übergabe zwischen den Rezeptionsschichten",
          new: "Neue Übergabe",
          waitingForMe: "{{count}} Übergabe wartet auf mich",
          myDraft: "Mein Entwurf",
          submitNow: "Jetzt übergeben",
          mineToComplete: "Von mir zu übernehmen",
          completeMine: "Als übernommen markieren",
          history: "Verlauf",
          empty: "Noch keine Übergaben vorhanden.",
        },
        filter: {
          allLocations: "Alle Standorte",
        },
        shift: {
          frueh: "Frühschicht",
          spaet: "Spätschicht",
          nacht: "Nachtschicht",
          andere: "Andere",
        },
        status: {
          draft: "Entwurf",
          submitted: "Übergeben",
          acknowledged: "Übernommen",
        },
        itemTypes: {
          info: "Info",
          task: "Aufgabe",
          incident: "Vorfall",
        },
        composer: {
          title: "Neue Schichtübergabe",
          date: "Datum",
          shift: "Schicht",
          location: "Standort",
          incoming: "Nachfolger:in",
          incomingOptional: "Optional auswählen",
          notes: "Allgemeine Notizen",
          notesPlaceholder: "Wichtige Punkte der Schicht…",
          items: "Punkte",
          itemContent: "Was ist zu übergeben?",
          roomRef: "Zimmer",
          addItem: "Punkt hinzufügen",
          removeItem: "Punkt entfernen",
          saveDraft: "Als Entwurf speichern",
          submit: "Übergeben",
        },
        detail: {
          title: "Übergabe",
          items: "{{count}} Punkte",
          toggleDone: "Erledigt umschalten",
          room: "Zimmer {{room}}",
          noItems: "Keine Punkte erfasst.",
          acknowledgedAt: "Übernommen am {{time}}",
          acknowledge: "Übergabe übernehmen",
          completeMine: "Als übernommen markieren",
        },
        banner: {
          title: "Schichtübergabe wartet",
          subtitle: "{{date}} · {{shift}} – bitte übernehmen",
        },
        toasts: {
          created: "Übergabe als Entwurf gespeichert.",
          submitted: "Übergabe übergeben.",
          acknowledged: "Übergabe übernommen.",
          deleted: "Entwurf gelöscht.",
        },
      },
      explorer: {
        title: "Explorer",
        subtitle: "Globale Suche über Gäste, Traces, Angebote und mehr",
        placeholder: "Suchen – Name, ID oder Begriff…",
        searchHint: "Mindestens 2 Zeichen eingeben, um zu suchen",
        searching: "Suche läuft…",
        filterAll: "Alle",
        clear: "Löschen",
        loadMore: "Mehr anzeigen",
        showLess: "Weniger anzeigen",
        noResults: "Keine Ergebnisse",
        noResultsHint: "Suchbegriff anpassen oder anders schreiben",
        noMoreResults: "Keine weiteren Ergebnisse",
        error: "Suche fehlgeschlagen. Bitte erneut versuchen.",
        retry: "Erneut versuchen",
        resultsCount: "{{count}} Ergebnisse",
        semanticTitle: "Ähnliche Treffer",
        type: {
          guest: "Gäste",
          trace: "Traces",
          offer: "Angebote",
          fundsache: "Fundsachen",
          support_ticket: "Support-Tickets",
          user: "Benutzer",
          inventory_item: "Inventar",
          kassenbuch_entry: "Kassenbuch",
          buchhaltung_doc: "Belege",
          waiting_list: "Warteliste",
          group: "Gruppen",
          loyalty_transaction: "Loyalty",
          anleitung: "Anleitungen",
          hr_request: "HR-Anträge",
          ht_list: "HT-Listen",
          ht_list_item: "HT-Listenpunkte",
          ht_device: "HT-Geräte",
          ht_room_check: "Zimmerchecks",
          housekeeping_room: "Zimmer (HK)",
          maintenance_window: "Wartungsfenster",
          company_contract: "Firmenverträge",
          firmenrate: "Firmenraten",
          global_task: "Aufgaben",
          reservation: "Reservierungen",
        },
      },
      inventory: {

        title: "Inventarverwaltung",
        subtitle: "Lagerbestand • Mindestbestände • Monatsabschlüsse",
        importExcelCsv: "IMPORT (EXCEL/CSV)",
        exportCsv: "CSV EXPORT",
        rollover: "Monatsabschluss",
        rolloverTooltip: "Sichert den jetzigen Bestand als Vormonatsbestand und setzt Zähler zurück",
        kpiTotalArticles: "Artikel Gesamt",
        kpiOutOfStock: "Nicht auf Lager",
        kpiLowStock: "Bestellbedarf",
        kpiTotalOrders: "Gesamt-Bestellmenge",
        tabCurrentStock: "Aktueller Bestand",
        tabHistory: "Abschlusshistorie",
        searchItemNumSupplier: "Artikel, Nummer oder Lieferant suchen...",
        statusAll: "Status: Alle",
        statusOk: "Status: OK",
        statusLowStock: "Status: Bestellbedarf",
        statusOutOfStock: "Status: Leer",
        supplierAll: "Lieferant: Alle",
        loadingItems: "Lade Artikel...",
        emptyTitle: "Keine Artikel gefunden",
        emptyDesc: "Passen Sie Ihre Suche/Filter an oder fügen Sie über den Button oben rechts neue Artikel hinzu.",
        thArticle: "Artikel",
        thCategory: "Kategorie",
        thStorageLocation: "Lagerort",
        thArticleNum: "Artikelnummer",
        thSupplier: "Lieferant",
        thPrevMonthStock: "Bestand Vormonat",
        thCurrentStock: "Jetziger Bestand",
        thStockChange: "Änderung Bestand",
        thMinStock: "Mindestbestand",
        thStatus: "Status",
        thOrderQty: "Bestellmenge",
        thLastOrder: "Letzte Bestellung",
        thLink: "Link",
        thActions: "Aktionen",
        btnSubtract: "Abziehen",
        btnAdd: "Hinzufügen",
        btnSet: "Setzen",
        btnSetOrderDate: "Bestelldatum setzen",
        tooltipEnterStock: "Bestandszahl eingeben",
        tooltipSetStock: "Bestand übernehmen",
        tooltipOpenLink: "Artikel-Link öffnen",
        historyEmptyTitle: "Bisher keine Abschlüsse vorhanden",
        historyEmptyDesc: "Sobald Sie am Ende eines Monats einen Monatsabschluss durchführen, werden die historischen Daten hier archiviert.",
        historyThMonth: "Abschluss-Monat",
        historyThBy: "Durchgeführt von",
        historyThOn: "Durchgeführt am",
        historyThItems: "Gelistete Artikel",
        historyBtnDetails: "Details anzeigen",
        toastInvalidValue: "Ungültiger Wert. Bitte eine ganze Zahl eingeben.",
        toastStockSet: "{{name}}: Bestand auf {{stock}} gesetzt",
        toastStockSetError: "Fehler beim Setzen des Bestands: {{message}}",
        toastItemAdded: "Artikel erfolgreich hinzugefügt.",
        toastItemAddError: "Fehler beim Hinzufügen: {{message}}",
        toastItemUpdated: "Artikel erfolgreich aktualisiert.",
        toastItemUpdateError: "Fehler beim Bearbeiten: {{message}}",
        toastItemDeleted: "Artikel erfolgreich gelöscht.",
        toastItemDeleteError: "Fehler beim Löschen: {{message}}",
        toastNoItemsRollover: "Keine Artikel für diesen Standort vorhanden, um einen Abschluss durchzuführen.",
        toastRolloverSuccess: "Monatsabschluss ({{month}}) für {{property}} erfolgreich abgeschlossen.",
        toastRolloverError: "Fehler beim Monatsabschluss: {{message}}",
        toastCsvExported: "Inventarliste als CSV exportiert.",
        csvHeaderChange: "Aenderung Bestand",
        csvStatusOut: "Nicht auf Lager",
        csvStatusLow: "Bestellbedarf",
        csvStatusOk: "OK",
        modalAddTitle: "Artikel hinzufügen",
        modalAddDesc: "Erstellen Sie einen neuen Eintrag im Inventar",
        modalEditTitle: "Artikel bearbeiten",
        modalEditDesc: "Ändern Sie die Eigenschaften dieses Inventargegenstands",
        modalDeleteTitle: "Artikel löschen?",
        modalDeleteDesc: "Möchten Sie den Artikel <strong>{{name}}</strong> wirklich unwiderruflich aus dem System löschen? Dies kann nicht rückgängig gemacht werden.",
        modalRolloverTitle: "Monatsabschluss durchführen",
        modalRolloverDesc1: "Der Monatsabschluss sichert den aktuellen Zustand aller Artikel. Folgende Aktionen werden ausgeführt:",
        modalRolloverDesc2: "Ein vollständiger Snapshot des aktuellen Inventars wird im Archiv gesichert.",
        modalRolloverDesc3: "Der Wert in <strong>Bestand Vormonat</strong> wird auf den aktuellen Wert von <strong>Jetziger Bestand</strong> gesetzt.",
        modalRolloverDesc4: "Die Bestandsänderung wird für den neuen Monat auf Null zurückgesetzt.",
        modalRolloverDesc5: "Sind Sie sicher, dass Sie den Monatsabschluss jetzt durchführen möchten?",
        btnCancel: "Abbrechen",
        btnSave: "Speichern",
        btnDelete: "Löschen",
        btnBookRollover: "Abschluss buchen",
        lblArticleName: "* Artikelname",
        lblArticleNamePh: "z.B. Microfasertücher Blau",
        lblArticleNum: "Artikelnummer",
        lblArticleNumPh: "Art-0092",
        lblSupplier: "Lieferant",
        lblSupplierPh: "Ecolab Deutschland",
        lblStorageLocation: "Lagerort(e)",
        lblStorageLocationPh: "z.B. Regal A2, Keller, Bar...",
        locationSingle: "Ort",
        locationPlural: "Orte",
        addAnotherLocation: "+ Weiteren Lagerort auswählen oder eintippen...",
        createLocation: "Lagerort neu erstellen:",
        renameLocation: "Lagerort umbenennen",
        deleteLocation: "Lagerort löschen",
        noLocationsYet: "Noch keine Lagerorte vorhanden. Tippen Sie einen Namen ein, um einen neuen Lagerort zu erstellen.",
        lblLink: "Artikel-Link (Optional)",
        lblLinkPh: "https://shop.example.com/item",
        lblLocation: "* Standort",
        lblPrevMonth: "Vormonat",
        lblCurrent: "Jetziger Best.",
        lblMin: "Mindestbest.",
        lblOrderQty: "Bestellmenge",
        lblOrderQtyActive: "Vorschlag aktiv",
        lblOrderQtyPh: "Empfohlen: min - jetzig",
        lblResetSuggest: "Zurücksetzen auf Auto-Vorschlag",
        unknown: "Unbekannt",
        allCategoriesShort: "Alle",
        newCategoryShort: "Neu",
        cat_Apartments: "Apartments",
        cat_Büromaterial: "Büromaterial",
        cat_Getränke: "Getränke",
        cat_Kaffee: "Kaffee",
        cat_Kaufland: "Kaufland",
        cat_Metro: "Metro",
        cat_Snacks: "Snacks",
        lastOrderDate: "Letztes Bestelldatum",
        addItem: "Artikel hinzufügen",
        editItem: "Artikel bearbeiten",
        deleteItem: "Artikel löschen",
        importItems: "Artikel importieren",
        itemName: "Artikelname",
        category: "Kategorie",
        quantity: "Menge",
        unit: "Einheit",
        minStock: "Mindestbestand",
        maxStock: "Maximalbestand",
        currentStock: "Aktueller Bestand",
        supplier: "Lieferant",
        lastOrder: "Letzte Bestellung",
        nextOrder: "Nächste Bestellung",
        price: "Preis",
        notes: "Notizen",
        allCategories: "Alle Kategorien",
        allSuppliers: "Alle Lieferanten",
        searchPlaceholder: "Artikel suchen...",
        confirmDelete: "Artikel wirklich löschen?",
        deleteSuccess: "Artikel erfolgreich gelöscht",
        saveSuccess: "Artikel erfolgreich gespeichert",
        loadError: "Fehler beim Laden der Artikel",
        saveError: "Fehler beim Speichern: {{message}}",
        noItems: "Keine Artikel gefunden",
        importWizard: "Import-Assistent",
        stockLow: "Niedriger Bestand",
        stockOk: "Bestand OK",
        stockOver: "Überbestand",
        orderDate: "Bestelldatum",
        setOrderDate: "Bestelldatum festlegen",
        setOrderDateBulk: "Sammelbestellung",
        selectItems: "Artikel auswählen",
        exportExcel: "Als Excel exportieren",
        importSuccess: "Import erfolgreich",
        importError: "Fehler beim Import: {{message}}",
        article: "Artikel",
        articleNumber: "Artikelnummer",
        prevMonthStock: "Bestand Vormonat",
        categoryPlaceholder: "z.B. Reinigung, Wäsche…",
        categoryCreated: "Kategorie \"{{name}}\" erstellt",
        itemsMovedToCategory: "{{count}} Artikel in \"{{name}}\" verschoben",
        categoryAssignError: "Fehler beim Zuweisen der Kategorie: {{message}}",
        categoryDeleted: "Kategorie \"{{name}}\" gelöscht",
        categoryDeleteError: "Fehler beim Löschen der Kategorie: {{message}}",
        confirmDeleteCategory: "Kategorie \"{{name}}\" löschen?\n\nAlle Zuordnungen werden entfernt. Die Kategorie-Tab verschwindet, wenn keine Artikel mehr zugeordnet sind.",
        deleteCategoryTitle: "Kategorie \"{{name}}\" löschen (entfernt Zuordnung)",
        addCategoryTitle: "Kategorie hinzufügen",
        categoryNamePlaceholder: "Kategorie-Name...",
        addCategory: "Hinzufügen",
      },
      filterBar: {
        today: "Heute",
        yesterday: "Gestern",
        thisWeek: "Diese Woche",
        lastWeek: "Letzte Woche",
        thisMonth: "Dieser Monat",
        lastMonth: "Letzter Monat",
        thisYear: "Dieses Jahr",
        lastYear: "Letztes Jahr",
        last7Days: "Letzte 7 Tage",
        last30Days: "Letzte 30 Tage",
        last90Days: "Letzte 90 Tage",
        custom: "Benutzerdefiniert",
        all: "Alle",
        from: "Von",
        to: "Bis",
        apply: "Anwenden",
        reset: "Zurücksetzen",
        preset: "Zeitraum",
      },
      hrAddUser: {
        title: "Mitarbeiter hinzufügen",
        manualTitle: "Mitarbeiter manuell hinzufügen",
        manualSubtitle: "Für manuelle Zeiterfassung ohne E-Mail-Login",
        holidayStateLabel: "Bundesland für Feiertage",
        addButton: "Hinzufügen",
        nameLabel: "Name (erforderlich)",
        namePlaceholder: "z. B. Maria Schmidt",
        emailLabel: "E-Mail-Adresse (optional)",
        emailPlaceholder: "Optional, leer lassen falls kein Login",
        proRataApplied: "Pro-Rata Berechnung angewendet:",
        daysCurrentYear: "{{count}} Tage (Laufendes Jahr)",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        role: "Rolle",
        department: "Abteilung",
        startDate: "Eintrittsdatum",
        exitDate: "Austrittsdatum",
        employmentPeriodTitle: "Beschäftigungszeitraum (pro-rata Urlaubsberechnung)",
        vacationAccountTitle: "Urlaubskonto",
        yearlyEntitlement: "Jahresanspruch",
        currentYearEntitlement: "Anspruch (laufendes Jahr)",
        remainingVacationPrevYear: "Resturlaub (Vorjahr)",
        employeeNumber: "Personalnummer",
        save: "Speichern",
        cancel: "Abbrechen",
        success: "Mitarbeiter erfolgreich hinzugefügt",
        error: "Fehler beim Hinzufügen: {{message}}",
        requiredFields: "Bitte füllen Sie alle Pflichtfelder aus",
        personType: "Personentyp",
        personTypeFull: "Mit Login",
        personTypeHr: "Nur HR-Person",
        hoursPerDay: "Stunden pro Tag",
        hoursPerWeek: "Stunden pro Woche",
        hoursPerWeekHint: "{{hours}} Std./Wo. verteilt auf {{days}} Arbeitstage ≈ {{perDay}} Std./Tag",
        weeklyHours: "Wochenstunden",
        workdaysSplitHint: "{{hours}} Std./Wo. verteilt auf {{days}} Arbeitstage ≈ {{perDay}} Std./Tag",
        workdays: "Arbeitstage",
        workdaysHint: "Primäre Arbeitstage wählen",
        noLoginWarning: "Diese Person hat keinen Login — alle Aktionen werden durch eine Führungskraft ausgeführt.",
      },
      attachmentUpload: {
        uploadFile: "Datei hochladen",
        chooseFile: "Datei auswählen",
        dragDrop: "Datei hier ablegen oder klicken",
        noFile: "Keine Datei ausgewählt",
        fileSelected: "Datei ausgewählt: {{name}}",
        removeFile: "Datei entfernen",
        uploadError: "Fehler beim Hochladen: {{message}}",
        fileTooLarge: "Datei zu groß (max. {{max}}MB)",
        invalidType: "Ungültiger Dateityp",
        uploading: "Wird hochgeladen...",
        uploadSuccess: "Upload erfolgreich",
        attachTitle: "Datei anhängen",
        fileTooLargeError: "\"{{name}}\" ist zu groß (max. {{max}} MB)",
        maxFilesError: "Maximal {{max}} Dateien erlaubt",
        selectFiles: "Dateien auswählen",
        selectFilesTitle: "Dateien zum Anhängen auswählen",
      },
      salesCrm: {
        tabTitle: "Pipeline",
        searchPlaceholder: "Firma, Branche, Standort suchen...",
        empty: "Keine Firmen gefunden",
        emptyLane: "Keine Unternehmen",
        view: { board: "Board", list: "Liste" },
        filter: {
          priorityAll: "Alle Prioritäten",
          priorityA: "Priorität A",
          priorityB: "Priorität B",
          priorityC: "Priorität C",
          phaseAll: "Alle Phasen",
          locationAll: "Alle Standorte",
        },
        priority: { a: "A - zuerst prüfen", b: "B - danach prüfen", c: "C - Longlist" },
        priorityBadge: "Prio {{priority}}",
        type: { prospect: "Zielfirma", bestand: "Bestandskunde" },
        phase: {
          none: "Nicht gestartet",
          "1": "Phase 1: Verstehen & vorbereiten",
          "2": "Phase 2: Neukunden gewinnen",
          "3": "Phase 3: Vertiefen & nachfassen",
          "4": "Phase 4: Buchungen verstetigen",
        },
        phaseBadge: "Phase {{phase}}",
        status: {
          neu: "Neu",
          kontaktiert: "Kontaktiert",
          bedarfsgespraech: "Bedarfsgespräch",
          angebot: "Angebot",
          wiedervorlage: "Wiedervorlage",
          rahmenvertrag_geprueft: "Rahmenvertrag geprüft",
          gewonnen: "Gewonnen",
          verloren: "Verloren",
        },
        appointments: {
          listTitle: "TERMINE",
          empty: "Keine Termine erfasst",
          emptySub: "Es wurden noch keine Termine oder Vor-Ort-Besuche protokolliert.",
          single: "Termin",
          plural: "Termine",
          subtitle: "Vor-Ort-Termine & Besuche",
        },
        contacts: {
          listTitle: "KONTAKTE",
          empty: "Keine Kontakte erfasst",
          emptySub: "Es wurden noch keine Anrufe, E-Mails oder Besuche protokolliert.",
          single: "Kontakt",
          plural: "Kontakte",
          subtitle: "Anrufe, E-Mails & Termine",
        },
        followUps: {
          open: "offen",
          due: "fällig",
          openModal: "Öffnen",
          listTitle: "WIEDERVORLAGEN",
          allCaughtUp: "Alle Aktivitäten sind auf dem aktuellen Stand.",
          selectPrompt: "Wählen Sie eine Wiedervorlage aus der Liste aus.",
          subtitle: "Wiedervorlagen & Termine",
          filterAll: "Alle",
          filterDue: "Fällig",
          filterToday: "Heute",
          filterUpcoming: "Demnächst",
          filterEmpty: "Keine Einträge für diesen Filter gefunden.",
          noItemsInFilter: "Keine Einträge in dieser Filteransicht vorhanden.",
        },
        company: {
          newButton: "Neue Firma",
          newTitle: "Neue Pipeline-Firma",
          editTitle: "Firma bearbeiten",
          edit: "Bearbeiten",
          save: "Speichern",
          create: "Anlegen",
          delete: "Löschen",
          deleteConfirm: "Diese Firma wirklich löschen? Alle Aktivitäten werden mitgelöscht.",
          duplicateName: "Eine Firma mit diesem Namen existiert bereits.",
          mutationError: "Aktion fehlgeschlagen. Bitte erneut versuchen.",
          name: "Firmenname",
          namePlaceholder: "z.B. Maschinenfabrik Herkules GmbH & Co. KG",
          type: "Typ",
          priority: "Priorität",
          phase: "Roadmap-Phase",
          status: "Pipeline-Status",
          location: "Ort",
          locationPlaceholder: "z.B. Siegen, Köln...",
          industry: "Branche",
          industryPlaceholder: "z.B. Bau / Industriebau, Maschinenbau...",
          reason: "Grund (Warum prüfen?)",
          reasonPlaceholder: "z.B. Baustellen, Projektteams, Nachunternehmer",
          contactPerson: "Ansprechpartner",
          contactAPosition: "Position",
          contactEmail: "E-Mail",
          contactPhone: "Telefon",
          contactBSection: "Kontakt B (zweiter Ansprechpartner)",
          contactBName: "Kontakt B – Name",
          contactBPosition: "Kontakt B – Position",
          contactBEmail: "Kontakt B – E-Mail",
          contactBPhone: "Kontakt B – Telefon",
          decisionMaker: "Entscheider / Bucher",
          apaleoName: "Apaleo-Firmenname (Umsatz-Abgleich)",
          apaleoNamePlaceholder: "Exakt wie in der Firmenliste (Umsatz-Tab)",
          apaleoHelp: "Verknüpft diese Firma mit den Apaleo-Umsatzdaten für den automatischen Abgleich von Logiernächten und Umsatz.",
          pipelineSection: "Pipeline & Priorisierung",
          contactsSection: "Ansprechpartner & Kontakte",
          addContact: "Kontakt hinzufügen",
          addAnotherContact: "Weiteren Ansprechpartner hinzufügen",
          contactNumber: "Kontakt #{{number}}",
          primaryContact: "Hauptkontakt",
          setPrimary: "Als Hauptkontakt festlegen",
          removeContact: "Kontakt entfernen",
          contactPersonName: "Name",
          contactNamePlaceholder: "Vorname Nachname...",
          role: "Rolle / Funktion",
          rolePlaceholder: "z.B. Ansprechpartner, Entscheider...",
          chooseRole: "Rolle wählen:",
          confirmDeletePrompt: "Löschen bestätigen?",
          yesDelete: "Ja, löschen",
          unnamedContact: "Unbenannter Kontakt",
          unknown: "Unbekanntes Unternehmen",
        },
        roles: {
          contactPerson: "Ansprechpartner",
          decisionMaker: "Entscheider / Bucher",
          management: "Geschäftsführung",
          accounting: "Buchhaltung",
          projectLead: "Projektleitung",
          assistant: "Assistenz",
        },
        contactImport: {
          button: "Kontakte importieren",
          title: "Kontakte aus Excel importieren",
          subtitle: "Excel mit den Spalten Firma, Kontakt A (Name/Position/Tel/E-Mail) und Kontakt B (Name/Position/Tel/E-Mail). Zuordnung per Firmenname. Leere Zellen überschreiben bestehende Kontakte nicht.",
          chooseFile: "Excel-Datei wählen",
          missingFirma: "Die Datei enthält keine Spalte \"Firma\". Bitte die Originaldatei verwenden.",
          noRows: "Keine Datenzeilen gefunden.",
          parseError: "Datei konnte nicht gelesen werden. Bitte .xlsx oder .csv verwenden.",
          matched: "{{count}} Firmen zugeordnet",
          unmatched: "{{count}} nicht gefunden",
          notFound: "Nicht in der Pipeline",
          match: "Zugeordnet",
          matchFuzzy: "Zugeordnet: {{company}} (über Namensteil — bitte prüfen)",
          unmatchedHint: "Nicht gefundene Firmen werden übersprungen. Bitte Firmennamen in der Pipeline anlegen oder Schreibweise prüfen.",
          emptyRows: "{{count}} zugeordnete Zeilen ohne Kontaktdaten",
          colFirma: "Firma",
          colContactA: "Kontakt A",
          colContactB: "Kontakt B",
          apply: "{{count}} Firmen aktualisieren",
          success: "{{count}} Firmen aktualisiert.",
          applyError: "Import fehlgeschlagen",
        },
        card: {
          detail: "Details öffnen",
          contractHandoff: "Vertrag anlegen",
        },
        detail: {
          profileSection: "Kundenprofil",
          activitySection: "Aktivitäten",
          noProfile: "Noch kein Profil ausgefüllt",
        },
        activity: {
          title: "Aktivität erfassen",
          quickAdd: "Aktivität",
          type: "Art",
          date: "Datum",
          followUp: "Wiedervorlage",
          followUpBadge: "Wiedervorlage: {{date}}",
          notes: "Notizen",
          notesPlaceholder: "Gesprächsnotizen, Ergebnisse, nächste Schritte...",
          save: "Speichern",
          empty: "Noch keine Aktivitäten",
        },
        activityType: {
          anruf: "Anruf",
          email: "E-Mail",
          besuch: "Besuch / Termin",
          angebot: "Angebot",
          notiz: "Notiz",
        },
        dragColumnHint: "Spalte ziehen zum Umsortieren",
        kpi: {
          contacts: "Kontakte",
          contactsTarget: "Ziel: {{min}}–{{max}} Kontakte",
          appointments: "Termine",
          appointmentsTarget: "Ziel: {{min}}–{{max}} Termine",
          followUps: "Wiedervorlagen",
          weekRange: "{{from}} – {{to}}",
          noFollowUps: "Keine offenen Wiedervorlagen",
          collapse: "Einklappen",
          expand: "Einblenden",
          quotaAchieved: "Ziel erreicht!",
          editQuota: "Ziel / Quote anpassen (Klicken zum Bearbeiten)",
        },
        profile: {
          title: "Kundenprofil",
          editButton: "Profil bearbeiten",
          save: "Speichern",
          revenueContext: "Umsatz (Zeitraum des Umsatz-Tabs): {{revenue}} · {{nights}} Nächtungen",
          bookingReason: "Buchungsanlass",
          bookingReasonPlaceholder: "Projekt, Serviceeinsatz, Montage, Schulung, Reise, Veranstaltung...",
          guestType: "Wer übernachtet?",
          guestTypePlaceholder: "Eigene Mitarbeitende, externe Techniker, Lieferanten, Gäste, Teams...",
          frequency: "Wie oft / wie lange?",
          frequencyPlaceholder: "z.B. 2× pro Monat, 3–5 Nächte",
          weekdays: "Typische Wochentage",
          weekdaysPlaceholder: "z.B. Mo–Do",
          channel: "Buchungsweg / Kanal",
          channelPlaceholder: "z.B. Direkt, E-Mail, Reisebüro",
          price: "Preis / Konditionen",
          pricePlaceholder: "z.B. Firmenrate 89 €, mit Frühstück",
          requirements: "Anforderungen",
          requirementsPlaceholder: "Parken, Küche, Rechnung, Lage, Flexibilität, Check-in...",
          internalNotes: "Interne Notizen",
        },
      },
      sales: {
        menuTitle: "Sales & Revenue",
        viewSubtitle: "Firmen, Ratenpläne & Traffic-Analyse",
        description: "Firmenverträge, Ratenpläne und Buchungs-Traffic aus Apaleo",
        hotelPrefix: "Hotel:",
        allHotels: "Alle Hotels",
        allCategories: "Alle Kategorien",
        companies: "Firmen",
        stammdaten: "Stammdaten",
        umsatz: "Umsatz",
        period: "Zeitraum: {{from}} – {{to}}",
        searchCompanies: "Firmen suchen...",
        searchRevenue: "Umsatz suchen...",
        calculatingRevenue: "Lade Umsatzbericht...",
        noCompanies: "Keine Firmen gefunden",
        noRevenueData: "Keine Umsatzdaten",
        ratePlans: "Ratenpläne",
        searchRatePlans: "Ratenpläne suchen...",
        all: "Alle",
        active: "Aktiv",
        inactive: "Inaktiv",
        plans: "Pläne",
        plansCount: "{{count}} Pläne",
        noDescription: "Keine Beschreibung",
        hotels: "Hotel: {{property}}",
        noRatePlans: "Keine Ratenpläne gefunden",
        traffic: "Traffic & Umsatz",
        trafficSubtitle: "Buchungsfrequenz & Ratenumsätze",
        default: "Standard",
        customRange: "Individuell",
        sorting: "Sortierung",
        sortByBookings: "Buchungen",
        sortByRevenue: "Umsatz",
        range: "Zeitraum",
        timeframe: "Zeitraum",
        days7: "7 Tage",
        days30: "30 Tage",
        days90: "90 Tage",
        days180: "180 Tage",
        days365: "365 Tage (1 Jahr)",
        from: "Von",
        to: "Bis",
        max30Days: "Maximal 30 Tage Zeitraum",
        customRangeHint: "Längere Zeiträume können die Ladezeit erhöhen",
        searchTraffic: "Ratenplan suchen...",
        calculatingTraffic: "Berechne Traffic-Daten...",
        category: "Kategorien: {{categories}}",
        bookings: "{{count}} Buchungen",
        revenue: "Umsatz",
        adr: "ADR",
        alos: "ALOS",
        nights: "{{count}} Nächte",
        noTraffic: "Kein Traffic im gewählten Zeitraum",
        roomNights: "{{count}} Übern.",
        debugFetched: "Reservierungen abgerufen: {{count}} (nur Anreisen im Zeitraum)",
        debugNoCompany: "{{count}} Reservierungen ohne Firmenname ausgeschlossen",
        debugCanceledExcluded: "{{count}} stornierte/No-Show-Reservierungen ausgeschlossen",
        reservationsList: "{{count}} Reservierungen in dieser Berechnung",
        noReservations: "Keine Reservierungen mit Firmenname im Zeitraum",
        startSearch: "Suche starten",
        searchStale: "Zeitraum geändert – Suche erneut starten",
        searchNotStarted: "Suche starten, um Daten zu laden",
        invoiceCount: "{{count}} Rechnungen in Apaleo gezählt",
        invoiceDates: "Rechnungsdaten: {{dates}}",
        invoiceFailedChunks: "Warnung: {{count}} Monatsabruf(e) der Firmenzeile fehlgeschlagen ({{periods}}) — Umsatz ist möglicherweise zu niedrig.",
        invoiceRowsInfo: "{{total}} Rechnungszeilen abgerufen, {{noCompany}} ohne Firmennamen",
        revenueSelectRow: "{{name}} auswählen",
        revenueSelectionCount: "{{count}} ausgewählt",
        revenueSelectionRevenue: "Umsatz Auswahl",
        revenueSelectionNights: "Übernachtungen Auswahl",
        revenueSelectionClear: "Auswahl aufheben",
        invoiceType: {
          Initial: "Rechnung",
          Advance: "Vorausrechnung",
          Correction: "Korrekturrechnung",
          Cancellation: "Stornorechnung",
          AdvanceCancellation: "Voraus-Storno",
          AdvanceCorrection: "Voraus-Korrektur",
          Proforma: "Proforma",
          Deposit: "Anzahlungsrechnung",
          DepositCancellation: "Anzahlungs-Storno",
          DepositCorrection: "Anzahlungs-Korrektur",
        },
      },
      auth: {
        email: "E-Mail",
        password: "Passwort",
        signIn: "Anmelden",
        signUp: "Registrieren",
        magicLink: "Magic-Link per E-Mail senden",
        google: "Mit Google fortfahren",
        passkey: "Mit Passkey anmelden",
        passkeyTitle: "Passkey (WebAuthn)",
        passkeyHelper: "Erstelle einen Passkey, um dich künftig ohne Passwort anzumelden.",
        passkeyCreate: "Passkey erstellen",
        passkeyCreating: "Wird erstellt…",
        passkeyCreated: "Passkey erfolgreich erstellt.",
        signingIn: "Anmeldung läuft…",
        or: "oder",
        invalidCredentials: "E-Mail oder Passwort ist ungültig.",
        emailNotConfirmed: "Bitte bestätige zuerst deine E-Mail-Adresse.",
        alreadyRegistered: "Diese E-Mail ist bereits registriert.",
        emailRequired: "Bitte gib eine E-Mail-Adresse ein.",
        captchaRequired: "Bitte bestätige das CAPTCHA.",
        magicLinkSent: "Falls diese E-Mail existiert, wurde ein Magic-Link gesendet.",
        checkEmail: "Bitte prüfe dein Postfach.",
        genericError: "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
        forgotPassword: "Passwort vergessen?",
        resetPassword: "Passwort zurücksetzen",
        resetEmailSent: "Falls diese E-Mail existiert, wurde ein Reset-Link gesendet.",
        newPassword: "Neues Passwort",
        confirmPassword: "Passwort bestätigen",
        passwordsDoNotMatch: "Passwörter stimmen nicht überein.",
        setNewPassword: "Neues Passwort setzen",
        settingPassword: "Passwort wird gesetzt…",
        passwordSet: "Passwort erfolgreich gesetzt.",
        passwordResetError: "Fehler beim Zurücksetzen. Bitte erneut versuchen.",
        newPasswordHint: "Mindestens 10 Zeichen. Mit Zahl, Klein-, Großbuchstaben & Sonderzeichen!",
      },
      uploadProgress: {
        done: "Hochgeladen",
        failed: "Upload fehlgeschlagen",
        preparing: "Wird vorbereitet...",
      },
      common: {
        demo: "Demo",
        pwa: {
          newVersionToast: "Neue Version verfügbar – wird beim nächsten Fensterwechsel geladen. Sie werden automatisch aktualisiert.",
        },
        errors: {
          updateLoading: "Neue Version wird geladen…",
          updateManual: "Die App wurde aktualisiert. Ein kurzer Neustart ist nötig.",
          reloadPage: "Seite neu laden",
          somethingWentWrong: "Etwas ist schiefgelaufen",
          unexpected: "Ein unerwarteter Fehler ist aufgetreten.",
          tryAgain: "Erneut versuchen",
        },
        reset: "Zurücksetzen",
        choose: "Bitte wählen...",
        logout: "Abmelden",
        welcome: "Willkommen",
        settings: "Einstellungen",
        save: "Speichern",
        cancel: "Abbrechen",
        next: "Weiter",
        back: "Zurück",
        search: "Suchen",
        loading: "Laden...",
        error: "Fehler",
        success: "Erfolg",
        print: "Drucken",
        archive: "Archiviert",
        delete: "Löschen",
        remove: "Entfernen",
        copyCode: "Code kopieren",
        edit: "Bearbeiten",
        close: "Schließen",
        open: "Öffnen",
        add: "Hinzufügen",
        export: "Exportieren",
        status: "Status",
        info: "Info",
        warning: "Warnung",
        propertySelection: "Hausauswahl",
        allProperties: "Alle Häuser",
        selected: "ausgewählt",
        today: "Heute",
        allOf: "Alle",
        allWithCount: "Alle ({{count}})",
        apiWarning: "API-Verbindung eingeschränkt",
        appName: "AdaptHub",
        applyFilters: "Filter anwenden",
        clearSelection: "Auswahl löschen",
        clock: "Uhr",
        done: "Erledigt",
        loadingApp: "Anwendung wird geladen\u2026",
        loggedIn: "Angemeldet",
        noOptions: "Keine Optionen",
        offlineMode: "Offline-Modus",
        operationFailed: "Vorgang fehlgeschlagen",
        preferences: "Einstellungen",
        recent: "Zuletzt verwendet",
        saving: "Wird gespeichert\u2026",
        select: "Ausw\u00e4hlen",
        selectAll: "Alle ausw\u00e4hlen",
        selectedCount: "{{count}} ausgew\u00e4hlt",
        system: "System",
        trace: "Trace",
        unknown: "Unbekannt",
        unknownShort: "Unbek.",
        update: "Aktualisieren",
        users: "Benutzer",
        languageLabel: "Sprache",
        languageDe: "Deutsch",
        languageEn: "Englisch",
        less: "Weniger",
        property: "Property",
        retry: "Erneut versuchen",
      },
      priority: {
        normal: "Normal",
        high: "Hoch",
        urgent: "Dringend",
      },
      fileViewer: {
        openExternally: "Im neuen Tab öffnen",
        download: "Herunterladen",
        loadFailed: "Datei konnte nicht geladen werden.",
        noPreview: "Diese Datei kann nicht direkt angezeigt werden (z. B. ZIP, Excel, HEIC). Lade sie herunter, um sie zu öffnen.",
      },
      preferences: {
        title: "Präferenzen",
        subtitle: "Personalisierung & Konfiguration",
        tabProperties: "Standorte",
        tabMenuGroups: "Menü-Gruppen",
        tabAdmin: "Admin",
        userFallback: "Gast",
        propertySelectionHelper: "Wähle deine bevorzugten Häuser aus. Diese werden als Standard-Filter in allen Modulen verwendet.",
        menuGroupNamePlaceholder: "z.B. Tägliche Aufgaben",
        noMenuGroups: "Noch keine Menü-Gruppen vorhanden. Erstelle eine neue Gruppe, um deine Sidebar-Tabs zu organisieren.",
        iframeDisplayNameLabel: "Anzeigename",
        iframeDisplayNamePlaceholder: "Name der Partner-App",
        iframeUrlLabel: "URL",
        iframeUrlPlaceholder: "https://app.beispiel.de",
        propertyEmailsTitle: "Kontakt-E-Mails",
        propertyEmailLabel: "E-Mail-Empfänger",
        propertyEmailPlaceholder: "email@beispiel.de",
        noPropertiesConfigured: "Keine Häuser konfiguriert",
        forceReloadWarning: "Dieser Vorgang lädt die Anwendung für alle Benutzer neu. Bitte mit Vorsicht verwenden.",
        forceReloadButton: "System neu laden",
      },
      inactivity: {
        warningBanner: "Automatische Abmeldung wegen Inaktivität in Kürze — bewegen Sie die Maus oder drücken Sie eine Taste.",
      },
      months: {
        jan: "Januar",
        feb: "Februar",
        mrz: "März",
        apr: "April",
        mai: "Mai",
        jun: "Juni",
        jul: "Juli",
        aug: "August",
        sep: "September",
        okt: "Oktober",
        nov: "November",
        dez: "Dezember",
      },
      kassenbuch: {
        title: "Kassenbuch",
        locked: "Festgeschrieben",
        tabs: {
          journal: "Journal",
          counter: "Kassenzähler",
          settings: "Einstellungen",
        },
        stats: {
          opening: "Anfangsbestand",
          income: "Einnahmen",
          incomeSum: "Summe Einnahmen",
          expense: "Ausgaben",
          expenseSum: "Summe Ausgaben",
          safe: "Tresorbestand",
          closing: "Endbestand",
          closingTarget: "Endbestand (Soll)",
        },
        ledger: {
          title: "Buchungsjournal",
          addEntry: "Buchung hinzufügen",
          reconciliation: "Kassenabgleich",
          closePeriod: "Kassenabschluss",
          periodLock: "Monat festschreiben",
          periodLockTooltip: "Kasse muss ausgeglichen sein, um abzuschließen",
        },
        counter: {
          title: "Physischer Bestand",
          qty: "Stückzahl",
          subtotal: "Zwischensumme",
          note: "Geldschein",
          coin: "Münze",
        },
        reconciliation: {
          targetBalance: "Soll-Bestand (Ledger)",
          actualBalance: "Ist-Bestand (Gezählt)",
          difference: "Differenz",
          balanced: "Die Kasse ist vollständig ausgeglichen.",
          balancedShort: "Kasse ausgeglichen.",
          unbalanced: "Warnung: Es wurde eine Differenz von {{amount}} festgestellt.",
          unbalancedShort: "Differenz von {{amount}} erkannt.",
          hint: "Bitte sicherstellen, dass alle Belege des Monats erfasst sind, bevor der Kassenabschluss durchgeführt wird. Differenzen über 0,00 EUR müssen im Journal begründet werden.",
        },
        systemStatus: "System-Status",
        systemStatusShort: "Systemstatus",
        export: {
          excel: "Excel Export",
          datev: "DATEV Export",
          success: "Export erfolgreich",
        },
        creationInfo: {
          title: "Erstellungsinformationen",
          text: "Dieser Eintrag wurde am {{date}} um {{time}} Uhr von {{user}} erstellt und ist GoBD-konform unveränderbar gespeichert.",
        },
        deletedBy: "Storniert von {{user}} am {{date}}",
        cancelled: "Storniert",
        storno: "Stornobuchung",
        receipt: {
          missing: "Fehlt",
          view: "Beleg anzeigen",
          delete: "Beleg löschen",
          upload: "Beleg hochladen",
          fetchFromApaleo: "Von Apaleo laden",
        },
        fetchInvoice: {
          title: "Rechnung von Apaleo laden",
          subtitle: "Beleg automatisch verknüpfen",
          invoiceNumber: "Rechnungsnummer",
          placeholder: "z.B. SI-2650286",
          loading: "Lade PDF...",
          fetch: "Jetzt laden",
          hint: "ID wird als {{propertyId}}-{{invoiceNo}} an Apaleo gesendet.",
        },
        bulkDownload: {
          button: "Belege herunterladen",
          title: "Belege als ZIP herunterladen",
          subtitle: "Alle Belege im Zeitraum für einen Standort",
          location: "Standort",
          from: "Von",
          to: "Bis",
          invalidRange: "\u201eBis\u201c muss nach \u201eVon\u201c liegen.",
          emptyRange: "Bitte Von und Bis angeben.",
          fetchError: "Belege konnten nicht geladen werden: {{message}}",
          downloading: "Lade {{done}} von {{total}} Belegen...",
          zipError: "ZIP-Erstellung fehlgeschlagen: {{message}}",
          summaryTitle: "Download abgeschlossen",
          summaryDownloaded: "{{count}} Beleg(e) heruntergeladen",
          summaryMissing: "{{count}} ohne Beleg übersprungen",
          summaryFailed: "{{count}} fehlgeschlagen",
          failedReason: "Beleg {{belegNr}}: {{reason}}",
          noReceipts: "Keine Belege im gewählten Zeitraum gefunden.",
          close: "Schließen",
          localhostHint: "Entwicklungsmodus: Es sind keine echten Belege hinterlegt — bitte in der Produktivumgebung testen.",
        },
        loading: "Lade Kassenbuch...",
        taxRateHint: "0%",
        amountHint: "0,00",
        date: "Datum",
      },
      newKassenbuchEntry: {
        title: "Neue Buchung erfassen",
        bookingType: "Buchungs-Typ",
        location: "Standort",
        choose: "Bitte wählen...",
        date: "Datum",
        payeePayer: "Zahlungsempfänger / -pflichtiger",
        payeePlaceholder: "z.B. Gast Müller",
        amount: "Betrag (€)",
        amountEur: "Betrag (€)",
        amountPlaceholder: "z.B. 25,00",
        income: "Einnahme",
        expense: "Ausgabe",
        safeTransfer: "Tresor-Umbuchung",
        direction: "Richtung",
        toSafe: "→ In den Tresor (Ausgabe)",
        fromSafe: "← Aus dem Tresor (Einnahme)",
        autoExpense: "Wird als Ausgabe gebucht",
        autoIncome: "Wird als Einnahme gebucht",
        safeAmount: "Tresor-Betrag (€)",
        invoiceNumber: "Rechnungsnummer",
        invoicePlaceholder: "z.B. SI-2650286",
        bookingText: "Buchungstext",
        noBookingTexts: "Keine Buchungstexte konfiguriert",
        taxRate: "Steuersatz",
        taxFree: "Steuerfrei (0%)",
        accountDebit: "Konto Soll",
        accountCredit: "Konto Haben",
        costCenter: "Kostenstelle",
        attachReceipt: "Beleg anhängen",
        clickToReplace: "Klicken zum Ersetzen",
        dragDrop: "Datei hier ablegen oder klicken",
        fileHint: "Akzeptiert: JPG, PNG, PDF (max. 10 MB)",
        saveBooking: "Buchung speichern",
        category: "Kategorie",
        receipt: "Beleg",
        notes: "Notizen",
        addEntry: "Buchung hinzufügen",
        updateEntry: "Buchung speichern",
        saveSuccess: "Buchung erfolgreich gespeichert",
        saveError: "Fehler beim Speichern: {{message}}",
        receiptUploaded: "Beleg hochgeladen",
        receiptUploadError: "Beleg-Upload fehlgeschlagen",
        confirmDiscard: "Diese Buchung wirklich verwerfen?",
      },
      kassenbuchSettings: {
        settingsTitle: "Kassenbuch Konfiguration",
        settingsDesc: "Konfiguriere Deine Kassenbuch-Instanz(en):",
        description: "Konfiguriere Deine Kassenbuch-Instanz(en):",
        location: "Standort",
        addLocation: "Standort hinzufügen",
        saveConfig: "Konfiguration speichern",
        propertyLabel: "Standort {{propId}}",
        cashAccount: "Konto Kassenbestand",
        costCenter: "Kostenstelle",
        tresorSettings: "Tresor-Einstellungen",
        tresorAccount: "Gegenkonto Tresortransfers",
        helpTitle: "HILFE & HINWEISE",
        helpText: "Hier können Sie die Konteneinstellungen und Buchungstexte für Ihr Kassenbuch verwalten. Änderungen an den Buchungstexten wirken sich nur auf zukünftige Buchungen aus.",
        predefinedTexts: "Vordefinierte Buchungstexte",
        addLabel: "Buchungstext",
        addPlaceholder: "z.B. Bareinzahlung Gast",
        addContraAccount: "Standard-Gegenkonto",
        addContraPlaceholder: "z.B. 1000",
        addTaxRate: "Standard-Steuersatz",
        tableHeaderText: "Buchungstext",
        tableHeaderAccount: "Gegenkonto",
        tableHeaderTax: "Steuersatz",
        emptyText: "Keine vordefinierten Buchungstexte konfiguriert.",
        confirmReset: "Möchten Sie diese Buchungstexte wirklich zurücksetzen?",
        configSaved: "Konfiguration gespeichert",
        locationAdded: "Standort hinzugefügt",
        locationRemoved: "Standort entfernt",
        textAdded: "Buchungstext hinzugefügt",
        textUpdated: "Buchungstext aktualisiert",
        textRemoved: "Buchungstext entfernt",
        confirmDeleteText: "Buchungstext wirklich löschen?",
        confirmRemoveLocation: "Standort wirklich entfernen?",
      },
      invoiceCorrection: {
        title: "Rechnungskorrektur",
        subtitleV1: "Rechnungskorrektur für ausgewählte Buchung",
        subtitleV2: "Erstelle eine korrigierte Rechnung",
        selectInvoice: "Rechnung auswählen",
        invoicePrefix: "Rechnung",
        downloadPdf: "PDF herunterladen",
        submit: "Korrektur einreichen",
        selectInvoiceDesc: "Wähle eine Rechnung aus, für die eine Korrektur ausgestellt werden soll.",
        requestHint: "Die Korrektur wird an die Rezeption zur Bearbeitung weitergeleitet.",
        gobdNotice: "Die Korrektur erfolgt nach den GoBD-Richtlinien. Die ursprüngliche Rechnung bleibt unverändert.",
        location: "Standort",
        noPrefix: "Kein Präfix",
        invoiceIdLabel: "Rechnungsnummer",
        invoicePlaceholder: "z.B. RE-2024-001",
        newNameLabel: "Neuer Rechnungsempfänger",
        newNamePlaceholder: "Name des neuen Empfängers",
        vatLabel: "USt-IdNr. (optional)",
        languageLabel: "Sprache",
        languageDe: "Deutsch",
        languageEn: "Englisch",
        streetLabel: "Straße / Nr.",
        zipLabel: "PLZ",
        cityLabel: "Ort",
        processing: "Wird verarbeitet...",
        execute: "Korrektur ausführen",
        success: "Rechnungskorrektur erfolgreich angefordert",
        error: "Fehler bei der Korrektur: {{message}}",
        downloading: "PDF wird heruntergeladen...",
      },
      hrHolidaySettings: {
        title: "Feiertagskonfiguration",
        subtitle: "Gesetzliche & regionale Feiertage",
        year: "Jahr",
        country: "Land",
        stateRegion: "Bundesland / Region",
        description: "Definiere Feiertage und Sonderregelungen",
        freeDay: "Freier Tag",
        halfDay: "Halber Tag",
        save: "Speichern",
        workDay: "Arbeitstag",
      },
      cityTaxAudit: {
        title: "Ortstaxen-Audit (City Tax)",
        allProperties: "Alle Häuser",
        tabUnpaid: "Ausstehend (Open)",
        tabPaid: "Bezahlt (Closed)",
        tabExported: "Exportiert",
        noResults: "Keine Einträge gefunden",
        guestName: "Gastname",
        arrival: "Anreise",
        departure: "Abreise",
        property: "Hotel",
        amount: "Betrag",
        status: "Status",
        open: "Offen",
        paid: "Bezahlt",
        markAsPaid: "Als bezahlt markieren",
        markAsUnpaid: "Als offen markieren",
        markAsExported: "Als exportiert markieren",
        exportCsv: "CSV Export",
        activeSelection: "Aktive Auswahl",
        case: "Fall",
        cases: "Fälle",
        close: "Schließen",
        conflictBadge: "Konflikt",
        conflictDescription: "Diese Zuordnung steht im Konflikt mit anderen Einträgen",
        conflictTitle: "Konflikte erkannt",
        csvExport: "CSV-Export",
        entriesCount: "{{count}} Einträge",
        excelExport: "Excel-Export",
        filterAll: "Alle",
        filterConflicts: "Nur Konflikte",
        filterNoConflicts: "Keine Konflikte",
        headerBalance: "Saldo",
        headerDeparture: "Abreise",
        headerGuest: "Gast",
        headerProperty: "Immobilie",
        headerStatus: "Status",
        inCategory: "in {{category}}",
        loading: "Lade Daten\u2026",
        resetFilter: "Filter zurücksetzen",
        searchPlaceholder: "Gäste suchen\u2026",
        showConflicts: "Konflikte anzeigen",
        showNoConflicts: "Ohne Konflikte anzeigen",
        statusCancelled: "Storniert",
        statusLabel: "Status",
        statusOpen: "Offen",
        statusPaid: "Bezahlt",
        subtitle: "Prüfung und Abstimmung der City-Tax-Daten",
        tabExempted: "Befreit",
      },
      recalcCityTax: {
        title: "Ortstaxe neu berechnen",
        subtitle: "7,5% Anpassung pro Nacht für ChannelManager-Buchungen",
        dateRange: "Zeitraum (Anreise)",
        dateFrom: "Von",
        dateTo: "Bis",
        sourceFilter: "Buchungsquelle",
        sourceFilterEmpty: "Keine Buchungsquellen in den geladenen Reservierungen gefunden – Quelle manuell eingeben.",
        sourceAddPlaceholder: "Quelle manuell hinzufügen…",
        sourceAdd: "Hinzufügen",
        sourceFilterActive: "Filter aktiv – nur diese Quellen werden verarbeitet: {{sources}}",
        createdRange: "Erstellungsdatum der Reservierung",
        createdHint: "Optional: schränkt nach dem Datum ein, an dem die Reservierung angelegt wurde (nicht die Anreise). Beispiel: Booking.com-Buchungen ab dem 14.05.2026 enthalten die Ortstaxe bereits.",
        createdInvalidDate: "Erstellungsdatum muss im Format JJJJ-MM-TT vorliegen.",
        createdOrderError: "„Erstellt von“ muss vor oder am „Erstellt bis“ liegen.",
        toolRecalc: "Ortstaxe neu berechnen",
        toolSplit: "HRS / Club-Rates aufteilen",
        splitBreakfastLabel: "Frühstück (brutto)",
        splitBreakfastPlaceholder: "z.B. 12,00",
        splitBreakfastInvalid: "Frühstücksbetrag muss eine Zahl größer 0 sein.",
        splitServiceLabel: "Apaleo-Service für die Frühstücksbuchung",
        splitServicePlaceholder: "z.B. BERLIN-FS_AIRPORT",
        splitServiceHint: "Wird pro Reservierung mit Anzahl = Erwachsene gebucht (idempotent: bereits gebuchte Services werden nicht doppelt gebucht). Leer = keine Service-Buchung.",
        splitPerPersonUnit: "€ / Person / Nacht",
        singleMode: "Nur eine Reservierung (für Echt-Test)",
        singleModeHint: "Wenn gesetzt, wird nur diese Reservierung verarbeitet (überschreibt den Zeitraum).",
        reservationIdLabel: "Reservierungs-ID",
        reservationIdPlaceholder: "z.B. RES-12345",
        reservationNotFound: "Reservierung mit dieser ID wurde nicht gefunden.",
        dryRun: "Dry-Run (nur Vorschau, keine API-Aufrufe)",
        dryRunHint: "Im Dry-Run werden keine Änderungen am Apaleo-System vorgenommen.",
        process: "Jetzt neu berechnen",
        processing: "Verarbeite Reservierungen\u2026",
        warning: "Diese Aktion entfernt die bestehende Ortstaxe und fügt pro Nacht eine neue Charge hinzu. Der Gesamtbetrag der Reservierung bleibt unverändert.",
        summary: "Zusammenfassung",
        processed: "Erfolgreich verarbeitet",
        skipped: "Übersprungen (nicht ChannelManager)",
        failed: "Fehlgeschlagen",
        noDateRange: "Bitte Von- und Bis-Datum auswählen.",
        noReservations: "Keine Reservierungen im gewählten Zeitraum gefunden.",
        noTimeSlicePrices: "Reservierung ohne gültige Nachtpreise übersprungen.",
        confirmTitle: "Verarbeitung starten?",
        confirmBody: "Es werden {{count}} Reservierungen verarbeitet. Dies kann nicht rückgängig gemacht werden.",
        confirmButton: "Verarbeiten",
        cancel: "Abbrechen",
        close: "Schließen",
        retry: "Erneut versuchen",
        resultsTitle: "Ergebnisse",
        columnReservation: "Reservierung",
        columnGuest: "Gast",
        columnChannel: "Kanal",
        columnNights: "Nächte",
        columnOriginalTotal: "Original",
        columnNewTotal: "Neu",
        columnStatus: "Status",
        statusProcessed: "Verarbeitet",
        statusSkipped: "Übersprungen",
        statusFailed: "Fehler",
        statusDryRun: "Dry-Run",
        successToast: "{{processed}} Reservierungen erfolgreich neu berechnet.",
        partialSuccessToast: "Verarbeitung abgeschlossen: {{processed}} OK, {{failed}} Fehler.",
        failureToast: "Verarbeitung fehlgeschlagen. Details in der Ergebnisliste.",
        automationComment: "Ortstaxe am {{date}} automatisch neu berechnet (AdaptHub).",
        automationCommentSplit: "Rate am {{date}} automatisch in Übernachtung + Frühstück getrennt (AdaptHub).",
        automationCommentSplitNoBreakfast: "Rate am {{date}} automatisch in Übernachtung + Frühstück getrennt (AdaptHub) – Frühstück konnte NICHT als Service gebucht werden ({{reason}}).",
      },
      waitingList: {
        title: "Warteliste",
        subtitle: "Gäste verwalten",
        newEntry: "Neuer Eintrag",
        hotel: "Hotel",
        persons: "Personen",
        arrival: "Anreise",
        departure: "Abreise",
        requester: "Melder",
        requesterPlaceholder: "Name des Melders...",
        status: "Status",
        notes: "Notizen",
        notesPlaceholder: "z.B. Kategorie oder Wunsch...",
        guestName: "Gastname",
        guestNamePlaceholder: "Name des Gastes...",
        desiredCategory: "Wunschkategorie",
        allCategories: "Alle Kategorien",
        update: "Aktualisieren",
        monitor: "Überwachen",
        listTab: "Liste",
        loading: "Lade Warteliste...",
        empty: "Keine Einträge",
        editTitle: "Eintrag bearbeiten",
        deleteTitle: "Eintrag löschen",
      },
      overbookingLocks: {
        title: "Überbuchungs-Sperren",
        newLock: "Neue Sperre",
        hotelLocation: "Hotel / Standort",
        roomCategory: "Zimmerkategorie",
        startDate: "Start",
        endDate: "Ende",
        lockCount: "Anzahl der Sperren",
        lockCountHint: "Legt fest, wie viele physische Zimmer maximal für diesen Zeitraum blockiert werden.",
        update: "Aktualisieren",
        monitor: "Überwachen",
        loadingLocks: "Lade Sperren...",
        empty: "Momentan keine aktiven Sperren",
        emptyActive: "Momentan keine aktiven Sperren",
        emptyInactive: "Momentan keine nicht-aktiven (gesperrten) Sperren",
        activeSubTab: "Aktiv",
        inactiveSubTab: "Nicht aktiv",
        blocked: "Gesperrt",
        roomAbbr: "Zi.",
        blocking: "Sperrt Zimmer...",
        activeChecking: "Aktiv (Prüft)",
        any: "Beliebig",
        subtitle: "Sperren verwalten",
        locksTab: "Sperren",
        allCategories: "Alle Kategorien",
        lockPeriodFrom: "Sperrzeitraum von",
        lockPeriodTo: "Sperrzeitraum bis",
        editTooltip: "Eintrag bearbeiten",
        deleteTooltip: "Sperre löschen / freigeben",
        maintenanceDescription: "Zimmer via. Überbuchungs-Sperre geblockt",
        reason: "Wartung",
        systemName: "AdaptHub Wartung",
        notificationText: "Überbuchungs-Sperre: {{roomNumber}} wurde vom {{arrival}} bis {{departure}} für die Überbuchungs-Sperre geblockt",
        toastSuccess: "Überbuchungs-Sperre erfolgreich erstellt",
      },
      usersView: {
        title: "Nutzerverwaltung",
        subtitleV1: "Verwalte Zugriffsrechte und Rollen deiner Kollegen.",
        subtitleV2: "Identity & Access Management (IAM)",
        searchPlaceholder: "Nutzer nach Name, E-Mail oder ID suchen",
        noUsers: "Keine Nutzer gefunden",
        tableEmployee: "Mitarbeiter & Apaleo Identity",
        tableLastSeen: "Zuletzt gesehen",
        tableRole: "Berechtigungs-Level",
        tableHR: "HR-Verantwortliche",
        tableAction: "Aktion",
        tableActionV2: "Engine",
        deleteTitle: "Nutzer endgültig löschen",
        deleteTitleV2: "User permanent terminieren",
        responsible: "Verantwortlich",
        users: "Nutzer",
        ownProfile: "Eigenes Profil",
      },
      onboarding: {
        title: "AdaptHub Onboarding-Assistent",
        subtitle: "Richten Sie Ihren SaaS-Tenant in wenigen Schritten ein.",
        step1_title: "Standorte auswählen",
        step1_desc: "Wählen Sie aus, welche Ihrer Apaleo-Properties in AdaptHub aktiviert sein sollen.",
        step2_title: "Module aktivieren",
        step2_desc: "Aktivieren Sie die gewünschten AdaptHub-Module für Ihr Team.",
        step3_title: "Zusammenfassung",
        step3_desc: "Überprüfen Sie Ihre Einstellungen vor dem Abschluss.",
        complete: "Onboarding abschließen",
        loadingProperties: "Properties werden geladen...",
        noProperties: "Keine Properties in Ihrem Apaleo-Konto gefunden. Bitte verknüpfen Sie mindestens ein Hotel in Apaleo.",
        moduleNameTraces: "Traces & Aufgaben",
        moduleDescTraces: "Zusammenarbeit und Aufgabenzuweisung.",
        moduleNameKassenbuch: "Kassenbuch",
        moduleDescKassenbuch: "GoBD-konforme petty cash Kassenführung.",
        moduleNameHr: "Personal & Zeit",
        moduleDescHr: "Zeiterfassung und Mitarbeiter-Organisation.",
        moduleNameHk: "Housekeeping",
        moduleDescHk: "Zimmer-Statusverwaltung und Reinigungsplanung.",
        moduleNameHt: "Haustechnik",
        moduleDescHt: "Mängellisten und Instandhaltungs-Arbeiten.",
        moduleNameFundsachen: "Fundsachen",
        moduleDescFundsachen: "Mitarbeiter-Erfassung von verlorenen Objekten.",
        moduleNameXrechnung: "XRechnung",
        moduleDescXrechnung: "DATEV-konforme Rechnungs-Exporttools.",
        activeLocations: "Aktive Standorte",
        activeModules: "Aktive Module",
        back: "Zurück",
        next: "Weiter",
        pendingTitle: "Einrichtung ausstehend",
        setupPhase: "Einrichtungsphase",
        waitingMessage: "Bitte warten Sie, bis der Administrator die Einrichtung abgeschlossen hat",
      },
      hr: {
        clock: {
          title: "Personalwesen",
          performed: "Geleistet",
          subtitle: "Personal Menü",
          description: "Verwalte deine Arbeitszeiten und Abwesenheiten.",
          clockIn: "Einstempeln",
          clockOut: "Ausstempeln",
          break: "Pause",
          breakEnd: "Pause beenden",
          statusIn: "Eingestempelt",
          statusOut: "Ausgestempelt",
          statusBreak: "In der Pause",
          todayStats: "Heutige Arbeitszeit",
          todayLogs: "Aktivitäten heute",
          weeklyStats: "Wochenarbeitszeit",
          monthlyStats: "Monatsarbeitszeit",
          overtime: "Überstunden",
        },
        tabs: {
          clock: "Zeiterfassung",
          history: "Mein Verlauf",
          requests: "Anträge",
          planner: "Abwesenheiten",
          absences: "Abwesenheiten",
          shifts: "Schichten",
          admin: "Admin",
          team: "Team",
          teamOverview: "Team-Übersicht",
          timesheets: "Stempelzeiten",
        },
        calendar: {
          viewLabel: "Ansicht",
          viewColumns: "Tagesraster",
          viewTimeline: "Zeitleiste",
          viewColumnsHint: "Tage als Spalten, Uhrzeiten senkrecht",
          viewTimelineHint: "Mitarbeiter als Zeilen, Uhrzeiten waagerecht",
          zeroLengthNotSupported: "Start- und Endzeit dürfen nicht identisch sein.",
          saveFailed: "Schicht konnte nicht gespeichert werden",
          views: {
            day: "Tag",
            workWeek: "Arbeitswoche",
            week: "Woche",
            month: "Monat",
          },
          searchEmployee: "Mitarbeiter suchen...",
          allTeams: "Alle Teams",
          rowsLabel: "Zeilen:",
          compact: "Kompakt",
          standard: "Standard",
          colorLabel: "Farbe:",
          colorEmployee: "Mitarbeiter",
          colorShiftType: "Schichtart",
          colorEmployeeHint: "Jeder Mitarbeiter hat seine eigene Farbe",
          colorShiftHint: "Farben nach Schichtzeit: Früh, Tag, Spät, Nacht",
          previousPeriod: "Vorheriger Zeitraum",
          nextPeriod: "Nächster Zeitraum",
          today: "Heute",
          jumpToDate: "Zu Datum springen",
          bulkShifts: "Sammelplanung",
          bulkShiftsHint: "Sammel-Schichtplanung für mehrere Mitarbeiter",
          addShift: "Schicht hinzufügen",
          addSlot: "Slot hinzufügen",
          employeesShown: "{{count}} Mitarbeiter angezeigt",
          jump: "Springen:",
          weekShort: "W{{week}} ({{from}}–{{to}})",
          timeColumn: "Zeit",
          dragHint: "Spaltentrenner horizontal ziehen zum Vergrößern · Schicht nach oben/unten ziehen zum Verschieben · Unteren Griff ziehen zum Ändern der Dauer",
          dragResizeColumn: "Horizontal ziehen, um die Spalte zu vergrößern (Doppelklick zum Zurücksetzen)",
          dragResizeStart: "Ziehen, um die Startzeit zu ändern (15-Min-Raster)",
          dragResizeEnd: "Ziehen, um die Endzeit zu ändern (15-Min-Raster)",
          dragColumnDivider: "Spaltentrenner ziehen, um Tage zu vergrößern",
          dragAdjustStart: "Ziehen, um die Startzeit anzupassen",
          dragAdjustEnd: "Ziehen, um die Endzeit anzupassen",
          clickToEdit: "Klicken zum Bearbeiten",
          dragToMove: "Ziehen zum Verschieben",
          overnightContinuation: "Fortsetzung vom Vortag",
          noEmployeesFiltered: "Keine Mitarbeiter für die aktuellen Filter — Team-Auswahl oder Suche zurücksetzen.",
          holidayNationwide: "Bundesweit",
          type: "Typ",
          noShiftsFound: "Keine Schichten für diese Filter gefunden",
          typeShift: "Schicht",
          typeOnCall: "Bereitschaft",
          typeBreak: "Pause",
          typeCallDuty: "Bereitschaftsdienst",
          typeOvertime: "Überstunden",
          callShort: "Ruf",
          breakShort: "Pause",
          staff: "Personal",
          teamMember: "Teammitglied",
          plusOneDay: "+1 Tag",
          deptLabel: "Abt.:",
          widthLabel: "Breite:",
          fit: "Passend",
          spacious: "Großzügig",
          detailed: "Detailliert",
          showNotes: "Notizen anzeigen",
          dayComment: "Tagesnotiz",
          addComment: "Notiz hinzufügen",
          editComment: "Notiz bearbeiten",
          commentPlaceholder: "Notiz für diesen Tag eingeben (z. B. Verspätung, Homeoffice, Übergabe)...",
          deleteComment: "Notiz löschen",
          deleteCommentConfirm: "Möchten Sie diese Tagesnotiz wirklich löschen?",
          hideNotes: "Notizen ausblenden",
          showNotesHint: "Notizen- & Abwesenheitszeile anzeigen",
          hideNotesHint: "Notizen- & Abwesenheitszeile ausblenden",
          scheduled: "Geplant",
          notesAndAbsences: "Notizen & Abwesenheiten",
          timelineHours: "Zeitleiste (00–24)",
          employeesColumn: "Mitarbeiter ({{filtered}}{{total}})",
          addSlotFor: "Schicht für {{name}} hinzufügen",
          editShiftTitle: "Schicht bearbeiten",
          createShiftTitle: "Neue Schicht erstellen",
          employeeLabel: "Mitarbeiter",
          dateLabel: "Datum",
          startLabel: "Start",
          endLabel: "Ende",
          shiftTypeLabel: "Schichtart",
          shiftTypeShift: "Schicht",
          shiftTypeOnCall: "Bereitschaft",
          shiftTypeBreak: "Pause",
          splitWithBreak: "Schicht mit Pause teilen",
          splitWithBreakHint: "Teilt in 2 Abschnitte mit 30 Min Pause dazwischen",
          splitButton: "Teilen (30 Min)",
          splitTooShort: "Die Schicht muss mindestens 1,5 Stunden dauern, um eine Pause einzufügen.",
          noteLabel: "Notiz / Details (optional)",
          notePlaceholder: "z. B. Frührezeption, Nachtdienst...",
          deleteShiftConfirm: "Schicht für {{name}} löschen?",
          deleteButton: "Löschen",
          contextMenu: {
            title: "Schicht-Aktionen",
            edit: "Bearbeiten",
            duplicate: "Duplizieren (morgen)",
            toOnCall: "In Rufbereitschaft umwandeln",
            toShift: "Zurück zur Schicht",
            delete: "Löschen",
          },
          cancelButton: "Abbrechen",
          saveShift: "Schicht speichern",
          createShiftButton: "Schicht erstellen",
          customisation: "Anpassung",
          customisationHint: "Zeilenhöhe, Farbmodus und Farben anpassen",
          colorCustomisation: "Farbanpassung",
          colorCustomisationHint: "Klicke auf ein Farbfeld, um die Farbe live zu ändern",
          openColorSettings: "Farbeinstellungen für Mitarbeiter und Schichten öffnen",
          customColorsApplied: "Eigene Farben aktiv",
          resetAll: "Alle zurücksetzen",
          resetAllHint: "Alle {{scope}}-Farben auf Standard zurücksetzen",
          scopeShift: "Schicht",
          scopeEmployee: "Mitarbeiter",
          closePopup: "Pop-up schließen",
          employeesTab: "Mitarbeiter",
          shiftTypesTab: "Schichtarten",
          filterEmployees: "Mitarbeiter filtern...",
          noEmployeesMatch: "Keine Mitarbeiter gefunden für \"{{query}}\"",
          editColorFor: "Farbe für {{name}} bearbeiten",
          locationFilter: "Arbeitsort filtern",
          allLocations: "Alle Standorte",
          resetToDefault: "{{name}} auf Standardfarbe zurücksetzen",
          resetToDefaultShort: "{{name}} zurücksetzen",
          colorsPersist: "Farben bleiben im Browser gespeichert",
          done: "Fertig",
          buckets: {
            early: { label: "Frühschicht", desc: "Morgen (vor 10:00)" },
            day: { label: "Tagschicht", desc: "Mittag (10:00 – 15:00)" },
            late: { label: "Spätschicht", desc: "Nachmittag (15:00 – 20:00)" },
            night: { label: "Nachtschicht", desc: "Übernacht (20:00 – 06:00)" },
            onCall: { label: "Bereitschaftsdienst", desc: "Standby / Rufbereitschaft" },
            break: { label: "Pause / Ruhe", desc: "Ruhezeit / Pause" },
          },
          shiftTitles: {
            early: "Frühschicht",
            day: "Tagschicht",
            late: "Spätschicht",
            night: "Nachtschicht",
            onCall: "Bereitschaftsdienst",
            onCallShort: "Bereitschaft",
            break: "Pause",
          },
          bulk: {
            appliedSummary: "{{count}} Schichten zugewiesen",
            appliedSummaryWithReplaced: "{{count}} Schichten zugewiesen ({{replaced}} überschrieben)",
            title: "Sammel-Schichtplanung & Automatisierung",
            subtitle: "Mehrpersonen-Schichten planen, wöchentliche Rhythmen wiederholen oder ganze Pläne nach vorne kopieren",
            batchTab: "Sammelplanung",
            cloneTab: "Plan kopieren",
            targetEmployees: "Ziel-Mitarbeiter",
            selectedCount: "{{count}} ausgewählt",
            allFilter: "Alle ({{count}})",
            searchEmployees: "Mitarbeiter nach Namen suchen...",
            selectAllFiltered: "Alle gefilterten auswählen ({{count}})",
            clear: "Leeren",
            hoursPerWeek: "{{hours}} Std./Wo.",
            dateRangeFirstCycle: "Zeitraum",
            from: "Von",
            to: "Bis",
            optionalNoEndDate: "Optional (oder Buttons unten nutzen)",
            clearToDate: "Enddatum entfernen",
            exceedsToDate: "Überschreitet gewähltes Enddatum (max. {{weeks}} Wo.)",
            scheduledViaButtons: "Gesteuert über Dauer-Buttons unten",
            manageTab: "Laufende & Erstellte Schichten",
            ongoingTitle: "Laufende Schichten (Heute aktiv)",
            ongoingActiveNow: "Jetzt aktiv",
            noOngoingNow: "Aktuell keine Schicht im Gang",
            noShiftsToday: "Keine Schichten für heute geplant",
            createdShiftsTitle: "Erstellte Schichten verwalten",
            manageSelectAll: "Alle auswählen",
            manageDeselectAll: "Auswahl aufheben",
            bulkDelete: "Ausgewählte löschen",
            bulkDeleteConfirm: "Möchten Sie wirklich {{count}} Schichten unwiderruflich löschen?",
            bulkDeleteSuccess: "{{count}} Schichten wurden erfolgreich gelöscht",
            deleteError: "Fehler beim Löschen der Schichten",
            deleteSingleConfirm: "Schicht von {{name}} am {{date}} wirklich löschen?",
            filterDateAll: "Alle Termine",
            filterDateToday: "Heute",
            filterDateWeek: "Diese Woche",
            filterDate4Weeks: "Nächste 30 Tage",
            ongoingShiftsCount: "Laufend",
            shiftsTodayCount: "Heute",
            totalShiftsCount: "Schichten insgesamt erfasst",
            activeDays: "Aktive Wochentage",
            monFri: "Mo–Fr",
            allSevenDays: "Alle 7 Tage",
            weekend: "Wochenende",
            repeatRecurrence: "Wiederholung",
            singlePeriod: "Einzelner Zeitraum",
            cyclesTotalDays: "{{cycles}} Zyklen ({{days}} Tage gesamt)",
            noRepeat: "Keine Wiederholung",
            everyWeek: "Jede Woche",
            everyTwoWeeks: "Alle 2 Wochen",
            repeatForDuration: "Wiederholen für:",
            cycles: "{{count}} Zyklen",
            weeks: "{{count}} Wochen",
            shiftTemplatePresets: "Schichtvorlagen & Presets",
            addPreset: "Preset hinzufügen",
            createPresetHint: "Neues Preset erstellen",
            resetPresetsHint: "Auf Standard-Presets zurücksetzen",
            editPresetFor: "Preset {{label}} bearbeiten",
            closeEdit: "Bearbeitung schließen",
            editPreset: "Preset bearbeiten:",
            save: "Speichern",
            presetName: "Preset-Name:",
            presetNamePlaceholder: "z. B. Früh (Early)",
            type: "Art:",
            times: "Zeiten:",
            time: "Zeit:",
            deletePreset: "Preset löschen",
            savedToBrowser: "In den Browser-Presets gespeichert",
            startTime: "Startzeit",
            endTime: "Endzeit",
            duration: "Dauer",
            regularShift: "Normale Schicht",
            onCallDuty: "Bereitschaftsdienst",
            overtime: "Überstunden",
            breakLabel: "Pause",
            shiftNote: "Schichtnotiz / Bezeichnung (optional)",
            shiftNotePlaceholder: "z. B. Standardrhythmus, Hochsaison-Rotation...",
            smartConflictCheck: "Intelligente Konfliktprüfung",
            conflictsDetected: "{{count}} Konflikte erkannt",
            smartConflictHint: "Überspringt automatisch Daten, an denen ein Mitarbeiter bereits eine Schicht oder eine genehmigte Abwesenheit (Urlaub, Krankheit) hat.",
            replaceExisting: "Bestehende Schichten an den Zieldaten ersetzen (überschreiben)",
            replaceExistingHint: "Wenn aktiviert, werden bestehende Schichten an diesen Daten durch die neuen Schichten ersetzt. Genehmigte Urlaube und Krankmeldungen bleiben geschützt.",
            willReplace: "{{count}} bestehende Schicht(en) werden ersetzt:",
            skippedConflicts: "Übersprungene Konflikte (Vorschau):",
            absenceDetail: "{{name}} am {{date}} (Abwesenheit: {{type}})",
            existingShiftDetail: "{{name}} am {{date}} (bestehende Schicht)",
            cloneEntireWeek: "Ganze Woche kopieren",
            cloneEntireWeekHint: "Alle Schichten einer vollen 7-Tage-Woche in die nächste(n) Woche(n) kopieren",
            cloneSingleDay: "Einzelnen Tag kopieren",
            cloneSingleDayHint: "Den Plan eines einzelnen Tages auf denselben Tag in der nächsten Woche(n) kopieren",
            sourceWeekStarting: "Quellwoche ab (Montag)",
            sourceDate: "Quelldatum",
            sourcePeriod: "Quellzeitraum: {{from}} bis {{to}} ({{count}} Schichten gefunden{{forEmployee}})",
            sourceDateInfo: "Quelldatum: {{date}} ({{count}} Schichten gefunden{{forEmployee}})",
            forEmployee: " für {{name}}",
            filterDepartment: "Abteilung filtern",
            singleEmployee: "Einzelner Mitarbeiter",
            allDepartments: "Alle Abteilungen ({{count}})",
            allEmployees: "Alle Mitarbeiter ({{count}})",
            sourceShiftsPreview: "Vorschau der Quellschichten",
            shiftCount: "{{count}} Schicht(en)",
            noShiftsOn: "Keine Schichten am {{date}} (Frei)",
            addShiftOn: "Schicht hinzufügen am {{date}}:",
            addShiftOnDayHint: "Schicht an diesem Tag hinzufügen",
            allocatedPeople: "Zugewiesene Personen für diese Schicht:",
            selectedOf: "{{selected}} von {{total}} ausgewählt",
            removeEmployee: "Mitarbeiter entfernen",
            removeEmployeeNamed: "{{name}} entfernen",
            selectPeople: "Personen auswählen",
            departmentMembers: "Abteilungsmitglieder",
            clearAll: "Alle abwählen",
            selectAll: "Alle auswählen",
            removeShift: "Schicht entfernen",
            editShiftRange: "Schicht {{start}} – {{end}} bearbeiten",
            deleteShiftRange: "Schicht {{start}} – {{end}} löschen",
            clearShiftsFor: "Schichten für {{day}} löschen",
            editDayShift: "{{day}}-Schicht bearbeiten",
            modified: "Geändert",
            clearAllShiftsDay: "Alle Schichten für diesen Tag löschen",
            dayOff: "Frei",
            off: "Frei",
            shiftShort: "{{count}} Sch.",
            copyForwardTo: "Nach vorne kopieren nach",
            plusWeeks: "+{{count}} Woche(n)",
            destinationStarts: "Ziel beginnt: {{date}}",
            through: " bis {{date}}",
            skipVacationConflicts: "Urlaubs-/Abwesenheitskonflikte überspringen",
            conflictsCount: "{{count}} Konflikte",
            skipVacationHint: "Mitarbeiter mit genehmigtem Urlaub oder Krankmeldung im Zielzeitraum werden automatisch vom Kopieren ausgeschlossen.",
            readyToSchedule: "Bereit zur Planung:",
            readyToClone: "Bereit zum Kopieren:",
            shiftsCount: "{{count}} Schichten",
            batchSummary: "({{employees}} Mitarbeiter · {{days}} Tage gesamt)",
            cloneSummary: "(aus {{count}} Quellschichten {{employee}}× {{weeks}} Woche(n))",
            scheduleShifts: "{{count}} Schichten planen",
            cloneShiftsForward: "{{count}} Schichten nach vorne kopieren",
            newPreset: "Neues Preset",
            dayLabel: "Tag",
          },
        },
        absences: {
          vacation: "Urlaub",
          sick: "Krankheit",
          training: "Aus-/Weiterbildung",
          other: "Sonstiges",
          compensatory: "Freizeitausgleich",
          submit: "Antrag stellen",
          myRequests: "Meine Anträge",
          pending: "Ausstehend",
          approved: "Genehmigt",
          rejected: "Abgelehnt",
          from: "Von",
          to: "Bis",
          type: "Art",
          status: "Status",
          noRequests: "Keine Anträge vorhanden",
          total: "Gesamt",
          taken: "Genommen",
          planned: "Geplant",
          remaining: "Resturlaub",
          reduced: "Abgebaut",
          days: "Tage",
          entitlement: "Anspruch",
          nextYear: "Nächstes Jahr",
          carryover: "Übertrag",
          remainingShort: "Rest",
          newAbsence: "Neue Abwesenheit",
          closeForm: "Abwesenheit schließen",
          showForm: "Neue Abwesenheit erfassen",
        },
        admin: {
          title: "Admin-Bereich",
          teamOverview: "Team-Übersicht",
          approve: "Genehmigen",
          reject: "Ablehnen",
          edit: "Bearbeiten",
          delete: "Löschen",
          addEntry: "Eintrag hinzufügen",
          employeeName: "Mitarbeitername",
          state: "Bundesland",
          role: "Rolle",
          actions: "Aktionen",
          planner: "Abwesenheiten",
          performRollover: "Jahreswechsel durchführen",
          editEntitlement: "Anspruch bearbeiten",
          editNextYear: "Nächstes Jahr bearbeiten",
          editCarryover: "Übertrag bearbeiten",
          timesheetsDesc: "Hier siehst du die genauen Stempelzeiten...",
        },
        time: {
          manualPause: "Pause manuell hinzufügen",
          editTime: "Zeit bearbeiten",
          missingEntry: "Fehlenden Eintrag hinzufügen",
          payoutButton: "Überstunden auszahlen",
          payoutModalTitle: "Überstunden auszahlen",
          payoutModalSubtitle: "Auszahlung reduziert das Zeitkonto um die angegebenen Stunden.",
          payoutHoursLabel: "Stunden auszahlen",
          payoutCommentLabel: "Kommentar / Abrechnungsmonat",
          payoutCommentPlaceholder: "z. B. Auszahlung Lohnabrechnung Oktober 2026",
          payoutNegativeWarning: "Achtung: Das Zeitkonto fällt dadurch ins Minus ({{after}}).",
          payoutConfirmButton: "Auszahlung buchen",
          payoutSuccessToast: "Überstunden-Auszahlung gebucht",
          thresholdWarning: "Zeitkonto außerhalb des Schwellenwerts (±20 Std.)",
          thresholdHigh: "Hohes Überstundenguthaben (≥ +20 Std.)",
          thresholdHighHint: "Überstundengrenze (+50h) überschritten",
          thresholdLowHint: "Minusstundengrenze (-10h) überschritten",
          thresholdLow: "Hohes Minusstundensaldo (≤ −20 Std.)",
          comment: "Kommentar",
          hours: "Stunden",
          minutes: "Minuten",
          save: "Speichern",
          cancel: "Abbrechen",
        },
        payout: {
          title: "Überstunden-Auszahlung",
          currentBalance: "Aktuelles Zeitkonto",
          amountLabel: "Auszahlungsstunden",
          dateLabel: "Auszahlungsdatum",
          commentLabel: "Verwendungszweck / Grund",
          commentPlaceholder: "z. B. Überstundenauszahlung Monatsabrechnung",
          deficitWarning: "Achtung: Diese Auszahlung übersteigt das vorhandene Zeitguthaben und führt zu Minusstunden auf dem Zeitkonto.",
          balanceAfter: "Zeitkonto nach Auszahlung",
          submit: "Auszahlung buchen",
        },
        loading: "Lade Personalwesen...",
        absence: "Abwesenheit",
        absenceRequestUpdate: "Abwesenheitsantrag aktualisiert",
        adminUpdateError: "Fehler beim Aktualisieren: {{message}}",
        employeeAdded: "Mitarbeiter hinzugefügt",
        employeeAddError: "Fehler beim Hinzufügen: {{message}}",
        duplicateEmailError: "Ein Mitarbeiter mit dieser E-Mail existiert bereits in diesem Mandanten.",
        settingsSaved: "Einstellungen gespeichert",
        settingsSaveError: "Fehler beim Speichern der Einstellungen: {{message}}",
        newEmployee: "Neuer Mitarbeiter",
        employeeNumber: "Personalnummer",
        department: "Abteilung",
        position: "Position",
        startDate: "Eintrittsdatum",
        endDate: "Austrittsdatum",
        contract: "Vertrag",
        vacation: "Urlaub",
        sick: "Krank",
        training: "Schulung",
        actions: {
          clockIn: "Kommen",
          clockOut: "Gehen",
          break: "Pause",
          manualPause: "Pause (manuell)",
          correction: "Korrektur",
          other: "Sonstige",
        },
        coverage: {
          understaffed: "Unterbesetzung",
          sufficient: "Ausreichend besetzt",
          fullCoverage: "Voll besetzt",
          alertDepts: "Unterbesetzung-Alert:",
          weekBack: "Eine Woche zurück",
          weekForward: "Eine Woche vor",
          hide: "Abdeckung ausblenden",
          show: "Abdeckung einblenden",
          hideCoverage: "Abdeckung ausblenden",
          showCoverage: "Abdeckung einblenden",
        },
        permissions: {
          noAccess: "Keine Berechtigung",
          adminOnly: "Nur für Administratoren",
        },
        addUser: {
          personType: "Personentyp",
          personTypeFull: "Mit Login",
          personTypeHr: "Nur HR-Person",
          hoursPerDay: "Stunden pro Tag",
        hoursPerWeek: "Stunden pro Woche",
        hoursPerWeekHint: "{{hours}} Std./Wo. verteilt auf {{days}} Arbeitstage ≈ {{perDay}} Std./Tag",
        weeklyHours: "Wochenstunden",
        workdaysSplitHint: "{{hours}} Std./Wo. verteilt auf {{days}} Arbeitstage ≈ {{perDay}} Std./Tag",
          workdays: "Arbeitstage",
          workdaysHint: "Wähle die primären Arbeitstage",
          noLoginWarning: "Diese Person hat keinen Login — alle Aktionen werden durch eine Führungskraft ausgeführt.",
        },
        adminClockOnBehalf: "Stempeln für",
        adminClockOnBehalfHint: "Als Führungskraft für diesen Mitarbeiter stempeln",
        dienstplan: {
          title: "Dienstplan",
          readOnlyHint: "Nur-Lese-Ansicht — Klicke auf einen Tag, um einen Kommentar für das Team zu hinterlassen.",
          commentPlaceholder: "Kommentar zu diesem Tag schreiben...",
          commentSave: "Kommentar speichern",
          commentDelete: "Kommentar löschen",
          filterEmployees: "Mitarbeiter filtern",
          allEmployees: "Alle Mitarbeiter",
        },
        shiftAssign: {
          title: "Schicht zuweisen",
          saved: "Schicht gespeichert",
          removed: "Schicht entfernt",
          notFound: "Schicht nicht gefunden — bitte Seite neu laden",
          startTime: "Beginn",
          endTime: "Ende",
          note: "Notiz (optional)",
        },
      },
      toasts: {
        success: "Erfolg",
        error: "Fehler",
        saved: "Gespeichert",
        savedLocal: "Gespeichert (Lokal)",
        kassenbuch: {
          noJournalPermission: "Keine Berechtigung für das Journal",
          noCounterPermission: "Keine Berechtigung für den Kassenzähler",
          periodLocked: "Dieser Zeitraum ist festgeschrieben. Belege können nicht mehr verändert werden.",
          periodLockedNewEntry: "Dieser Zeitraum ist festgeschrieben. Neue Buchungen sind nicht mehr zulässig.",
          receiptUploaded: "Beleg erfolgreich hochgeladen",
          receiptUploadedLocal: "Beleg hochgeladen (Lokal)",
          receiptUploadError: "Fehler beim Beleg-Upload: {{message}}",
          invoiceNotFound: "Rechnung nicht gefunden oder Zugriff verweigert.",
          invoiceFetchError: "Fehler beim Laden der Rechnung: {{message}}",
          confirmDeleteReceipt: "Möchten Sie diesen Beleg wirklich löschen?",
          receiptDeleted: "Beleg erfolgreich gelöscht",
          receiptDeletedLocal: "Beleg gelöscht (Lokal)",
          receiptDeleteError: "Fehler beim Löschen des Belegs: {{message}}",
          settingsSaved: "Einstellungen erfolgreich gespeichert",
          settingsSavedLocal: "Einstellungen gespeichert (Lokal)",
          settingsSaveError: "Fehler beim Speichern der Einstellungen: {{message}}",
          entryAdded: "Buchung erfolgreich hinzugefügt",
          entryAddedLocal: "Buchung hinzugefügt (Lokal)",
          entryAddError: "Fehler beim Hinzufügen der Buchung: {{message}}",
          confirmCancelEntry: "Eintrag stornieren? Es wird eine GoBD-konforme Gegenbuchung im aktuellen Zeitraum erzeugt. Der Originalbeleg bleibt dauerhaft im Journal sichtbar.",
          entryCancelled: "Eintrag erfolgreich storniert",
          entryCancelledLocal: "Eintrag storniert (Lokal)",
          entryCancelError: "Fehler beim Stornieren: {{message}}",
          confirmLockPeriod: "Möchten Sie diesen Monat wirklich festschreiben? Danach können KEINE weiteren Buchungen mehr vorgenommen oder storniert werden. Dies ist gesetzlich unumkehrbar!",
          periodLockedSuccess: "Monat erfolgreich festgeschrieben",
          periodLockedSuccessLocal: "Monat erfolgreich festgeschrieben (Lokal)",
          periodLockError: "Fehler beim Festschreiben: {{message}}",
          counterUpdatedLocal: "Zähler aktualisiert (Lokal)",
          excelExportSuccess: "Excel-Export erfolgreich",
          datevExportSuccess: "DATEV-CSV-Export erfolgreich",
          saveError: "Fehler beim Speichern: {{message}}",
        },
        hr: {
          clockError: "Fehler beim Stempeln: {{message}}",
          saved: "Gespeichert",
          savedLocal: "Gespeichert (Lokal)",
          requestSubmitted: "Antrag erfolgreich eingereicht",
          requestSubmitError: "Fehler beim Einreichen: {{message}}",
          approved: "Antrag genehmigt",
          rejectConfirm: "Antrag wirklich ablehnen?",
          rejected: "Antrag abgelehnt",
          deleteConfirm: "Eintrag wirklich löschen?",
          deleted: "Eintrag gelöscht",
          deleteError: "Fehler beim Löschen: {{message}}",
          pauseAdded: "Pause hinzugefügt",
          pauseAddError: "Fehler beim Hinzufügen der Pause: {{message}}",
          timeSaved: "Zeit gespeichert",
          timeSaveError: "Fehler beim Speichern der Zeit: {{message}}",
          missingEntryAdded: "Fehlender Eintrag hinzugefügt",
          missingEntryError: "Fehler beim Hinzufügen: {{message}}",
          rolloverDone: "Jahreswechsel durchgeführt",
          rolloverError: "Fehler beim Jahreswechsel: {{message}}",
        },
        loginFailed: "Anmeldung fehlgeschlagen: {{message}}",
      },
      bookingDrawer: {
        newBooking: "Neue Buchung",
        step1Availability: "Schritt 1: Verfügbarkeit",
        step2GuestData: "Schritt 2: Gastdaten",
        success: "Erfolgreich!",
        reservationCreatedPrefix: "Reservierung",
        reservationCreatedSuffix: "erstellt.",
        cancellationPolicyAndRate: "Stornierungsbedingungen & Rate",
        bookedRate: "Gebuchte Rate",
        conditions: "Bedingungen",
        loadingCancellationPolicy: "Stornierungsbedingungen werden geladen...",
        linkCompany: "Firma verknüpfen (optional)",
        searchCompany: "Firma suchen...",
        noCompanyFound: "Keine Firma gefunden",
        reservationComment: "Kommentar zur Reservierung",
        commentPlaceholder: "z.B. Late Check-in, Hund dabei...",
        saveComment: "Kommentar speichern",
        bookExtrasServices: "Extras / Services buchen",
        quantity: "Anzahl",
        price: "Preis (EUR)",
        addService: "Service hinzufügen",
        searchService: "Service suchen...",
        noServices: "Keine Services",
        closeWindow: "Fenster schließen",
        searchExistingGuest: "Bestehenden Gast suchen (optional)",
        nameOrEmail: "Name oder Email...",
        crmHistory: "CRM-Historie",
        regularGuest: "Stammgast",
        apaleoSearch: "Apaleo Suche...",
        apaleoHistory: "Apaleo Historie",
        apaleoGuest: "Apaleo-Gast",
        noEmail: "Keine Email",
        external: "Extern",
        guestBlocked: "Gast gesperrt",
        guestBlockedDescription: "Dieser Gast steht auf der internen Blacklist. Buchungen sind nicht gestattet.",
        hotel: "Hotel",
        persons: "Personen",
        arrival: "Anreise",
        departure: "Abreise",
        checkAvailability: "Verfügbarkeit prüfen",
        searchingOffers: "Suche Angebote...",
        startSearchPrompt: "Suche starten, um verfügbare Zimmer zu sehen",
        noOffersFound: "Keine Angebote gefunden. Bitte Zeitraum oder Personen anpassen.",
        room: "Zimmer",
        companyRates: "Firmenraten",
        select: "Auswählen",
        availableCategories: "Verfügbare Kategorien",
        fromPrice: "Ab {{price}} {{currency}}",
        fromPrice_other: "Ab {{price}} {{currency}}",
        back: "Zurück",
        ratesAvailable: "{{count}} Rate verfügbar",
        ratesAvailable_other: "{{count}} Raten verfügbar",
        selectRate: "Wählen",
        backToSelection: "Zurück zur Auswahl",
        selectedOffer: "Ausgewähltes Angebot",
        nights: "Nächte",
        totalPrice: "Gesamtpreis",
        manualPricePerNight: "Manueller Preis pro Nacht",
        manualPriceDescription: "Überschreibe den Standardpreis für diesen Aufenthalt",
        newTotalPrice: "Neuer Gesamtpreis:",
        confirmGuestData: "Gastdaten bestätigen",
        internalGuestNote: "Interne Gastnotiz",
        createTaskFromNote: "Task aus Notiz erstellen?",
        department: "Abteilung",
        startFrom: "Erledigen ab",
        endBy: "Erledigen bis",
        firstName: "Vorname *",
        lastName: "Nachname *",
        email: "E-Mail Adresse",
        phone: "Telefonnummer",
        address: "Anschrift (Optional)",
        street: "Straße & Hausnummer",
        postalCode: "PLZ",
        city: "Stadt",
        countryCode: "Land (ISO-Code)",
        confirmBooking: "Verbindlich buchen",
        unknown: "Unbekannt",
        fillAllFields: "Bitte fülle alle Felder aus",
        offerSearchError: "Fehler bei der Angebotssuche: {{error}}",
        requiredFields: "Vor- und Nachname sind Pflichtfelder!",
        noOfferSelected: "Kein Angebot ausgewählt",
        bookingCreated: "Buchung {{bookingId}} wurde erfolgreich erstellt",
        taskCreated: "Task für Anreisetag wurde erstellt",
        preferredRoomAssignmentError: "Wunschzimmer {{preferredRoom}} konnte nicht zugewiesen werden.",
        bookingError: "Fehler bei der Buchung: {{message}}",
        commentSaved: "Kommentar gespeichert",
        saveError: "Fehler beim Speichern: {{message}}",
        companyLinkedFolioFailed: "Firma verknüpft, aber Folio-Update fehlgeschlagen",
        companyLinked: "Firma erfolgreich verknüpft",
        linkError: "Fehler beim Verknüpfen: {{message}}",
        serviceBookingError: "Fehler beim Buchen des Services: {{message}}",
        vip: "VIP",
        blacklist: "Blacklist",
      },
      offerDrawer: {
        editOffer: "Angebot bearbeiten",
        newOffer: "Neues Angebot",
        step2GuestDataAndPrice: "Schritt 2: Gastdaten & Preis",
        step1Availability: "Schritt 1: Verfügbarkeit",
        offerUpdated: "Angebot aktualisiert!",
        offerCreated: "Angebot erstellt!",
        copyLink: "Link kopieren",
        linkCopied: "Link kopiert!",
        searchExistingGuest: "Bestehenden Gast suchen (optional)",
        nameOrEmail: "Name oder Email...",
        crmHistory: "CRM-Historie",
        regularGuest: "Stammgast",
        apaleoSearch: "Apaleo Suche...",
        apaleoHistory: "Apaleo Historie",
        noEmail: "Keine Email",
        external: "Extern",
        guestBlocked: "Gast gesperrt",
        guestBlockedDescription: "Dieser Gast steht auf der internen Blacklist.",
        hotel: "Hotel",
        persons: "Personen",
        arrival: "Anreise",
        departure: "Abreise",
        children: "Kinder",
        validUntil: "Gültig bis",
        checkAvailability: "Verfügbarkeit prüfen",
        searchingOffers: "Suche Angebote...",
        startSearchPrompt: "Suche starten, um verfügbare Zimmer zu sehen",
        noOffersFound: "Keine Angebote gefunden. Bitte Zeitraum oder Personen anpassen.",
        room: "Zimmer",
        companyRates: "Firmenraten",
        standardRate: "Standard Rate",
        standard: "Standard",
        select: "Auswählen",
        availableCategories: "Verfügbare Kategorien",
        fromPrice: "Ab {{price}} {{currency}}",
        fromPrice_other: "Ab {{price}} {{currency}}",
        back: "Zurück",
        ratesAvailable: "{{count}} Rate verfügbar",
        ratesAvailable_other: "{{count}} Raten verfügbar",
        choose: "Wählen",
        backToSelection: "Zurück zur Auswahl",
        selectedCategory: "Ausgewählte Kategorie",
        nights: "{{count}} Nacht",
        nights_other: "{{count}} Nächte",
        totalPrice: "Gesamtpreis",
        netTotal: "Netto (ohne MwSt.)",
        manualPricePerNight: "Manueller Preis pro Nacht",
        manualPriceDescription: "Überschreibe den Standardpreis für diesen Aufenthalt",
        newTotalPrice: "Neuer Gesamtpreis:",
        guestDataAndDetails: "Gastdaten & Details",
        internalGuestNote: "Interne Gastnotiz",
        createTaskFromNote: "Task aus Notiz erstellen?",
        departmentLabel: "Abteilung",
        department: {
          Rezeption: "Rezeption",
          Housekeeping: "Housekeeping",
          Haustechnik: "Haustechnik",
          Management: "Management",
          Sales: "Sales"
        },
        startFrom: "Erledigen ab",
        endBy: "Erledigen bis",
        firstName: "Vorname *",
        lastName: "Nachname *",
        email: "E-Mail Adresse *",
        phone: "Telefonnummer",
        address: "Anschrift (Optional)",
        street: "Straße & Hausnummer",
        postalCode: "PLZ",
        city: "Stadt",
        countryCode: "Land (ISO-Code)",
        internalNote: "Interne Notiz",
        internalNotePlaceholder: "Interne Anmerkungen zum Angebot...",
        guestMessage: "Nachricht an Gast",
        guestMessagePlaceholder: "Diese Nachricht wird dem Gast im Angebot angezeigt...",
        offerLanguage: "Sprache der Angebotsseite",
        languageGerman: "Deutsch",
        languageEnglish: "Englisch",
        offerLanguageHint: "Bestimmt, in welcher Sprache der Gast die Angebotsseite sieht.",
        cancellationPolicy: "Stornierungsbedingungen",
        linkCompany: "Firma verknüpfen (optional)",
        searchCompany: "Firma suchen...",
        noCompanyFound: "Keine Firma gefunden",
        updateOffer: "Angebot aktualisieren",
        createOffer: "Angebot erstellen",
        fillAllFields: "Bitte fülle alle Felder aus",
        offerSearchError: "Fehler bei der Angebotssuche: {{error}}",
        requiredFields: "Vorname, Nachname und E-Mail sind Pflichtfelder!",
        noCategorySelected: "Keine Kategorie ausgewählt",
        enterValidPrice: "Bitte gib einen gültigen Preis ein",
        selectValidUntil: "Bitte wähle ein Gültigkeitsdatum",
        offerCreationError: "Fehler beim Erstellen des Angebots",
        genericError: "Fehler: {{message}}",
        linkFallback: "Link: {{url}}",
        discount: "Rabatt",
        discountPercent: "Rabatt in %",
        discountAmount: "Rabattbetrag",
        voucher: "Gutschein",
        voucherCode: "Gutscheincode",
        voucherApplied: "Gutschein angewendet",
        voucherInvalid: "Ungültiger Gutscheincode",
        voucherExpired: "Gutschein abgelaufen",
        addons: "Zusatzleistungen",
        addonBreakfast: "Frühstück",
        addonParking: "Parkplatz",
        addonWifi: "WLAN",
        addonSpa: "Spa-Zugang",
        addonPet: "Haustier",
        totalWithAddons: "Gesamtpreis inkl. Zusatzleistungen",
        ratePlan: "Ratenplan",
        mealPlan: "Verpflegung",
        mealBreakfast: "Frühstück inklusive",
        mealHalfBoard: "Halbpension",
        mealFullBoard: "Vollpension",
        mealNone: "Ohne Verpflegung",
        cancellation: "Stornierung",
        cancellationFree: "Kostenlose Stornierung",
        cancellationNonRefundable: "Nicht erstattbar",
        cancellationPolicyShort: "Bis 24h vor Anreise kostenlos stornierbar",
        payNow: "Jetzt zahlen",
        payOnArrival: "Zahlung bei Anreise",
        payAtHotel: "Zahlung im Hotel",
        paymentMethod: "Zahlungsweise",
        specialRequests: "Besondere Wünsche",
        specialRequestsPlaceholder: "z.B. Allergien, späte Anreise...",
        arrivalTime: "Anreisezeit",
        estimatedArrival: "Voraussichtliche Anreise",
        departureTime: "Abreisezeit",
        sendOfferEmail: "Angebot per E-Mail senden",
        offerSent: "Angebot per E-Mail versendet",
        offerSentError: "Fehler beim Versenden der E-Mail",
        copyOffer: "Angebot duplizieren",
        offerDuplicated: "Angebot dupliziert",
        deleteOffer: "Angebot löschen",
        confirmDeleteOffer: "Angebot wirklich löschen?",
        offerDeleted: "Angebot gelöscht",
        offerDeletedError: "Fehler beim Löschen des Angebots",
        expireOffer: "Angebot verfallen",
        offerExpired: "Angebot abgelaufen",
        regenerateLink: "Link neu generieren",
        regenerateLinkConfirm: "Bisheriger Link wird ungültig. Fortfahren?",
        linkRegenerated: "Link neu generiert",
        printOffer: "Angebot drucken",
        pdfDownload: "Als PDF herunterladen",
        language: "Sprache",
        languageDE: "Deutsch",
        languageEN: "Englisch",
        editCutoffTitle: "Cut-off-Datum bearbeiten",
        editCutoffSubtitle: "Nur das Gültigkeitsdatum kann noch geändert werden",
        amendNoticeTitle: "Angebot anpassen",
        amendNotice: "Dieses Angebot wurde bereits an den Gast gesendet. Änderungen (Termine, Zimmer, Preise) sind sofort auf der Angebotsseite des Gastes sichtbar; die Verfügbarkeit wird erst bei der Bestätigung durch den Gast geprüft. Die Gästedaten bleiben unverändert.",
        cutoffEditNotice: "Angebot bereits versendet",
        cutoffEditNoticeDescription: "Dieses Angebot wurde bereits an den Gast gesendet. Es können keine Angebotsdetails mehr geändert werden, aber das Cut-off-Datum lässt sich verlängern oder verkürzen.",
        cutoffHelp: "Wähle ein neues Datum inkl. Uhrzeit, bis zu dem der Gast das Angebot annehmen kann.",
        cutoffSave: "Neues Cut-off speichern",
        cutoffUpdated: "Cut-off-Datum aktualisiert",
        offerNumber: "Angebotsnummer",
      },
      offersView: {
        title: "Angebote",
        subtitle: "Angebotsverwaltung & Gästebestätigungen",
        newOffer: "Neues Angebot",
        all: "Alle",
        searchPlaceholder: "Nach Gast, E-Mail oder Angebotsnummer suchen...",
        shareLinkPrompt: "Angebot versendet! Teilen Sie diesen Link mit dem Gast:",
        copy: "Kopieren",
        copied: "Kopiert!",
        noMatchingOffers: "Keine passenden Angebote",
        noOffersYet: "Noch keine Angebote",
        adjustFilters: "Filter anpassen",
        createFirstOffer: "Erstellen Sie das erste Angebot",
        send: "Senden",
        amendOffer: "Angebot anpassen",
        editCutoff: "Cut-off-Datum bearbeiten",
        copyLink: "Link kopieren",
        bookingError: "Buchungsfehler",
        editOffer: "Angebot bearbeiten",
        arrival: "Anreise",
        departure: "Abreise",
        guests: "Gäste",
        adults: "Erwachsene",
        children: "Kinder",
        location: "Standort",
        category: "Kategorie",
        rate: "Rate",
        totalPrice: "Gesamtpreis",
        cityTaxIncluded: "Darin City Tax",
        company: "Firma",
        createdAt: "Erstellt am",
        validUntil: "Gültig bis",
        statusLabel: "Status",
        clockSuffix: "Uhr",
        autoExpired: "Aus dem Cut-off-Datum automatisch erkannt",
        messageToGuest: "Nachricht an Gast",
        internalNotes: "Interne Notizen",
        section: {
          stay: "Aufenthalt",
          services: "Leistungen",
          guestDetails: "Gastdetails",
          offerData: "Angebotsdaten"
        },
        status: {
          draft: "Entwurf",
          sent: "Gesendet",
          expired: "Abgelaufen",
          converted: "Gebucht"
        }
      },
      guestProfile: {
        guestProfile: "Gästeprofil",
        reservationDetails: "Reservierungsdetails",
        autoAssign: "Auto zuweisen",
        noRoom: "Kein Zimmer",
        roomAbbr: "Zi.",
        stays: "Aufenthalte",
        noEmail: "Keine Email",
        noPhone: "Keine Telefonnummer",
        copyName: "Name kopieren",
        copyResId: "Reservierungs-ID kopieren",
        copyNameBtn: "Name",
        copyResIdBtn: "ID",
        nameCopied: "Name kopiert",
        resIdCopied: "Reservierungs-ID kopiert",
        guestStatus: "Gast-Status",
        statusRegular: "Stammgast",
        statusVip: "VIP",
        statusBlacklist: "Blacklist",
        blacklistReasonRequired: "Sperrgrund (Pflichtfeld) *",
        blacklistReasonPlaceholder: "Warum wird dieser Gast gesperrt?",
        companyRates: "Firmenraten / Verknüpfungen",
        searchRate: "Rate suchen...",
        loadingRates: "Lade Ratenpläne...",
        noRatesFound: "Keine Ratenpläne gefunden.",
        noSearchResults: "Nichts gefunden.",
        general: "Generell",
        address: "Adresse",
        street: "Strasse & Hausnummer",
        streetPlaceholder: "Musterstrasse 1",
        postalCode: "PLZ",
        postalCodePlaceholder: "12345",
        city: "Stadt",
        cityPlaceholder: "Berlin",
        countryCode: "Ländercode",
        countryCodePlaceholder: "DE",
        internalNotes: "Interne Notizen",
        notesPlaceholder: "Wichtige Hinweise zum Gast...",
        preferredRoom: "Wunschzimmer",
        preferredRoomDescription: "Gib die Zimmernummer des bevorzugten Zimmers an. Bei einer neuen Buchung wird dieses Zimmer automatisch zugewiesen.",
        preferredRoomPlaceholder: "z.B. 101",
        cleaningPlanning: "Reinigungs-Planung",
        cleaningActive: "Aktiv",
        cleaningDescription: "Wähle einen festen Reinigungstag für diesen Aufenthalt. Die Reinigung erscheint dann automatisch im Housekeeping-Plan.",
        history: "Aufenthalte",
        noHistory: "Keine Historie",
        current: "Aktuell",
        newBooking: "Neue Buchung",
        close: "Schließen",
        save: "Speichern",
        cancel: "Abbrechen",
        blacklistReasonMissing: "Bitte gib einen Grund für die Blacklist-Sperre an",
        profileSaved: "Gästekartei gespeichert",
        saveError: "Fehler beim Speichern: {{message}}",
        cleaningSaveError: "Fehler beim Speichern der Reinigung",
        monday: "Montag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        saturday: "Samstag",
        sunday: "Sonntag",
        allLocations: "Alle Standorte",
        edit: "Bearbeiten",
        removeRate: "Rate entfernen",
        externalIds: "Externe IDs",
        externalCodeLabel: "External Code",
        extRefGlobalDistributionSystemId: "GDS-ID",
        extRefOnlineTravelAgencyId: "OTA-ID",
        extRefOnlineBookingToolId: "Online-Buchungstool",
        extRefChannelManagerId: "Channel-Manager",
        extRefCentralReservationSystemId: "Zentrales Reservierungssystem",
        extRefLegacyId: "Legacy-ID",
        resNights: "Nächte",
        resCategory: "Kategorie",
        resRatePlan: "Ratenplan",
        resSource: "Quelle",
        resSourceDirect: "Direkt",
        resCityTax: "City Tax",
        resTotalWithTax: "Gesamt inkl. City Tax",
        resExtras: "Extras & Zusatzleistungen",
        folioTab: "Folio & Rechnungen",
        folioNoFolios: "Keine Folios für diese Reservierung vorhanden.",
        folioMain: "Hauptfolio",
        folioSecondary: "Unterfolio",
        folioBalance: "Saldo",
        folioStatusOpen: "Offen",
        folioStatusClosed: "Geschlossen",
        folioStatusClosedWithInvoice: "Mit Rechnung",
        folioCharges: "Positionen",
        folioNoCharges: "Keine Positionen",
        folioAllowances: "Gutschriften",
        folioPayments: "Zahlungen",
        folioInvoices: "Rechnungen",
        folioPosted: "Gebucht",
        folioUnposted: "Nicht gebucht",
        folioRoutedTo: "Weitergeleitet",
        folioMovedTo: "Verschoben",
        folioAddCharge: "Position buchen",
        folioAddPayment: "Zahlung erfassen",
        folioCreateInvoice: "Rechnung erstellen",
        folioCloseFolio: "Folio schließen",
        folioReopenFolio: "Folio wieder öffnen",
        folioChargeName: "Bezeichnung",
        folioServiceType: "Service-Typ",
        folioVatType: "USt-Typ",
        folioAmount: "Betrag",
        folioQty: "Menge",
        folioPaymentMethod: "Zahlungsmethode",
        folioReceipt: "Beleg-Nr. (optional)",
        folioSave: "Buchen",
        folioCancel: "Abbrechen",
        folioChargeSuccess: "Position erfolgreich gebucht.",
        folioPaymentSuccess: "Zahlung erfolgreich erfasst.",
        folioInvoiceSuccess: "Rechnung erstellt.",
        folioCloseSuccess: "Folio geschlossen.",
        folioReopenSuccess: "Folio wieder geöffnet.",
        folioActionError: "Aktion fehlgeschlagen: {{message}}",
        folioConfirmInvoice: "Rechnung für dieses Folio erstellen?",
        folioConfirmClose: "Folio wirklich schließen? Dies kann nicht rückgängig gemacht werden.",
        folioConfirmReopen: "Folio wieder öffnen?",
        folioPdfError: "PDF konnte nicht geladen werden.",
        folioCorrectCharge: "Position korrigieren",
        folioCorrectChargeAmount: "Korrekturbetrag",
        folioCorrectChargeReason: "Grund",
        folioCorrectChargeHint: "Es wird eine Gutschrift (Allowance) auf diese Position gebucht. Der Betrag darf die Position nicht überschreiten.",
        folioCorrectChargePost: "Gutschrift buchen",
        folioCorrectChargeSuccess: "Korrektur (Gutschrift) erfolgreich gebucht.",
        folioEditDebitor: "Rechnungsempfänger bearbeiten",
        folioEditDebitorType: "Empfänger-Typ",
        folioEditDebitorPerson: "Gast (Privatperson)",
        folioEditDebitorCompany: "Firma",
        folioEditDebitorCompanyName: "Firmenname",
        folioEditDebitorFirstName: "Vorname",
        folioEditDebitorLastName: "Nachname",
        folioEditDebitorAddress: "Adresse",
        folioEditDebitorStreet: "Straße & Nr.",
        folioEditDebitorZip: "PLZ",
        folioEditDebitorCity: "Ort",
        folioEditDebitorSave: "Speichern",
        folioEditDebitorSuccess: "Rechnungsempfänger aktualisiert.",
        folioEditDebitorNoChanges: "Keine Änderungen zu speichern.",
        folioBusinessDate: "Leistungsdatum",
        folioService: "Leistung",
        folioNoChargesOnFolio: "Keine Leistungen auf diesem Folio.",
        folioHasRoutedOutCharges: "Dieses Folio hat weitergeleitete Leistungen.",
        folioShowAllCharges: "Alle Folio-Leistungen anzeigen",
        folioShowMore: "Mehr anzeigen",
        folioShowLess: "Weniger anzeigen",
        folioShownOf: "{{shown}} von {{total}}",
        folioShowN: "{{count}} anzeigen",
        folioShowAllCount: "Alle anzeigen ({{count}})",
        folioMoveChargeShort: "Umbuchen...",
        folioCorrectChargeShort: "Korrigieren...",
        folioBillingDetails: "Rechnungsdetails",
        folioCustomDetails: "Eigene Angaben",
        folioBooker: "Bucher",
        folioNoName: "Kein Name",
        folioCountryGermany: "Deutschland",
        folioEdit: "Bearbeiten",
        folioAddBillingDetails: "Rechnungsadresse hinzufügen",
        folioNoBillingAddress: "Keine Rechnungsadresse",
        folioRoutedIn: "Routing eingehend",
        folioRoutedOut: "Routing ausgehend",
        folioActions: "Aktionen",
        folioMustBalance: "Folio muss ausgeglichen sein (0,00 EUR)",
        folioCloseShort: "Schließen",
        folioDownloadInvoice: "Rechnung herunterladen",
        folioDocuments: "Dokumente",
        folioNoDocuments: "Keine Rechnungsdokumente vorhanden",
        folioPaymentDate: "Zahlungsdatum",
        folioMethodReceipt: "Methode / Beleg",
        folioStatus: "Status",
        folioPaymentsCount: "Zahlungen ({{count}})",
        folioNoPayments: "Auf diesem Folio sind keine Zahlungen gebucht.",
        folioPaymentDefault: "Zahlung",
        folioRecordPayment: "Zahlung erfassen",
        folioCorrection: "Korrektur",
        folioBookerLabel: "Buchender (Booker)",
        folioNotAvailable: "Nicht vorhanden",
        folioTitleMs: "Frau",
        folioTitleMr: "Herr",
        folioTitleDr: "Dr.",
        folioTitleProf: "Prof.",
        folioTitleOther: "Divers",
        folioOtherOption: "Sonstiges",
        extrasAddTitle: "Extra hinzufügen",
        extrasEditTitle: "Extra bearbeiten",
        extrasPickService: "Leistung wählen",
        extrasSearchPlaceholder: "Leistung suchen…",
        extrasNoServices: "Keine buchbaren Leistungen für diese Unterkunft gefunden.",
        extrasCount: "Anzahl",
        extrasPricePerUnit: "Preis pro Einheit",
        extrasAdd: "Hinzufügen",
        extrasSave: "Speichern",
        extrasRemove: "Entfernen",
        extrasConfirmRemove: "Diese Zusatzleistung wirklich entfernen? Dies kann nicht rückgängig gemacht werden.",
        extrasAdded: "Zusatzleistung hinzugefügt.",
        extrasUpdated: "Zusatzleistung aktualisiert.",
        extrasRemoved: "Zusatzleistung entfernt.",
        extrasRebookFailed: "Zusatzleistung wurde entfernt, aber die Neubuchung schlug fehl — bitte manuell erneut hinzufügen.",
        extrasEmpty: "Keine Zusatzleistungen gebucht.",
        resCommentEdit: "Kommentar bearbeiten",
        resCommentSaved: "Kommentar gespeichert.",
        resCommentError: "Kommentar konnte nicht gespeichert werden: {{message}}",
        svcType: {
            Other: "Sonstiges",
            Accommodation: "Unterkunft",
            FoodAndBeverages: "Gastronomie",
            CityTax: "City Tax",
            SecondCityTax: "City Tax II",
            CancellationFees: "Stornogebühren",
            NoShow: "No-Show",
            LocalTax: "Örtliche Steuer",
            ConsumptionTax: "Verbrauchssteuer",
        },
        vatType: {
            Null: "0 %",
            VeryReduced: "Ermäßigt (stark)",
            Reduced: "Ermäßigt",
            Normal: "Regulär",
            Without: "Ohne",
            Special: "Sonder",
        },
        payMethod: {
            PaymentAccount: "Zahlungskonto",
            Cash: "Bar",
            BankTransfer: "Überweisung",
            CreditCard: "Kreditkarte",
            VisaCredit: "Visa (Kredit)",
            VisaDebit: "Visa (Debit)",
            MasterCard: "Mastercard",
            Maestro: "Maestro",
            GiroCard: "Girocard",
            PayPal: "PayPal",
            Voucher: "Gutschein",
            Cheque: "Scheck",
            Other: "Sonstige",
        },
        folioPayAccount: {
            select: "Zahlungskonto",
            selectPlaceholder: "Zahlungskonto wählen…",
            loading: "Zahlungskonten werden geladen…",
            loadError: "Zahlungskonten konnten nicht geladen werden.",
            empty: "Für diese Reservierung ist kein Zahlungskonto hinterlegt.",
            asyncHint: "Die Zahlung wird über das Zahlungskonto verarbeitet. Der Folio-Saldo aktualisiert sich, sobald Apaleo die Zahlung bestätigt (Status: Ausstehend).",
            success: "Zahlung über Zahlungskonto ausgelöst.",
            error: "Zahlung über Zahlungskonto fehlgeschlagen. Bitte erneut versuchen.",
        },
        payStatus: {
            Pending: "Ausstehend",
            Success: "Erfolgreich",
            Failure: "Fehlgeschlagen",
            Canceled: "Storniert",
        },
        resCompany: "Firma",
        resAdults: "Erwachsene",
        resChildren: "Kinder",
        resPriceDetails: "Preisdetails",
        resTotalGross: "Gesamt (brutto)",
        resTotalNet: "Netto",
        resPerNight: "Nachtübersicht",
        resAdditionalInfo: "Weitere Informationen",
        resId: "Reservierungs-ID",
        resBookingId: "Buchungs-ID",
        resCreatedAt: "Erstellt am",
        resCancellation: "Storniert am",
        resCancellationReason: "Stornogrund",
        resComment: "Kommentar",
        resNoPriceData: "Keine Preisdaten verfügbar",
      },
      guestPortal: {
        title: "Guest Portal",
        subtitle: "Hotel Guest Services & Loyalty",
        brandSubtitle: "AdaptHub SaaS B2C",
        logIn: "Anmelden",
        register: "Registrieren",
        dashboardTab: "Dashboard",
        myStays: "Meine Stays",
        invoices: "Rechnungen",
        portal: "Portal",
        stays: "Stays",
        receipts: "Belege",
        greeting: "Hallo, {{name}}!",
        guest: "Gast",
        dashboardDescription: "Hier finden Sie Ihre Hotelaufenthalte, Rechnungsbelege und Ihren aktuellen Loyalty Status.",
        viewStays: "Stays ansehen",
        loyaltyCard: "Loyalty Club Card",
        totalPoints: "Gesamtpunkte",
        member: "Gast-Mitglied",
        gold: "Gold",
        silver: "Silver",
        bronze: "Bronze",
        nextStay: "Nächster Aufenthalt",
        active: "Aktiv vor Ort",
        confirmed: "Bestätigt",
        checkIn: "Check-In:",
        checkOut: "Check-Out:",
        room: "Zimmer:",
        assignmentAtArrival: "Zuweisung bei Anreise",
        noUpcomingStays: "Keine bevorstehenden Aufenthalte gebucht.",
        wantToBook: "Sie möchten buchen?",
        toWebsite: "Zur Website",
        pointHistory: "Punkte-Verlauf",
        noPointsYet: "Noch keine Punkte gesammelt. Punkte werden nach dem Check-Out gutgeschrieben.",
        staysAndBookings: "Aufenthalte & Buchungen",
        staysDescription: "Historische Übersicht aller Stays, die mit Ihrer E-Mail-Adresse gebucht wurden.",
        refresh: "Aktualisieren",
        searchPlaceholder: "Stay ID, Hotel oder Zimmer suchen...",
        allStatuses: "Alle Status",
        inhouse: "Inhouse",
        checkedOut: "Abgereist",
        cancelled: "Storniert",
        loadingBookings: "Lade Buchungen...",
        noMatchingStays: "Keine passenden Aufenthalte gefunden",
        noMatchingStaysDescription: "Für Ihre aktuellen Filter- und Sucheinstellungen gibt es keine passenden Einträge.",
        resetFilters: "Filter zurücksetzen",
        code: "Code:",
        arrival: "Anreise:",
        departure: "Abreise:",
        na: "n/a",
        totalAmount: "Rechnungsbetrag",
        viewInvoice: "Rechnung abrufen",
        pointsDisplay: "{{points}} Punkte",
        languageLabel: "Sprache",
        lang_de: "DE",
        lang_en: "EN",
        fallbackHotelName: "Adapt Hotel",
        pointsToNextTier: "Noch {{points}} Punkte bis {{tier}}",
        tierMaxed: "Höchste Stufe erreicht",
        statTotalStays: "Aufenthalte",
        statUpcoming: "Anstehend",
        statInvoices: "Rechnungen",
        pointsUnit: "Punkte",
        profileTab: "Meine Daten",
        rewardsTab: "Prämien",
        requestsTab: "Anfragen",
        profileTitle: "Meine Daten",
        profileDescription: "Ihre hinterlegten Daten. Änderungen reichen Sie über das Formular unten ein — unsere Rezeption prüft und übernimmt sie. (DSGVO Art. 15/16)",
        profileName: "Name",
        profileEmail: "E-Mail",
        profilePhone: "Telefon",
        profileAddress: "Adresse",
        profileNotProvided: "Nicht hinterlegt",
        dataChangeTitle: "Daten ändern",
        dataChangeDescription: "Gewünschte Änderungen eintragen. Leere Felder bleiben unverändert.",
        dataChangeSubmit: "Änderung anfordern",
        dataChangeSuccess: "Anfrage gesendet! Unsere Rezeption bearbeitet sie in Kürze.",
        dataChangeEmpty: "Bitte mindestens ein Feld ausfüllen.",
        stayRequestTitle: "Early Check-In / Late Check-Out",
        stayRequestNotice: "Wichtig: Dies ist eine unverbindliche Anfrage. Eine Zusage hängt von der Verfügbarkeit ab und erfolgt durch unsere Rezeption.",
        stayRequestType: "Art der Anfrage",
        earlyCheckin: "Early Check-In (frühere Anreise)",
        lateCheckout: "Late Check-Out (spätere Abreise)",
        stayRequestReservation: "Reservierung",
        stayRequestTime: "Gewünschte Uhrzeit (optional)",
        stayRequestNotes: "Anmerkungen (optional)",
        stayRequestSubmit: "Anfrage senden",
        stayRequestSuccess: "Anfrage gesendet! Wir melden uns mit einer Zusage oder Absage.",
        stayRequestNoReservations: "Keine anstehenden Reservierungen für eine Anfrage.",
        rewardsTitle: "Prämien einlösen",
        rewardsDescription: "Tauschen Sie Ihre Punkte gegen Prämien ein. Die Ausgabe erfolgt nach Prüfung durch unsere Rezeption.",
        rewardsCost: "Punkte",
        rewardsRedeem: "Einlösen",
        rewardsNotEnough: "Dafür fehlen Ihnen noch {{missing}} Punkte.",
        rewardsSuccess: "Prämie angefordert! Unsere Rezeption hält sie für Sie bereit.",
        rewardsBalanceChanged: "Ihr Punktestand hat sich geändert — bitte Seite neu laden und erneut versuchen.",
        rewardsNewBalance: "Neuer Punktestand: {{points}}",
        rewardsEmpty: "Keine Prämien verfügbar.",
        requestsHistoryNote: "Ihre Anfragen landen direkt bei unserer Rezeption — Sie werden über das Ergebnis informiert.",
        showingEntries: "Zeige {{start}} bis {{end}} von {{total}} Einträgen",
        back: "Zurück",
        forward: "Weiter",
        noStaysFound: "Keine Aufenthalte gefunden",
        noStaysFoundDescription: "Es wurden keine Reservierungen gefunden, die mit der E-Mail-Adresse <strong>{{email}}</strong> verknüpft sind.",
        invoicesAndDocuments: "Rechnungsbelege & Belege",
        invoicesDescription: "Hier können Sie Rechnungen herunterladen oder eine offizielle Rechnungskorrektur anfordern.",
        gobdTitle: "GoBD Konformitäts-Hinweis:",
        gobdText: "Geschriebene Rechnungen dürfen gemäß GoBD-Richtlinien nicht gelöscht oder direkt verändert werden. Für Korrekturen (z.B. geänderter Firmenname oder Anschrift) können Sie unten bequem eine Korrektur anfordern. Unsere Rezeption wird Ihnen ein Storno und eine korrigierte Neurechnung ausstellen.",
        loadingInvoices: "Lade Rechnungen...",
        invoiceNumber: "Rechnungsnummer",
        date: "Datum",
        reservation: "Reservierung",
        amount: "Betrag",
        actions: "Aktionen",
        invoicePrefix: "Rechnung",
        pdf: "PDF",
        correction: "Korrektur",
        noInvoices: "Keine Rechnungen vorhanden",
        noInvoicesDescription: "Nach Abreise und Rechnungslegung Ihrer Aufenthalte werden Ihre Belege hier automatisch aufgelistet.",
        requestCorrection: "Rechnungskorrektur anfordern",
        invoiceLabel: "Rechnung:",
        requestSubmitted: "Antrag eingereicht!",
        requestSubmittedDescription: "Ihre Korrekturwünsche wurden an die Rezeption übermittelt. Wir senden Ihnen die korrigierte Fassung per E-Mail zu.",
        previousName: "Bisheriger Name / Firmenname (auf Beleg)",
        previousNamePlaceholder: "z.B. Privat oder falsche Firma",
        futureName: "Zukünftiger Empfänger-Name / Firmenname *",
        futureNamePlaceholder: "z.B. Siemens AG",
        street: "Straße & Hausnummer *",
        streetPlaceholder: "z.B. Hauptstr. 12a",
        zipCode: "PLZ *",
        zipCodePlaceholder: "10115",
        city: "Ort *",
        cityPlaceholder: "Berlin",
        vatNumber: "USt-IdNr. (VAT Number) - optional",
        vatNumberPlaceholder: "z.B. DE123456789",
        invoiceLanguage: "Sprache der neuen Rechnung (Language)",
        german: "Deutsch (DE)",
        english: "English (EN)",
        additionalNotes: "Zusätzliche Anmerkungen",
        additionalNotesPlaceholder: "z.B. Bitte Abteilung X angeben...",
        submitCorrection: "Korrektur anfordern",
        downloadError: "Fehler beim Herunterladen der PDF-Rechnung.",
        correctionSubmitError: "Fehler beim Einreichen des Korrekturantrags.",
      },
      internalResources: {
        title: "Interne Ressourcen",
        subtitle: "Interne Checklisten & Kontrollen",
        namePrompt: "Name des neuen Checks (z. B. Brandschutz-Wochencheck):",
        renamePrompt: "Neuen Namen eingeben:",
        nameExists: "Ein Check mit diesem Namen existiert bereits",
        deleteConfirm: "Check \"{{name}}\" wirklich löschen? Zugehörige Einträge bleiben in der Datenbank, sind aber nicht mehr sichtbar.",
        addCheck: "Check hinzufügen",
        noChecks: "Noch keine Checks angelegt",
        noChecksHint: "Füge oben über „Check hinzufügen“ deinen ersten Check hinzu.",
        sperrapartmentsTab: "Sperrapartments",
      },
      sperrapartments: {
        title: "Sperrapartments",
        subtitle: "Wartungsfenster mit Verlaufs-Snapshot — gelöschte Fenster bleiben sichtbar",
        refresh: "Liste aktualisieren",
        keywordsEdit: "Schlüsselwörter bearbeiten",
        keywordsTitle: "Schlüsselwörter",
        keywordsDesc: "Nur Wartungsfenster, deren Grund oder Beschreibung eines dieser Schlüsselwörter (Kommagetrennt) enthält, werden aufgelistet.",
        keywordsPlaceholder: "z. B. Renovierung, Schadensfall",
        keywordsCurrent: "{{count}} Schlüsselwörter aktiv",
        keywordsSaved: "Schlüsselwörter gespeichert",
        searchPlaceholder: "Zimmer, Grund oder Beschreibung suchen …",
        filterAll: "Alle",
        filterFrom: "Von",
        filterTo: "Bis",
        filterLocation: "Standort",
        filterStatus: "Status",
        pageInfo: "Seite {{page}} von {{pages}} · {{count}} Einträge",
        prevPage: "Zurück",
        nextPage: "Weiter",
        syncError: "Fehler beim Laden der Wartungsfenster — die Liste kann unvollständig sein.",
        keywordsChip: "{{count}} Schlüsselwörter",
        colRoom: "Zimmer",
        colPeriod: "Zeitraum",
        colReason: "Grund",
        colStatus: "Status",
        colTrace: "Trace",
        statusActive: "Aktiv",
        statusPast: "Vergangen",
        statusDeleted: "Gelöscht",
        deletedAt: "Gelöscht am {{date}}",
        noKeywords: "Keine Schlüsselwörter konfiguriert",
        noKeywordsHint: "Öffne die Einstellungen (Zahnrad) und definiere die Schlüsselwörter für die Liste.",
        noResults: "Keine Sperrapartments gefunden",
        createWindow: "Wartungsfenster erstellen",
        traceDone: "Erledigt",
        tracePartial: "Teilweise ({{done}} von {{total}})",
        traceOpen: "Offen ({{total}})",
      },
      haustechnik: {
        title: "Haustechnik",
        menuTitle: "Haustechnik Menü",
        menuSubtitleV1: "Listen & Checks",
        menuTabs: "Tabs",
        v1Description: "Verwalte Listen, Zimmerchecks und Wartungsfenster.",
        v2Description: "Wartungs- & Infrastruktur-Hub",
        tabs: {
          lists: "Listen",
          zimmercheck: "Zimmercheck",
          freeRooms: "Freie Zimmer",
          maintenance: "Wartungsfenster",
          projectPlanning: "Projektplanung",
          sperrapartments: "Sperrapartments",
        },
        projectPlanning: {
          title: "Projekt- & Ablaufplanung",
          subtitle: "Instandhaltungs-Traces in schrittweise Arbeitsphasen unterteilen",
          totalTraces: "Traces Gesamt",
          open: "Offen",
          inProgress: "In Bearbeitung",
          statusInReview: "In Prüfung",
          completed: "Erledigt",
          selected: "Ausgewählt",
          reviewAndDone: "Review & Done",
          reviewAndDoneAction: "Als erledigt abschließen",
          reviewAndDoneTooltip: "Projekt prüfen und als erledigt abschließen",
          readyForReviewTitle: "Alle Schritte erledigt — Bereit zum Abschluss",
          readyForReviewDesc: "Alle Schritte sind erledigt.",
          openProject: "Projekt öffnen",
          openTrace: "Trace öffnen",
          step: "Schritt",
          overdue: "Überfällig",
          area: "Bereich",
          allAreas: "Alle Bereiche",
          allStatuses: "Alle Status",
          searchPlaceholder: "Suche nach Zimmer, Titel, Ersteller...",
          newTrace: "Neuer HT-Trace",
          newProject: "Neues Projekt",
          createProjectTitle: "Neues Projekt erstellen",
          createProjectSubtitle: "Eigenständiges Projekt für die Ablaufplanung anlegen",
          projectName: "Projektname / Titel",
          projectNamePlaceholder: "z.B. Renovierung Flur 2. OG, Filterwechsel...",
          projectArea: "Bereich",
          projectRooms: "Betroffene Zimmer / Einheiten (optional)",
          projectRoomsPlaceholder: "z.B. 101, 102 oder Allgemeinbereich",
          projectPriority: "Priorität",
          projectStartDate: "Startdatum",
          projectDueDate: "Ziel-Fälligkeitsdatum",
          projectDescription: "Beschreibung / Umfang (optional)",
          projectDescriptionPlaceholder: "Ziele, Besonderheiten oder benötigtes Material...",
          initialStepTitle: "Erster Arbeitsschritt (optional)",
          initialStepPlaceholder: "z.B. Material beschaffen, Bereich vorbereiten...",
          createAndOpenPlanner: "Projekt anlegen & planen",
          projectCreatedSuccess: "Projekt erfolgreich angelegt und im Planer geöffnet",
          titleRequired: "Bitte einen Projektnamen eingeben.",
          emptyState: "Keine Instandhaltungs-Projekte gefunden",
          emptyStateDesc: "Es liegen derzeit keine Projekte für Haustechnik vor.",
          emptyPlannedState: "Keine geplanten Projekte vorhanden",
          emptyPlannedStateDesc: "Erstelle im Planer einen schrittweisen Ablaufplan für ein Projekt.",
          emptyHistoryState: "Keine abgeschlossenen Projekte",
          emptyHistoryStateDesc: "Hier erscheinen alle erfolgreich abgeschlossenen Projekte und Instandhaltungs-Abläufe.",
          reopenProject: "Wiedereröffnen",
          reopenProjectTooltip: "Projekt wieder in Bearbeitung setzen",
          projectReopenedSuccess: "Projekt erfolgreich wiedereröffnet!",
          goToPlanner: "Zum Planer wechseln",
          addPlanButton: "Plan erstellen",
          viewTable: "Tabelle",
          viewKanban: "Kanban",
          viewPlanner: "Projektplaner",
          tabPlannedList: "Projektliste",
          tabPlanner: "Projektplaner",
          tabHistory: "Historie",
          priority: "Priorität",
          room: "Zimmer",
          assigned: "Zugewiesen",
          dueDate: "Fällig",
          actions: "Aktionen",
          deviceReplaced: "E-Gerät getauscht",
          quickStatusChange: "Status ändern",
          selectTrace: "Projekt zur Ablaufplanung auswählen",
          selectTraceDesc: "Wähle links ein Projekt aus, um einen schrittweisen Ablaufplan mit Terminen und Personal festzulegen.",
          planSteps: "Schrittweiser Ablaufplan",
          roomsScope: "Betroffene Zimmer / Einheiten",
          roomsPlaceholder: "z.B. 101, 102 oder 105",
          totalDuration: "Gesamtdauer",
          daysUnit: "Tage",
          dayUnit: "Tag",
          addStep: "Schritt hinzufügen",
          stepTitlePlaceholder: "z.B. Vorbereitung / 2 Tage Wartezeit / Ausführung",
          stepTypeWork: "Arbeitsschritt",
          stepTypeWait: "Wartezeit",
          durationDays: "Dauer (Tage)",
          assignee: "Zuständig",
          noAssignee: "Nicht zugewiesen",
          scheduledDate: "Geplantes Datum",
          stepStatusPending: "Ausstehend",
          stepStatusProgress: "In Arbeit",
          stepStatusDone: "Erledigt",
          savePlan: "Projektplan speichern",
          planSaved: "Projektplan erfolgreich gespeichert",
          noPlanYet: "Noch kein Ablaufplan vorhanden",
          createPlanNow: "Plan jetzt erstellen",
          progress: "Fortschritt",
          plannedTraces: "Geplante Projekte",
          unplannedTraces: "Ungeplante Projekte",
          allTraces: "Alle Projekte",
          stepCount: "{{completed}} von {{total}} Schritten",
          stepNumber: "Schritt {{number}}",
          notes: "Notizen / Anweisungen",
          detailsAndHistory: "Projekt öffnen",
          phasesAndSteps: "Phasen & Arbeitsschritte ({{count}})",
          noPlanDesc: "Erstelle manuell Schritte für Arbeitsphasen, Wartezeiten und Zuständige.",
          moveUp: "Nach oben",
          moveDown: "Nach unten",
          deleteStep: "Schritt löschen",
          stepWaitPlaceholder: "z.B. 2 Tage warten",
          durationLabel: "Dauer:",
          stepsUnit: "Schritte",
          unplanned: "Ungeplant",
          editPlan: "Plan bearbeiten ➔",
          editPlanButton: "Plan bearbeiten",
          cancel: "Abbrechen",
          noUnitsAssigned: "Keine Einheiten zugewiesen",
          notDone: "Nicht erledigt",
          markDone: "Erledigt",
          viewSteps: "Schritte",
          planAction: "Planen ➔",
          noPlan: "Kein Plan",
          areaLabel: "Bereich:",
          areaPainting: "Malern",
          areaEmergency: "Havarie",
          areaGeneral: "Allgemein",
          areaAppliance: "E-Geräte (Getauscht)",
          areaSanitary: "Sanitär",
          areaElectric: "Elektrik",
          areaHVAC: "HVAC / Klima",
          plannedShort: "Geplant",
          planSavedSuccess: "Projektplan erfolgreich gespeichert",
        },
        list: {
          title: "Listen",
          addEntry: "Eintrag hinzufügen",
          entriesCount: "{{count}} Eintrag verzeichnet",
          entriesCount_other: "{{count}} Einträge verzeichnet",
          egeraeteCount: "{{count}} Gerät erfasst",
          egeraeteCount_other: "{{count}} Geräte erfasst",
          selectList: "Bitte eine Liste auswählen",
          deleteConfirm: "Eintrag löschen?",
          deleteListConfirm: "Liste wirklich löschen?",
          newListNamePrompt: "Name der neuen Liste:",
          columnsPrompt: "Spaltennamen (kommagetrennt):",
          columnsDefault: "Projekt, Status, Notizen",
          newList: "Neue Liste",
          newListSubtitle: "Erstelle eine eigene Liste mit individuellen Spalten",
          newListTitle: "Titel der Liste",
          newListTitlePlaceholder: "z.B. Wartungsplan",
          newListColumns: "Spalten",
          newListColumnPlaceholder: "Spaltenname...",
          newListAddColumn: "Spalte hinzufügen",
          newListRemoveColumn: "Spalte entfernen",
          newListCreate: "Erstellen",
          newListCancel: "Abbrechen",
          newListTitleRequired: "Titel ist erforderlich",
          newListMinColumn: "Mindestens eine Spalte erforderlich",
          newListSuccess: "Liste \"{{name}}\" erstellt",
          editList: "Liste bearbeiten",
          editListSubtitle: "Titel und Spalten anpassen",
          editListSubtitleSystem: "Nur der Titel kann angepasst werden",
          editListSave: "Speichern",
          editSuccess: "Liste \"{{name}}\" aktualisiert",
          deleteList: "Liste löschen",
          deleteSuccess: "Liste \"{{name}}\" gelöscht",
          deleteSystemBlocked: "System-Listen können nicht gelöscht werden",
          noEntries: "Noch keine Einträge vorhanden",
          trace: "Trace",
          pagePrev: "Vorherige Seite",
          pageNext: "Nächste Seite",
          pageInfo: "Seite {{page}} von {{totalPages}}",
          tracePlaceholder: "Trace...",
          date: "Datum",
          location: "Standort",
          locationPlaceholder: "Standort",
          sortTooltip: "Klicken zum Sortieren (aufsteigend/absteigend)",
          sortAsc: "Aufsteigend sortiert",
          sortDesc: "Absteigend sortiert",
        },
        zimmercheck: {
          title: "Zimmercheck",
          subtitle: "Instandhaltungs-Audit",
          room: "Zimmer",
          property: "Property",
          location: "Standort",
          lastCheck: "Letzter Check",
          auditNotes: "Audit-Notizen",
          auditOk: "Audit OK",
          auditNotesPlaceholder: "Notiz...",
          columnNameExists: "Spaltenname bereits vorhanden",
          interval: "Intervall",
          days: "Tage",
          dueWarning: "Fällig (> {{days}} T.)",
          sortByLastCheck: "Nach letztem Check sortieren",
          sortAlphabetical: "Alphabetisch sortieren",
          column: "Spalte",
          deleteColumn: "Spalte löschen",
          addCustomColumn: "+ Spalte hinzufügen",
          customColumnNamePrompt: "Name der Spalte:",
          maxColumnsReached: "Maximal 3 benutzerdefinierte Spalten pro Property.",
          filterAll: "Alle",
          filterDue: "Fällig",
          filterOk: "Audit OK",
          filterPending: "Nicht geprüft",
        },
        freeRooms: {
          title: "Freie Zimmer",
          subtitleOver: "Kapazitäts-Übersicht",
          subtitle: "Echtzeit Belegungs-Übersicht",
          free: "Frei",
          available: "Verfügbar",
          arrival: "Anreise",
          departure: "Abreise",
          noEntries: "Keine Einträge gefunden",
          filterAll: "Alle",
          filterArrival: "Anreise",
          filterDeparture: "Abreise",
        },
        maintenance: {
          title: "Wartung",
          subtitle: "Out-of-Order Management",
          new: "Neue Wartung",
          schedule: "Wartung planen",
          scheduleSubtitle: "Einheit für Instandhaltung sperren",
          scheduleApaleoSubtitle: "Neue OOO-Meldung an Apaleo",
          scheduleButton: "Planen",
          deleteConfirm: "Löschen?",
          deleteConfirmV2: "Eintrag wirklich löschen?",
          room: "Zimmer",
          roomLabel: "Zi. {{room}}",
          roomOption: "Zimmer {{name}}",
          period: "Zeitraum",
          periodSync: "Zeitraum (Apaleo Sync)",
          reason: "Grund / Beschreibung",
          reasonStatus: "Grund / Status",
          phase: "Phase",
          scheduled: "Geplant",
          active: "Aktiv",
          archived: "Archiviert",
          defaultReason: "Instandhaltung",
          noWindows: "Keine Wartungsfenster im gewählten Zeitraum",
          unit: "Zimmer / Einheit",
          targetUnit: "Ziel-Einheit (Zimmer)",
          selectUnit: "Einheit wählen...",
          start: "Start",
          end: "Ende",
          from: "Von",
          to: "Bis",
          internalNote: "Interne Notiz",
          notePlaceholder: "Beschreibe den Grund der Sperrung...",
          reasonNotes: "Grund & Notizen",
          repairPlaceholder: "Was muss repariert werden?",
          create: "Erstellen",
          searchPlaceholder: "Zimmer / Beschreibung suchen...",
        },
        filter: {
          allLocations: "Alle Standorte",
          allOccupancy: "Alle Status (FR/AR/DP/OC)",
          occupied: "Belegt",
          searchRoom: "Zimmer suchen...",
          searchRoomShort: "ZIMMER...",
          noResults: "Keine Zimmer gefunden",
          collapseFilters: "Filter einklappen",
          expandFilters: "Filter ausklappen",
        },
        error: {
          loadFailed: "Fehler beim Laden",
          prefix: "Fehler: ",
        },
        exportToExcel: "Als Excel exportieren",
        exportSuccess: "Export erfolgreich",
        print: "Drucken",
        help: "Hilfe",
      },
      traces: {
        menuTitle: "Traces Menü",
        untitled: "Ohne Titel",
        filterAndActions: "Filter & Aktionen",
        description: "Verwalte Aufgaben & Dokumentation.",
        import: "Importieren",
        newTrace: "Neuer Trace",
        title: "Traces",
        syncing: "Traces werden synchronisiert...",
        subtitle: "Aufgaben & Dokumentation verwalten",
        filterLabel: "Filter",
        basisDatumRequired: "Bitte ein gültiges Basisdatum angeben.",
        reporter: "Melder",
        assigned: "Zugewiesen",
        status: {
          open: "Offen",
          inProgress: "In Bearbeitung",
          done: "Erledigt",
          deleted: "Gelöscht",
        },
        sort: {
          newest: "Neueste zuerst",
          dueDate: "Fälligkeit",
        },
        filter: {
          myTraces: "Meine Traces",
          myOverdue: "Meine Überfälligen",
          deptOpen: "Abteilung Offen",
          deptOverdue: "Abteilung Überfällig",
          active: "Filter aktiv",
          department: "Abteilungen",
          searchPlaceholder: "Traces, Gäste oder Zimmer suchen",
          roomPlaceholder: "Zimmernummer filtern...",
          status: "Status",
          location: "Standorte",
          dueFrom: "Fällig ab",
          dueTo: "Fällig bis",
        },
        stats: {
          myTraces: "Meine Traces",
          myOverdue: "Meine Überfällig",
          deptOpen: "Abteilung Offen",
          deptOverdue: "Abteilung Fällig",
        },
        empty: {
          noTraces: "Keine Traces gefunden",
        },
        overdue: "Überfällig",
        room: {
          prefix: "Zimmer ",
        },
        guest: {
          prefix: "Gast: ",
        },
        requester: {
          prefix: "Melder: ",
        },
        assignedTo: {
          prefix: "Zuständig: ",
        },
        start: "Start",
        dueDate: "Fällig bis",
        noDate: "Kein Datum",
        confirmDone: {
          title: "Aufgabe abschließen?",
          subtitle: "Möchten Sie diese Aufgabe wirklich als erledigt markieren?",
          cancel: "Abbrechen",
          confirm: "Erledigt",
          cta: "Als erledigt markieren",
        },
        details: "Details",
        messages: "{{count}} Nachricht",
        messages_plural: "{{count}} Nachrichten",
        planTag: "Plan",
        addPlanTag: "Plan erstellen",
        openPlanButton: "Plan anzeigen",
        editPlanInPlanner: "Plan im Planer öffnen",
        createPlanInPlanner: "Ablaufplan erstellen",
        createStepPlan: "Ablaufplan erstellen",
        editStepPlan: "Ablaufplan bearbeiten",
        planAvailableAfterCreate: "Ablaufplan erst nach Erstellung des Traces verfügbar",
      },
      traceModal: {
        editTitle: "Trace bearbeiten",
        details: "Details",
        title: "Titel",
        description: "Beschreibung / Details",
        noDescription: "Keine Details oder Beschreibung vorhanden.",
        preview: "Vorschau",
        edit: "Bearbeiten",
        boldTooltip: "Fett formatieren (**text**)",
        bold: "Fett",
        headingTooltip: "Überschrift einfügen (### text)",
        heading: "Überschrift",
        listTooltip: "Aufzählungspunkt einfügen (- text)",
        list: "Liste",
        descriptionPlaceholder: "Beschreibung oder Gast-Angaben hier eingeben...",
        invoiceCorrection: "Automatisierte Rechnungskorrektur",
        apaleoReady: "Apaleo API bereit",
        originalInvoice: "Originale Rechnung",
        guestEmail: "Gast E-Mail",
        languageCode: "Sprachcode (Language)",
        originalName: "Originaler Name",
        individual: "Privatperson",
        newRecipient: "Neuer Empfänger / Firma",
        newAddress: "Neue Anschrift",
        vatNumber: "USt-IdNr. (VAT)",
        processing: "Verarbeite...",
        alreadyCancelled: "Bereits storniert Γ£ô",
        executeCorrection: "Korrektur ausführen",
        assignment: "Zuweisung",
        persons: "Personen",
        requester: "Melder / Auftraggeber",
        requesterPlaceholder: "Name des Melders",
        department: "Abteilung",
        status: {
          label: "Status",
          open: "Offen",
          inProgress: "In Bearbeitung",
          done: "Erledigt",
          deleted: "Gelöscht",
        },
        location: "Standort",
        linkGuest: "Gast verknüpfen",
        searchGuest: "Gast suchen...",
        searchingApaleo: "Apaleo...",
        minChars: "Mindestens 3 Zeichen...",
        noResults: "Nichts gefunden",
        roomAbbr: "Zi.",
        room: "Zimmer",
        start: "Start",
        dueDate: "Fällig",
        setArrival: "+ Anreise",
        setDeparture: "+ Abreise",
        maintenanceSection: "Haustechnik",
        selectArea: "Bereich wählen",
        area: {
          painting: "Malern",
          damage: "Havarie",
          general: "Allgemein",
        },
        deviceSwapped: "Gerät getauscht",
        attachment: "Anhang:",
        selected: "Gewählt",
        change: "├ändern",
        addMore: "Weitere hinzufügen",
        attachments: "Anhänge",
        you: "Du",
        messagePlaceholder: "Nachricht...",
        justNow: "Gerade eben",
        minutesAgo: "vor {{count}} Minuten",
        hoursAgo: "vor {{count}} Stunden",
        daysAgo: "vor {{count}} Tagen",
        deleteSeries: "Serie löschen",
        confirmCorrection: "Möchtest du die Rechnungskorrektur für Re. {{invoiceId}} wirklich ausführen? Dies storniert die alte Rechnung, ändert die Folio-Adresse und erstellt eine neue Rechnung.",
        folioNotFound: "Folio-ID der Originalrechnung konnte nicht ermittelt werden.",
        correctionLog: "Rechnungskorrektur erfolgreich ausgeführt. Alte Re. {{invoiceId}} storniert. Neue Re. {{newInvoiceNumber}} erstellt.",
        correctionSuccess: "Rechnungskorrektur erfolgreich ausgeführt!",
        correctionError: "Fehler bei der Rechnungskorrektur: {{message}}",
        sendError: "Fehler beim Senden: {{message}}",
        confirmDelete: 'Trace "{{title}}" wirklich löschen?',
        confirmDeleteSimple: "Trace wirklich löschen?",
        noUnit: "Kein Zimmer ausgewählt",
      },
      fundsachen: {
        menuTitle: "Fundsachen Menü",
        filterAndActions: "Filter & Aktionen",
        title: "Fundsachen",
        archiveTitle: "Fundsachen Archiv",
        description: "Verwalte gefundene Gegenstände.",
        newEntry: "Neuer Eintrag",
        filter: {
          searchPlaceholder: "Gegenstände, Zimmer oder Namen suchen",
          status: "Status",
          location: "Standorte",
          foundFrom: "Gefunden von",
          foundTo: "Gefunden bis",
        },
        empty: {
          noResults: "Keine Fundsachen gefunden",
          archiveEmpty: "Archiv leer",
          noFilterResults: "Keine Einträge für die gewählten Filter gefunden",
        },
        room: {
          prefix: "Zimmer ",
        },
        guest: {
          prefix: "Gast: ",
          ref: "Ref: ",
        },
        create: {
          title: "Neue Fundsache",
          descriptionPlaceholder: "Was wurde gefunden?",
          roomLabel: "Zimmer / Fundort",
          roomPlaceholder: "Zi-Nummer",
          foundDateLabel: "* Funddatum",
          locationLabel: "* Standort",
          locationMissing: "Bitte wähle einen Standort aus.",
          locationLoadFailed: "Standorte konnten nicht geladen werden. Bitte Seite neu laden.",
          attachmentLabel: "Dokumentation (Foto)",
          uploadLabel: "Foto hochladen",
        },
        createV2: {
          title: "Neue Erfassung",
          subtitle: "Gegenstand in das Sicherheits-System aufnehmen",
          descriptionLabel: "* Beschreibung",
          descriptionPlaceholder: "Beschreibung...",
          roomLabel: "Fundort / Zimmer",
          roomPlaceholder: "Zi-Nummer / Fundort",
          foundDateLabel: "* Funddatum",
          attachmentLabel: "Anhänge",
          uploadLabel: "Upload starten",
          fileHint: "PNG, JPG oder PDF ΓÇó Maximale Kapazität: 25MB",
          saving: "Synchronisiere Daten...",
        },
        status: {
          open: "Offen",
          contacted: "Gast kontaktiert",
          sent: "Versendet/Erledigt",
        },
        log: {
          created: "hat den Eintrag erstellt",
          createdAction: "Fundsache erstellt",
          edited: "hat Details bearbeitet",
          editedAction: "Fundsache bearbeitet",
          deletedAction: "Fundsache gelöscht",
          fileUploaded: "Neuer Anhang hochgeladen",
          fileRemoved: "Anhang entfernt",
        },
        change: {
          status: "Status:",
          room: "Zimmer:",
          description: "Beschreibung:",
          reference: "Referenz:",
          foundDate: "Funddatum:",
          responsible: "Verantwortlich:",
          requester: "Auftraggeber:",
        },
        confirmDelete: "Wirklich löschen?",
        justNow: "Gerade eben",
        minutesAgo: "vor {{count}} m",
        hoursAgo: "vor {{count}} h",
        daysAgo: "vor {{count}} d",
        noOne: "Niemand",
        userLoadError: "Konnte Nutzerliste nicht laden",
        exportList: "Liste exportieren",
        markReturned: "Als zurückgegeben markieren",
        returned: "Zurückgegeben",
        returnedOn: "Zurückgegeben am",
        noResultsForSearch: "Keine Ergebnisse für die Suche",
      },
      fundModal: {
        editTitle: "Fundsache bearbeiten",
        details: "Details",
        chat: "Chat ({{count}})",
        log: "Log",
        setStatus: "* Status setzen",
        roomLabel: "Zimmer / Fundort",
        roomPlaceholder: "Zi-Nummer...",
        location: "Standort",
        descriptionLabel: "* Gegenstandsbeschreibung",
        descriptionPlaceholder: "Was wurde gefunden? Detaillierte Beschreibung...",
        guestReference: "Referenz (Gast)",
        searchGuestPlaceholder: "In Apaleo nach Gast suchen...",
        searching: "Suche...",
        noResults: 'Keine Ergebnisse für "{{term}}"',
        roomAbbr: "Zi.",
        foundDateLabel: "* Funddatum",
        responsibility: "Zuständigkeit",
        selectDefault: "Auswählen...",
        requester: "Melder / Auftraggeber",
        requesterPlaceholder: "Name des Melders...",
        attachments: "Anhänge",
        attachment: "Anhang",
        attachmentSubtitle: "Dokument / Foto",
        removeFile: "Datei entfernen",
        ready: "Bereit",
        uploadFile: "Datei hochladen",
        discard: "Verwerfen",
        saving: "Speichern...",
        collaboration: "Kollaboration",
        collaborationSubtitle: "Aktivitäten & Interaktion",
        teamChat: "Team Chat ({{count}})",
        noMessages: "Keine Nachrichten",
        logEmpty: "Log ist leer",
        messagePlaceholder: "Nachricht...",
        sendError: "Fehler beim Senden: {{message}}",
      },
      chat: {
        filterAll: "Alle",
        filterDirect: "Direkt",
        filterTeams: "Team-Chats",
        startDirectMessage: "Direktnachricht",
        jumpToPresent: "Zum Ende springen",
        typing: "{{name}} tippt...",
        typingPlural: "{{name}} tippen...",
        searchPlaceholder: "Nachrichten durchsuchen...",
        searchConversationsPlaceholder: "Chats durchsuchen…",
        searchNoResults: "Keine Treffer in geladenen Nachrichten",
        searchHistoryHits: "{{count}} Treffer im Verlauf",
        searchHistoryHits_other: "{{count}} Treffer im Verlauf",
        searchLoadFailed: "Nachricht konnte nicht geladen werden",
        loadOlder: "Ältere Nachrichten laden",
        attachment: "Anhang",
        fileTooLarge: "Datei zu groß (max. {{max}} MB)",
        receiptsAll: "✓✓ Alle gelesen",
        receiptsRead: "✓✓ Gelesen",
        receiptsSent: "✓ Gesendet",
        readByCount: "gelesen",
        react: "Reagieren",
        muteConversation: "Benachrichtigungen stummschalten",
        conversationMuted: "Stummgeschaltet — klicken zum Aktivieren",
        pinConversation: "Chat anpinnen",
        unpinConversation: "Anpinnung lösen",
        pinForMe: "Für mich anpinnen",
        unpinForMe: "Für mich lösen",
        pinForEveryone: "Für alle anpinnen",
        unpinForEveryone: "Für alle lösen",
        pinnedForMe: "Für mich angepinnt",
        pinnedForEveryone: "Für alle angepinnt",
        pinForMeHint: "Nur in deiner Liste oben",
        pinForEveryoneHint: "Für alle Mitglieder ganz oben",
        pinChatOptions: "Chat anpinnen",
        pinned: "Angepinnt",
        pinMessage: "Nachricht anpinnen",
        unpinMessage: "Anpinnung lösen",
        pinMessageOptions: "Nachricht anpinnen",
        pinnedMessages: "Angepinnte Nachrichten",
        pinnedMessagesCount: "{{count}} angepinnte Nachricht",
        pinnedMessagesCount_plural: "{{count}} angepinnte Nachrichten",
        pinnedMessagesTooltip: "Angepinnte Nachrichten ein-/ausblenden",
        pinChatTooltip: "Chat oben anpinnen",
        unpinChatTooltip: "Chat lösen",
        muteTooltip: "Chat stummschalten",
        unmuteTooltip: "Stummschaltung aufheben",
        groupInfoTooltip: "Chat-Details & Info",
        jumpToMessage: "Zur Nachricht springen",
        jump: "Anzeigen",
        messageNotInWindow: "Nachricht liegt außerhalb der geladenen Nachrichten",
        groupInfo: "Gruppeninfo",
        addMember: "Mitglieder hinzufügen",
        memberAdded: "Mitglieder hinzugefügt",
        memberRemoved: "Mitglied entfernt",
        cannotRemoveCreator: "Der Ersteller kann nicht entfernt werden",
        groupFull: "Gruppe ist voll (max. 50 Mitglieder)",
        groupCreator: "Ersteller",
        groupAdmin: "Admin",
        groupMember: "Mitglied",
        promoteAdmin: "Zum Admin ernennen",
        demoteAdmin: "Admin-Rechte entziehen",
        memberPromoted: "Mitglied wurde zum Admin ernannt",
        memberDemoted: "Admin-Rechte entzogen",
        renameGroup: "Gruppe umbenennen",
        renameGroupSuccess: "Gruppe umbenannt",
        shareEntity: "Verknüpfung einfügen",
        entityPending: "{{type}} {{id}} wird an die nächste Nachricht angehängt",
        shareTypeTrace: "Trace",
        shareTypeOffer: "Angebot",
        shareTypeReservation: "Reservierung",
        openTrace: "Trace öffnen",
        openOffer: "Angebot öffnen",
        openReservation: "Reservierung öffnen",
        shareToChat: "An Chat senden",
        sharePickConversation: "{{type}} anhängen — Chat auswählen und senden",
        typingMultiple: "{{count}} Personen tippen...",
        online: "Online",
        anonymous: "Unbekannt",
        readBy: "Gelesen von {{names}}",
        reply: "Antworten",
        forward: "Weiterleiten",
        forwarded: "Weitergeleitet",
        forwardedFrom: "Weitergeleitet von {{name}}",
        forwardSuccess: "Nachricht weitergeleitet",
        replyTo: "Antworten auf",
        cancelReply: "Antwort abbrechen",
        replyingTo: "Antwort auf {{name}}",
        messageNotFound: "Originalnachricht nicht verfügbar",
        emojiPicker: "Emoji-Auswahl",
        moreEmojis: "Mehr Emojis",
        emojiSearchPlaceholder: "Emoji suchen...",
        emojiSearchResults: "Suchergebnisse",
        noEmojisFound: "Keine Emojis gefunden",
        emojiCat: {
          popular: "Beliebt & Häufig",
          smileys: "Smileys & Gesichter",
          gestures: "Gesten & Hände",
          hearts: "Herzen & Liebe",
          celebration: "Feier & Party",
          nature: "Natur & Tiere",
          food: "Essen & Trinken",
          symbols: "Symbole & Status",
        },
        title: "Chat",
        newChat: "Neuer Chat",
        newDm: "Direktnachricht",
        newGroup: "Gruppe erstellen",
        groupName: "Gruppenname",
        groupNamePlaceholder: "z. B. Rezeption Morgen",
        addMembers: "Mitglieder hinzufügen",
        searchCoworkers: "Kollegen suchen…",
        messagePlaceholder: "Nachricht schreiben…",
        edited: "bearbeitet",
        deleted: "Nachricht gelöscht",
        empty: "Noch keine Nachrichten",
        emptyList: "Keine Unterhaltungen",
        unread: "Ungelesen",
        leaveGroup: "Gruppe verlassen",
        removeMember: "Entfernen",
        sendFailed: "Senden fehlgeschlagen",
        deleteMessage: "Nachricht löschen",
        deletedSuccess: "Nachricht gelöscht",
        deleteNotPermitted: "Löschen nicht erlaubt",
        editMessage: "Nachricht bearbeiten",
        editingMessage: "Nachricht bearbeiten",
        editedSuccess: "Nachricht bearbeitet",
        saveEdit: "Speichern",
        cancelEdit: "Abbrechen",
        copy: "Text kopieren",
        copied: "In Zwischenablage kopiert",
        you: "Du",
        close: "Schließen",
        backToList: "Alle Chats",
        yesterday: "Gestern",
        dropImage: "Bild oder Datei hier ablegen",
        dropImageHint: "Wird als Anhang im Chat gesendet",
        imageAttached: "Bild angehängt",
        fileAttached: "Datei angehängt",
      },
      xrechnung: {
        subtitle: "XML-Generator mit manuellem & teilbefülltem Formular-Editor",
        step1Source: "1. Quelle wählen",
        selectLocation: "Standort wählen",
        fullId: "Vollständige ID:",
        description: "Sie können eine Rechnung aus apaleo laden und fehlende Felder manuell ergänzen, oder mit einem leeren Formular von Grund auf eine konforme XML erstellen.",
        loadSuccess: "Rechnung erfolgreich geladen und Formular befüllt.",
        currencyLabel: "Währung (cbc:DocumentCurrencyCode)",
        dueDateLabel: "Fälligkeitsdatum (cbc:DueDate)",
        amountsTitle: "Beträge & Summen",
        streetLabel: "Straße & Nr. (StreetName)",
        customerTitle: "Rechnungsempfänger (Customer)",
        buyerRefLabel: "Leitweg-ID / Käufer-Referenz (BuyerReference)",
        deleteRow: "Zeile löschen",
        noTaxSplit: 'Keine Steueraufteilung hinterlegt. Klicken Sie auf "Hinzufügen", um einen Eintrag zu erstellen.',
        helpText: "Wählen Sie links einen Standort und geben Sie eine Rechnungsnummer ein, um die Daten aus apaleo zu laden, oder erstellen Sie ein neues manuelles Formular.",
        blankLoaded: "Leeres Formular geladen. Tragen Sie Ihre Daten ein.",
        blankInitError: "Fehler beim Initialisieren des Formulars.",
        invoiceNoRequired: "Bitte geben Sie eine Rechnungsnummer ein.",
        loadError: "Fehler beim Laden der Rechnung.",
        downloadSuccess: "XRechnung erfolgreich heruntergeladen.",
        downloadError: "Fehler beim Erstellen der XRechnung.",
        invoiceNo: "Rechnungsnummer",
        invoiceNoPlaceholder: "z.B. 12345",
        invoiceId: "Rechnungsnummer (cbc:ID)",
        issueDate: "Rechnungsdatum (cbc:IssueDate)",
        actualDeliveryDate: "Leistungsdatum (ActualDeliveryDate)",
        netAmount: "Netto-Betrag (€)",
        taxAmount: "Steuer-Betrag (€)",
        grossAmount: "Brutto-Betrag (€)",
        companyName: "Firmenname (Name)",
        vatId: "USt-ID (Tax ID / VAT-ID)",
        postalCode: "PLZ",
        city: "Ort",
        country: "Land",
        accountHolder: "Kontoinhaber",
        iban: "IBAN",
        bic: "BIC",
        contactName: "Ansprechpartner (Name)",
        contactPhone: "Ansprechpartner (Telefon)",
        contactEmail: "Ansprechpartner (E-Mail)",
        nameCompany: "Name / Firma (Name)",
        nameCompanyPlaceholder: "z.B. Max Mustermann",
        buyerRefPlaceholder: "z.B. 991-33333-22",
        customerEmail: "E-Mail-Adresse (E-Mail)",
        customerEmailPlaceholder: "z.B. rechnung@kunde.de",
        customerStreetPlaceholder: "Musterweg 12",
        customerPostalPlaceholder: "12345",
        customerCityPlaceholder: "Musterstadt",
        customerCountryPlaceholder: "DE",
        netAmountShort: "Netto (€)",
        taxAmountShort: "Steuer (€)",
      },
      reservations: {
        menuTitleV1: "Reservierungs Menü",
        menuSubtitleV1: "Filter & Suche",
        menuTitleV2: "Reservierungen Menü",
        menuSubtitleV2: "KPIs & Filter",
        overview: "Übersicht",
        hotelStatusToday: "Hotel Status Heute",
        guests: "Gäste",
        occupancy: "Belegung",
        arrivals: "Anreisen",
        departures: "Abreisen",
        followUp: "Anschluss",
        followUpName: "Anschluss (Name)",
        inRoom: "Im Zimmer",
        today: "Heute",
        reservations: "Reservierungen",
        results: "{{count}} Treffer",
        waitingList: "Warteliste",
        overbookingLocks: "Überbuchungs-Sperren",
        mergeProfiles: "Profile zusammenführen",
        offer: "Angebot",
        invoiceCorrection: "Rechnungskorrektur",
        newBooking: "Neue Buchung",
        recalculateCityTax: "Ortstaxe neu berechnen",
        searchAllBadge: "Globale Suche",
        searchAllHint: "Es wird die gesamte Reservierungshistorie durchsucht (Name, E-Mail, Firma, ID, Zimmer) — Datum und Filter werden ignoriert",
        searchPlaceholder: "Gäste, Zimmer oder ID suchen",
        jumpToReservation: "Zur Reservierung springen (per ID)",
        jumpNotFound: "Keine Reservierung mit dieser ID gefunden",
        locations: "Standorte",
        statusInHouse: "Im Haus",
        statusConfirmed: "Bestätigt",
        statusCheckedOut: "Ausgecheckt",
        statusCanceled: "Storniert",
        active: "Aktive",
        rate: "Rate",
        checkIn: "Check-In",
        checkOut: "Check-Out",
        expected: "Erwartet",
        planned: "Geplant",
        locks: "Sperren",
        room: "Zimmer",
        guestDetails: "Gastdetails",
        crm: "CRM",
        location: "Standort",
        cleaning: "Reinigung",
        arrival: "Anreise",
        departure: "Abreise",
        source: "Quelle",
        sourceDirect: "Direkt",
        stayDate: "Aufenthaltsdatum",
        creation: "Erstellungsdatum",
        status: "Status",
        allStatuses: "Alle Status",
        allLocations: "Alle Standorte",
        allCrm: "Alle CRM",
        clearAll: "Alle löschen",
        noStatus: "Kein Status",
        statusVip: "VIP",
        statusBlacklist: "Blacklist",
        statusRegular: "Stammgast",
        statusNoShow: "Nicht erschienen",
        hideKpis: "KPIs ausblenden",
        showKpis: "KPIs einblenden",
        synchronizing: "Synchronisiere...",
        noReservationsFound: "Keine Reservierungen gefunden.",
        idPrefix: "ID: ",
        rotationPrefix: "",
        rowsPerPage: "Zeilen pro Seite:",
        actions: {
          column: "Aktionen",
          checkIn: "Check-In",
          checkOut: "Check-Out",
          cancel: "Stornieren",
          confirmCheckIn: "Check-In für diese Reservierung durchführen?",
          confirmCheckOut: "Check-Out für diese Reservierung durchführen?",
          confirmCancel: "Diese Reservierung wirklich stornieren?",
          checkInSuccess: "Check-In erfolgreich durchgeführt",
          checkOutSuccess: "Check-Out erfolgreich durchgeführt",
          cancelSuccess: "Reservierung erfolgreich storniert",
          checkInError: "Fehler beim Check-In",
          checkOutError: "Fehler beim Check-Out",
          cancelError: "Fehler beim Stornieren",
        },
        assignUnit: {
          buttonTitle: "Zimmer zuweisen",
          title: "Zimmer zuweisen",
          currentRoom: "Aktuelles Zimmer",
          currentLabel: "aktuell",
          searchPlaceholder: "Zimmer suchen...",
          noUnits: "Keine Zimmer gefunden",
          occupiedLabel: "belegt",
          uncategorized: "Ohne Kategorie",
          success: "Zimmer erfolgreich zugewiesen",
          logTitle: "Zimmer zugewiesen",
          logBody: "Reservierung {{resId}} auf Zimmer {{unitName}} zugewiesen.",
          // Room-change guard (2026-10-13): cross-category / over-capacity confirmation.
          confirmCrossCategory: "Achtung: Diese Reservierung soll in die Kategorie \"{{targetCategory}}\" verschoben werden. Fortfahren?",
          confirmCapacity: "Achtung: Kategorie \"{{targetCategory}}\" bietet max. {{maxPersons}} Personen, die Reservierung umfasst {{guestCount}} Gäste. Trotzdem fortfahren?",
          confirmCrossCategoryAndCapacity: "Achtung: Die Kategorie \"{{targetCategory}}\" bietet max. {{maxPersons}} Personen, die Reservierung umfasst {{guestCount}} Gäste — und wechselt die Zimmerkategorie. Trotzdem fortfahren?",
        },
      },
      housekeeping: {
        roomStatus: {
          dirty: "Schmutzig",
          clean: "Sauber",
          inspected: "Inspektion",
        },
        priorityRooms: "Prioritätszimmer",
        menuTitle: "Housekeeping Menü",
        menuSubtitlePlan: "Planung & Filter",
        menuSubtitleFilter: "Filter & Ansicht",
        titlePlan: "Housekeeping & Bleiber",
        titleForecast: "Housekeeping Forecast",
        descriptionPlan: "Plane Reinigungen und Zimmerstatus.",
        descriptionForecast: "Statusübersicht und Reinigungsplanung.",
        descriptionPlanV2: "Planung & Zimmerstatus-Management",
        descriptionForecastV2: "Kapazitätsplanung & Analyse",
        cleaningPlan: "Reinigungsplan",
        searchPlaceholder: "Gast, Zimmer...",
        searchPlaceholderV2: "Gast oder Zimmer suchen...",
        locations: "Standorte",
        location: "Standort",
        departures: "Abreisen",
        arrivals: "Anreisen",
        stayovers: "Bleiber",
        filterFree: "Frei",
        clearFilters: "Filter löschen",
        filterLabel: "Filter",
        forecastLabel: "Forecast",
        from: "Von",
        to: "Bis",
        allLocations: "Alle Standorte",
        rooms: "{{count}} Zimmer",
        settingsTitle: "Housekeeping-Einstellungen",
        settingsDesc: "Definiere Schlüsselwörter für Wartungen. Wartungen, die diese Wörter enthalten und im ausgewählten Zeitraum enden, werden auf der Reinigungsliste angezeigt.",
        keywordsLabel: "Wartung-Schlüsselwörter (kommagetrennt)",
        remarkPlaceholder: "Bemerkung...",
        maintenance: "Wartungen",
        newPlan: "Neuer Plan",
        room: "Zimmer",
        status: "Status",
        priority: "Priorität",
        assignedTo: "Zugewiesen an",
        export: "Exportieren",
        print: "Drucken",
        refresh: "Aktualisieren",
        properties: "Häuser",
        quickFilters: "Schnellfilter",
        stay: "Aufenthalt",
        turnover: "Wechsel",
        out: "Aus",
        in: "Ein",
      },
      analytics: {
        propertyFilter: "Hausauswahl",
        allProperties: "Alle Häuser",
        preset: {
          thisMonth: "Monat",
          lastMonth: "Letzter Monat",
          "30days": "30 Tage",
          next7Days: "Nächste 7 Tage",
          nextMonth: "Nächster Monat",
        },
        noData: "Keine Analysedaten verfügbar",
        netRevenueLegend: "Netto-Logisumsatz",
        roundedValues: "Werte gerundet",
        avgDaily: "Ø Täglich",
        peakDay: "Höchstwert",
        average: "Durchschnitt",
        barView: "Balken",
        areaView: "Trendkurve",
        weekend: "Wochenende",
        dataSource: "Datenquelle: Live Finanz-API",
        financeAudit: "Finanzprüfung",
        cityTaxAudit: "Ortstaxe auditieren",
        accessDenied: "Zugriff verweigert",
        reportFilter: "Berichtsfilter",
        periodPropertyFilter: "Zeitraum- & Hausauswahl",
        tab: {
          revenue: "Umsatz & Performance",
          bookingStats: "Buchungsstatistik",
          heatmaps: "Heatmaps",
          kpiEvolution: "KPI-Entwicklungen",
        },
        kpiEvolution: {
          title: "KPI-Entwicklungen",
          subtitle: "Entwicklung deiner KPIs gegenüber früheren Zeiträumen",
          vsBefore: "vs.",
          noData: "Keine Snapshot-Daten für den gewählten Zeitraum. Der tägliche KPI-Snapshot hat erst begonnen – Werte sammeln sich ab heute.",
          loading: "Snapshots werden geladen...",
          loadFailed: "Snapshots konnten nicht geladen werden.",
          metric: {
            netRevenue: "Nettoumsatz",
            grossRevenue: "Bruttoumsatz",
            soldUnits: "Zimmernächte",
            occupancy: "Auslastung",
            adr: "ADR",
            revpar: "RevPAR",
          },
          comparison: "Vergleich",
          current: "Aktueller Zeitraum",
          previous: "Tag {{days}} davor",
          modeActual: "Ist-Werte",
          modeForecast: "Entwicklung",
          forecast: {
            targetLabel: "Zieldatum",
            pickupTitle: "Entwicklung ({{days}} Tage)",
            noData: "Keine Snapshots für dieses Datum. Die täglichen Snapshots müssen erst anlaufen (nach der Migration + erstem Cron-Lauf).",
          },
          monthly: {
            tabLabel: "Monate",
            title: "Monatsansicht",
            subtitle: "Monatswerte aus Ist-Daten und Entwicklungen — die täglich aktualisierte Übersicht",
            month: "Monat",
            occOoo: "Occ % ohne OOO",
            budget: "Budget netto",
            difference: "Differenz",
            yearTotal: "Jahressumme",
            badgeActual: "Ist",
            badgeForecast: "Entwicklung",
            editBudget: "Budget bearbeiten",
            pickupTitle: "Entwicklung {{month}}",
            noPickup: "Keine Entwicklung-Verlaufspunkte für diesen Monat.",
            compareTitle: "Vergleich",
            comparePickSecond: "Zum Vergleichen zweiten Punkt anklicken",
            monthNames: "Jan,Feb,Mär,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez",
          },
          year: {
            previous: "Vorheriges Jahr",
            next: "Nächstes Jahr",
            today: "Aktuelles Jahr",
          },
          explorer: {
            tabLabel: "Explorer",
            title: "KPI-Explorer",
            subtitle: "Jahr {{year}} · {{scope}}",
            allProperties: "Alle Standorte",
            day: "Tag",
            monthTotal: "Monat gesamt",
            backToYear: "Zurück zum Jahr",
            drillHint: "Auf einen Monat klicken, um die Tageswerte zu sehen.",
          },
          dayChart: {
            title: "Tagesverlauf ({{days}} Tage)",
            subtitle: "Tägliche Werte der letzten Tage",
            current: "Jetzt",
            past: "Vorher",
          },
          legend: {
            current: "Aktueller Zeitraum",
            offset: "Vorperiode ({{days}} T. davor)",
          },
        },
        kpiHelp: {
          button: "Anleitung & Kennzahlen",
          buttonShort: "Hilfe",
          modalTitle: "KPI-Entwicklungen — Anleitung & Kennzahlen",
          intro:
            "Diese Ansicht zeigt die Entwicklung der wichtigsten Kennzahlen. Die Werte stammen aus den täglichen Snapshots (06:30 Uhr) und werden für abgeschlossene Tage eingefroren. Alle Werte sind Netto-Werte in Euro.",
          tabsTitle: "Die vier Unterreiter",
          tabActualTerm: "Ist-Werte",
          tabActualText:
            "Abgeschlossene Tage aus den täglichen Snapshots. Vergleicht den gewählten Zeitraum mit dem gleich langen Zeitraum davor (1/3/7/14/30 Tage zurück) und zeigt zusätzlich den Tagesverlauf als Liniendiagramm.",
          tabForecastTerm: "Entwicklung",
          tabForecastText:
            "Der aktuelle Buchungsstand für zukünftige Tage. Zeigt, wie sich ein Anreisetag über die Tage hinweg entwickelt hat (Pickup). Umsatzkennzahlen sind hier nicht verfügbar, weil die Verfügbarkeitsabfrage keine Preise liefert.",
          tabMonthlyTerm: "Monatsansicht",
          tabMonthlyText:
            "Eine Zeile pro Monat des Kalenderjahres, mit denselben Spalten wie im bisherigen Google-Sheet. Vergangene Monate zeigen Ist-Werte, zukünftige die Entwicklung. Budgets lassen sich hier pro Monat und Standort eintragen (nur Admin/Management).",
          tabExplorerTerm: "Explorer",
          tabExplorerText:
            "Zum Nachschauen: Jahr → Monat → Tag. Auf einen Monat klicken, um die einzelnen Tage zu sehen. Geeignet für Mehresjahres-Vergleiche und zum Prüfen auffälliger Monate.",
          readingTitle: "Anzeige & Bedienung",
          badgeActualTerm: "Grüner Badge „IST“",
          badgeActualText:
            "Der Monat enthält abgeschlossene Tage — die Zahlen sind endgültig.",
          badgeForecastTerm: "Blauer Badge „ZUKUNFT“",
          badgeForecastText:
            "Der Monat liegt ganz oder teilweise in der Zukunft — die Zahlen sind der aktuelle Buchungsstand und ändern sich täglich.",
          yearTerm: "Jahresauswahl ‹ 2026 ›",
          yearText:
            "Wechselt das Jahr in der Monatsansicht und im Explorer. Wichtig für Budgets: auch zukünftige Jahre (z. B. 2027) können vorab geplant werden. Der Knopf „Aktuelles Jahr“ springt zurück.",
          budgetTerm: "Budget & Differenz",
          budgetText:
            "Das Budget wird pro Standort und Monat gepflegt (Stift-Symbol, nur Admin/Management). Die Differenz ist Ist-Umsatz minus Budget — grün bei Überschreitung, rot bei Unterschreitung. Im Reiter „Alle Standorte“ wird das Budget über die Standorte summiert.",
          tooltipTerm: "Diagramme",
          tooltipText:
            "Mit der Maus über ein Diagramm fahren (auf dem Handy entlangziehen), um Datum, Umsatz und Zimmernächte des jeweiligen Tages zu sehen.",
          metricsTitle: "Kennzahlen & Formeln",
          mSoldUnitsText:
            "Verkaufte Zimmernächte im Zeitraum — die Anzahl der Übernachtungen, nicht der Buchungen.",
          mOccupancyText:
            "Die von Apaleo übermittelte Auslastung. Achtung: hier sind Out-of-Order-Zimmer enthalten, die Auslastung fällt also niedriger aus als ohne OOO.",
          mOccOooText:
            "Auslastung ohne Out-of-Order-Zimmer. Wird NICHT aus der übermittelten Auslastung herausgerechnet, sondern direkt berechnet — dafür werden die feste Zimmeranzahl des Standorts und die Tage des Zeitraums benötigt.",
          mNetRevenueText:
            "Netto-Logiserlös (ohne MwSt.) für den Zeitraum.",
          mAdrText:
            "Durchschnittlicher Netto-Zimmerpreis pro verkaufter Zimmernacht.",
          mRevparText:
            "Netto-Umsatz pro verfügbarer Zimmernacht. Wichtig: durch Zimmer × Tage geteilt — nicht nur durch die Zimmerzahl. Sonst wäre es der Monatsumsatz pro Zimmer und zwischen Monaten nicht vergleichbar.",
          mBudgetText:
            "Geplantes Netto-Umsatzziel für den Monat (pro Standort).",
          mDifferenceText:
            "Abweichung des Ist-Umsatzes vom Budget.",
          notesTitle: "Hinweise & Grenzen",
          noteOooTerm: "Auslastung ohne OOO",
          noteOooText:
            "Für die Zimmeranzahl sind die physischen Zimmer je Standort hinterlegt (Berlin 189, Giessen 31, Siegen 102, Wetzlar 33). Ändert sich der Zimmerbestand, muss der Wert angepasst werden — sonst stimmt diese Kennzahl nicht mehr.",
          noteHorizonTerm: "Entwicklung-Horizont",
          noteHorizonText:
            "Die Entwicklung reicht so weit, wie der tägliche Snapshot blickt (aktuell ein Jahr). Weiter entfernte Monate zeigen daher noch keine Entwicklungswerte — sie füllen sich, sobald der Horizont sie erreicht.",
          noteHistoryTerm: "Historie",
          noteHistoryText:
            "Die Ist-Werte vor September 2026 stammen aus dem importierten Google-Sheet (ab 2023). Die täglichen Snapshots selbst gibt es erst seit September 2026.",
        },
        heatmaps: {
          revenueTitle: "Umsatz-Heatmap",
          revenueSubtitle: "Netto-Umsatz nach Woche × Wochentag",
          metricRevenue: "Umsatz",
          metricRns: "Zimmernächte",
          paceTitle: "Buchungstempo & Vorlaufzeit",
          paceSubtitle: "Buchungen nach Aufenthaltsmonat × Vorlaufzeit",
          stayMonth: "Aufenthaltsmonat",
          lead: {
            b1: "1-3 Tage",
            b2: "4-7 Tage",
            b3: "8-14 Tage",
            b4: "15-30 Tage",
            b5: "31+ Tage",
          },
          paceExplainer: "Zeilen = Anreisemonat, Spalten = Vorlaufzeit zwischen Buchung und Anreise",
          noData: "Keine Heatmap-Daten im gewählten Zeitraum",
          kw: "KW {{week}}",
        },
        loadingMetrics: "Metriken werden aggregiert...",
        kpi: {
          netRevenue: "Nettoumsatz",
          adr: "ADR (Netto)",
          revPar: "RevPAR",
          occupancy: "Auslastung",
          alos: "ALOS",
          roomNights: "Zimmernächte",
        },
        chartTitle: "Umsatzentwicklung",
        chartSubtitle: "Täglicher Netto-Logisumsatz",
        expandChart: "Diagramm vergrößern",
        collapseChart: "Diagramm verkleinern",
        realtimeMetrics: "Echtzeit-Metriken",
        night: "Nacht",
        nights: "Nächte",
        exportButton: "Exportieren",
        exportSuccess: "Daten erfolgreich exportiert",
        devMode: "Dev-Modus",
        calculation: {
          sum: "Summe",
          total: "Gesamt",
        },
      },
      anleitungen: {
        noContent: "Kein Inhalt verfasst.",
        title: "Anleitungen",
        subtitle: "Wissensdatenbank & Handbücher",
        newFolder: "Neuer Ordner",
        newManual: "Neues Handbuch",
        loadingFiles: "Lade Dateien...",
        folderEmpty: "Ordner leer",
        folderEmptySubtitle: "Noch keine Inhalte vorhanden",
        noSearchResults: "Keine Ergebnisse",
        noSearchResultsSubtitle: "Keine Treffer für deine Suche",
        globalSearchPrefix: 'Suchergebnisse für "',
        createFolderTitle: "Neuen Ordner erstellen",
        folderNameLabel: "Ordnername",
        cancel: "Abbrechen",
        create: "Erstellen",
        manualModalSubtitle: "Handbuchdetails & Inhalt",
        manualTitleLabel: "Titel",
        typeLabel: "Typ",
        typeMarkdown: "Markdown-Editor",
        typeUpload: "Datei-Upload",
        typeLink: "Web-Link",
        writeTab: "Bearbeiten",
        previewTab: "Vorschau",
        splitTab: "Geteilt",
        editorTitle: "Editor",
        directDownload: "Direkter Download",
        currentFile: "Aktuelle Datei",
        uploadConstraints: "PDF, DOC, PNG, JPG ΓÇö max. 20 MB",
        uploadProgress: "Upload-Fortschritt",
        webLinkLabel: "Web-Link",
        save: "Speichern",
        operatingManuals: "Betriebsanleitungen",
        fileManagement: "Dateimanagement",
        newEntry: "Neuer Eintrag",
        syncingCatalog: "Synchronisiere Katalog...",
        directoryEmpty: "Verzeichnis leer",
        directoryEmptySubtitle: "Noch keine Einträge vorhanden",
        noHits: "Keine Treffer",
        globalHitsPrefix: 'Globale Treffer für "',
        createDirectoryTitle: "Neues Verzeichnis",
        directoryStructureSubtitle: "Verzeichnisstruktur verwalten",
        directoryNameLabel: "Verzeichnisname",
        saveManualSubtitle: "Handbuch speichern",
        formatTypeLabel: "Format",
        markdownEditor: "Markdown-Editor",
        uploadAttachment: "Anhang hochladen",
        hyperlink: "Hyperlink",
        editorTab: "Editor",
        splitView: "Geteilte Ansicht",
        visualEditor: "Visueller Editor",
        currentUpload: "Aktueller Upload",
        uploadConstraintsV2: "PDF, DOC, PNG, JPG ΓÇö max. 20 MB",
        uploadProgressV2: "Upload-Fortschritt",
        openInBrowser: "Im Browser öffnen",
        confirmDelete: 'Möchtest du "{{name}}" wirklich löschen?',
        deleteSuccess: "Erfolgreich gelöscht!",
        deleteError: "Löschfehler: ",
        delete: "Löschen",
        editManual: "Handbuch bearbeiten",
        editorPlaceholder: "# Überschrift 1...",
        chooseFile: "Neue Datei auswählen",
        catalogSubtitle: "Katalog & Handbücher",
        editManualEntry: "Handbucheintrag bearbeiten",
        chooseDocument: "Dokument per Klick auswählen",
        backToList: "Zurück zur Übersicht",
        saveSuccess: "Erfolgreich gespeichert",
        deleteConfirm: "Wirklich löschen?",
        newVersionAvailable: "Neue Version verfügbar",
        outdated: "Veraltet",
        cannotDeleteSystemManual: "System-Anleitungen können nicht gelöscht werden",
        close: "Schließen",
        fileLabel: "Datei",
        folder: "Ordner",
        folderNotEmpty: "Ordner ist nicht leer",
        searchPlaceholder: "Anleitungen suchen\u2026",
        systemManualTitle: "System-Anleitung",
        noTenant: "Kein Mandant aktiv. Bitte neu anmelden.",
      },
      routingManagement: {
        loadGroupsError: "Fehler beim Laden der Gruppen: ",
        loadRoutingsError: "Fehler beim Laden der Routing-Regeln: ",
        enterBookingIdError: "Bitte wählen oder geben Sie eine Buchungs-ID ein.",
        enterDestFolioIdError: "Bitte geben Sie eine Ziel-Folio-ID an.",
        createRoutingSuccess: "Abrechnungs-Routing erfolgreich erstellt.",
        createRoutingError: "Fehler beim Erstellen des Routings: ",
        deleteRoutingSuccess: "Routing-Regel erfolgreich gelöscht.",
        deleteRoutingError: "Fehler beim Löschen der Routing-Regel: ",
        bookingSelectionTitle: "Buchungsauswahl für Abrechnungs-Routings",
        searchGroupLabel: "Gruppe suchen / auswählen",
        selectedGroupLabel: "Ausgewählte Gruppe",
        groupSearchPlaceholder: "Gruppe nach Name, ID oder Buchungs-ID suchen...",
        searchingRunning: "Suche läuft...",
        searching: "Suche...",
        noGroupsFound: "Keine Gruppen gefunden",
        bookingPrefix: "| Buchung:",
        manualBookingIdLabel: "Oder Buchungs-ID manuell",
        manualBookingIdPlaceholder: "z.B. B-101 oder PTCUCBDK",
        bookingLabel: "Buchung:",
        activeRoutingsTitle: "Aktive Routings ({{count}})",
        loadingRoutings: "Lade Routing-Regeln...",
        noRoutingsTitle: "Keine Routings vorhanden",
        noRoutingsDescription: "Für diese Buchung sind zurzeit keine automatischen Abrechnungs-Routings eingerichtet.",
        routeTo: "Route nach:",
        to: "bis",
        end: "Ende",
        deleteRuleTitle: "Regel löschen",
        newRoutingRuleTitle: "Neue Routing-Regel",
        destFolioIdLabel: "* Ziel-Folio-ID (Target)",
        destFolioIdPlaceholder: "z.B. FOL-MOCK-201 oder FOL-Schmidt",
        routingTypeLabel: "* Routing-Typ",
        serviceTypeOption: "Kategorie (ServiceType)",
        serviceOption: "Artikel (Service)",
        categoryLabel: "* Kategorie",
        serviceNameLabel: "* Artikelname",
        serviceNamePlaceholder: "z.B. Frühstück",
        validFromLabel: "Gültig ab (Optional)",
        validToLabel: "Gültig bis (Optional)",
        creating: "Erstelle...",
        createRoutingButton: "Routing erstellen",
        noBookingTitle: "Keine Buchung gewählt",
        noBookingDescription: "Wählen Sie oben eine Gruppe oder geben Sie eine Buchungs-ID manuell ein, um aktive Abrechnungs-Routings zu verwalten oder neue Erstattungsregeln hinzuzufügen.",
        typeSubAccount: "Sub-Account",
        typeServiceType: "Service-Typ",
        typeService: "Service",
        typeComplete: "Komplett",
        typeAllPostings: "Alle Buchungsposten"
      },
      reservationImporter: {
        loadGroupsError: "Fehler beim Laden der Gruppen: ",
        loadBlocksError: "Fehler beim Laden der Blöcke: ",
        fileEmptyError: "Die hochgeladene Datei ist leer.",
        readExcelError: "Fehler beim Lesen der Excel-Datei.",
        lastNameMissing: "Nachname fehlt.",
        arrivalMissingDefault: "Anreise fehlt, Standard: {{date}}",
        arrivalOutsideRange: "Anreise ({{date}}) außerhalb des Kontingent-Zeitraums.",
        departureMissingDefault: "Abreise fehlt, Standard: {{date}}",
        departureOutsideRange: "Abreise ({{date}}) außerhalb des Kontingent-Zeitraums oder vor Anreise.",
        noValidRows: "Keine gültigen Reservierungszeilen zum Importieren vorhanden.",
        batchError: "Batch ab Zeile {{line}}: {{message}}",
        title: "Gästelisten-Importer",
        subtitle: "Erstellen Sie Reservierungen en bloc aus Excel/CSV-Tabellen",
        fileLabel: "Datei",
        step: "Schritt {{current}} von {{total}}",
        searchGroupLabel: "* Gruppe suchen / auswählen",
        selectedGroupLabel: "Ausgewählte Gruppe",
        groupSearchPlaceholder: "Gruppe nach Name, ID oder Buchungs-ID suchen...",
        searchingRunning: "Suche läuft...",
        searching: "Suche...",
        noGroupsFound: "Keine Gruppen gefunden",
        bookingPrefix: "| Buchung:",
        selectBlockLabel: "* Kontingent (Block) auswählen",
        selectBlockOption: "Kontingent wählen...",
        to: "bis",
        activeBlockLabel: "Aktives Kontingent",
        uploadPrompt: "Klicken Sie zum Hochladen oder ziehen Sie eine Datei hierher",
        uploadFormats: "Erlaubt: Excel (.xlsx) oder CSV",
        columnMappingDescription: "Spaltenzuordnung: Ordnen Sie die Excel-Spalten den Apaleo-Feldern zu.",
        notMapped: "-- Nicht zugeordnet --",
        back: "Zurück",
        previewAndValidate: "Vorschau & Validierung",
        guestNameHeader: "Gastname",
        emailHeader: "E-Mail",
        arrivalHeader: "Anreise",
        departureHeader: "Abreise",
        adultsChildrenHeader: "Erw / Kind",
        statusHeader: "Status",
        unknown: "Unbekannt",
        warning: "Warnung",
        ok: "OK",
        error: "Fehler",
        importStart: "Import starten ({{count}} Zeilen)",
        importingList: "Importiere Gästeliste...",
        percentComplete: "{{percent}}% abgeschlossen",
        importComplete: "Importvorgang abgeschlossen",
        batchResults: "Ergebnisse der Stapelverarbeitung:",
        successful: "Erfolgreich",
        failed: "Fehlgeschlagen",
        followingErrors: "Folgende Fehler sind aufgetreten:",
        newImport: "Neuer Import"
      },
      serviceQuickBooking: {
        loadGroupsError: "Fehler beim Laden der Gruppen: ",
        loadBlocksError: "Fehler beim Laden der Blöcke: ",
        loadReservationsError: "Fehler beim Laden der Reservierungen: ",
        loadServicesError: "Fehler beim Laden der Services: ",
        selectServiceError: "Bitte wählen Sie einen Service aus.",
        selectReservationError: "Bitte wählen Sie mindestens eine Reservierung aus.",
        title: "Service-Schnellbuchung",
        subtitle: "Buchen Sie einen Service en bloc für alle oder ausgewählte Reservierungen eines Kontingents.",
        searchGroupLabel: "* Gruppe suchen / auswählen",
        selectedGroupLabel: "Ausgewählte Gruppe",
        groupSearchPlaceholder: "Gruppe nach Name, ID oder Buchungs-ID suchen...",
        searchingRunning: "Suche läuft...",
        searching: "Suche...",
        noGroupsFound: "Keine Gruppen gefunden",
        bookingPrefix: "| Buchung:",
        selectBlockLabel: "* Kontingent (Block) auswählen",
        selectBlockOption: "Kontingent wählen...",
        to: "bis",
        guestListTitle: "Gästeliste ({{count}})",
        selectAll: "Alle auswählen",
        deselectAll: "Alle abwählen",
        loadingReservations: "Lade Reservierungen...",
        noActiveReservations: "Keine aktiven Reservierungen",
        noActiveReservationsDesc: "Für dieses Kontingent wurden noch keine aktiven Reservierungen erstellt.",
        unknownGuest: "Unbekannter Gast",
        roomUnknown: "Zimmer?",
        adults: "Erw",
        serviceConfigTitle: "Servicekonfiguration",
        selectServiceLabel: "Service auswählen",
        loadingServicesFor: "Lade Services für {{propertyId}}...",
        noServicesFound: "Keine Services für dieses Hotel gefunden.",
        pricePrefix: "Preis:",
        overridePriceLabel: "Preis überschreiben (EUR)",
        bookingCountLabel: "Anzahl Buchungsposten",
        countTypeDefault: "Standard (Frühstück = Erw-Anzahl, Sonst = 1)",
        countTypeCustom: "Manuell festlegen",
        bookServiceButton: "Service buchen für {{count}} Reservierungen",
        bookingServices: "Buche Services...",
        percentComplete: "{{percent}}% abgeschlossen",
        bookingComplete: "Schnellbuchung abgeschlossen",
        serviceResults: "Ergebnisse der Service-Buchungen:",
        successfullyBooked: "Erfolgreich gebucht",
        failed: "Fehlgeschlagen",
        followingErrors: "Folgende Fehler sind aufgetreten:",
        doneNewBooking: "Fertig / Neue Buchung"
      },
      groupsList: {
        loadGroupsError: "Fehler beim Laden der Gruppen: ",
        loadBlocksError: "Fehler beim Laden der Blöcke: ",
        fillRequiredFields: "Bitte füllen Sie alle Pflichtfelder aus.",
        createGroupSuccess: "Gruppe erfolgreich erstellt.",
        createGroupError: "Fehler beim Erstellen der Gruppe: ",
        createBlockSuccess: "Zimmerkontingent (Block) erfolgreich erstellt.",
        createBlockError: "Fehler beim Erstellen des Blocks: ",
        enterLastName: "Bitte geben Sie einen Nachnamen an.",
        createReservationSuccess: "Reservierung erfolgreich erstellt.",
        bookingError: "Fehler beim Buchen: ",
        searchPlaceholder: "Gruppenname, Bucher, Booking ID...",
        arrivalFrom: "Anreise ab",
        departureTo: "Abreise bis",
        bis: "bis",
        allLocations: "Standort: Alle",
        createGroupButton: "Gruppe erstellen",
        groupsTitle: "Gruppenbuchungen",
        loadingGroups: "Lade Gruppen...",
        noGroupsTitle: "Keine Gruppen vorhanden",
        noGroupsDescription: "Erstellen Sie eine neue Gruppe oder passen Sie die Filter an.",
        bookingLabel: "Booking:",
        contactPerson: "Ansprechpartner / Booker",
        properties: "Betrieb(e)",
        comment: "Kommentar",
        blocksTitle: "Zimmerkontingente (Blocks)",
        addBlockButton: "Kontingent hinzufügen",
        loadingBlocks: "Lade Kontingente...",
        noBlocksTitle: "Keine Kontingente eingerichtet",
        noBlocksDescription: "Legen Sie für diese Gruppe ein Zimmerkontingent über \"Kontingent hinzufügen\" an.",
        defaultUnitGroup: "Double Room",
        ratePrefix: "Rate:",
        defaultRatePlan: "Standard Rate",
        perNight: "pro Nacht",
        bookButton: "Buchen",
        period: "Zeitraum",
        bookedBlocked: "Gebucht / Gesperrt",
        occupancy: "Auslastung",
        noGroupSelected: "Keine Gruppe ausgewählt",
        noGroupSelectedDescription: "Wählen Sie eine Gruppenbuchung aus der Liste links, um Details anzuzeigen, Kontingente einzurichten und Excel-Gästelisten zu importieren.",
        createGroupModalTitle: "Neue Gruppe erstellen",
        createGroupModalSubtitle: "Legen Sie eine neue Apaleo-Gruppenbuchung an",
        groupNameLabel: "* Gruppenname",
        groupNamePlaceholder: "z.B. Schmidt Hochzeitsgesellschaft",
        bookerFirstNameLabel: "Vorname Bucher",
        bookerLastNameLabel: "* Nachname Bucher",
        bookerEmailLabel: "* E-Mail Bucher",
        firstNamePlaceholder: "Max",
        lastNamePlaceholder: "Mustermann",
        emailPlaceholder: "max@muster.de",
        propertyLabel: "* Standort / Property",
        commentLabel: "Kommentar / Notiz",
        commentPlaceholder: "Zusätzliche Bemerkungen...",
        cancel: "Abbrechen",
        creating: "Erstelle...",
        saveGroup: "Gruppe speichern",
        createBlockModalTitle: "Zimmerkontingent einrichten",
        createBlockModalSubtitle: "Block erstellen für Gruppe: {{name}}",
        ratePlanLabel: "* Ratenplan",
        selectRatePlan: "Ratenplan wählen",
        unitGroupLabel: "* Zimmerkategorie",
        selectCategory: "Kategorie wählen",
        arrivalFromLabel: "* Anreise ab",
        departureToLabel: "* Abreise bis",
        unitsCountLabel: "* Zimmeranzahl (Sperrung)",
        dailyRateLabel: "* Tagesrate Brutto",
        saveBlock: "Kontingent erstellen",
        editBlockModalTitle: "Kontingent bearbeiten",
        editBlockModalSubtitle: "Ändern Sie Zeitraum, Zimmeranzahl oder Rate des Kontingents.",
        editBlockFixedLabel: "Fix (nicht änderbar): Ratenplan & Zimmerkategorie",
        editBlockButton: "Bearbeiten",
        editBlockButtonTitle: "Kontingent bearbeiten",
        updatingBlock: "Speichere...",
        saveBlockEdit: "Änderungen speichern",
        updateBlockSuccess: "Kontingent aktualisiert.",
        updateBlockError: "Fehler beim Aktualisieren des Kontingents: ",
        quickBookingModalTitle: "Zimmer buchen (Pickup)",
        quickBookingModalSubtitle: "Buchen im Block {{blockId}} ({{unitGroup}})",
        guestFirstNameLabel: "Vorname Gast",
        guestLastNameLabel: "* Nachname Gast",
        emailLabel: "E-Mail Adresse",
        personsAdultsLabel: "* Personen / Erwachsene",
        booking: "Buchen...",
        completeBooking: "Buchung abschließen",
        exportExcel: "Excel exportieren",
        importGuestList: "Gästeliste importieren",
        blockFull: "Kontingent voll",
        noRatesAvailable: "Keine Raten verfügbar",
        confirmDeleteBlock: "Kontingent wirklich löschen?",
        bookerInfoLabel: "Bucher-Informationen",
        subtitle: "Übersicht aller Gruppenreservierungen",
        title: "Gruppen",
        addedToQueue: "Gast zur Warteschlange hinzugefügt.",
        updateEntry: "Eintrag aktualisieren",
        addToQueue: "Zur Warteschlange hinzufügen",
        queueEmpty: "Warteschlange ist leer. Fügen Sie mindestens einen Gast hinzu.",
        bookAll: "Alle buchen",
        allBookingsSuccess: "{{count}} Reservierungen erfolgreich erstellt.",
        someBookingsFailed: "{{success}} erfolgreich, {{failed}} fehlgeschlagen.",
        allBookingsFailed: "Alle Buchungen sind fehlgeschlagen.",
        queueTitle: "Warteschlange",
        guestCount: "Gast {{index}}",
        remove: "Entfernen",
        edit: "Bearbeiten",
        bookingResults: "Buchungsergebnisse",
        close: "Schließen",
        retry: "Erneut versuchen",
        adultsShort: "Erw.",
      },
      supportTicket: {
        header: "Kundenservice & Support",
        headerSubtitle: "Support-Tickets verwalten & erstellen",
        yourTickets: "Ihre Tickets ({{count}})",
        newTicket: "Neues Ticket",
        noActiveTickets: "Keine aktiven Tickets",
        noActiveTicketsDesc: "Haben Sie Fragen oder ein technisches Problem? Erstellen Sie einfach ein Support-Ticket.",
        priorityHigh: "Hoch",
        priorityMedium: "Mittel",
        priorityLow: "Niedrig",
        statusOpen: "Offen",
        statusInProgress: "In Bearbeitung",
        statusResolved: "Gelöst",
        categoryGeneral: "Allgemeine Frage",
        categoryKassenbuch: "Kassenbuch",
        categoryHr: "Personal & Zeit (HR)",
        categoryTechnical: "Technischer Fehler",
        categoryNotification: "Benachrichtigung",
        categoryBilling: "Abrechnung",
        categoryUi: "Schaltflächen/Benutzeroberfläche",
        createTitle: "Neues Ticket einreichen",
        backToList: "Zurück zur Liste",
        subjectLabel: "Thema / Betreff",
        subjectPlaceholder: "Worum geht es?",
        categoryLabel: "Kategorie",
        priorityLabel: "Priorität",
        descriptionLabel: "Beschreibung",
        descriptionPlaceholder: "Beschreiben Sie Ihr Anliegen so detailliert wie möglich...",
        attachmentLabel: "Anhang (Optional, z. B. Screenshot)",
        chooseFile: "Datei auswählen",
        cancel: "Abbrechen",
        submitTicket: "Ticket absenden",
        tickets: "Tickets",
        priorityPrefix: "Prio: ",
        subjectPrefix: "Thema: ",
        attachment: "Anhang:",
        attachmentsCount: "Anhänge ({{count}}):",
        downloadAttachment: "Download Anhang",
        optionalMessage: "Optionale Nachricht hinzufügen...",
        writeReply: "Schreiben Sie eine Antwort...",
        ticketResolved: "Dieses Ticket wurde gelöst. Antworten öffnet das Ticket erneut.",
        reopenTicket: "Ticket wieder öffnen",
        employeeFallback: "Mitarbeiter",
        customerFallback: "Kunde",
        toastFillFields: "Bitte füllen Sie alle Felder aus.",
        toastUploadError: "Fehler beim Hochladen der Datei: {{message}}",
        toastCreated: "Support-Ticket erfolgreich erstellt!",
        toastCreateError: "Fehler beim Erstellen des Tickets: {{message}}",
        toastSendError: "Fehler beim Senden der Nachricht.",
        toastFileTooLarge: "Die Datei darf maximal 5MB groß sein.",
        toastReopened: "Ticket wieder geöffnet.",
        title: "Titel",
        titlePlaceholder: "Kurze Beschreibung des Problems",
        description: "Beschreibung",
        category: "Kategorie",
        categoryBug: "Fehler",
        categoryFeature: "Funktionswunsch",
        categoryQuestion: "Frage",
        categoryOther: "Sonstiges",
        priority: "Priorität",
        priorityCritical: "Kritisch",
        department: "Abteilung",
        departmentHousekeeping: "Housekeeping",
        departmentMaintenance: "Haustechnik",
        departmentReception: "Empfang",
        departmentManagement: "Management",
        replyPlaceholder: "Antwort eingeben...",
        internalNote: "Interne Notiz",
        customerReply: "Antwort an Kunde",
        statusClosed: "Geschlossen",
      },
      missingTime: {
        title: "Fehlende Zeiteinträge",
        subtitle: "Erfassung fehlender Arbeitszeiten",
        description: "Für die folgenden Tage fehlen Zeiteinträge:",
        endTimeLabel: "Endzeit",
        restoreButton: "Wiederherstellen",
        footerNote: "Bitte erfassen Sie die fehlenden Zeiten nach.",
      },
      hrAbsence: {
        title: "Abwesenheit erfassen",
        subtitle: "Neuen Abwesenheitsantrag stellen",
        employeeLabel: "Mitarbeiter",
        categoryLabel: "Kategorie",
        vacation: "Urlaub",
        sick: "Krankheit",
        compensatory: "Freizeitausgleich",
        training: "Aus-/Weiterbildung",
        other: "Sonstiges",
        periodStart: "Beginn",
        periodEnd: "Ende",
        statusApproved: "Genehmigt ✓",
        deleteTooltip: "Eintrag löschen",
        cancel: "Abbrechen",
        save: "Speichern",
        statusPending: "Ausstehend",
        statusRejected: "Abgelehnt",
      },
      hrEntitlement: {
        title: "Mitarbeiterdaten",
        subtitle: "Stammdaten und Urlaubsanspruch des Mitarbeiters",
        bulkSelected: "{{count}} Mitarbeiter ausgewählt",
        bulkHint: "Nur Felder, die du änderst, werden für ALLE ausgewählten Mitarbeiter gespeichert. Leere Felder bleiben unverändert.",
        bulkEditTitle: "Mehrfachbearbeitung",
        bulkToggleTitle: "Mitarbeiter für Mehrfachbearbeitung auswählen",
        selectAll: "Alle auswählen",
        deselectAll: "Alle abwählen",
        unchangedPlaceholder: "unverändert",
        sortHint: "Klicken zum Sortieren (aufsteigend/absteigend/zurücksetzen)",
        hoursPerWeek: "Stunden pro Woche",
        hoursPerWeekHint: "{{hours}} Std./Wo. verteilt auf {{days}} Arbeitstage ≈ {{perDay}} Std./Tag",
        weeklyHours: "Wochenstunden",
        workdaysSplitHint: "{{hours}} Std./Wo. verteilt auf {{days}} Arbeitstage ≈ {{perDay}} Std./Tag",
        employeeLabel: "Mitarbeiter",
        holidayStateLabel: "Bundesland",
        workLocationLabel: "Arbeitsort",
        workLocationUnassigned: "Nicht zugewiesen",
        employmentPeriod: "Anstellungszeitraum",
        entryDate: "Eintrittsdatum",
        exitDate: "Austrittsdatum",
        currentYear: "Aktuelles Jahr",
        vacationEntitlement: "Urlaubsanspruch (Tage)",
        currentYearLabel: "Aktuelles Jahr",
        carryoverLabel: "Resturlaub Vorjahr",
        nextYearStandardLabel: "Standard nächstes Jahr",
        vacationEntitlementStandard: "Standard-Urlaubsanspruch (Tage)",
        previousYearRemaining: "Resturlaub Vorjahr (Tage)",
        nextYear: "Nächstes Jahr",
        nextYearDescription: "Urlaubsanspruch für das nächste Jahr vorschauen",
        proRataCalculation: "Pro-rata Berechnung bei unterjährigem Eintritt/Austritt",
        applyValue: "Wert übernehmen",
        calculatedTotal: "Berechneter Gesamtanspruch",
        days: "Tage",
        workingModel: "Arbeitsmodell",
        cancel: "Abbrechen",
        save: "Speichern",
      },
      holidayStateModal: {
        title: "Bundesland zuweisen",
        subtitle: "Bestimmt die gesetzlichen Feiertage für die Urlaubsberechnung dieses Mitarbeiters.",
        currentState: "Aktuelles Bundesland",
        selectLabel: "Neues Bundesland",
        noState: "Kein Bundesland gesetzt",
        clearState: "Bundesland entfernen",
        cancel: "Abbrechen",
        save: "Speichern",
      },
      hrRolloverConfirm: {
        title: "Jahreswechsel durchführen",
        subtitle: "Übernahme der Resturlaubstage in das neue Jahr",
        warningLabel: "Achtung",
        warningBullet1: "Der Jahreswechsel kann nur einmal pro Jahr durchgeführt werden.",
        warningBullet2: "Nicht übertragbare Resturlaubstage verfallen.",
        warningBullet3: "Der Vorgang kann nicht rückgängig gemacht werden.",
        projectionLabel: "Projektion",
        thEmployee: "Mitarbeiter",
        thCurrentRemaining: "Aktueller Rest",
        thNextYearEntitlement: "Neuer Anspruch",
        thNewStatus: "Status",
        thFormula: "Formel",
        thEditablePlan: "Plan (editierbar)",
        thNewEntitlement: "Neuer Anspruch",
        thNewCarryover: "Übertrag",
        thNewTotal: "Neuer Gesamtanspruch",
        days: "Tage",
        pleaseWait: "Bitte warten...",
        confirmButton: "Jahreswechsel bestätigen",
        cancel: "Abbrechen",
        nextYear: "Nächstes Jahr",
        previousYear: "Vorjahr",
        warningText: "Sind Sie sicher, dass Sie den Jahreswechsel für alle Mitarbeiter durchführen möchten?",
      },
      adminTimesheet: {
        defaultComment: "Korrektur durch HR-Admin",
        correctionSuccess: "Korrektur gespeichert",
        fromPlaceholder: "Beginn",
        toPlaceholder: "Ende",
        correctionModule: "Zeitkorrektur",
        correctionSub: "Manuelle Korrektur der Arbeitszeit",
        modeLabel: "Korrekturart",
        modeDelta: "Stunden korrigieren",
        modeTimes: "Start/Ende setzen",
        timesReplaceHint: "Ersetzt alle Stempel dieses Tages (Start, Ende, Pause).",
        endAfterStart: "Die Endzeit muss nach der Startzeit liegen.",
        ongoingSessionBlocked: "Der Mitarbeiter ist gerade eingestempelt — bitte erst ausstempeln lassen.",
        dateLabel: "Datum",
        timeDiffLabel: "Differenz",
        documentationLabel: "Dokumentation",
        commentPlaceholder: "Grund der Korrektur...",
        saveCorrection: "Korrektur speichern",
        hoursAbbr: "Std.",
        minutesAbbr: "Min.",
        payout: "Auszahlung",
        payoutSuccess: "Auszahlung erfolgreich gebucht",
        payoutDefaultComment: "Auszahlung Überstunden",
      },
      historyTable: {
        date: "Datum",
        presence: "Anw.",
        break: "Pause",
        netWork: "Netto",
        diff: "Diff.",
        timeAccount: "Konto",
        correctionLog: "Korrektur",
        noData: "Keine Daten",
        pause: "Pause",
        active: "Aktiv",
        correctTimeTitle: "Arbeitszeit korrigieren",
        correctTimeSubtitle: "Kommen-/Gehen-Zeiten und Pause anpassen",
        startTimeLabel: "Kommen",
        endTimeLabel: "Gehen",
        breakLabel: "Pause (Minuten)",
        reasonLabel: "Grund der Korrektur",
        reasonPlaceholder: "z.B. Einstempeln vergessen...",
      },
      lateCheckout: {
        title: "Late Checkout buchen",
        subtitle: "Späte Abreise als Zusatzleistung",
        button: "Late Checkout",
        buttonTitle: "Late Checkout buchen",
        timeLabel: "Gewünschte Abreisezeit",
        timeHint: "Die Uhrzeit wird als Notiz an der Reservierung vermerkt, damit die Reinigung sie sieht.",
        serviceLabel: "Zusatzleistung",
        serviceLoading: "Leistungen werden geladen...",
        serviceMissing: "Für diese Unterkunft ist keine Late-Checkout-Leistung hinterlegt. Bitte in Apaleo anlegen und erneut versuchen.",
        info: "Die Leistung wird auf die Gästerechnung gebucht und die Reservierung erhält den Vermerk „LCO [Uhrzeit] gebucht“.",
        confirm: "Buchen",
        booking: "Wird gebucht...",
        cancel: "Abbrechen",
        success: "Late Checkout für {{time}} Uhr gebucht",
        commentFailed: "Late Checkout wurde gebucht, der Vermerk an der Reservierung konnte aber nicht gespeichert werden. Bitte manuell nachtragen.",
        error: "Late Checkout konnte nicht gebucht werden",
        unknownGuest: "Unbekannter Gast",
        room: "Zimmer",
        departure: "Abreise",
      },
      cleaningPlan: {
        loading: "Lade Reinigungsplan...",
        lateCheckout: "LCO",
        roomLabel: "Zimmer",
        remarks: "Bemerkungen",
        cleanButton: "Sauber melden",
        dirtyButton: "Schmutzig melden",
        statusCheckedOut: "Abgereist",
        statusDeparture: "Noch Abreise",
        statusInHouse: "Im Haus",
        statusConfirmed: "Anreise",
        conditionClean: "Sauber",
        conditionDirty: "Schmutzig",
        conditionInspection: "Inspektion",
        conditionUnknown: "Unbekannt",
        stayover: "Bleiber",
        statusFree: "Frei",
        noResults: "Keine Reinigungen gefunden",
        adultsAbbr: "Erw.",
        child: "Kind",
        children: "Kinder",
        longStayTooltip: "Langzeit-Bleiber",
        chooseDay: "Tag wählen",
        portrait: "Hochformat",
        landscape: "Querformat",
        selectRow: "Für Druck auswählen",
        deselectRow: "Druck-Auswahl aufheben",
        selectedCount: "{{count}} Zimmer für den Druck ausgewählt",
        clearSelection: "Auswahl aufheben",
      },
      traceCreate: {
        newTrace: "Neuer Trace",
        traceText: "Trace-Text",
        tracePlaceholder: "Was ist zu tun?",
        property: "Standort",
        assignment: "Zuständigkeit",
        selectDepartment: "Abteilung wählen",
        requester: "Melder / Auftraggeber",
        requesterPlaceholder: "Name des Melders",
        persons: "Personen",
        roomPrefix: "Zimmer",
        roomUnit: "Einheit",
        roomPlaceholder: "Zi.-Nr.",
        searchPlaceholder: "Nach Gast suchen...",
        searchingApaleo: "Apaleo-Suche...",
        minChars: "Mindestens 3 Zeichen",
        noResults: "Keine Ergebnisse",
        linkGuestReservation: "Gast / Reservierung verknüpfen",
        idLabel: "ID",
        arrival: "Anreise",
        departure: "Abreise",
        startFrom: "Erledigen ab",
        endBy: "Erledigen bis",
        attachFile: "Datei anhängen",
        addMoreFiles: "Weitere Datei anhängen",
        htDetails: "Haustechnik Details",
        htArea: "HT-Bereich",
        noArea: "Kein Bereich",
        painting: "Malern",
        damage: "Havarie",
        general: "Allgemein",
        deviceSwappedYes: "Gerät getauscht ✓",
        deviceSwappedNo: "Gerät getauscht?",
        recurringTrace: "Wiederkehrender Trace?",
        frequency: "Frequenz",
        daily: "Täglich",
        weekly: "Wöchentlich",
        monthly: "Monatlich",
        interval: "Intervall",
        days: "Tage",
        weeks: "Wochen",
        months: "Monate",
        endAfter: "Ende nach",
        amount: "Anzahl",
        endOn: "Ende am",
        anchor: "Anker",
        start: "Start",
        due: "Fällig",
        cancel: "Abbrechen",
        createTrace: "Trace erstellen",
        title: "Titel",
        titlePlaceholder: "z.B. Minibar auffüllen",
        description: "Beschreibung",
        descriptionPlaceholder: "Detaillierte Beschreibung des Vorgangs",
        priority: "Priorität",
        priorityLow: "Niedrig",
        priorityMedium: "Mittel",
        priorityHigh: "Hoch",
        priorityUrgent: "Dringend",
        category: "Kategorie",
        categoryHousekeeping: "Housekeeping",
        categoryMaintenance: "Wartung",
        categoryService: "Service",
        categoryComplaint: "Reklamation",
        categoryRequest: "Wunsch",
        notes: "Notizen",
        notesPlaceholder: "Interne Notizen...",
        addAttachment: "Anhang hinzufügen",
        removeAttachment: "Anhang entfernen",
        notifyByEmail: "Per E-Mail benachrichtigen",
        notifyByPush: "Per Push benachrichtigen",
        createAndAssign: "Erstellen & Zuweisen",
        createAndClose: "Erstellen & Schließen",
        saveAsTemplate: "Als Vorlage speichern",
        selectTemplate: "Vorlage auswählen",
        templateName: "Vorlagenname",
        estimatedTime: "Geschätzter Aufwand (Min.)",
      },
      profileMerge: {
        title: "Profile synchronisieren",
        subtitle: "Stammdatenbereinigung in Apaleo",
        minCharsToast: "Bitte gib mindestens 3 Zeichen für die Suche ein.",
        minCharsSearch: "Mindestens 3 Zeichen",
        manualSelection: "Manuelle Auswahl",
        allHits: 'Alle Treffer für "{{term}}"',
        unknownName: "Unbekannter Name",
        noEmail: "Keine E-Mail hinterlegt",
        noPhone: "Keine Telefonnummer hinterlegt",
        selectMinOneToast: "Bitte wähle mit den Checkboxen mindestens eine weitere Reservierung aus, die synchronisiert werden soll.",
        successMsg: "Erfolgreich! Die sauberen Gastdaten wurden auf {{count}} Reservierung(en) übertragen.",
        search: "Suche",
        searchPlaceholder: "Name, E-Mail...",
        grouping: "Gruppierung",
        all: "Alle",
        scanning: "Scanne Profile...",
        nothingFound: "Nichts gefunden.",
        startSearch: "Suche starten",
        noDetails: "Keine Details",
        dataComparison: "Daten-Abgleich",
        selectTarget: "Wähle das Ziel-Profil (grün) für die Synchronisation",
        collapseAll: "Alle zuklappen",
        expandAll: "Alle aufklappen",
        syncingCount: "{{count}} Reservierungen werden synchronisiert",
        identicalCount: "{{count}} Profile sind bereits identisch",
        synchronize: "Synchronisieren",
        target: "Ziel",
        sync: "Sync",
        resId: "Res-ID",
        arrival: "Anreise",
        guestData: "Gastdaten",
        contact: "Kontakt",
        ok: "✓ Ok",
        hideDetails: "Details schließen",
        showDetails: "Details anzeigen",
        address: "Anschrift",
        noAddress: "Keine Adresse hinterlegt",
        company: "Unternehmen",
        noCompany: "Kein Unternehmen",
        birthday: "Geburtstag",
        identity: "Identität",
        titleLabel: "Titel",
        gender: "Gender",
        nation: "Nation",
        selectGroup: "Gruppe auswählen",
        selectGroupHint: "Wähle links eine Gruppe aus, um die Profile auf einen sauberen Stand zu bringen.",
      },
      offerConfirmation: {
        invalidLink: "Ungültiger Angebotslink. Bitte kontaktieren Sie uns für ein neues Angebot.",
        loadError: "Angebot konnte nicht geladen werden.",
        connectionError: "Verbindungsfehler. Bitte versuchen Sie es später erneut.",
        confirmationFailed: "Bestätigung fehlgeschlagen",
        loading: "Angebot wird geladen...",
        notAvailable: "Angebot nicht verfügbar",
        expired: "Dieses Angebot ist abgelaufen (gültig bis {{date}}). Bitte fordern Sie ein neues Angebot an.",
        bookingConfirmed: "Buchung bestätigt!",
        alreadyConfirmed: "Bereits bestätigt",
        thankYouMessage: "Vielen Dank! Die Buchung ({{bookingId}}) wurde erfolgreich erstellt. Sie erhalten in Kürze eine Bestätigung per E-Mail.",
        alreadyConverted: "Dieses Angebot wurde bereits bestätigt und in eine Buchung umgewandelt.",
        bookingId: "Buchungs-ID",
        yourOffer: "Ihr Angebot",
        validUntil: "Gültig bis",
        location: "Standort",
        arrival: "Anreise",
        departure: "Abreise",
        guests: "Gäste",
        adults: "Erwachsene",
        children: "Kinder",
        category: "Kategorie",
        notSpecified: "Nicht spezifiziert",
        totalPrice: "Gesamtpreis",
        teamMessage: "Nachricht vom Team",
        company: "Firma",
        cancellationPolicy: "Stornierungsbedingungen",
        expiryNoticeTitle: "Hinweis zur Gültigkeit",
        expiryNotice: "Bitte beachten Sie, dass bis zur Bestätigung des Angebotes keine Zimmer fest geblockt werden und nicht bestätigte Angebote nach Ablauf der angegebenen Gültigkeit automatisch verfallen.",
        booking: "Wird gebucht...",
        acceptAndBook: "Angebot annehmen & buchen",
        questions: "Fragen zum Angebot?",
        termsAccept: "Mit der Buchung stimmen Sie unseren Allgemeinen Geschäftsbedingungen zu.",
        refresh: "Angebot neu laden",
        summary: "Zusammenfassung",
        details: "Details",
        servicesBreakdown: "Aufschlüsselung der Leistungen",
        cityTaxIncludedShort: "Darin enthaltene City Tax",
        perUnit: "pro Einheit",
        perNight: "pro Nacht",
        services: "Leistungen",
        servicesCount: "Leistungen",
        inPositions: "in",
        positions: "Positionen",
      },
      adminDashboard: {
        title: "Admin-Bereich",
        subtitle: "Mandanten, Webhooks, Tickets & Automatisierungen",
        tenants: "Mandanten",
        tenantList: "Mandantenliste",
        addTenant: "Mandant hinzufügen",
        tenantName: "Mandantenname",
        tenantId: "Mandanten-ID",
        tenantStatus: "Status",
        active: "Aktiv",
        inactive: "Inaktiv",
        suspend: "Sperren",
        unsuspend: "Entsperren",
        features: "Feature-Flags",
        automations: "Automatisierungen",
        syncStatus: "Sync-Status",
        lastSync: "Letzte Synchronisierung",
        mailSync: "E-Mail-Synchronisierung",
        runNow: "Jetzt ausführen",
        webhooks: "Webhooks",
        registerWebhook: "Webhook registrieren",
        retryWebhook: "Erneut versuchen",
        webhookLogs: "Webhook-Logs",
        webhookEventLog: "Webhook-Ereignisverlauf",
        webhookStatus: "Status",
        eventFilterAll: "Alle Ereignistypen",
        eventFilterFrom: "Von Datum",
        eventFilterTo: "Bis Datum",
        webhookResult: "Ergebnis",
        webhookNoEvents: "Keine Webhook-Ereignisse vorhanden",
        webhookStepOk: "OK",
        webhookStepIgnored: "Ignoriert",
        webhookStepSkipped: "Übersprungen",
        webhookStepFailed: "Fehler",
        supportTickets: "Support-Tickets",
        createTicket: "Ticket erstellen",
        ticketSubject: "Betreff",
        ticketMessage: "Nachricht",
        submitTicket: "Ticket absenden",
        ticketCount: "{{count}} Tickets",
        search: "Suchen...",
        filter: "Filter",
        all: "Alle",
        logs: "Logs",
        success: "Erfolg",
        error: "Fehler",
        attachFile: "Datei anhängen",
        send: "Senden",
        sending: "Wird gesendet...",
        cancel: "Abbrechen",
        priority: "Priorität",
        status: "Status",
        onboardingCompleted: "Abgeschlossen",
        onboardingOpen: "Offen",
        liveUsers: "Live",
        liveUsersTitle: "Aktive Benutzer",
        liveUsersSubtitle: "{{count}} Benutzer aktuell online",
        live: "Live",
        noLiveUsers: "Keine Benutzer online",
        liveUser: "Benutzer",
        role: "Rolle",
        connectedSince: "Online seit",
        usage: {
          tab: "Nutzung",
          totalEvents: "Navigationen",
          activeUsers: "Aktive Benutzer",
          mostUsedMenus: "Meistgenutzte Menüs",
          leastUsedMenus: "Am wenigsten genutzt (UX-Priorität)",
          subtabBreakdown: "Untermenü-Nutzung nach Menü",
          dailyActivity: "Tägliche Aktivität",
          topUsers: "Aktivste Benutzer",
          refresh: "Aktualisieren",
          range7: "7 Tage",
          range30: "30 Tage",
          range90: "90 Tage",
          allTenants: "Alle Mandanten",
          noData: "Noch keine Nutzungsdaten — Daten sammeln sich ab der nächsten Navigation.",
          privacyNote: "Nutzungsanalyse: es werden nur Menü-/Untermenü-Navigationen erfasst (interne Benutzerkennung, Rolle, Menü). Keine Suchbegriffe, keine Gäste-/Reservierungsdaten. Speicherfrist 180 Tage.",
        },
      },
      automationBuilder: {
        common: {
          loading: "Lade Automatisierungen...",
          commaSeparated: "Mehrere Begriffe mit Komma trennen",
          all: "Alle",
          choose: "Bitte wählen",
          noneSelectedAll: "Nichts ausgewählt = keine Einschränkung",
        },
        workflowsSubtitle: "Deine eigenen Wenn-dann-Regeln",
        options: {
          languageDe: "Deutsch",
          languageEn: "Englisch",
        },
        statusGroups: {
          open: "Offen",
          in_progress: "In Bearbeitung",
          done: "Erledigt",
          cancelled: "Gelöscht",
        },
        dueMode: {
          all: "Alle offenen Traces",
          today: "Bis heute fällig",
          overdue: "Nur überfällig (vor heute)",
        },
        placeholders: {
          title: "Verfügbare Platzhalter",
          example: "Beispiel",
          booking_arrived: {
            event: "Kurzbeschreibung des Auslösers, z. B. inklusive gebuchter Extras",
            property: "Das Haus, für das die Regel ausgelöst hat",
          },
          email_received: {
            event: "Kurzbeschreibung (neue E-Mail im Postfach)",
            property: "Das Haus, für das die Regel ausgelöst hat",
          },
          invoice_created: {
            event: "Kurzbeschreibung inkl. Rechnungsnummer",
            property: "Das Haus, für das die Regel ausgelöst hat",
          },
          every_day_at: {
            event: "Kurzbeschreibung inkl. Uhrzeit",
            property: "Das Haus, für das die Regel ausgelöst hat",
          },
          traces_digest_at: {
            count: "Anzahl der offenen Traces",
            overdue: "Anzahl der überfälligen Traces",
            scope: "Kurzbeschreibung der Filter (Abteilung, Haus, Fälligkeit)",
            date: "Das Datum des Versands",
          },
          overbooking_detected: {
            event: "Kurzbeschreibung inkl. schlechtester Verfügbarkeit, z. B. Überbuchung (-1)",
            dates: "Der Aufenthaltszeitraum, z. B. 05.10. und 08.10.",
            property: "Das Haus, für das die Regel ausgelöst hat",
          },
        },
        builder: {
          title: "Automatisierungs-Regeln",
          titleTooltip: "Hier legst du eigene Regeln fest: Wenn etwas passiert, macht AdaptHub automatisch etwas dafür. Kein technisches Wissen nötig.",
          subtitle: "Deine eigenen Wenn-dann-Regeln – ganz ohne Technik",
          create: "Neue Regel",
          createTooltip: "Startet eine Schritt-für-Schritt-Anleitung, um eine neue Automatisierung anzulegen.",
          templates: "Vorlagen",
          templatesTooltip: "Fertige Beispiele zum Ausprobieren – mit einem Klick startklar.",
          empty: "Noch keine eigenen Regeln angelegt. Starte mit einer Vorlage oder klicke auf \"Neue Regel\".",
        },
        triggers: {
          booking_arrived: {
            label: "Eine neue Buchung kommt an",
            tooltip: "Löst aus, sobald eine neue Reservierung in Apaleo ankommt (z. B. von Booking.com oder der eigenen Website).",
            fields: {
              rateCodeContains: {
                label: "Nur Buchungen mit diesem Preiscode",
                tooltip: "Trage hier etwas ein, wenn die Regel nur bei bestimmten Preiscodes gelten soll. Leer lassen = alle Buchungen.",
              },
              servicesInclude: {
                label: "Nur Buchungen mit einem dieser Extras",
                tooltip: "Komma-getrennte Codes von Extras (z. B. BABYBETT, AUFB_ERW). Leer = alle Buchungen.",
              },
              propertyId: {
                label: "Nur für dieses Haus",
                tooltip: "Optional: Regel auf ein bestimmtes Haus beschränken. Leer = alle Häuser.",
              },
            },
          },
          email_received: {
            label: "Eine neue E-Mail kommt an",
            tooltip: "Löst aus, sobald eine neue E-Mail in einem beobachteten Postfach ankommt.",
            fields: {
              fromAddressContains: {
                label: "Nur E-Mails von diesem Absender",
                tooltip: "Teil der Absenderadresse, z. B. \"booking.com\". Leer = beliebiger Absender.",
              },
              subjectContains: {
                label: "Nur E-Mails mit diesem Wort im Betreff",
                tooltip: "Wort oder Text, der im Betreff vorkommen muss. Leer = beliebiger Betreff.",
              },
              mailbox: {
                label: "Nur in diesem Postfach",
                tooltip: "Optional: Regel auf ein bestimmtes Postfach beschränken. Leer = alle Postfächer.",
              },
            },
          },
          invoice_created: {
            label: "Eine neue Rechnung kommt an",
            tooltip: "Löst aus, sobald eine neue Rechnung in Apaleo erzeugt wird (z. B. durch den Nacht-Abschluss).",
            fields: {
              propertyId: {
                label: "Nur für dieses Haus",
                tooltip: "Optional: Regel auf ein bestimmtes Haus beschränken. Leer = alle Häuser.",
              },
            },
          },
          every_day_at: {
            label: "Täglich zu einer bestimmten Uhrzeit",
            tooltip: "Löst jeden Tag zur eingestellten Uhrzeit aus (Serverzeit/UTC). Ideal für morgendliche Aufgaben-Übersichten.",
            fields: {
              timeOfDay: {
                label: "Uhrzeit (HH:MM)",
                tooltip: "Uhrzeit im 24-Stunden-Format, z. B. 08:00. Die Regel feuert stündlich auf die Minute genau.",
              },
            },
          },
          traces_digest_at: {
            label: "Tägliche Erinnerung an offene Traces",
            tooltip: "Verschickt jeden Tag zur eingestellten Uhrzeit eine E-Mail mit der Anzahl offener Traces und einer Liste mit Links. Die Uhrzeit gilt in deutscher Zeit (Berlin), auch bei Sommer-/Winterzeit.",
            fields: {
              timeOfDay: {
                label: "Uhrzeit (HH:MM)",
                tooltip: "Uhrzeit in deutscher Zeit, z. B. 19:00. Der Versand läuft stündlich, deshalb zählt die volle Stunde (19:15 wird als 19:00 verschickt).",
              },
              statusGroups: {
                label: "Welche Status zählen als offen?",
                tooltip: "Nichts auswählen = Offen und In Bearbeitung. Erledigte oder gelöschte Traces werden dann nicht mitgezählt.",
              },
              departments: {
                label: "Nur diese Abteilungen",
                tooltip: "Nichts auswählen = alle Abteilungen. Für ein Haus pro Abteilung eine eigene Regel anlegen.",
              },
              propertyId: {
                label: "Nur dieses Haus",
                tooltip: "Nichts auswählen = alle Häuser. So kann pro Haus eine eigene Erinnerung angelegt werden.",
              },
              dueMode: {
                label: "Welche Fälligkeit?",
                tooltip: "Alle offenen = jeder offene Trace. Bis heute = heute oder früher fällig. Nur überfällig = vor heute fällig.",
              },
            },
          },
          overbooking_detected: {
            label: "Eine Überbuchung wird erkannt",
            tooltip: "Prüft bei jeder Buchung automatisch, ob die Verfügbarkeit des Zimmertyps für den Aufenthalt überbucht ist (keine freien Zimmer). Löst dann aus.",
            fields: {
              propertyId: {
                label: "Nur für dieses Haus",
                tooltip: "Optional: Regel auf ein bestimmtes Haus beschränken (z. B. eine Info-Adresse pro Haus). Leer = alle Häuser.",
              },
            },
          },
        },
        actions: {
          send_push: {
            label: "Eine Benachrichtigung senden",
            tooltip: "Sendet eine App-Benachrichtigung an eine Abteilung oder Person.",
            fields: {
              department: {
                label: "An wen? (Abteilung oder Name)",
                tooltip: "Empfänger der Benachrichtigung, z. B. Rezeption, Housekeeping oder ein Personenname. Pflichtfeld.",
              },
              messageTemplate: {
                label: "Nachricht (optional)",
                tooltip: "Text der Benachrichtigung. Der Platzhalter {{event}} wird durch eine Kurzbeschreibung des Auslösers ersetzt.",
              },
            },
          },
          create_trace: {
            label: "Eine Aufgabe (Trace) anlegen",
            tooltip: "Legt automatisch eine Aufgabe im Trace-System an.",
            fields: {
              title: {
                label: "Titel der Aufgabe",
                tooltip: "Text, der als Aufgabenname erscheint.",
              },
              department: {
                label: "Zuständige Abteilung",
                tooltip: "Wem die Aufgabe zugewiesen wird (Standard: Housekeeping).",
              },
              titleFromService: {
                label: "Titel automatisch aus dem Extra ableiten",
                tooltip: "Wenn aktiviert, wird der Code des passenden Extras als Aufgabentitel verwendet.",
              },
            },
          },
          send_email: {
            label: "Eine E-Mail senden",
            tooltip: "Sendet eine Benachrichtigungs-E-Mail an eine Mitarbeiterin oder einen Mitarbeiter.",
            fields: {
              toEmail: {
                label: "An welche E-Mail-Adresse?",
                tooltip: "E-Mail-Adresse des Empfängers. Pflichtfeld.",
              },
              subject: {
                label: "Betreff (optional)",
                tooltip: "Betreffzeile. Der Platzhalter {{event}} wird durch eine Kurzbeschreibung des Auslösers ersetzt.",
              },
              bodyTemplate: {
                label: "Text (optional)",
                tooltip: "E-Mail-Text. {{event}} = Kurzbeschreibung des Auslösers; bei Überbuchungs-Regeln zusätzlich {{dates}} = Aufenthaltszeitraum (z. B. \"01.10. und 05.10.\").",
              },
            },
          },
          send_trace_digest: {
            label: "Tägliche Trace-Erinnerung per E-Mail",
            tooltip: "Sendet jeden Tag eine E-Mail mit der Anzahl offener Traces und einer Liste mit Links. Braucht den Auslöser Tägliche Erinnerung an offene Traces.",
            fields: {
              toEmail: {
                label: "An welche E-Mail-Adresse?",
                tooltip: "Empfänger der Erinnerung, z. B. info@adaptberlin.de. Pflichtfeld.",
              },
              subject: {
                label: "Betreff (optional)",
                tooltip: "Betreffzeile. Platzhalter: {{count}} = Anzahl, {{overdue}} = überfällig, {{scope}} = Filter, {{date}} = Datum.",
              },
              bodyTemplate: {
                label: "Text oben in der Mail (optional)",
                tooltip: "Einleitung über der Trace-Liste. Platzhalter: {{count}} = Anzahl, {{overdue}} = überfällig, {{scope}} = Filter, {{date}} = Datum. Leer = Standard-Text.",
              },
              statusGroups: {
                label: "Status (überschreibt den Auslöser)",
                tooltip: "Optional. Nur nötig, wenn die Erinnerung anders zählen soll als im Auslöser eingestellt.",
              },
              departments: {
                label: "Abteilungen",
                tooltip: "Optional. Nichts auswählen = alle Abteilungen.",
              },
              propertyId: {
                label: "Haus",
                tooltip: "Optional. Nichts auswählen = alle Häuser.",
              },
              dueMode: {
                label: "Fälligkeit",
                tooltip: "Steuert Liste und Zähler: alle offenen, bis heute fällig oder nur überfällig.",
              },
              includeTitles: {
                label: "Trace-Titel in der Liste anzeigen",
                tooltip: "Ohne Haken enthält die Liste nur Haus, Abteilung und Links – keine Titel. Sinnvoll, wenn Titel Gästenamen enthalten könnten.",
              },
              includeBreakdown: {
                label: "Aufteilung pro Abteilung mitschicken",
                tooltip: "Ergänzt eine Zeile wie Housekeeping: 4; Rezeption: 2.",
              },
              alwaysSend: {
                label: "Auch bei 0 offenen Traces senden",
                tooltip: "Ohne Haken wird an Tagen ohne offene Traces keine E-Mail verschickt.",
              },
              language: {
                label: "Sprache der E-Mail",
                tooltip: "Standard: Deutsch.",
              },
            },
          },        },
        wizard: {
          title: "Automatisierung erstellen",
          step1: "Wann?",
          step2: "Eingrenzen",
          step3: "Was tun?",
          whenQuestion: "Wann soll die Automatisierung ausgelöst werden?",
          narrowQuestion: "Soll sie nur in bestimmten Fällen ausgelöst werden?",
          narrowOptional: "Alles leer lassen gilt für alle Fälle.",
          whatQuestion: "Was soll passieren?",
          ruleName: "Name der Regel",
          ruleNamePlaceholder: "z. B. Babybett-Task bei neuer Buchung",
          ruleNameTooltip: "Ein verständlicher Name, damit alle im Team wissen, was diese Regel tut.",
          defaultName: "{{trigger}} → {{action}}",
          startDisabled: "Neue Regeln starten deaktiviert. Du aktivierst sie mit einem Klick auf den Schalter, sobald alles passt.",
          startDisabledTooltip: "So kannst du in Ruhe prüfen, ob die Regel richtig eingestellt ist, bevor sie läuft.",
          next: "Weiter",
          back: "Zurück",
          cancel: "Abbrechen",
          close: "Schließen",
          save: "Regel speichern",
          saving: "Speichert...",
          saved: "Regel gespeichert (startet deaktiviert)",
          saveError: "Regel konnte nicht gespeichert werden",
        },
        rule: {
          enabled: "Aktiv",
          disabled: "Aus",
          enableTooltip: "Regel einschalten – sie läuft ab jetzt automatisch.",
          disableTooltip: "Regel ausschalten (Not-Aus). Es passiert sofort nichts mehr.",
          history: "Verlauf",
          historyTooltip: "Zeigt, wann diese Regel zuletzt gelaufen ist und ob es geklappt hat.",
          edit: "Bearbeiten",
          editTooltip: "Regel ändern.",
          delete: "Löschen",
          deleteTooltip: "Regel endgültig löschen.",
          deleteConfirm: "Diese Regel wirklich löschen?",
        },
        history: {
          title: "Verlauf: {{name}}",
          empty: "Diese Regel ist noch nicht gelaufen.",
          emptyTooltip: "Sobald die Regel aktiv ist und auslöst, erscheinen hier die Ausführungen.",
          status: {
            success: "Erfolgreich",
            failed: "Fehlgeschlagen",
            skipped_throttled: "Übersprungen (Limit)",
          },
        },
        templates: {
          title: "Fertige Vorlagen",
          tracesDigest: {
            name: "Tägliche Trace-Erinnerung",
            tooltip: "Verschickt jeden Tag um 19:00 Uhr eine E-Mail mit der Anzahl offener Traces und einer Liste mit Links. Danach noch Abteilung und Haus einstellen.",
          },
          extraBed: {
            name: "Zustellbett-Buchung → Haushalt-Aufgabe",
            tooltip: "Bei einer neuen Buchung mit Zustellbett wird automatisch eine Aufgabe fürs Housekeeping angelegt.",
          },
          bookingPush: {
            name: "Neue Buchung → Nachricht an Rezeption",
            tooltip: "Die Rezeption bekommt bei jeder neuen Buchung eine App-Benachrichtigung.",
          },
          emailPush: {
            name: "Neue E-Mail → Nachricht an Buchhaltung",
            tooltip: "Die Buchhaltung wird bei jeder neuen E-Mail im Postfach benachrichtigt.",
          },
          overbookingBerlin: {
            name: "Überbuchung Berlin → info@adaptberlin.de",
            tooltip: "Bei einer Überbuchung im Haus Berlin wird eine E-Mail an info@adaptberlin.de gesendet (Port des Make.com-Szenarios).",
          },
          overbookingGiessen: {
            name: "Überbuchung Giessen → info@adaptgiessen.de",
            tooltip: "Bei einer Überbuchung im Haus Giessen wird eine E-Mail an info@adaptgiessen.de gesendet.",
          },
          overbookingWetzlar: {
            name: "Überbuchung Wetzlar → info@adaptwetzlar.de",
            tooltip: "Bei einer Überbuchung im Haus Wetzlar wird eine E-Mail an info@adaptwetzlar.de gesendet.",
          },
          overbookingSiegen: {
            name: "Überbuchung Siegen → info@adaptsiegen.de",
            tooltip: "Bei einer Überbuchung im Haus Siegen wird eine E-Mail an info@adaptsiegen.de gesendet.",
          },
        },
      },
      automations: {
        title: "Automatisierungen",
        subtitle: "Workflows und Regeln verwalten",
        description: "Konfiguriere automatische Abläufe für dein Hotel",
        addAutomation: "Automatisierung hinzufügen",
        noAutomations: "Keine Automatisierungen konfiguriert",
        enable: "Aktivieren",
        disable: "Deaktivieren",
        enabled: "Aktiviert",
        disabled: "Deaktiviert",
        active: "Aktiv",
        inactive: "Inaktiv",
        settings: "Einstellungen",
        save: "Speichern",
        cancel: "Abbrechen",
        runHistory: "Ausführungsverlauf",
        lastRun: "Letzte Ausführung",
        nextRun: "Nächste Ausführung",
        success: "Erfolgreich",
        failed: "Fehlgeschlagen",
        serviceCode: "Service-Code",
        serviceTitle: "Service-Titel",
        department: "Abteilung",
        serviceCodeLabel: "Service-Code",
        serviceTitleLabel: "Service-Titel",
        departmentLabel: "Abteilung",
        tabAutomations: "Automatisierungen",
      },
  emailScans: {
    title: "E-Mail-Scans",
    description: "Outlook-Buchungs-Scan, D-Edge-Storno-Scan und HRS-Firmen-Scan: Setups, Retry-Queue und detailliertes Ereignis-Log.",
    setups: "Setups",
    cronLabel: "Intervall",
    automaticOn: "Automatik an",
    automaticOff: "Nur manuell",
    connectingOutlook: "Verbinde mit Outlook 365...",
    runFailed: "Scan fehlgeschlagen.",
    runProcessed: "{{count}} E-Mail(s) verarbeitet.",
    "queue.title": "HRS-Warteschlange (wartet auf Reservierung)",
    "queue.noReference": "keine Referenz",
    "queue.attempts": "Versuch {{count}}/3",
    eventLog: "Detailliertes Ereignis-Log",
    loadEvents: "Ereignisse laden",
    noEvents: "Keine E-Mail-Scan-Ereignisse gefunden",
    runEntry: "Durchlauf abgeschlossen",
    "setup.outlook.title": "Outlook-Buchungs-Scan",
    "setup.outlook.description": "Durchsucht den D-Edge-Posteingang und verknüpft Buchungsreferenzen mit Reservierungen.",
    "setup.dedge.title": "D-Edge-Storno-Scan",
    "setup.dedge.description": "Prüft Storno-Mails gegen noch bestätigte Apaleo-Reservierungen.",
    "setup.hrs.title": "HRS-Firmen-Scan",
    "setup.hrs.description": "Verknüpft die Rechnungsfirma aus HRS-Buchungsbestätigungen mit der Apaleo-Reservierung (Adressabgleich, 3 Versuche).",
  },
      buchhaltung: {
        title: "Buchhaltung",
        subtitle: "Finanzen & Auswertungen",
        invoices: "Rechnungen",
        payments: "Zahlungen",
        allMerchants: "Alle Händler",
        apaleoPayInactive: "Apaleo Pay ist für diese Immobilie nicht aktiviert",
        createdAt: "Erstellt am",
        filterDate: "Datum filtern",
        filterProperties: "Immobilien filtern",
        merchantAccount: "Händlerkonto",
        payoutAmount: "Auszahlungsbetrag",
        payoutDate: "Auszahlungsdatum",
        payoutTotal: "Summe Auszahlungsbetrag",
        payoutTotalPending: "{{count}} offen",
        settlementId: "Abrechnungs-ID",
        batchNumber: "Batch-Nr.",
        settlements: "Abrechnungen",
        actions: "Aktionen",
        entries: "Einträge",
        deleteFolderConfirm: "Ordner \"{{name}}\" mit {{count}} Dateien wirklich löschen?",
        deleteTooDeep: "Ordner ist zu tief verschachtelt ({{depth}} Ebenen) — bitte in Teilen löschen",
        folderCreated: "Ordner erstellt",
        folderDeleted: "Ordner gelöscht",
        copyLink: "Link kopieren",
        linkCopied: "Link in die Zwischenablage kopiert",
        massDelete: "Massenlöschung",
        massDeleteConfirm: "Möchten Sie {{count}} Elemente wirklich löschen?",
        progress: "Fortschritt",
        receiptDeleted: "Beleg gelöscht",
        receiptUploaded: "Beleg hochgeladen",
        searchReceipts: "Belege suchen",
      },
      folderUpload: {
        title: "Datei-Upload",
        subtitle: "Dateien in Ordner hochladen",
        selectFiles: "Dateien auswählen",
        dragDrop: "Dateien hierher ziehen oder klicken",
        maxSize: "Maximale Dateigröße: 25MB",
        allowedTypes: "Erlaubte Formate: PDF, JPG, PNG",
        uploading: "Wird hochgeladen...",
        uploadSuccess: "Upload erfolgreich",
        uploadError: "Fehler beim Hochladen",
        folder: "Ordner",
        createFolder: "Ordner erstellen",
        folderName: "Ordnername",
        folderNamePlaceholder: "z.B. Rechnungen 2024",
        cancel: "Abbrechen",
        create: "Erstellen",
        delete: "Löschen",
        deleteConfirm: "Ordner wirklich löschen?",
        share: "Teilen",
        copy: "Kopieren",
        move: "Verschieben",
        rename: "Umbenennen",
        name: "Name",
        size: "Größe",
        type: "Typ",
        modified: "Geändert",
        created: "Erstellt",
        owner: "Besitzer",
        download: "Herunterladen",
        preview: "Vorschau",
        view: "Ansicht",
        list: "Liste",
        grid: "Raster",
        sortBy: "Sortieren nach",
        sortName: "Name",
        sortDate: "Datum",
        sortSize: "Größe",
        ascending: "Aufsteigend",
        descending: "Absteigend",
        refresh: "Aktualisieren",
        search: "Suchen...",
        clear: "Zurücksetzen",
        all: "Alle",
        files: "Dateien",
        folders: "Ordner",
        itemsSelected: "{{count}} Elemente ausgewählt",
        empty: "Keine Dateien vorhanden",
        emptyHint: "Lade deine erste Datei hoch",
        permission: "Berechtigung",
        permissionRead: "Lesen",
        permissionWrite: "Schreiben",
        public: "Öffentlich",
        private: "Privat",
        browserNotSupported: "Ihr Browser unterstützt die Ordnerauswahl nicht",
        fileFolderCount: "{{files}} Dateien, {{folders}} Ordner",
        scanning: "Ordner wird gelesen\u2026",
        selectFailed: "Auswahl fehlgeschlagen",
        selectFolder: "Ordner auswählen",
        selectFolderHint: "Wählen Sie einen Ordner mit Belegen",
        selectedFolder: "Ausgewählter Ordner",
        someValidationFailed: "Einige Dateien konnten nicht validiert werden:\n{{messages}}",
        tooManyFiles: "Der Ordner enthält zu viele Dateien (max. {{count}}) — bitte in mehreren Durchläufen hochladen",
        nothingSelected: "Keine Dateien ausgewählt — mindestens ein Ordner oder eine Datei muss ausgewählt bleiben",
        excludedCount: "{{count}} Dateien abgewählt",
        resetSelection: "Auswahl zurücksetzen",
                shiftMultiSelectHint: "Klick: Ordner ein-/ausschließen · Shift+Klick: Bereich ab letztem Ordner",
                folderNotFound: "Ordnerpfad nicht gefunden — Ansicht zurückgesetzt",
        dropHint: "Tipp: Mehrere Ordner im Windows Explorer markieren (Strg+Klick) und hierher ziehen",
        droppedItems: "Ausgewählte Elemente",
        dropNoFolders: "Keine Ordner erkannt — bitte Ordner aus dem Windows Explorer hierher ziehen",
        structure: "Struktur",
        upload: "Hochladen",
        uploadFailed: "Upload fehlgeschlagen",
        uploadProgress: "{{done}} von {{total}} hochgeladen",
        validationFailed: "Validierung fehlgeschlagen",
        loadMore: "Mehr anzeigen ({{shown}} von {{total}})",
        uploadOverwritten: "{{count}} bestehende Datei(en) wurde(n) ersetzt",
        finalizePartial: "{{count}} Datei(en) wurden hochgeladen, konnten aber NICHT im Belege-Register gespeichert werden — bitte Upload wiederholen",
      },
      publicOfferConfirmation: {
        title: "Angebot bestätigen",
        subtitle: "Bitte überprüfe deine Buchungsdaten",
        bookNow: "Jetzt buchen",
        checkIn: "Anreise",
        checkOut: "Abreise",
        guests: "Gäste",
        adults: "Erwachsene",
        children: "Kinder",
        totalPrice: "Gesamtpreis",
        pricePerNight: "Preis pro Nacht",
        nights: "{{count}} Nacht",
        nights_other: "{{count}} Nächte",
        guest: "Gast",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        phone: "Telefon",
        specialRequests: "Besondere Wünsche",
        specialRequestsPlaceholder: "Allergien, Anreisezeit, etc.",
        terms: "AGB",
        accept: "Annehmen",
        decline: "Ablehnen",
        cancel: "Abbrechen",
        confirm: "Bestätigen",
        success: "Buchung erfolgreich",
        error: "Fehler bei der Buchung",
        loading: "Lade Angebot...",
        secure: "Sichere Verbindung",
        encrypted: "Verschlüsselt",
        privacy: "Datenschutz",
        offerExpired: "Dieses Angebot ist leider abgelaufen",
        contactHotel: "Bitte kontaktiere das Hotel für ein neues Angebot",
        company: "Firma",
        address: "Anschrift",
        street: "Straße",
        postalCode: "PLZ",
        city: "Stadt",
        country: "Land",
        arrival: "Anreise",
        departure: "Abreise",
      },
      traceImport: {
        title: "Traces importieren",
        subtitle: "Mehrere Traces aus einer Datei erstellen",
        selectFile: "Datei auswählen",
        fileFormat: "Dateiformat",
        csv: "CSV",
        json: "JSON",
        xml: "XML",
        dropFile: "Datei hier ablegen",
        browse: "Durchsuchen",
        upload: "Hochladen",
        uploading: "Wird hochgeladen...",
        success: "Import erfolgreich",
        error: "Fehler beim Import",
        mapping: "Spalten zuordnen",
        columns: "Spalten",
        source: "Quelle",
        target: "Ziel",
        preview: "Vorschau",
        import: "Importieren",
        importing: "Importiere...",
        importAll: "Alle importieren",
        importSelected: "Auswahl importieren",
        skipDuplicates: "Duplikate überspringen",
        updateExisting: "Bestehende aktualisieren",
        validate: "Validieren",
        validationError: "Validierungsfehler",
        missingColumns: "Fehlende Spalten",
        invalidData: "Ungültige Daten",
        complete: "Abgeschlossen",
        cancelled: "Abgebrochen",
        next: "Weiter",
        back: "Zurück",
        finish: "Fertig",
        close: "Schließen",
        noFileSelected: "Keine Datei ausgewählt",
        processing: "Verarbeite...",
      },
      bulkOrderDate: {
        title: "Sammelbestellung",
        subtitle: "Bestelldatum für mehrere Artikel setzen",
        selectItems: "Artikel auswählen",
        orderDate: "Bestelldatum",
        supplier: "Lieferant",
        quantity: "Menge",
        unit: "Einheit",
        price: "Preis",
        total: "Gesamt",
        notes: "Notizen",
        save: "Speichern",
        cancel: "Abbrechen",
        success: "Bestelldatum gesetzt",
        error: "Fehler beim Speichern",
        loading: "Lade Artikel...",
        noItems: "Keine Artikel ausgewählt",
        selectAll: "Alle auswählen",
        deselectAll: "Alle abwählen",
      },
      customKpi: {
        title: "Custom KPI",
        subtitle: "Eigene Kennzahlen definieren",
        name: "Name",
        namePlaceholder: "z.B. Durchschnittlicher Zimmerpreis",
        description: "Beschreibung",
        type: "Typ",
        calculation: "Berechnung",
        sum: "Summe",
        average: "Durchschnitt",
        count: "Anzahl",
        max: "Maximum",
        min: "Minimum",
        formula: "Formel",
        field: "Feld",
        source: "Quelle",
        color: "Farbe",
        icon: "Symbol",
        save: "Speichern",
        cancel: "Abbrechen",
        delete: "Löschen",
        confirmDelete: "KPI wirklich löschen?",
        error: "Fehler",
        required: "Pflichtfeld",
        selectField: "Feld auswählen",
        noFields: "Keine Felder verfügbar",
        preview: "Vorschau",
      },
      inventoryImport: {
        title: "Import Wizard (Excel / CSV)",
        subtitle: "Inventardaten aus Datei laden",
        selectFile: "Datei auswählen",
        fileFormat: "Unterstützte Formate: .xlsx, .csv. Die Spalten \"Artikel\", \"Bestand Vormonat\", \"Jetziger Bestand\" und \"Mindestbestand\" werden erwartet.",
        csv: "CSV",
        excel: "Excel",
        upload: "Hochladen",
        uploading: "Wird hochgeladen...",
        success: "Import Erfolgreich!",
        error: "Fehler beim Import",
        mapping: "Spalten zuordnen",
        columns: "Spalten",
        source: "Quelle",
        target: "Ziel",
        preview: "Vorschau & Validierung",
        import: "Importieren",
        importing: "Import läuft…",
        complete: "Abgeschlossen",
        cancelled: "Abgebrochen",
        next: "Weiter",
        back: "Zurück",
        finish: "Fertig",
        noFileSelected: "Keine Datei ausgewählt",
        parseError: "Fehler beim Parsen der Datei. Bitte überprüfen Sie das Format.",
        noValidData: "Keine gültigen Daten zum Importieren gefunden.",
        imported: "Inventar importiert",
        importSummary: "{{added}} hinzugefügt, {{updated}} aktualisiert ({{property}})",
        importError: "Fehler beim Importieren: {{message}}",
        location: "Standort: ",
        dropFile: "Datei auswählen oder ablegen",
        browse: "Datei durchsuchen",
        entriesFound: "{{count}} Einträge gefunden. Existierende Artikel (basierend auf Name oder Artikelnummer) werden aktualisiert, neue hinzugefügt.",
        entriesProcessed: "{{current}} / {{total}} Einträge verarbeitet",
        article: "Artikel",
        articleNumber: "Artikelnummer",
        category: "Kategorie",
        prevMonthStock: "Bestand Vormonat",
        currentStock: "Jetziger Bestand",
        minStock: "Mindestbestand",
        url: "URL",
        missingArticleName: "Fehlender Artikelname",
        missing: "Fehlt",
        successDescription: "Ihre Inventardaten für den Standort {{property}} wurden erfolgreich synchronisiert.",
        added: "Neu Hinzugefügt",
        updated: "Aktualisiert",
        closeWizard: "Wizard schließen",
        restart: "Neu starten",
        importData: "Daten importieren",
        importRunning: "Import läuft\u2026",
        previewValidation: "Vorschau & Validierung",
      },
      installPwa: {
        title: "App installieren",
        description: "Installiere AdaptHub als App auf deinem Gerät",
        install: "Installieren",
        dismiss: "Schließen",
        installed: "Installation erfolgreich",
      },
      housekeepingForecast: {
        title: "Housekeeping Forecast",
        subtitle: "Kapazitätsplanung & Vorschau",
        today: "Heute",
        tomorrow: "Morgen",
        thisWeek: "Diese Woche",
        nextWeek: "Nächste Woche",
        occupancy: "Auslastung",
        staffNeeded: "Benötigte Mitarbeiter",
        noData: "Keine Daten verfügbar",
        error: "Fehler beim Laden",
        printLandscape: "Drucken (Querformat)",
        printPortrait: "Drucken (Hochformat)",
        printLandscapeTitle: "Drucken im Querformat",
        printPortraitTitle: "Drucken im Hochformat",
        date: "Datum",
        weekday: "Wochentag",
      },
      analyticsChart: {
        title: "Analytics Chart",
        noData: "Keine Daten verfügbar",
        error: "Fehler beim Laden",
      },
      reportingStats: {
        title: "Reporting & Statistik",
        period: "Zeitraum",
        daily: "Täglich",
        weekly: "Wöchentlich",
        monthly: "Monatlich",
        yearly: "Jährlich",
        custom: "Benutzerdefiniert",
        export: "Exportieren",
        print: "Drucken",
        refresh: "Aktualisieren",
        filter: "Filter",
        compareWith: "Vergleichen mit",
        previousPeriod: "Vorheriger Zeitraum",
        previousYear: "Vorjahr",
      },
      roomRackControls: {
        title: "Room-Rack Steuerung",
        refresh: "Aktualisieren",
        filter: "Filter",
        sort: "Sortieren",
        settings: "Einstellungen",
        export: "Exportieren",
        controlsTitle: "Steuerung & Tastaturkürzel",
        shortcutsTitle: "Tastaturkürzel",
        ctrlClick: "Strg + Klick",
        arrowKeys: "Pfeiltasten",
        doubleClick: "Doppelklick",
        drag: "Ziehen",
        delete: "Löschen",
        esc: "Esc",
        ctrl: "Strg",
        mouseWheel: "Mausrad",
        leftMouse: "Linke Maustaste",
        dragEdges: "Ränder ziehen",
        del: "Entf",
        modalTitle: "Tastaturkürzel & Steuerung",
        mouseControl: "Maus-Steuerung",
        keyboardShortcuts: "Tastaturkürzel",
        mouse1Action: "Details öffnen (Reservierung / Wartung)",
        mouse2Action: "Block in anderes Zimmer oder Zeitraum verschieben",
        mouse3Action: "Dauer eines Wartungsfensters ändern",
        mouse4Action: "Wartungsfenster duplizieren",
        mouse5Action: "Zimmerplan stufenlos zoomen",
        mouse6Action: "Wartungsfenster/Reservierung in leeren Zellen erstellen",
        key1Action: "Ausgewählte Wartung löschen / Reservierung vom Zimmer entkoppeln",
        key2Action: "Check-In für ausgewählte Reservierung durchführen",
        key3Action: "Check-Out für ausgewählte Reservierung durchführen",
        key4Action: "Ausgewählten Block ein Zimmer hoch oder runter verschieben",
        key5Action: "Ausgewähltes Wartungsfenster um 1 Tag vor oder zurück verschieben",
        key6Action: "Zimmerplan Zeitleiste vergrößern oder verkleinern (Zoom)",
        key7Action: "Auswahl aufheben und offene Detailfenster schließen",
      },
      multiRoomMaintenance: {
        title: "Seriensperrung erstellen",
        collapseTooltip: "Minimieren (Tabelle im Hintergrund anzeigen)",
        expand: "Erweitern",
        seriesLock: "Seriensperrung",
        roomCount: "{{count}} Zimmer",
        typeOverbooking: "Überbuchungsschutz",
        typeMaintenance: "Wartung",
        typeLabel: "Sperrungs-Typ *",
        outOfOrder: "Out of Order",
        outOfService: "Out of Service",
        selectRooms: "Zimmer auswählen ({{count}} ausgewählt) *",
        all: "Alle",
        none: "Keine",
        searchRooms: "Zimmer suchen...",
        noRoomsFound: "Keine Zimmer gefunden.",
        startDate: "Startdatum *",
        startTime: "Startzeit *",
        endDate: "Enddatum *",
        endTime: "Endzeit *",
        description: "Beschreibung",
        descriptionPlaceholder: "Sperrgrund...",
        presetsLabel: "Beschreibungstexte",
        cancel: "Abbrechen",
        create: "Erstellen",
        creating: "Erstellen...",
        noRooms: "Bitte wählen Sie mindestens ein Zimmer aus.",
        fillAllFields: "Bitte füllen Sie alle Datums- und Zeitfelder aus.",
        invalidDate: "Ungültiges Datum oder Uhrzeit.",
        endBeforeStart: "Das Enddatum muss nach dem Startdatum liegen.",
        createError: "Fehler beim Erstellen der Wartungsfenster.",
        trace: {
          enable: "Trace dazu erstellen",
          enableHint: "Legt pro Zimmer und pro Abteilung einen verknüpften Trace an. Ohne Haken wird nur das Wartungsfenster erstellt.",
          departments: "Abteilungen",
          noDepartment: "Bitte mindestens eine Abteilung für den Trace auswählen.",
          fanOutHint: "{{count}} Trace(s) werden erstellt ({{rooms}} Zimmer × {{departments}} Abteilungen).",
          text: "Trace-Text",
          textPlaceholder: "z. B. AB Langzeitgast, Sperre vom 06.11.–08.11.2026",
          textHint: "Vorschlag aus Beschreibung und Zeitraum — frei bearbeitbar.",
          createdCount: "{{count}} Trace(s) erstellt",
        },
      },
      roomRackSettings: {
        statusConfirmed: "Bestätigt",
        statusInHouse: "Im Haus",
        statusCheckedOut: "Ausgecheckt",
        statusOutOfOrder: "Out of Order",
        statusOutOfService: "Out of Service",
        saveError: "Fehler beim Speichern der Farben.",
        title: "Zimmerplan-Farben",
        subtitle: "Statusfarben anpassen",
        resetDefaults: "Standard wiederherstellen",
        saving: "Wird gespeichert...",
      },
      roomRack: {
        title: "Zimmerplan",
        itemMenu: {
          assign: "Zimmer wechseln",
          details: "Details öffnen",
        },
        maintMenu: {
          edit: "Wartungsfenster bearbeiten",
          delete: "Wartungsfenster löschen",
        },
        beta: "Room Rack Beta",
        loadingRoomPlan: "Lade Zimmerplan...",
        showControls: "Steuerung & Tastaturkürzel anzeigen",
        roomStatusLegend: "Zimmerstatus",
        statusClean: "Sauber",
        statusDirty: "Schmutzig",
        statusInspection: "Inspektion",
        conditionUnknown: "Unbekannt",
        conditionUpdated: "Zimmerstatus aktualisiert",
        conditionUpdateError: "Fehler beim Aktualisieren des Zimmerstatus",
        noConditionPermission: "Sie haben keine Berechtigung, den Zimmerstatus zu ändern.",
        customizeColors: "Farben anpassen",
        rooms: "Zimmer",
        sortAlphabetical: "Alphabetisch",
        sortByCategory: "Zimmerkategorie",
        allCategories: "Alle Kategorien",
        allStatuses: "Alle Status",
        statusConfirmed: "Bestätigt",
        statusInHouse: "Im Haus",
        statusCheckedOut: "Ausgecheckt",
        statusMaintenance: "Maintenance",
        seriesLock: "Seriensperrung",
        newReservation: "Neue Reservierung erstellen",
        createMaintenance: "Wartungsfenster erstellen",
        editMaintenance: "Wartungsfenster bearbeiten",
        selectedRooms: "Ausgewählte Zimmer",
        filterMaintenance: "Filter Wartungsfenster",
        startDate: "Startdatum",
        endDate: "Enddatum",
        time: "Zeit",
        lockReason: "Sperrgrund...",
        description: "Beschreibung",
        presetsLabel: "Beschreibungstexte",
        change: "Ändern",
        noBookingPermission: "Sie haben keine Berechtigung, Reservierungen zu erstellen.",
        noViewPermission: "Sie haben keine Berechtigung, Reservierungsdetails anzuzeigen.",
        noMovePermission: "Sie haben keine Berechtigung, Reservierungen zu verschieben.",
        cannotDuplicateReservations: "Reservierungen können nicht dupliziert werden.",
        cannotMoveWithArrows: "Reservierungszeiträume können nicht per Pfeiltaste verschoben werden.",
        roomAssigned: "Zimmer erfolgreich zugewiesen",
        roomReleased: "Zimmer erfolgreich freigegeben",
        roomReleaseError: "Fehler beim Freigeben des Zimmers",
        checkInSuccess: "Check-In erfolgreich durchgeführt",
        checkInError: "Fehler beim Check-In",
        checkOutSuccess: "Check-Out erfolgreich durchgeführt",
        checkOutError: "Fehler beim Check-Out",
        confirmCheckIn: "Check-In für diese Reservierung durchführen?",
        confirmCheckOut: "Check-Out für diese Reservierung durchführen?",
        confirmReleaseRoom: "Möchten Sie das Zimmer für die ausgewählte Reservierung wirklich freigeben?",
        confirmDeleteMaintenance: "Dieses Wartungsfenster wirklich löschen?",
        confirmDeleteSelectedMaintenance: "Möchten Sie die {{count}} ausgewählten Wartungsfenster wirklich löschen?",
        maintCreated: "Wartungsfenster erfolgreich erstellt",
        maintUpdated: "Wartungsfenster erfolgreich geändert",
        maintDeleted: "Wartungsfenster erfolgreich gelöscht",
        maintDuplicated: "Wartungsfenster dupliziert",
        maintMoved: "Wartungsfenster verschoben",
        maintMovedNewRoom: "Wartungsfenster verschoben (neues Zimmer)",
        maintMovedOtherRoom: "Wartung auf anderes Zimmer verschoben",
        maintPeriodAdjusted: "Wartungsfenster Zeitraum angepasst",
        maintCreateError: "Fehler beim Erstellen der Wartung",
        maintDeleteError: "Fehler beim Löschen der Wartungsfenster",
        maintenanceDeletedCount: "{{count}} Wartungsfenster erfolgreich gelöscht",
        errorMessage: "Fehler: {{message}}",
        show3Days: "3 Tage anzeigen",
        show7Days: "7 Tage anzeigen",
        show14Days: "14 Tage anzeigen",
        zoomIn: "Vergrößern",
        zoomOut: "Verkleinern",
        sorting: "Sortierung",
        category: "Kategorie",
        status: "Status",
        location: "Standort",
        filter: "Filter",
        controls: "Steuerung & Tastaturkürzel",
        help: "Hilfe",
        done: "Fertig",
        blocking: "Seriensperrung",
        maintsSelected: "Wartungsfenster ausgewählt",
        clearSelection: "Auswahl aufheben",
        selection: "Auswahl...",
        noPermissionCreate: "Sie haben keine Berechtigung, Reservierungen zu erstellen.",
        noPermissionView: "Sie haben keine Berechtigung, Reservierungsdetails anzuzeigen.",
        noPermissionMove: "Sie haben keine Berechtigung, Reservierungen zu verschieben.",
        cannotDuplicateRes: "Reservierungen können nicht dupliziert werden.",
        cannotMoveResByArrow: "Reservierungszeiträume können nicht per Pfeiltaste verschoben werden.",
        confirmDeleteMaints: "Möchten Sie die {{count}} ausgewählten Wartungsfenster wirklich löschen?",
        maintPeriodMoved: "Wartungszeitraum verschoben",
        unknownGuest: "Unbekannt",
        loading: "Lade Zimmerplan...",
        actionForRoom: "Aktion für Zimmer",
        deleting: "Löschen...",
        changing: "Ändern...",
      },
      autoBlock: {
        title: "Auto-Block Konfiguration",
        description: "Automatische Sperrung von Verfügbarkeiten",
        enable: "Aktivieren",
        disable: "Deaktivieren",
        trigger: "Auslöser",
        threshold: "Schwellenwert",
        action: "Aktion",
        time: "Zeit",
        timezone: "Zeitzone",
        roomCategories: "Zimmerkategorien",
        roomCategoriesPlaceholder: "z.B. Standard, Deluxe",
        save: "Speichern",
        success: "Konfiguration gespeichert",
        error: "Fehler beim Speichern",
      },
      autoKassenbuch: {
        title: "Auto-Kassenbuch Konfiguration",
        description: "Automatische Kassenbuch-Einträge",
        enable: "Aktivieren",
        disable: "Deaktivieren",
        trigger: "Auslöser",
        entryTextPlaceholder: "Eintragstext",
        save: "Speichern",
        success: "Konfiguration gespeichert",
        error: "Fehler beim Speichern",
      },
      guestNameCleanup: {
        title: "Gastnamen-Bereinigung",
        description: "Bereinigung von Gastnamen in Reservierungen",
        enable: "Aktivieren",
        disable: "Deaktivieren",
        rules: "Regeln",
        splitCombinedName: "Vor- und Nachnamen aufteilen",
        removeDuplicateFirstName: "Doppelten Vornamen entfernen",
        save: "Speichern",
        success: "Konfiguration gespeichert",
        error: "Fehler beim Speichern",
      },
      voucherRateEmail: {
        title: "Voucher-Rate E-Mail übernehmen",
        description: "Übernimmt bei bestätigten Reservierungen der Rate \"Voucher-Rate tripz\" die Bucher-E-Mail in den Hauptgast.",
        settings: "Einstellungen",
        ratePlanLabel: "Rate-Plan (Name oder Code)",
        ratePlanHelp: "Exakter Name oder Code des Rate-Plans; Groß-/Kleinschreibung und zusätzliche Leerzeichen werden ignoriert.",
        fillOnlyNote: "Nur leere Gast-E-Mails werden gefüllt. Eine bereits hinterlegte Gast-E-Mail wird nie überschrieben.",
        inactiveHint: "Diese Automatik ist noch nicht aktiv. Ein Testlauf funktioniert trotzdem; für den stündlichen Betrieb bitte einschalten und speichern.",
        dryRunLabel: "Nur simulieren (nichts in Apaleo schreiben)",
        dryRunHelp: "Aktiv: Der stündliche Lauf zählt nur die Treffer und schreibt keine Änderungen.",
        save: "Speichern",
        success: "Konfiguration gespeichert",
        runNow: "Jetzt prüfen (Simulation)",
        runWrite: "Jetzt schreiben",
        runWriteConfirm: "Die Bucher-E-Mail wird jetzt in Apaleo in den Hauptgast geschrieben. Fortfahren?",
        runDone: "Prüfung abgeschlossen",
        runError: "Prüfung fehlgeschlagen",
        runSummary: "Geprüft: {{scanned}} · Kopiert: {{copied}} · Übersprungen: {{skipped}} · Fehler: {{failed}}",
        runRatePlans: "Gefundene Rate-Plans: {{count}}",
        runNoRatePlan: "Kein Rate-Plan mit diesem Namen/Code gefunden.",
        runProperties: "Geprüfte Objekte: {{count}}",
        runPropertySource: "Objektquelle: {{source}}",
        runReasons: "Gründe: {{reasons}}",
        skipNoProperties: "Keine Objekte gefunden — weder die Tenant-Objektliste noch die Apaleo-Objektliste liefert ein Objekt.",
        skipPropertiesUnavailable: "Die Apaleo-Objektliste konnte nicht geladen werden. Details im Server-Log.",
        skipNotConfigured: "Die Automatik ist noch nicht gespeichert.",
        skipDisabled: "Die Automatik ist noch nicht gespeichert und aktiviert — bitte zuerst einschalten (oder speichern).",
        skipDisabledPlatform: "Die Automatik ist in der Plattform (Admin-Dashboard) für diesen Tenant nicht freigegeben.",
        skipError: "Der Lauf ist mit einem Fehler abgebrochen.",
      },
      loyaltySync: {
        title: "Loyalty-Sync",
        description: "Synchronisierung mit Loyalty-Programmen",
        enable: "Aktivieren",
        disable: "Deaktivieren",
        trigger: "Auslöser",
        save: "Speichern",
        success: "Konfiguration gespeichert",
        error: "Fehler beim Speichern",
        settings: "Loyalty-Programmkonfiguration",
        delete: "Löschen",
        calculationBasis: "Berechnungsgrundlage",
        pointsPerUnit: "Punkte pro Einheit",
        tiers: "Stufen",
        tierName: "Name",
        tierNamePlaceholder: "z.B. Gold",
        thresholdLabel: "Schwellenwert",
        thresholdPlaceholder: "z.B. 10",
        thresholdSuffix: "Nächte",
        noTiers: "Keine Stufen konfiguriert",
        noTiersDescription: "Füge Treuestufen mit Schwellenwerten hinzu",
        moneySpent: "Umsatz",
        nights: "Übernachtungen",
        arrivals: "Anreisen",
      },
      extraBedRestore: {
        title: "Zustellbett-Wiederherstellung",
        description: "Stellt Zusatzleistungen (z. B. Zustellbetten) wieder her, die der Channel-Manager beim erneuten Sync entfernt hat",
        enable: "Aktivieren",
        disable: "Deaktivieren",
        rules: "Regeln",
        watchClientId: "Channel-Manager Client-ID",
        watchClientIdDesc: "Client-ID des Channel-Managers, dessen Reservierungsänderungen die Prüfung auslösen",
        amendmentClientId: "Integrations-Client-ID",
        amendmentClientIdDesc: "Client-ID der Integration, deren vorherige Änderungen wiederhergestellt werden sollen",
        lookbackHours: "Suchfenster (Stunden)",
        lookbackHoursDesc: "Wie weit zurück in den Reservierungs-Logs nach Änderungen gesucht wird. Standard 720 Stunden (30 Tage).",
        baseOccupancy: "Standardbelegung",
        baseOccupancyDesc: "Anzahl der Gäste im Standardtarif. Für jeden Gast darüber wird ein Zustellbett hinzugefügt (z. B. 3 Gäste bei Standard 2 = 1 Zustellbett).",
        extraBedServiceId: "Zustellbett-Service-ID",
        extraBedServiceIdDesc: "Durch Komma getrennte Apaleo-Service-Codes für zusätzliche Schlafkapazität (z. B. 'AUFB_ERW, BABYBETT'). Alle Codes zählen zur Bestandskapazität; der erste wird als Buchungsziel verwendet. Wenn leer, wird die Automatisierung übersprungen.",
        extraBedServiceIdPlaceholder: "AUFB_ERW, BABYBETT",
        save: "Speichern",
        success: "Konfiguration gespeichert",
        error: "Fehler beim Speichern",
      },
      overbookingLocksConfig: {
        title: "Overbooking-Locks",
        description: "Sperren bei Überbuchung verwalten",
        enable: "Aktivieren",
        disable: "Deaktivieren",
        trigger: "Auslöser",
        autoBlock: "Automatisch blockieren",
        sendPush: "Push-Benachrichtigungen senden",
        checkInterval: "Prüfintervall (Minuten)",
        save: "Speichern",
        success: "Konfiguration gespeichert",
        error: "Fehler beim Speichern",
      },
      roomDateSync: {
        title: "Raum-Datum-Sync",
        description: "Synchronisierung von Raumdaten",
        enable: "Aktivieren",
        disable: "Deaktivieren",
        trigger: "Auslöser",
        syncRoomNumbers: "Zimmernummern synchronisieren",
        syncArrivalDates: "Anreisedaten synchronisieren",
        autoDeleteOnCancel: "Bei Stornierung automatisch löschen",
        save: "Speichern",
        success: "Konfiguration gespeichert",
        error: "Fehler beim Speichern",
      },
      waitingListMonitor: {
        title: "Wartelisten-Monitor",
        description: "Überwachung der Warteliste",
        enable: "Aktivieren",
        disable: "Deaktivieren",
        trigger: "Auslöser",
        sendPush: "Push-Benachrichtigungen senden",
        checkInterval: "Prüfintervall (Minuten)",
        save: "Speichern",
        success: "Konfiguration gespeichert",
        error: "Fehler beim Speichern",
      },
      logs: {
        actions: {
          logout: "Abmelden",
          systemLogin: "System-Anmeldung",
        },
        details: {
          logoutPaymentBlock: "Abmelden wegen Zahlungsblock",
          userLoggedIn: "Benutzer hat sich angemeldet",
          userLoggedOut: "Benutzer hat sich abgemeldet",
        },
      },
      notifications: {
        chatReply: "{{from}} hat auf deine Nachricht geantwortet",
        confirmDeleteAll: "Diese Benachrichtigung wirklich für ALLE Benutzer endgültig löschen?",
        confirmDeleteAllMany: "Diese {{count}} Benachrichtigungen wirklich für ALLE Benutzer endgültig löschen?",
        deleteForAll: "Für alle löschen",
        deleteForAllAdmin: "Für alle löschen (Admin)",
        empty: "Keine Benachrichtigungen vorhanden",
        forAllAdmin: "Für alle (Admin)",
        forMe: "Für mich",
        hideForMe: "Für mich ausblenden",
        justNow: "Gerade eben",
        markAllRead: "Alle als gelesen markieren",
        newMessage: "Neue Nachricht",
        read: "Gelesen",
        expand: "Mehr anzeigen",
        collapse: "Weniger",
        subtitle: "Deine Erwähnungen & Alerts",
        title: "Benachrichtigungen",
        titleShort: "Benachrichtigungen",
        activityFilterAll: "Alle",
        activityFilterTrace: "Traces",
        activityFilterChatReply: "Antworten",
        activityFilterLostFound: "Fundsachen",
        activityFilterTicket: "Tickets",
        activityFilterStorno: "Storno",
        activityFilterHr: "Personal",
        activityFilterOther: "Sonstiges",
        activityFilterToggle: "Filter",
        activityFilterClear: "Filter aufheben",
      },
      patchNotes: {
        labels: {
          fix: "Fehlerbehebung",
          improvement: "Verbesserung",
          new: "Neu",
        },
        showPatchNotes: "Patch-Notes anzeigen",
        subtitle: "Updates und System-Verbesserungen",
        title: "Patch-Notes",
        whatsNew: "Was ist neu?",
        whatsNewTooltip: "Klicke hier, um die Patch-Notes zu lesen",
        changesV161_1: "Zimmerplan hat ein kleines Interface-Update bekommen und man kann den Plan jetzt während der Seriensperrung richtig sehen und bewegen.",
        changesV161_2: "Tickets zeigen jetzt den geschriebenen Text der Nachricht richtig an.",
        changesV161_3: "Hausdamen dürfen jetzt auch im Zimmerplan-Menü Gästedetails ansehen.",
        changesV161_4: "Die Seitenleiste kann jetzt verkleinert werden.",
      },
      systemLogs: {
        actions: "Aktionen",
        empty: "Keine Log-Einträge",
        loadMore: "Mehr laden",
        searchPlaceholder: "Logs durchsuchen\u2026",
        subtitle: "Systemaktivitäten",
      },
      subscription: {
        goToApaleoStore: "Zum Apaleo Store",
        suspendedMessage: "Ihr Abonnement wurde pausiert. Bitte aktualisieren Sie Ihre Zahlungsdaten.",
        suspendedSubtitle: "Zugriff eingeschränkt",
        suspendedTitle: "Abonnement pausiert",
      },
      support: {
        title: "Support & Hilfe",
      },
      fetchProgress: {
        generic: "Daten werden geladen…",
        reservations: "Reservierungen werden geladen…",
        companyRevenue: "Firmenumsatz wird berechnet…",
        pageOf: "Seite {{page}}/{{total}}",
        rows: "{{count}} Zeilen",
        elapsed: "{{seconds}} s",
        patience: "Datenmenge ist groß – dauert einen Moment",
      },
      utils: {
        dateFormatDE: "DD.MM.YYYY",
        dateFormatUS: "MM/DD/YYYY",
      },
      businessClub: {
        tabTitle: "BusinessClub",
        title: "BusinessClub Mitglieder",
        subtitle: "BusinessClub-Programm",
        // Double opt-in confirmation page (audit M-8)
        confirmLoading: "Anmeldung wird bestätigt...",
        confirmSuccessTitle: "Anmeldung bestätigt",
        confirmSuccessBody: "Vielen Dank! Ihre BusinessClub-Mitgliedschaft ist aktiviert. Ihr persönlicher Promo-Code wurde Ihnen soeben per E-Mail zugesendet.",
        confirmAlready: "Diese Anmeldung wurde bereits bestätigt. Ihr Promo-Code wurde Ihnen per E-Mail zugesendet.",
        confirmFailedTitle: "Bestätigung fehlgeschlagen",
        confirmFailed: "Der Bestätigungslink ist ungültig oder abgelaufen. Bitte melden Sie sich erneut an oder kontaktieren Sie unser Team.",
        confirmMissingParams: "Der Bestätigungslink ist unvollständig. Bitte verwenden Sie den Link aus Ihrer Bestätigungs-E-Mail.",
        confirmHint: "Falls das Problem weiterhin besteht, wenden Sie sich an unser Team.",
        optinPendingTitle: "Fast fertig: Bitte E-Mail bestätigen",
        optinPendingText: "Wir haben Ihnen eine Bestätigungs-E-Mail gesendet. Klicken Sie auf den Link darin — Ihr Promo-Code wird Ihnen direkt nach der Bestätigung per E-Mail zugesendet. (Ungewollt? Ignorieren Sie die E-Mail; die Adresse wird nach 14 Tagen automatisch gelöscht.)",
        search: "Mitglieder suchen...",
        filterEmail: "E-Mail filtern...",
        filterCompany: "Firma filtern...",
        statsWindow: "Reservierungen, Umsatz und Roomnights im gewählten Zeitraum. E-Mail-Modus: eigene Buchungen (Gast-E-Mail). Firmen-Modus: Buchungen über die Firmenrate. Beides: Summe beider Zuordnungen (Doppelzählung möglich bei eigener Buchung über die Firmenrate).",
        statsReservations: "Res.",
        statsRevenue: "Umsatz",
        statsRoomnights: "RNs",
        searchModeEmail: "E-Mail",
        searchModeCompany: "Firma",
        joinedDate: "Angemeldet am",
        joinedDateHint: "Datum der Mitgliedschaft — kann bei Importen korrigiert werden.",
        searchModeBoth: "Beides",
        statsTermEmail: "Reservierungen per E-Mail suchen...",
        statsTermCompany: "Reservierungen per Firma suchen...",
        statsTermBoth: "Reservierungen per E-Mail oder Firma suchen...",
        statsFrom: "Von",
        statsTo: "Bis",
        statsSearch: "Suchen",
        statsClear: "Zurücksetzen",
        statsRangeInvalid: "Ungültiger Zeitraum — Von muss vor Bis liegen.",
        noMembers: "Noch keine Mitglieder",
        noResults: "Keine Treffer",
        name: "Name",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        company: "Firma",
        phone: "Telefon",
        source: "Quelle",
        totalRow: "Gesamt",
        source_public: "Anmeldung",
        source_website: "Website",
        source_manual: "Manuell",
        locations: "Standort(e)",
        locationsPlaceholder: "z.B. Siegen, Wetzlar",
        locationsHint: "Standort(e) aus dem Website-Formular",
        memberMessage: "Nachricht",
        memberMessageHint: "Nachricht aus dem Website-Formular",
        created: "Angemeldet",
        actions: "Aktionen",
        addMember: "Mitglied anlegen",
        editMember: "Mitglied bearbeiten",
        deleteMember: "Mitglied löschen",
        confirmDelete: "{{name}} wirklich löschen?",
        memberCreated: "Mitglied angelegt",
        memberUpdated: "Änderungen gespeichert",
        memberDeleted: "Mitglied gelöscht",
        configSaved: "Promo-Code gespeichert",
        saveError: "Speichern fehlgeschlagen",
        duplicateMember: "Diese E-Mail ist bereits als Mitglied registriert.",
        fieldRequired: "Pflichtfeld",
        invalidEmail: "Ungültige E-Mail-Adresse",
        emailLocked: "Die E-Mail-Adresse kann nachträglich nicht geändert werden.",
        marketingConsent: "Einwilligung für Marketing-Kommunikation (DSGVO)",
        signUpLink: "Anmeldelink:",
        copyLink: "Kopieren",
        copied: "Kopiert",
        promoCodeSettings: "Promo-Code",
        promoCodeHint: "Gemeinsamer Code für alle Mitglieder",
        promoCodeDescription: "Dieser Code wird neuen Mitgliedern nach der Anmeldung angezeigt und per E-Mail zugestellt.",
        promoCodePlaceholder: "z.B. BC2026",
        publicTitle: "BusinessClub",
        publicSubtitle: "Werden Sie Mitglied und sichern Sie sich Ihre exklusiven Vorteile.",
        signUpButton: "Jetzt anmelden",
        successTitle: "Willkommen, {{name}}!",
        successText: "Ihre Anmeldung war erfolgreich. Eine Bestätigungs-E-Mail mit Ihrem Promo-Code ist unterwegs.",
        alreadyMemberTitle: "Sie sind bereits Mitglied!",
        alreadyMemberText: "Mit dieser E-Mail-Adresse existiert bereits eine BusinessClub-Mitgliedschaft. Hier ist Ihr Promo-Code:",
        yourPromoCode: "Ihr Promo-Code",
        promoCodeUsage: "Geben Sie den Code bei Ihrer nächsten Buchung auf unserer Website ein.",
        codePending: "Ihr Promo-Code wird Ihnen in Kürze per E-Mail zugesandt.",
        consentText: "Ich möchte per E-Mail über Angebote und Vorteile des BusinessClub informiert werden (optional, jederzeit widerruflich).",
        consentRequired: "Bitte bestätigen Sie die Einwilligung",
        languageLabel: "Sprache",
        lang_de: "DE",
        lang_en: "EN",
        ibeTitle: "Direkt buchen",
        ibeSubtitle: "Lösen Sie Ihren Promo-Code direkt bei der Buchung ein.",
        bookNow: "Zur Buchung",
        rateLimited: "Zu viele Versuche. Bitte versuchen Sie es später erneut.",
        signUpError: "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
      },
      firmenvertraege: {
        // List view
        title: "Firmenverträge",
        companyName: "Firma",
        contractId: "Vertragsnummer",
        status: "Status",
        validFrom: "Gültig ab",
        validTo: "Gültig bis",
        ratePlanCount: "Ratenpläne",
        lastModified: "Zuletzt geändert",
        noContracts: "Keine Verträge gefunden",
        searchPlaceholder: "Verträge suchen...",
        filterStatus: "Status filtern",
        selectedCount: "{{count}} ausgewählt",
        contractsCount: "{{count}} Verträge",
        bulkDelete: "Auswahl löschen",
        bulkExport: "Auswahl exportieren",
        addContract: "Neuer Vertrag",
        importExcel: "Excel importieren",
        // Status values
        statusDraft: "Entwurf",
        statusActive: "Aktiv",
        statusExpired: "Abgelaufen",
        statusArchived: "Archiviert",
        // Detail modal
        contractDetails: "Vertragsdetails",
        contactPerson: "Ansprechpartner",
        email: "E-Mail",
        phone: "Telefon",
        notes: "Notizen",
        linkedRatePlans: "Verknüpfte Ratenpläne",
        attachedFiles: "Anhänge",
        noRatePlans: "Keine Ratenpläne verknüpft",
        noFiles: "Keine Dateien vorhanden",
        edit: "Bearbeiten",
        save: "Speichern",
        cancel: "Abbrechen",
        delete: "Löschen",
        archive: "Archivieren",
        confirmDelete: "Vertrag wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
        confirmArchive: "Vertrag wirklich archivieren?",
        // File upload
        uploadPdf: "PDF hochladen",
        dragDropHint: "PDF hier ablegen oder klicken",
        maxFileSize: "Maximale Dateigröße: {{max}} MB",
        invalidFileType: "Nur PDF-Dateien sind erlaubt",
        fileTooLarge: "Datei ist zu groß (max. {{max}} MB)",
        uploadSuccess: "Datei erfolgreich hochgeladen",
        uploadError: "Fehler beim Hochladen: {{message}}",
        version: "Version",
        uploadDate: "Hochgeladen am",
        download: "Herunterladen",
        filePreview: "Vorschau",
        deleteFile: "Datei löschen",
        // Import wizard
        importTitle: "Firmenraten-Import",
        stepUpload: "Upload",
        stepMapping: "Zuordnung",
        stepValidation: "Validierung",
        stepConfirmation: "Bestätigung",
        stepExecution: "Ausführung",
        uploadExcel: "Excel-Datei (.xlsx) hochladen",
        preview: "Vorschau",
        mapColumns: "Spalten zuordnen",
        autoDetected: "Automatisch erkannt",
        validationErrors: "Validierungsfehler",
        validationWarnings: "Warnungen",
        companiesWillBeCreated: "Firmen werden angelegt",
        ratePlansWillBeCreated: "Ratenpläne werden angelegt",
        ratePlansWillBeUpdated: "Ratenpläne werden aktualisiert",
        selectContract: "Bestehenden Vertrag auswählen",
        createNewContract: "Neuen Vertrag anlegen",
        executing: "Wird ausgeführt...",
        successCount: "Erfolgreich",
        errorCount: "Fehlgeschlagen",
        downloadErrorReport: "Fehlerbericht herunterladen",
        // Wizard step 1 (upload)
        browse: "Durchsuchen",
        largeFileWarning: "Große Datei: {{count}} Zeilen erkannt",
        largeFileHint: "Importe über 500 Zeilen können länger dauern. Nur fortsetzen, wenn die Datei vom Vertriebsteam vorbereitet wurde.",
        rowsFound: "Zeilen gefunden",
        showingFirstN: "Erste {{shown}} von {{total}} Zeilen angezeigt",
        parseError: "Excel-Datei konnte nicht gelesen werden",
        // Wizard step 2 (mapping)
        excelColumn: "Excel-Spalte",
        targetField: "Ziel-Feld",
        required: "Pflicht",
        optional: "Optional",
        unmapped: "Nicht zugeordnet",
        requiredFields: "Pflichtfelder",
        optionalFields: "Optionale Felder",
        unmappedRequiredColumns: "Pflichtspalten sind nicht zugeordnet",
        allRequiredMapped: "Alle Pflichtspalten sind zugeordnet",
        // Wizard step 3 (validation)
        validating: "Validierung läuft...",
        validationPassed: "{{count}} Zeilen erfolgreich validiert",
        validationFailed: "{{count}} gültige Zeilen, {{errors}} blockierende Fehler",
        blockingErrorsCount: "{{count}} blockierende Fehler",
        warningsCount: "{{count}} Warnungen",
        // Wizard step 4 (confirmation)
        propertyLabel: "Apaleo-Property",
        propertyHint: "Standard: {{default}}",
        contractSelector: "Vertrag",
        attachToExisting: "An bestehenden anhängen",
        noEligibleContracts: "Keine aktiven Verträge vorhanden. Bitte zuerst einen neuen anlegen.",
        executeImport: "Import starten",
        // Wizard step 5 (execution)
        executionCreated: "Angelegt",
        executionFailed: "Fehlgeschlagen",
        executionCreating: "Wird angelegt...",
        executionPending: "Ausstehend",
        executionComplete: "Import abgeschlossen",
        executionInProgress: "Importiere {{current}} von {{total}}",
        executionContract: "Vertrag",
        kategorieCol: "Kategorie",
        code: "Code",
        resultLabel: "Ergebnis",
        retryFailed: "Fehlgeschlagene erneut versuchen",
        // Rate editing
        editRate: "Rate bearbeiten",
        tier: "LOS-Stufe",
        losRange: "LOS-Bereich",
        basePrice: "Grundpreis",
        restrictions: "Einschränkungen",
        marketSegments: "Marktsegmente",
        channelCodes: "Vertriebskanäle",
        corporateCodes: "Firmenkennungen",
        pushToApaleo: "An Apaleo übertragen",
        changesPreview: "Änderungsvorschau",
        noChanges: "Keine Änderungen",
        pushSuccess: "Änderungen erfolgreich übertragen",
        pushError: "Fehler bei der Übertragung: {{message}}",
        apaleoLink: "In Apaleo öffnen",
        rateEditTitle: "Ratenplan bearbeiten",
        rateEditSubtitle: "Rate-Details anpassen und Änderungen an Apaleo übertragen.",
        minLos: "Min LOS (Nächte)",
        maxLos: "Max LOS (Nächte)",
        minAdvance: "Mindestvorlauf (Tage)",
        maxAdvance: "Maximalvorlauf (Tage)",
        isActive: "Aktiv / buchbar",
        isActiveHint: "Schaltet das Apaleo-Feld isBookable um.",
        backToEdit: "Zurück zum Bearbeiten",
        tierChangeWarning: "Das Ändern der LOS-Stufe verändert den Bereich und kann bestehende Buchungen betreffen.",
        confirmTierChange: "Stufenwechsel bestätigen",
        notFoundHint: "Der Apaleo-Ratenplan wurde nicht gefunden. Die Verknüpfung wurde möglicherweise extern entfernt.",
        removeLink: "Verknüpfung entfernen",
        retry: "Erneut versuchen",
        patchPreviewTitle: "JSON-Patch-Operationen, die an Apaleo gesendet werden",
        immutableHint: "Unveränderliche Felder (id, code, propertyId, unitGroupId, timeSliceDefinitionId, accountingConfigs) werden nicht gesendet.",
        restrictionsEmpty: "Keine Einschränkungen gesetzt",
        diffTitle: "Änderungsübersicht",
        noChangesHint: "Keine Änderungen zum Übertragen.",
        auditing: "Diese Änderung wird im Audit-Log des Vertrags erfasst.",
        fieldLabel: "Feld",
        oldValue: "Aktuell",
        newValue: "Neu",
        previewChanges: "Änderungen prüfen",
        tierBadge: "Stufe",
        // Audit log
        auditCreated: "Vertrag erstellt",
        auditEdited: "Vertrag bearbeitet",
        auditImported: "Ratenpläne importiert",
        auditDeleted: "Vertrag gelöscht",
        auditArchived: "Vertrag archiviert",
        auditRatePushed: "Ratenplan-Änderung übertragen",
        // Bulk-Operationen (Phase 2.5)
        bulkArchive: "Auswahl archivieren",
        bulkHardDelete: "Auswahl endgültig löschen",
        confirmBulkArchive: "{{count}} Verträge archivieren?",
        confirmBulkArchiveSubtitle: "Dadurch werden auch die verknüpften Apaleo-Ratenpläne deaktiviert. Archivierte Verträge können später wiederhergestellt werden.",
        confirmBulkDelete: "{{count}} Verträge ENDGÜLTIG LÖSCHEN?",
        confirmBulkDeleteSubtitle: "Diese Aktion kann nicht rückgängig gemacht werden. Tippe DELETE zur Bestätigung.",
        typeDeletePlaceholder: "DELETE eintippen",
        bulkProgress: "{{done}} von {{total}} verarbeitet",
        bulkResultArchived: "{{count}} Verträge archiviert",
        bulkResultPartialArchive: "{{count}} archiviert, {{skipped}} übersprungen (Konflikte)",
        bulkResultDeleted: "{{count}} Verträge gelöscht",
        bulkResultPartialDelete: "{{count}} gelöscht, {{skipped}} übersprungen",
        // Export (Phase 2.5)
        exportLoading: "Export wird vorbereitet...",
        exportLargeWarning: "Du bist im Begriff {{count}} Verträge zu exportieren. Dies kann einen Moment dauern. Fortfahren?",
        exportContinue: "Fortfahren",
        exportEmpty: "Keine Verträge zum Exportieren",
        exportError: "Export fehlgeschlagen: {{message}}",
        exportSuccess: "{{count}} Verträge exportiert",
        exportNoteMissingData: "Einige Verträge hatten unvollständige Ratenplan-Daten.",
        exportNoteTimeout: "Ratenplan-Daten konnten für einige Verträge nicht geladen werden; Export enthält nur Vertragsdaten.",
        // General
        loading: "Laden...",
        error: "Fehler",
        success: "Erfolg",
        confirmAction: "Aktion bestätigen",
        close: "Schließen",
        // Link rate plans (Phase 6)
        linkRatePlans: "Bestehende Ratenpläne verknüpfen",
        linkRatePlansSubtitle: "Bestehende Apaleo-Ratenpläne durchsuchen und mit diesem Vertrag verknüpfen.",
        selectProperty: "Apaleo-Property",
        searchRatePlans: "Ratenpläne suchen (Code oder Name)",
        ratePlanCode: "Code",
        ratePlanName: "Name",
        columnProperty: "Property",
        noRatePlansFound: "Keine Ratenpläne gefunden",
        noRatePlansForProperty: "Keine Ratenpläne für Property {{property}} gefunden",
        ratePlansTruncated: "Die Ergebnisliste wurde aus Sicherheitsgründen auf 1000 Ratenpläne gekappt. Bitte grenze die Suche ein (Property oder Suchbegriff), um weitere Pläne zu sehen.",
        alreadyLinked: "Verknüpft",
        linkSelected: "{{count}} verknüpfen",
        linkSelectedCount: "{{count}} ausgewählt",
        linkingInProgress: "Verknüpfe {{done}}/{{total}}",
        linkSuccess: "{{count}} Ratenplan/Ratenpläne verknüpft",
        linkError: "Verknüpfung fehlgeschlagen: {{message}}",
        unlinkRatePlan: "Verknüpfung aufheben",
        confirmUnlink: "Diesen Ratenplan vom Vertrag abtrennen? Der Ratenplan bleibt in Apaleo und in den Verknüpfungen anderer Verträge erhalten.",
        unlinkSuccess: "Ratenplan-Verknüpfung aufgehoben",
        unlinkError: "Aufheben der Verknüpfung fehlgeschlagen",
        selectAll: "Auswählen",
        clearSelection: "Auswahl leeren",
        pagination: "Seite",
        pageOf: "Seite {{page}} von {{total}} ({{count}} gesamt)",
      },
    }
  },
  en: {
    translation: {
      dashboard: {
        title: "Overview",
        previewNotice: "Preview",
        subtitle: "Today's hotel status",
        arrivalsToday: "Today's arrivals",
        departuresToday: "Today's departures",
        upcomingArrivals: "Upcoming arrivals",
        upcomingDepartures: "Upcoming departures",
        allLocations: "All locations",
        showingUpcomingNotice: "No arrivals today — Next upcoming arrivals:",
        showingUpcomingDepNotice: "No departures today — Next upcoming departures:",
        quickActions: "Current & upcoming reservations",
        viewAllReservations: "All reservations",
        noArrivalsToday: "No arrivals today",
        noDeparturesToday: "No departures today",
        unassigned: "Unassigned (UA)",
        customizeButton: "Customize Dashboard",
        customizeTitle: "Customize Widgets & Modules",
        customizeSubtitle: "Choose which widgets to display on your personal dashboard.",
        customizing: "Edit Mode",
        dragToReorder: "Drag to reorder",
        dragToResize: "Drag to resize",
        toggleSize: "Toggle size",
        sizeSmall: "Compact / 1 col",
        rowsLabel: "{{count}} row(s)",
        sizeMedium: "Medium / 2 cols",
        sizeLarge: "Large / full width",
        moveUp: "Move up",
        moveDown: "Move down",
        removeWidget: "Remove widget",
        enableWidget: "Enable",
        disableWidget: "Disable",
        resetDefaults: "Reset to defaults",
        addWidgets: "Add widgets",
        saveLayout: "Done",
        greetings: {
          morning: "Good morning",
          day: "Hello",
          evening: "Good evening",
        },
        kpis: {
          employeeFocus: "My Focus Area",
          hotelOverview: "Hotel Overview",
          personalSubtitle: "Personal tasks and shift overview for {{name}}",
          hotelSubtitle: "Live overview of rooms and guests",
          myTraces: "My Open Traces",
          overdue: "overdue",
          followUps: "Follow-Up Bookings",
          deptTasks: "Department Tasks",
          hoursWorkedToday: "Worked Today",
          overtime: "Overtime",
          overtimeBalance: "Time Account",
          upcomingEvents: "Upcoming Events",
          nextEvent: "Next Event",
          holiday: "Public Holiday",
          vacationUpcoming: "Vacation",
          daysCount: "in {{days}}d",
          todayBadge: "Today",
          tomorrowBadge: "Tomorrow",
          noEvents: "No events",
          handoversToConfirm: "Open Handovers",
        },
        widgets: {
          jumpToReservation: {
            title: "Jump to reservation",
            desc: "Open a reservation directly by ID.",
          },
          openTickets: {
            title: "Ongoing Tickets",
            desc: "Open support tickets across all tenants.",
            allClear: "No ongoing tickets — all clear.",
            noSubject: "No subject",
            moreCount: "{{count}} more tickets",
          },
          timeTracking: {
            title: "Time Tracking & Clock",
            desc: "Current working time, shift status, and vacation balance.",
            todayWorked: "Worked today",
            statusIn: "Clocked in",
            statusBreak: "Break",
            statusOut: "Clocked out",
            clockIn: "Clock in",
            clockOut: "Clock out",
            pause: "Break",
            target: "Target",
            perDay: "per day",
            vacation: "Vacation left",
            days: "days",
            clockLog: "Today's Log",
            noLogsToday: "No clock events today yet",
            viewFullLog: "HR Log",
          },
          traces: {
            title: "My Traces",
            desc: "Personal and department traces at a glance.",
            myTab: "My Traces",
            deptTab: "Department",
            allDone: "All done",
            noTasks: "No open traces",
            openCount: "open",
            viewAll: "View all traces",
          },
          myTraces: {
            title: "My Traces",
            desc: "Traces assigned directly to you.",
            noTasks: "No open traces",
            allDone: "All done! You have no open personal traces.",
            createTask: "New Trace",
            markDone: "Mark as done",
            openCount: "open",
            viewAll: "View all traces",
          },
          deptTraces: {
            title: "Department Traces",
            desc: "Open traces in your work area.",
            noTasks: "No department traces",
            departmentClean: "No open traces for {{dept}}.",
            assignedTo: "Assigned to",
            openCount: "open traces",
            viewDeptTraces: "View department traces",
          },
          teamOnDuty: {
            title: "Team on Duty",
            desc: "Colleagues currently clocked in on shift.",
            noActive: "No active staff",
            noActiveSubtitle: "No other team members are currently clocked in.",
            onDuty: "On duty",
            clockedIn: "active colleagues",
            viewHr: "Staff schedule",
          },
          handover: {
            title: "Shift Handover",
            desc: "Important handover notes and announcements from earlier shifts.",
            pendingAcknowledgment: "{{count}} handover(s) awaiting confirmation",
            noHandovers: "No recent handovers",
            allTransferred: "All shift notes are up to date.",
            viewHandovers: "Open Handover",
          },
          arrivals: {
            title: "Today's Arrivals",
            desc: "Compact list of expected guests and check-ins today.",
          },
          departures: {
            title: "Today's Departures",
            desc: "Compact list of departures and check-outs today.",
          },
          occupancyKpi: {
            title: "My Overview",
            desc: "Personal tasks, working hours, and upcoming events.",
          },
          housekeeping: {
            title: "Housekeeping & Room Status",
            desc: "Room cleaning status, priority rooms, and stayovers.",
            summary: "Total of {{total}} rooms in cleaning schedule.",
            roomsTotal: "Rooms",
            viewHk: "Open Housekeeping",
          },
          maintenance: {
            title: "Maintenance & Repairs",
            desc: "Open repair tickets and facility defect reports.",
            noRepairs: "No open repairs",
            facilityOk: "All reported defects have been resolved.",
            openTickets: "open tickets",
            viewHt: "Open Maintenance",
          },
          cashRegister: {
            title: "Cash Ledger & Register",
            desc: "Current cash balance and shift register status.",
            currentBalance: "Current Cash Balance",
            statusOk: "Ledger reconciled",
            viewKassenbuch: "Open Cash Ledger",
          },
          quickActions: {
            title: "Quick Actions",
            desc: "Direct access to key booking and operations tools.",
          },
        },
        actions: {
          newBooking: "New Reservation",
          newTrace: "New Trace",
          chat: "Chat",
          newAbsence: "New Absence Req.",
          fundsachen: "Lost & Found",
          wartungsfenster: "Maintenance Window",
          handover: "Shift Handover",
        },
      },
      roles: {
        admin: "Administrator",
        management: "Management",
        sales: "Sales",
        reception: "Reception",
        rads: "Internal Resources",
        housekeeping: "Housekeeping",
        haustechnik: "Maintenance",
        ht_leitung: "Head of Maintenance",
        hausdame: "Head Housekeeper",
        accountant: "Accounting",
        staff: "Staff",
      },
      departments: {
        reception: "Reception",
        rezeption: "Reception",
        housekeeping: "Housekeeping",
        haustechnik: "Maintenance",
        sales: "Sales",
        accounting: "Accounting",
        buchhaltung: "Accounting",
        management: "Management",
        mg: "Management",
        fo: "Front Office",
        hk: "Housekeeping",
        ht: "Maintenance",
        bh: "Accounting",
        sl: "Sales",
        dx: "Directorship",
        direktion: "Directorship",
        ir: "Internal Resources",
        general: "General",
      },
      holidays: {
        newYear: "New Year's Day",
        epiphany: "Epiphany",
        womensDay: "International Women's Day",
        goodFriday: "Good Friday",
        easterMonday: "Easter Monday",
        laborDay: "Labor Day",
        ascension: "Ascension Day",
        whitMonday: "Whit Monday",
        corpusChristi: "Corpus Christi",
        assumption: "Assumption of Mary",
        childrensDay: "World Children's Day",
        germanUnity: "German Unity Day",
        reformationDay: "Reformation Day",
        allSaints: "All Saints' Day",
        repentanceDay: "Repentance and Prayer Day",
        christmas1: "Christmas Day",
        christmas2: "Boxing Day",
      },
      htBereich: {
        allgemein: "General",
        elektrik: "Electrical",
        sanitaer: "Plumbing",
        moebel: "Furniture",
        "heizung/klima": "HVAC / Climate",
        aussenbereich: "Outdoor Area",
      },
      tabs: {
        dashboard: "Dashboard (Prototyp)",
        internalresources: "Internal Resources",
        reservations: "Reservations (table)",
        analytics: "Reporting",
        traces: "Traces",
        hk: "Housekeeping & Stayovers",
        ht: "Maintenance",
        fundsachen: "Lost & Found",
        hr: "Human Resources",
        sales: "Sales & Revenue",
        logs: "System Logs",
        users: "User Management",
        kassenbuch: "Cash Ledger",
        xrechnung: "XRechnung",
        anleitungen: "Instructions",
        inventory: "Inventory",
        offers: "Offers",
        admin: "Admin Panel",
        iframe: "Partner App",
        automations: "Automations",
        workflows: "Workflows",
        buchhaltung: "Accounting",
        groups: "Groups",
        roomrack: "Room Rack",
        availability: "Availability",
        explorer: "Explorer",
        handover: "Shift Handover",
        customOrder: "Custom Order",
        reset: "Reset",
        resetOrderTooltip: "Restore default order",
        savingGroup: "Saving group…",
        groupSaveError: "The group could not be saved. Please try again.",
      },
      availability: {
        title: "Availability",
        subtitle: "Occupancy and free rooms per category — all properties, one view.",
        filter: {
          allProperties: "All properties",
        },
        nav: {
          back7: "7 days back",
          today: "Today",
          forward7: "7 days forward",
          windowDays: "{{days}} days",
          from: "From",
        },
        metric: {
          available: "Available",
          occupancy: "Occupancy",
          sold: "Sold",
          sellable: "Sellable",
        },
        density: {
          compact: "Compact",
          normal: "Normal",
          wide: "Wide",
        },
        legend: {
          plenty: "plenty free",
          few: "few free",
          soldOut: "sold out",
          overbookable: "sold out, overbooking allowed",
        },
        grid: {
          roomTypes: "Room categories",
          propertyTotal: "Total (hotel)",
          noRoomTypes: "No room categories in this period.",
        },
        weekdays: {
          mon: "Mon",
          tue: "Tue",
          wed: "Wed",
          thu: "Thu",
          fri: "Fri",
          sat: "Sat",
          sun: "Sun",
        },
        metrics: {
          houseCount: "House count (total rooms)",
          sold: "Sold",
          outOfOrder: "Out of order (OOO)",
          outOfInventory: "Out of inventory",
          blocksDefinite: "Definite blocks",
          blocksTentative: "Tentative blocks",
          occupancy: "Occupancy",
          sellable: "Sellable",
          allowedOverbooking: "Allowed overbooking",
        },
        empty: "No properties available.",
        retry: "Error – try again",
        error: "Availability could not be loaded.",
        windowLabel: "{{from}} – {{to}}",
        updating: "Loading period…",
        cellTooltip: "{{name}} · {{date}}: {{free}} free / {{total}} total",
        loading: "Loading…",
        refresh: "Refresh",
      },
      handover: {
        items: "items",
        noNotes: "No notes",
        view: {
          title: "Shift Handover",
          subtitle: "Structured handover between reception shifts",
          new: "New Handover",
          waitingForMe: "{{count}} handover waiting for me",
          myDraft: "My draft",
          submitNow: "Submit now",
          mineToComplete: "Mine to complete",
          completeMine: "Mark complete",
          history: "History",
          empty: "No handovers yet.",
        },
        filter: {
          allLocations: "All locations",
        },
        shift: {
          frueh: "Early shift",
          spaet: "Late shift",
          nacht: "Night shift",
          andere: "Other",
        },
        status: {
          draft: "Draft",
          submitted: "Submitted",
          acknowledged: "Acknowledged",
        },
        itemTypes: {
          info: "Info",
          task: "Task",
          incident: "Incident",
        },
        composer: {
          title: "New Shift Handover",
          date: "Date",
          shift: "Shift",
          location: "Location",
          incoming: "Successor",
          incomingOptional: "Optional",
          notes: "General notes",
          notesPlaceholder: "Key points of the shift…",
          items: "Items",
          itemContent: "What needs handing over?",
          roomRef: "Room",
          addItem: "Add item",
          removeItem: "Remove item",
          saveDraft: "Save as draft",
          submit: "Submit",
        },
        detail: {
          title: "Handover",
          items: "{{count}} items",
          toggleDone: "Toggle done",
          room: "Room {{room}}",
          noItems: "No items recorded.",
          acknowledgedAt: "Acknowledged at {{time}}",
          acknowledge: "Acknowledge handover",
          completeMine: "Mark complete",
        },
        banner: {
          title: "Shift handover waiting",
          subtitle: "{{date}} · {{shift}} — please acknowledge",
        },
        toasts: {
          created: "Handover saved as draft.",
          submitted: "Handover submitted.",
          acknowledged: "Handover acknowledged.",
          deleted: "Draft deleted.",
        },
      },
      explorer: {
        title: "Explorer",
        subtitle: "Global search across guests, traces, offers and more",
        placeholder: "Search — name, ID or term…",
        searchHint: "Type at least 2 characters to search",
        searching: "Searching…",
        filterAll: "All",
        clear: "Clear",
        loadMore: "Show more",
        showLess: "Show less",
        noResults: "No results",
        noResultsHint: "Try a different or shorter search term",
        noMoreResults: "No further results",
        error: "Search failed. Please try again.",
        retry: "Try again",
        resultsCount: "{{count}} results",
        semanticTitle: "Semantic matches",
        type: {
          guest: "Guests",
          trace: "Traces",
          offer: "Offers",
          fundsache: "Lost & Found",
          support_ticket: "Support Tickets",
          user: "Users",
          inventory_item: "Inventory",
          kassenbuch_entry: "Cash Book",
          buchhaltung_doc: "Accounting Docs",
          waiting_list: "Waiting List",
          group: "Groups",
          loyalty_transaction: "Loyalty",
          anleitung: "Manuals",
          hr_request: "HR Requests",
          ht_list: "Maintenance Lists",
          ht_list_item: "Maintenance List Items",
          ht_device: "Devices",
          ht_room_check: "Room Checks",
          housekeeping_room: "Rooms (Housekeeping)",
          maintenance_window: "Maintenance Windows",
          company_contract: "Company Contracts",
          firmenrate: "Company Rates",
          global_task: "Tasks",
          reservation: "Reservations",
        },
      },
      inventory: {

        title: "Inventory Management",
        subtitle: "Stock • Minimum Stocks • Monthly Closings",
        importExcelCsv: "IMPORT (EXCEL/CSV)",
        exportCsv: "CSV EXPORT",
        rollover: "Month Closing",
        rolloverTooltip: "Saves current stock as previous month stock and resets counters",
        kpiTotalArticles: "Total Articles",
        kpiOutOfStock: "Out of Stock",
        kpiLowStock: "Order Needed",
        kpiTotalOrders: "Total Order Quantity",
        tabCurrentStock: "Current Stock",
        tabHistory: "Closing History",
        searchItemNumSupplier: "Search article, number or supplier...",
        statusAll: "Status: All",
        statusOk: "Status: OK",
        statusLowStock: "Status: Order Needed",
        statusOutOfStock: "Status: Empty",
        supplierAll: "Supplier: All",
        loadingItems: "Loading articles...",
        emptyTitle: "No articles found",
        emptyDesc: "Adjust your search/filters or add new articles using the button on the top right.",
        thArticle: "Article",
        thCategory: "Category",
        thStorageLocation: "Storage Location",
        thArticleNum: "Article Number",
        thSupplier: "Supplier",
        thPrevMonthStock: "Prev Month Stock",
        thCurrentStock: "Current Stock",
        thStockChange: "Stock Change",
        thMinStock: "Min Stock",
        thStatus: "Status",
        thOrderQty: "Order Qty",
        thLastOrder: "Last Order",
        thLink: "Link",
        thActions: "Actions",
        btnSubtract: "Subtract",
        btnAdd: "Add",
        btnSet: "Set",
        btnSetOrderDate: "Set order date",
        tooltipEnterStock: "Enter stock number",
        tooltipSetStock: "Apply stock",
        tooltipOpenLink: "Open article link",
        historyEmptyTitle: "No closings available yet",
        historyEmptyDesc: "As soon as you perform a month closing at the end of a month, the historical data will be archived here.",
        historyThMonth: "Closing Month",
        historyThBy: "Performed by",
        historyThOn: "Performed on",
        historyThItems: "Listed Articles",
        historyBtnDetails: "Show Details",
        toastInvalidValue: "Invalid value. Please enter an integer.",
        toastStockSet: "{{name}}: Stock set to {{stock}}",
        toastStockSetError: "Error setting stock: {{message}}",
        toastItemAdded: "Article successfully added.",
        toastItemAddError: "Error adding: {{message}}",
        toastItemUpdated: "Article successfully updated.",
        toastItemUpdateError: "Error updating: {{message}}",
        toastItemDeleted: "Article successfully deleted.",
        toastItemDeleteError: "Error deleting: {{message}}",
        toastNoItemsRollover: "No articles available for this location to perform a closing.",
        toastRolloverSuccess: "Month closing ({{month}}) for {{property}} successfully completed.",
        toastRolloverError: "Error during month closing: {{message}}",
        toastCsvExported: "Inventory list exported as CSV.",
        csvHeaderChange: "Stock Change",
        csvStatusOut: "Out of Stock",
        csvStatusLow: "Order Needed",
        csvStatusOk: "OK",
        modalAddTitle: "Add Article",
        modalAddDesc: "Create a new entry in the inventory",
        modalEditTitle: "Edit Article",
        modalEditDesc: "Change the properties of this inventory item",
        modalDeleteTitle: "Delete Article?",
        modalDeleteDesc: "Do you really want to permanently delete the article <strong>{{name}}</strong> from the system? This cannot be undone.",
        modalRolloverTitle: "Perform Month Closing",
        modalRolloverDesc1: "The month closing secures the current state of all articles. The following actions will be executed:",
        modalRolloverDesc2: "A complete snapshot of the current inventory will be secured in the archive.",
        modalRolloverDesc3: "The value in <strong>Prev Month Stock</strong> will be set to the current value of <strong>Current Stock</strong>.",
        modalRolloverDesc4: "The stock change will be reset to zero for the new month.",
        modalRolloverDesc5: "Are you sure you want to perform the month closing now?",
        btnCancel: "Cancel",
        btnSave: "Save",
        btnDelete: "Delete",
        btnBookRollover: "Book Closing",
        lblArticleName: "* Article Name",
        lblArticleNamePh: "e.g. Microfiber Cloths Blue",
        lblArticleNum: "Article Number",
        lblArticleNumPh: "Art-0092",
        lblSupplier: "Supplier",
        lblSupplierPh: "Ecolab Germany",
        lblStorageLocation: "Storage Location(s)",
        lblStorageLocationPh: "e.g. Shelf A2, Basement, Bar...",
        locationSingle: "location",
        locationPlural: "locations",
        addAnotherLocation: "+ Select or type another storage location...",
        createLocation: "Create new storage location:",
        renameLocation: "Rename storage location",
        deleteLocation: "Delete storage location",
        noLocationsYet: "No storage locations yet. Type a name to create a new storage location.",
        lblLink: "Article Link (Optional)",
        lblLinkPh: "https://shop.example.com/item",
        lblLocation: "* Location",
        lblPrevMonth: "Prev Month",
        lblCurrent: "Current",
        lblMin: "Min. Stock",
        lblOrderQty: "Order Qty",
        lblOrderQtyActive: "Suggestion active",
        lblOrderQtyPh: "Recommended: min - current",
        lblResetSuggest: "Reset to auto-suggestion",
        unknown: "Unknown",
        allCategoriesShort: "All",
        newCategoryShort: "New",
        cat_Apartments: "Apartments",
        cat_Büromaterial: "Office Supplies",
        cat_Getränke: "Beverages",
        cat_Kaffee: "Coffee",
        cat_Kaufland: "Kaufland",
        cat_Metro: "Metro",
        cat_Snacks: "Snacks",
        lastOrderDate: "Last Order Date",
        addItem: "Add Item",
        editItem: "Edit Item",
        deleteItem: "Delete Item",
        importItems: "Import Items",
        itemName: "Item Name",
        category: "Category",
        quantity: "Quantity",
        unit: "Unit",
        minStock: "Minimum Stock",
        maxStock: "Maximum Stock",
        currentStock: "Current Stock",
        supplier: "Supplier",
        lastOrder: "Last Order",
        nextOrder: "Next Order",
        price: "Price",
        notes: "Notes",
        allCategories: "All Categories",
        allSuppliers: "All Suppliers",
        searchPlaceholder: "Search items...",
        confirmDelete: "Really delete this item?",
        deleteSuccess: "Item deleted successfully",
        saveSuccess: "Item saved successfully",
        loadError: "Error loading items",
        saveError: "Error saving: {{message}}",
        noItems: "No items found",
        importWizard: "Import Wizard",
        stockLow: "Low Stock",
        stockOk: "Stock OK",
        stockOver: "Overstock",
        orderDate: "Order Date",
        setOrderDate: "Set Order Date",
        setOrderDateBulk: "Bulk Order",
        selectItems: "Select items",
        exportExcel: "Export as Excel",
        importSuccess: "Import successful",
        importError: "Error importing: {{message}}",
        article: "Article",
        articleNumber: "Article Number",
        prevMonthStock: "Previous Month Stock",
        categoryPlaceholder: "e.g. Cleaning, Laundry…",
        categoryCreated: "Category \"{{name}}\" created",
        itemsMovedToCategory: "{{count}} items moved to \"{{name}}\"",
        categoryAssignError: "Error assigning category: {{message}}",
        categoryDeleted: "Category \"{{name}}\" deleted",
        categoryDeleteError: "Error deleting category: {{message}}",
        confirmDeleteCategory: "Delete category \"{{name}}\"?\n\nAll assignments will be removed. The category tab will disappear if no items are assigned.",
        deleteCategoryTitle: "Delete category \"{{name}}\" (removes assignment)",
        addCategoryTitle: "Add category",
        categoryNamePlaceholder: "Category name...",
        addCategory: "Add",
      },
      hrAddUser: {
        title: "Add Employee",
        manualTitle: "Add Employee Manually",
        manualSubtitle: "For manual time tracking without email login",
        holidayStateLabel: "Federal State for Holidays",
        addButton: "Add Employee",
        nameLabel: "Name (required)",
        namePlaceholder: "e.g. Maria Schmidt",
        emailLabel: "Email Address (optional)",
        emailPlaceholder: "Optional, leave blank if no login",
        proRataApplied: "Pro-rata calculation applied:",
        daysCurrentYear: "{{count}} days (Current year)",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        role: "Role",
        department: "Department",
        startDate: "Start Date",
        exitDate: "Exit Date",
        employmentPeriodTitle: "Employment Period (pro-rata vacation)",
        vacationAccountTitle: "Vacation Account",
        yearlyEntitlement: "Yearly Entitlement",
        currentYearEntitlement: "Current Year Entitlement",
        remainingVacationPrevYear: "Remaining Vacation (prev. year)",
        employeeNumber: "Employee Number",
        save: "Save",
        cancel: "Cancel",
        success: "Employee successfully added",
        error: "Error adding employee: {{message}}",
        requiredFields: "Please fill in all required fields",
        personType: "Person Type",
        personTypeFull: "With Login",
        personTypeHr: "HR Person Only",
        hoursPerDay: "Hours per Day",
        hoursPerWeek: "Hours per Week",
        hoursPerWeekHint: "{{hours}} h/week across {{days}} workdays ≈ {{perDay}} h/day",
        weeklyHours: "Weekly Hours",
        workdaysSplitHint: "{{hours}} h/week across {{days}} workdays ≈ {{perDay}} h/day",
        workdays: "Workdays",
        workdaysHint: "Select primary workdays",
        noLoginWarning: "This person has no login — all actions are performed by a manager.",
      },
      attachmentUpload: {
        attachTitle: "Attach file",
        fileTooLargeError: "\"{{name}}\" is too large (max {{max}} MB)",
        maxFilesError: "Maximum {{max}} files allowed",
        selectFiles: "Select files",
        selectFilesTitle: "Select files to attach",
      },
      salesCrm: {
        tabTitle: "Pipeline",
        searchPlaceholder: "Search company, industry, location...",
        empty: "No companies found",
        emptyLane: "No companies",
        view: { board: "Board", list: "List" },
        filter: {
          priorityAll: "All priorities",
          priorityA: "Priority A",
          priorityB: "Priority B",
          priorityC: "Priority C",
          phaseAll: "All phases",
          locationAll: "All locations",
        },
        priority: { a: "A - check first", b: "B - check next", c: "C - longlist" },
        priorityBadge: "Prio {{priority}}",
        type: { prospect: "Prospect", bestand: "Existing customer" },
        phase: {
          none: "Not started",
          "1": "Phase 1: Understand & prepare",
          "2": "Phase 2: Acquire new customers",
          "3": "Phase 3: Deepen & follow up",
          "4": "Phase 4: Stabilize bookings",
        },
        phaseBadge: "Phase {{phase}}",
        status: {
          neu: "New",
          kontaktiert: "Contacted",
          bedarfsgespraech: "Needs meeting",
          angebot: "Offer",
          wiedervorlage: "Follow-up",
          rahmenvertrag_geprueft: "Framework contract reviewed",
          gewonnen: "Won",
          verloren: "Lost",
        },
        appointments: {
          listTitle: "APPOINTMENTS",
          empty: "No appointments logged",
          emptySub: "No appointments or on-site visits have been logged.",
          single: "Appointment",
          plural: "Appointments",
          subtitle: "On-site meetings & visits",
        },
        contacts: {
          listTitle: "CONTACTS",
          empty: "No contacts logged",
          emptySub: "No calls, emails or visits have been logged.",
          single: "Contact",
          plural: "Contacts",
          subtitle: "Calls, emails & meetings",
        },
        followUps: {
          open: "open",
          due: "due",
          openModal: "Open",
          listTitle: "FOLLOW-UPS",
          allCaughtUp: "All activities are up to date.",
          selectPrompt: "Select a follow-up from the list.",
          subtitle: "Follow-ups & appointments",
          filterAll: "All",
          filterDue: "Due",
          filterToday: "Today",
          filterUpcoming: "Upcoming",
          filterEmpty: "No entries found for this filter.",
          noItemsInFilter: "No entries available in this filter view.",
        },
        company: {
          newButton: "New company",
          newTitle: "New pipeline company",
          editTitle: "Edit company",
          edit: "Edit",
          save: "Save",
          create: "Create",
          delete: "Delete",
          deleteConfirm: "Really delete this company? All activities will be deleted too.",
          duplicateName: "A company with this name already exists.",
          mutationError: "Action failed. Please try again.",
          name: "Company name",
          namePlaceholder: "e.g. Maschinenfabrik Herkules GmbH & Co. KG",
          type: "Type",
          priority: "Priority",
          phase: "Roadmap phase",
          status: "Pipeline status",
          location: "Location",
          locationPlaceholder: "e.g. London, Berlin...",
          industry: "Industry",
          industryPlaceholder: "e.g. Construction, Engineering...",
          reason: "Reason (why check?)",
          reasonPlaceholder: "e.g. construction sites, project teams, subcontractors",
          contactPerson: "Contact person",
          contactAPosition: "Position",
          contactEmail: "Email",
          contactPhone: "Phone",
          contactBSection: "Contact B (second contact person)",
          contactBName: "Contact B – Name",
          contactBPosition: "Contact B – Position",
          contactBEmail: "Contact B – Email",
          contactBPhone: "Contact B – Phone",
          decisionMaker: "Decision maker / booker",
          apaleoName: "Apaleo company name (revenue match)",
          apaleoNamePlaceholder: "Exactly as in the company list (revenue tab)",
          apaleoHelp: "Links this company with Apaleo revenue data for automatic matching of room nights and revenue.",
          pipelineSection: "Pipeline & Prioritization",
          contactsSection: "Contacts & Decision Makers",
          addContact: "Add contact",
          addAnotherContact: "Add another contact",
          contactNumber: "Contact #{{number}}",
          primaryContact: "Primary contact",
          setPrimary: "Set as primary contact",
          removeContact: "Remove contact",
          contactPersonName: "Name",
          contactNamePlaceholder: "First & Last name...",
          role: "Role / Function",
          rolePlaceholder: "e.g. Contact person, Decision maker...",
          chooseRole: "Choose role:",
          confirmDeletePrompt: "Confirm deletion?",
          yesDelete: "Yes, delete",
          unnamedContact: "Unnamed contact",
          unknown: "Unknown company",
        },
        roles: {
          contactPerson: "Contact Person",
          decisionMaker: "Decision Maker / Booker",
          management: "Management",
          accounting: "Accounting",
          projectLead: "Project Lead",
          assistant: "Assistant",
        },
        contactImport: {
          button: "Import contacts",
          title: "Import contacts from Excel",
          subtitle: "Excel with the columns Company, Contact A (name/position/tel/email) and Contact B (name/position/tel/email). Matched by company name. Empty cells never overwrite existing contacts.",
          chooseFile: "Choose Excel file",
          missingFirma: "The file has no \"Company\" column. Please use the original file.",
          noRows: "No data rows found.",
          parseError: "Could not read the file. Please use .xlsx or .csv.",
          matched: "{{count}} companies matched",
          unmatched: "{{count}} not found",
          notFound: "Not in the pipeline",
          match: "Matched",
          matchFuzzy: "Matched: {{company}} (via partial name — please verify)",
          unmatchedHint: "Unmatched companies are skipped. Create the company names in the pipeline or check the spelling.",
          emptyRows: "{{count}} matched rows without contact data",
          colFirma: "Company",
          colContactA: "Contact A",
          colContactB: "Contact B",
          apply: "Update {{count}} companies",
          success: "{{count}} companies updated.",
          applyError: "Import failed",
        },        card: {
          detail: "Open details",
          contractHandoff: "Create contract",
        },
        detail: {
          profileSection: "Customer profile",
          activitySection: "Activities",
          noProfile: "No profile filled in yet",
        },
        activity: {
          title: "Log activity",
          quickAdd: "Activity",
          type: "Type",
          date: "Date",
          followUp: "Follow-up",
          followUpBadge: "Follow-up: {{date}}",
          notes: "Notes",
          notesPlaceholder: "Meeting notes, outcomes, next steps...",
          save: "Save",
          empty: "No activities yet",
        },
        activityType: {
          anruf: "Call",
          email: "Email",
          besuch: "Visit / meeting",
          angebot: "Offer",
          notiz: "Note",
        },
        dragColumnHint: "Drag column to reorder",
        kpi: {
          contacts: "Contacts",
          contactsTarget: "Target: {{min}}–{{max}} contacts",
          appointments: "Appointments",
          appointmentsTarget: "Target: {{min}}–{{max}} appointments",
          followUps: "Follow-ups",
          weekRange: "{{from}} – {{to}}",
          noFollowUps: "No open follow-ups",
          collapse: "Collapse",
          expand: "Expand",
          quotaAchieved: "Goal achieved!",
          editQuota: "Edit target / quota (Click to edit)",
        },
        profile: {
          title: "Customer profile",
          editButton: "Edit profile",
          save: "Save",
          revenueContext: "Revenue (revenue-tab period): {{revenue}} · {{nights}} nights",
          bookingReason: "Booking reason",
          bookingReasonPlaceholder: "Project, service call, assembly, training, travel, event...",
          guestType: "Who stays?",
          guestTypePlaceholder: "Own staff, external technicians, suppliers, guests, teams...",
          frequency: "How often / how long?",
          frequencyPlaceholder: "e.g. 2× per month, 3–5 nights",
          weekdays: "Typical weekdays",
          weekdaysPlaceholder: "e.g. Mon–Thu",
          channel: "Booking channel",
          channelPlaceholder: "e.g. Direct, email, travel agency",
          price: "Price / terms",
          pricePlaceholder: "e.g. corporate rate €89, incl. breakfast",
          requirements: "Requirements",
          requirementsPlaceholder: "Parking, kitchen, invoice, location, flexibility, check-in...",
          internalNotes: "Internal notes",
        },
      },
      sales: {
        menuTitle: "Sales & Revenue",
        viewSubtitle: "Companies, Rate Plans & Traffic Analysis",
        description: "Company contracts, rate plans and booking traffic from Apaleo",
        hotelPrefix: "Hotel:",
        allHotels: "All Hotels",
        allCategories: "All Categories",
        companies: "Companies",
        stammdaten: "Master Data",
        umsatz: "Revenue",
        period: "Period: {{from}} – {{to}}",
        searchCompanies: "Search companies...",
        searchRevenue: "Search revenue...",
        calculatingRevenue: "Loading revenue report...",
        noCompanies: "No companies found",
        noRevenueData: "No revenue data",
        ratePlans: "Rate Plans",
        searchRatePlans: "Search rate plans...",
        all: "All",
        active: "Active",
        inactive: "Inactive",
        plans: "Plans",
        plansCount: "{{count}} plans",
        noDescription: "No description",
        hotels: "Hotel: {{property}}",
        noRatePlans: "No rate plans found",
        traffic: "Traffic & Revenue",
        trafficSubtitle: "Booking frequency & rate revenues",
        default: "Default",
        customRange: "Custom",
        sorting: "Sort by",
        sortByBookings: "Bookings",
        sortByRevenue: "Revenue",
        range: "Range",
        timeframe: "Timeframe",
        days7: "7 Days",
        days30: "30 Days",
        days90: "90 Days",
        days180: "180 Days",
        days365: "365 Days (1 Year)",
        from: "From",
        to: "To",
        max30Days: "Maximum 30-day range",
        customRangeHint: "Longer ranges may increase load time",
        searchTraffic: "Search rate plan...",
        calculatingTraffic: "Calculating traffic data...",
        category: "Categories: {{categories}}",
        bookings: "{{count}} Bookings",
        revenue: "Revenue",
        adr: "ADR",
        alos: "ALOS",
        nights: "{{count}} Nights",
        noTraffic: "No traffic in selected period",
        roomNights: "{{count}} nights",
        debugFetched: "Reservations fetched: {{count}} (arrivals in period only)",
        debugNoCompany: "{{count}} reservations excluded — no company name",
        debugCanceledExcluded: "{{count}} canceled/no-show reservations excluded",
        reservationsList: "{{count}} reservations in this calculation",
        noReservations: "No reservations with a company name in this period",
        startSearch: "Start search",
        searchStale: "Period changed — start search again",
        searchNotStarted: "Start the search to load data",
        invoiceCount: "{{count}} invoices found in Apaleo",
        invoiceDates: "Invoice dates: {{dates}}",
        invoiceFailedChunks: "Warning: {{count}} monthly fetch(es) of the company report failed ({{periods}}) — revenue may be undercounted.",
        invoiceRowsInfo: "{{total}} invoice rows fetched, {{noCompany}} without a company name",
        revenueSelectRow: "Select {{name}}",
        revenueSelectionCount: "{{count}} selected",
        revenueSelectionRevenue: "Selected revenue",
        revenueSelectionNights: "Selected nights",
        revenueSelectionClear: "Clear selection",
        invoiceType: {
          Initial: "Invoice",
          Advance: "Advance invoice",
          Correction: "Correction invoice",
          Cancellation: "Cancellation invoice",
          AdvanceCancellation: "Advance cancellation",
          AdvanceCorrection: "Advance correction",
          Proforma: "Proforma",
          Deposit: "Deposit invoice",
          DepositCancellation: "Deposit cancellation",
          DepositCorrection: "Deposit correction",
        },
      },
      auth: {
        email: "Email",
        password: "Password",
        signIn: "Sign in",
        signUp: "Sign up",
        magicLink: "Send magic link",
        google: "Continue with Google",
        passkey: "Sign in with passkey",
        passkeyTitle: "Passkey (WebAuthn)",
        passkeyHelper: "Create a passkey to sign in without a password.",
        passkeyCreate: "Create passkey",
        passkeyCreating: "Creating…",
        passkeyCreated: "Passkey created successfully.",
        signingIn: "Signing in…",
        or: "or",
        invalidCredentials: "Invalid email or password.",
        emailNotConfirmed: "Please confirm your email address first.",
        alreadyRegistered: "This email is already registered.",
        emailRequired: "Please enter an email address.",
        captchaRequired: "Please complete the CAPTCHA.",
        magicLinkSent: "If this email exists, a magic link has been sent.",
        checkEmail: "Please check your inbox.",
        genericError: "Sign-in failed. Please try again.",
        forgotPassword: "Forgot password?",
        resetPassword: "Reset password",
        resetEmailSent: "If this email exists, a reset link has been sent.",
        newPassword: "New password",
        confirmPassword: "Confirm password",
        passwordsDoNotMatch: "Passwords do not match.",
        setNewPassword: "Set new password",
        settingPassword: "Setting password…",
        passwordSet: "Password successfully set.",
        passwordResetError: "Reset failed. Please try again.",
        newPasswordHint: "At least 10 characters. Must include a number, lowercase and uppercase letters, and special characters!",
      },
      uploadProgress: {
        done: "Uploaded",
        failed: "Upload failed",
        preparing: "Preparing...",
      },
      common: {
        demo: "Demo",
        pwa: {
          newVersionToast: "New version available – it loads on your next window switch. You'll be updated automatically.",
        },
        errors: {
          updateLoading: "Loading new version…",
          updateManual: "The app was updated. A quick reload is required.",
          reloadPage: "Reload page",
          somethingWentWrong: "Something went wrong",
          unexpected: "An unexpected error occurred.",
          tryAgain: "Try again",
        },
        reset: "Reset",
        choose: "Choose...",
        logout: "Logout",
        welcome: "Welcome",
        settings: "Settings",
        save: "Save",
        cancel: "Cancel",
        next: "Next",
        back: "Back",
        search: "Search",
        loading: "Loading...",
        error: "Error",
        success: "Success",
        print: "Print",
        archive: "Archived",
        delete: "Delete",
        remove: "Remove",
        copyCode: "Copy code",
        edit: "Edit",
        close: "Close",
        open: "Open",
        add: "Add",
        export: "Export",
        status: "Status",
        info: "Info",
        warning: "Warning",
        propertySelection: "Property Selection",
        allProperties: "All Properties",
        selected: "selected",
        today: "Today",
        allOf: "All of",
        allWithCount: "All ({{count}})",
        apiWarning: "API connection limited",
        appName: "AdaptHub",
        applyFilters: "Apply Filters",
        clearSelection: "Clear Selection",
        clock: "Clock",
        done: "Done",
        loadingApp: "Loading application\u2026",
        loggedIn: "Logged in",
        noOptions: "No options",
        offlineMode: "Offline mode",
        operationFailed: "Operation failed",
        preferences: "Preferences",
        recent: "Recent",
        saving: "Saving\u2026",
        select: "Select",
        selectAll: "Select all",
        selectedCount: "{{count}} selected",
        system: "System",
        trace: "Trace",
        unknown: "Unknown",
        unknownShort: "Unk.",
        update: "Update",
        users: "Users",
        languageLabel: "Language",
        languageDe: "German",
        languageEn: "English",
        less: "Less",
        property: "Property",
        retry: "Retry",
      },
      priority: {
        normal: "Normal",
        high: "High",
        urgent: "Urgent",
      },
      fileViewer: {
        openExternally: "Open in new tab",
        download: "Download",
        loadFailed: "The file could not be loaded.",
        noPreview: "This file can't be displayed directly (e.g. ZIP, Excel, HEIC). Download it to open it.",
      },
      preferences: {
        title: "Preferences",
        subtitle: "Personalization & Configuration",
        tabProperties: "Properties",
        tabMenuGroups: "Menu Groups",
        tabAdmin: "Admin",
        userFallback: "Guest",
        propertySelectionHelper: "Select your preferred properties. These will be used as default filters in all modules.",
        menuGroupNamePlaceholder: "e.g. Daily Tasks",
        noMenuGroups: "No menu groups yet. Create a new group to organize your sidebar tabs.",
        iframeDisplayNameLabel: "Display Name",
        iframeDisplayNamePlaceholder: "Name of the partner app",
        iframeUrlLabel: "URL",
        iframeUrlPlaceholder: "https://app.example.com",
        propertyEmailsTitle: "Contact Emails",
        propertyEmailLabel: "Email Recipient",
        propertyEmailPlaceholder: "email@example.com",
        noPropertiesConfigured: "No properties configured",
        forceReloadWarning: "This action will reload the application for all users. Please use with caution.",
        forceReloadButton: "Reload System",
      },
      inactivity: {
        warningBanner: "Automatic logout due to inactivity soon — move your mouse or press a key.",
      },
      months: {
        jan: "January",
        feb: "February",
        mrz: "March",
        apr: "April",
        mai: "May",
        jun: "June",
        jul: "July",
        aug: "August",
        sep: "September",
        okt: "October",
        nov: "November",
        dez: "December",
      },
      kassenbuch: {
        title: "Cash Ledger",
        locked: "Finalized",
        tabs: {
          journal: "Journal",
          counter: "Cash Count",
          settings: "Settings",
        },
        stats: {
          opening: "Opening Balance",
          income: "Income",
          incomeSum: "Total Income",
          expense: "Expenses",
          expenseSum: "Total Expenses",
          safe: "Safe Balance",
          closing: "Closing Balance",
          closingTarget: "Closing Balance (Target)",
        },
        ledger: {
          title: "Journal",
          addEntry: "Add Entry",
          reconciliation: "Reconciliation",
          closePeriod: "Period Close",
          periodLock: "Finalize Month",
          periodLockTooltip: "Cash must be balanced before closing",
        },
        counter: {
          title: "Physical Count",
          qty: "Quantity",
          subtotal: "Subtotal",
          note: "Banknote",
          coin: "Coin",
        },
        reconciliation: {
          targetBalance: "Target Balance (Ledger)",
          actualBalance: "Actual Balance (Counted)",
          difference: "Difference",
          balanced: "The cash is fully balanced.",
          balancedShort: "Cash is balanced.",
          unbalanced: "Warning: A difference of {{amount}} was detected.",
          unbalancedShort: "Difference of {{amount}} detected.",
          hint: "Please ensure all documents for the month are recorded before finalizing. Differences over 0.00 EUR must be justified in the journal.",
        },
        systemStatus: "System Status",
        systemStatusShort: "System Status",
        export: {
          excel: "Excel Export",
          datev: "DATEV Export",
          success: "Export successful",
        },
        creationInfo: {
          title: "Creation Info",
          text: "This entry was created on {{date}} at {{time}} by {{user}} and is stored immutably in GoBD-compliant form.",
        },
        deletedBy: "Cancelled by {{user}} on {{date}}",
        cancelled: "Cancelled",
        storno: "Cancellation Entry",
        receipt: {
          missing: "Missing",
          view: "View Receipt",
          delete: "Delete Receipt",
          upload: "Upload Receipt",
          fetchFromApaleo: "Fetch from Apaleo",
        },
        fetchInvoice: {
          title: "Load Invoice from Apaleo",
          subtitle: "Auto-link receipt",
          invoiceNumber: "Invoice Number",
          placeholder: "e.g. SI-2650286",
          loading: "Loading PDF...",
          fetch: "Load Now",
          hint: "ID will be sent to Apaleo as {{propertyId}}-{{invoiceNo}}.",
        },
        bulkDownload: {
          button: "Download Receipts",
          title: "Download Receipts as ZIP",
          subtitle: "All receipts in a period for one location",
          location: "Location",
          from: "From",
          to: "To",
          invalidRange: "\u201cTo\u201d must be after \u201cFrom\u201d.",
          emptyRange: "Please specify From and To.",
          fetchError: "Could not load receipts: {{message}}",
          downloading: "Downloading {{done}} of {{total}} receipts...",
          zipError: "ZIP creation failed: {{message}}",
          summaryTitle: "Download complete",
          summaryDownloaded: "{{count}} receipt(s) downloaded",
          summaryMissing: "{{count}} skipped (no receipt)",
          summaryFailed: "{{count}} failed",
          failedReason: "Receipt {{belegNr}}: {{reason}}",
          noReceipts: "No receipts found in the selected period.",
          close: "Close",
          localhostHint: "Development mode: no real receipts are stored here — please test in the production environment.",
        },
        loading: "Loading Cash Ledger...",
        taxRateHint: "0%",
        amountHint: "0.00",
        date: "Date",
      },
      newKassenbuchEntry: {
        title: "New Booking Entry",
        bookingType: "Booking Type",
        location: "Location",
        choose: "Please choose...",
        date: "Date",
        payeePayer: "Payee / Payer",
        payeePlaceholder: "e.g. Guest Müller",
        amount: "Amount (€)",
        amountEur: "Amount (€)",
        amountPlaceholder: "e.g. 25.00",
        income: "Income",
        expense: "Expense",
        safeTransfer: "Safe Transfer",
        direction: "Direction",
        toSafe: "→ Into Safe (Expense)",
        fromSafe: "← From Safe (Income)",
        autoExpense: "Will be posted as expense",
        autoIncome: "Will be posted as income",
        safeAmount: "Safe Amount (€)",
        invoiceNumber: "Invoice Number",
        invoicePlaceholder: "e.g. SI-2650286",
        bookingText: "Booking Description",
        noBookingTexts: "No booking descriptions configured",
        taxRate: "Tax Rate",
        taxFree: "Tax Free (0%)",
        accountDebit: "Debit Account",
        accountCredit: "Credit Account",
        costCenter: "Cost Center",
        attachReceipt: "Attach Receipt",
        clickToReplace: "Click to replace",
        dragDrop: "Drop file here or click to upload",
        fileHint: "Accepts: JPG, PNG, PDF (max. 10 MB)",
        saveBooking: "Save Booking",
        category: "Category",
        receipt: "Receipt",
        notes: "Notes",
        addEntry: "Add Entry",
        updateEntry: "Update Entry",
        saveSuccess: "Entry saved successfully",
        saveError: "Error saving: {{message}}",
        receiptUploaded: "Receipt uploaded",
        receiptUploadError: "Receipt upload failed",
        confirmDiscard: "Really discard this entry?",
      },
      kassenbuchSettings: {
        settingsTitle: "Cash Ledger Configuration",
        settingsDesc: "Configure your Cash Ledger instance(s):",
        description: "Configure your Cash Ledger instance(s):",
        location: "Location",
        addLocation: "Add Location",
        saveConfig: "Save Configuration",
        propertyLabel: "Location {{propId}}",
        cashAccount: "Cash Account",
        costCenter: "Cost Center",
        tresorSettings: "Tresor Settings",
        tresorAccount: "Tresor Transfer Contra Account",
        helpTitle: "HELP & INFORMATION",
        helpText: "Here you can manage the account settings and booking descriptions for your cash book. Changes to the booking descriptions only affect future bookings.",
        predefinedTexts: "Predefined Booking Texts",
        addLabel: "Booking Description",
        addPlaceholder: "e.g. Cash deposit guest",
        addContraAccount: "Default Contra Account",
        addContraPlaceholder: "e.g. 1000",
        addTaxRate: "Default Tax Rate",
        tableHeaderText: "Booking Description",
        tableHeaderAccount: "Contra Account",
        tableHeaderTax: "Tax Rate",
        emptyText: "No predefined booking descriptions configured.",
        confirmReset: "Do you really want to reset these booking descriptions?",
        configSaved: "Configuration saved",
        locationAdded: "Location added",
        locationRemoved: "Location removed",
        textAdded: "Booking text added",
        textUpdated: "Booking text updated",
        textRemoved: "Booking text removed",
        confirmDeleteText: "Really delete this booking text?",
        confirmRemoveLocation: "Really remove this location?",
      },
      invoiceCorrection: {
        title: "Invoice Correction",
        subtitleV1: "Invoice correction for selected booking",
        subtitleV2: "Create a corrected invoice",
        selectInvoice: "Select Invoice",
        invoicePrefix: "Invoice",
        downloadPdf: "Download PDF",
        submit: "Submit Correction",
        selectInvoiceDesc: "Select an invoice to issue a correction for.",
        requestHint: "The correction will be forwarded to reception for processing.",
        gobdNotice: "The correction follows GoBD guidelines. The original invoice remains unchanged.",
        location: "Location",
        noPrefix: "No prefix",
        invoiceIdLabel: "Invoice Number",
        invoicePlaceholder: "e.g. INV-2024-001",
        newNameLabel: "New Invoice Recipient",
        newNamePlaceholder: "Name of new recipient",
        vatLabel: "VAT ID (optional)",
        languageLabel: "Language",
        languageDe: "German",
        languageEn: "English",
        streetLabel: "Street / No.",
        zipLabel: "ZIP Code",
        cityLabel: "City",
        processing: "Processing...",
        execute: "Execute Correction",
        success: "Invoice correction requested successfully",
        error: "Error during correction: {{message}}",
        downloading: "Downloading PDF...",
      },
      hrHolidaySettings: {
        title: "Holiday Configuration",
        subtitle: "Statutory & Regional Holidays",
        year: "Year",
        country: "Country",
        stateRegion: "State / Region",
        description: "Define holidays and special rules",
        freeDay: "Day off",
        halfDay: "Half day",
        save: "Save",
        workDay: "Work day",
      },
      cityTaxAudit: {
        title: "City Tax Audit",
        allProperties: "All Properties",
        tabUnpaid: "Unpaid (Open)",
        tabPaid: "Paid (Closed)",
        tabExported: "Exported",
        noResults: "No entries found",
        guestName: "Guest Name",
        arrival: "Arrival",
        departure: "Departure",
        property: "Property",
        amount: "Amount",
        status: "Status",
        open: "Open",
        paid: "Paid",
        markAsPaid: "Mark as Paid",
        markAsUnpaid: "Mark as Open",
        markAsExported: "Mark as Exported",
        exportCsv: "CSV Export",
        activeSelection: "Active Selection",
        case: "Case",
        cases: "Cases",
        close: "Close",
        conflictBadge: "Conflict",
        conflictDescription: "This mapping conflicts with other entries",
        conflictTitle: "Conflicts Detected",
        csvExport: "CSV Export",
        entriesCount: "{{count}} entries",
        excelExport: "Excel Export",
        filterAll: "All",
        filterConflicts: "Conflicts Only",
        filterNoConflicts: "No Conflicts",
        headerBalance: "Balance",
        headerDeparture: "Departure",
        headerGuest: "Guest",
        headerProperty: "Property",
        headerStatus: "Status",
        inCategory: "in {{category}}",
        loading: "Loading data\u2026",
        resetFilter: "Reset Filter",
        searchPlaceholder: "Search guests\u2026",
        showConflicts: "Show Conflicts",
        showNoConflicts: "Show Without Conflicts",
        statusCancelled: "Cancelled",
        statusLabel: "Status",
        statusOpen: "Open",
        statusPaid: "Paid",
        subtitle: "Audit and reconciliation of city-tax data",
        tabExempted: "Exempted",
      },
      recalcCityTax: {
        title: "Recalculate City Tax",
        subtitle: "7.5% nightly adjustment for ChannelManager bookings",
        dateRange: "Date Range (Arrival)",
        dateFrom: "From",
        dateTo: "To",
        sourceFilter: "Booking source",
        sourceFilterEmpty: "No booking sources found in the loaded reservations — enter a source manually.",
        sourceAddPlaceholder: "Add source manually…",
        sourceAdd: "Add",
        sourceFilterActive: "Filter active — only these sources will be processed: {{sources}}",
        createdRange: "Reservation creation date",
        createdHint: "Optional: limits by when the reservation was created (not arrival). Example: Booking.com bookings created from 14 May 2026 already include City Tax.",
        createdInvalidDate: "Creation date must be in YYYY-MM-DD format.",
        createdOrderError: "\"Created from\" must be on or before \"Created to\".",
        toolRecalc: "Recalculate City Tax",
        toolSplit: "Split HRS / Club Rates",
        splitBreakfastLabel: "Breakfast (gross)",
        splitBreakfastPlaceholder: "e.g. 12.00",
        splitBreakfastInvalid: "Breakfast amount must be a number greater than 0.",
        splitServiceLabel: "Apaleo service for the breakfast booking",
        splitServicePlaceholder: "e.g. BERLIN-FS_AIRPORT",
        splitServiceHint: "Booked per reservation with count = adults (idempotent: already-booked services are not double-booked). Empty = no service booking.",
        splitPerPersonUnit: "€ / person / night",
        singleMode: "Single reservation only (for live testing)",
        singleModeHint: "When set, only this reservation is processed (overrides the date range).",
        reservationIdLabel: "Reservation ID",
        reservationIdPlaceholder: "e.g. RES-12345",
        reservationNotFound: "No reservation found with this ID.",
        dryRun: "Dry-Run (preview only, no API calls)",
        dryRunHint: "Dry-Run does not perform any changes in the Apaleo system.",
        process: "Recalculate now",
        processing: "Processing reservations\u2026",
        warning: "This action removes the existing city tax and adds a new charge per night. The reservation total stays unchanged.",
        summary: "Summary",
        processed: "Successfully processed",
        skipped: "Skipped (not ChannelManager)",
        failed: "Failed",
        noDateRange: "Please select From and To dates.",
        noReservations: "No reservations found in the selected period.",
        noTimeSlicePrices: "Reservation has no valid nightly prices, skipped.",
        confirmTitle: "Start processing?",
        confirmBody: "{{count}} reservations will be processed. This cannot be undone.",
        confirmButton: "Process",
        cancel: "Cancel",
        close: "Close",
        retry: "Retry",
        resultsTitle: "Results",
        columnReservation: "Reservation",
        columnGuest: "Guest",
        columnChannel: "Channel",
        columnNights: "Nights",
        columnOriginalTotal: "Original",
        columnNewTotal: "New",
        columnStatus: "Status",
        statusProcessed: "Processed",
        statusSkipped: "Skipped",
        statusFailed: "Failed",
        statusDryRun: "Dry-Run",
        successToast: "{{processed}} reservations recalculated successfully.",
        partialSuccessToast: "Done: {{processed}} OK, {{failed}} failed.",
        failureToast: "Processing failed. See result list for details.",
        automationComment: "City tax automatically recalculated on {{date}} (AdaptHub).",
        automationCommentSplit: "Rate automatically split into accommodation + breakfast on {{date}} (AdaptHub).",
        automationCommentSplitNoBreakfast: "Rate automatically split into accommodation + breakfast on {{date}} (AdaptHub) – breakfast could NOT be booked as a service ({{reason}}).",
      },
      waitingList: {
        title: "Waiting List",
        subtitle: "Manage guests",
        newEntry: "New Entry",
        hotel: "Hotel",
        persons: "Persons",
        arrival: "Arrival",
        departure: "Departure",
        requester: "Requester",
        requesterPlaceholder: "Requester name...",
        status: "Status",
        notes: "Notes",
        notesPlaceholder: "e.g. Category or request...",
        guestName: "Guest Name",
        guestNamePlaceholder: "Guest name...",
        desiredCategory: "Desired Category",
        allCategories: "All Categories",
        update: "Update",
        monitor: "Monitor",
        listTab: "List",
        loading: "Loading waitlist...",
        empty: "No entries",
        editTitle: "Edit entry",
        deleteTitle: "Delete entry",
      },
      overbookingLocks: {
        title: "Overbooking Locks",
        newLock: "New Lock",
        hotelLocation: "Hotel Location",
        roomCategory: "Room Category",
        startDate: "Start",
        endDate: "End",
        lockCount: "Number of Locks",
        lockCountHint: "Determines the maximum number of physical rooms blocked for this period.",
        update: "Update",
        monitor: "Monitor",
        loadingLocks: "Loading locks...",
        empty: "No active locks at the moment",
        emptyActive: "No active locks at the moment",
        emptyInactive: "No non-active (blocked) locks at the moment",
        activeSubTab: "Active",
        inactiveSubTab: "Non-Active",
        blocked: "Blocked",
        roomAbbr: "Rm.",
        blocking: "Blocking room...",
        activeChecking: "Active (Checking)",
        any: "Any",
        subtitle: "Manage locks",
        locksTab: "Locks",
        allCategories: "All Categories",
        lockPeriodFrom: "Lock Period From",
        lockPeriodTo: "Lock Period To",
        editTooltip: "Edit entry",
        deleteTooltip: "Delete / release lock",
        maintenanceDescription: "Room blocked via Overbooking-Lock",
        reason: "Maintenance",
        systemName: "AdaptHub Maintenance",
        notificationText: "Overbooking-Lock: {{roomNumber}} has been blocked via Overbooking-Lock from {{arrival}} to {{departure}}",
        toastSuccess: "Overbooking-Lock created successfully",
      },
      usersView: {
        title: "User Management",
        subtitleV1: "Manage access rights and roles of your colleagues.",
        subtitleV2: "Identity & Access Management (IAM)",
        searchPlaceholder: "Search users by name, email or ID",
        noUsers: "No users found",
        tableEmployee: "Employee & Apaleo Identity",
        tableLastSeen: "Last Seen",
        tableRole: "Permission Level",
        tableHR: "HR Responsible",
        tableAction: "Action",
        tableActionV2: "Engine",
        deleteTitle: "Permanently delete user",
        deleteTitleV2: "Permanently terminate user",
        responsible: "Responsible",
        users: "users",
        ownProfile: "Own Profile",
      },
      onboarding: {
        title: "AdaptHub Onboarding Wizard",
        subtitle: "Configure your SaaS tenant in just a few steps.",
        step1_title: "Select Properties",
        step1_desc: "Select which of your Apaleo properties should be active in AdaptHub.",
        step2_title: "Activate Modules",
        step2_desc: "Enable the desired AdaptHub modules for your team.",
        step3_title: "Summary",
        step3_desc: "Verify your configuration before finishing.",
        complete: "Complete Onboarding",
        loadingProperties: "Loading properties...",
        noProperties: "No properties found in your Apaleo account. Please link at least one hotel in Apaleo.",
        moduleNameTraces: "Traces & Tasks",
        moduleDescTraces: "Collaboration and task assignment.",
        moduleNameKassenbuch: "Cash Ledger",
        moduleDescKassenbuch: "GoBD-compliant petty cash management.",
        moduleNameHr: "HR & Time",
        moduleDescHr: "Time tracking and employee organization.",
        moduleNameHk: "Housekeeping",
        moduleDescHk: "Room status management and cleaning planning.",
        moduleNameHt: "Maintenance",
        moduleDescHt: "Defect lists and maintenance work.",
        moduleNameFundsachen: "Lost & Found",
        moduleDescFundsachen: "Employee recording of lost items.",
        moduleNameXrechnung: "XRechnung",
        moduleDescXrechnung: "DATEV-compliant invoice export tools.",
        activeLocations: "Active Locations",
        activeModules: "Active Modules",
        back: "Back",
        next: "Next",
        pendingTitle: "Setup pending",
        setupPhase: "Setup phase",
        waitingMessage: "Please wait until the administrator has completed the setup",
      },
      hr: {
        clock: {
          title: "Human Resources",
          performed: "Performed",
          subtitle: "Personal Menu",
          description: "Manage your working hours and absences.",
          clockIn: "Clock In",
          clockOut: "Clock Out",
          break: "Break",
          breakEnd: "End Break",
          statusIn: "Clocked In",
          statusOut: "Clocked Out",
          statusBreak: "On Break",
          todayStats: "Today's Work Time",
          todayLogs: "Today's Activity",
          weeklyStats: "Weekly Work Time",
          monthlyStats: "Monthly Work Time",
          overtime: "Overtime",
        },
        tabs: {
          clock: "Time Tracking",
          history: "My History",
          requests: "Requests",
          planner: "Schedule",
          absences: "Absences",
          shifts: "Shifts",
          admin: "Admin",
          team: "Team",
          teamOverview: "Team Overview",
          timesheets: "Timesheets",
        },
        calendar: {
          viewLabel: "View",
          viewColumns: "Day grid",
          viewTimeline: "Timeline",
          viewColumnsHint: "Days as columns, hours vertical",
          viewTimelineHint: "Employees as rows, hours horizontal",
          zeroLengthNotSupported: "Start and end time cannot be identical.",
          saveFailed: "Could not save the shift",
          views: {
            day: "Day",
            workWeek: "Work Week",
            week: "Week",
            month: "Month",
          },
          searchEmployee: "Search employee...",
          allTeams: "All Teams",
          rowsLabel: "Rows:",
          compact: "Compact",
          standard: "Standard",
          colorLabel: "Color:",
          colorEmployee: "Employee",
          colorShiftType: "Shift Type",
          colorEmployeeHint: "Each employee has their own distinct color",
          colorShiftHint: "Colors based on shift time: Early, Day, Late, Night",
          previousPeriod: "Previous period",
          nextPeriod: "Next period",
          today: "Today",
          jumpToDate: "Jump to date",
          bulkShifts: "Bulk Shifts",
          bulkShiftsHint: "Bulk Shift Planning for multiple employees",
          addShift: "Add Shift",
          addSlot: "Add Slot",
          employeesShown: "{{count}} employees shown",
          jump: "Jump:",
          weekShort: "W{{week}} ({{from}}–{{to}})",
          timeColumn: "Time",
          dragHint: "Drag column dividers horizontally to resize · Drag shift up/down to reschedule · Drag bottom handle to resize duration",
          dragResizeColumn: "Drag horizontally to resize column (double-click to reset)",
          dragResizeStart: "Drag to resize start time (15m snap)",
          dragResizeEnd: "Drag to resize end time (15m snap)",
          dragColumnDivider: "Drag column divider to resize days",
          dragAdjustStart: "Drag to adjust start time",
          dragAdjustEnd: "Drag to adjust end time",
          clickToEdit: "Click to edit",
          dragToMove: "Drag to move",
          overnightContinuation: "Continues from previous day",
          noEmployeesFiltered: "No employees match the current filters — reset the team selection or search.",
          holidayNationwide: "Nationwide",
          type: "Type",
          noShiftsFound: "No shifts found matching your filters.",
          typeShift: "Shift",
          typeOnCall: "On-Call",
          typeBreak: "Break",
          typeCallDuty: "Call Duty",
          typeOvertime: "Overtime",
          callShort: "Call",
          breakShort: "Brk",
          staff: "Staff",
          teamMember: "Team member",
          plusOneDay: "+1 day",
          deptLabel: "Dept:",
          widthLabel: "Width:",
          fit: "Fit",
          spacious: "Spacious",
          detailed: "Detailed",
          showNotes: "Show Notes",
          dayComment: "Day Note",
          addComment: "Add note",
          editComment: "Edit note",
          commentPlaceholder: "Enter note for this day (e.g. late arrival, home office, handover)...",
          deleteComment: "Delete note",
          deleteCommentConfirm: "Are you sure you want to delete this day note?",
          hideNotes: "Hide Notes",
          showNotesHint: "Show Notes & Absences row",
          hideNotesHint: "Hide Notes & Absences row",
          scheduled: "Scheduled",
          notesAndAbsences: "Notes & Absences",
          timelineHours: "Timeline Hours (00–24)",
          employeesColumn: "Employees ({{filtered}}{{total}})",
          addSlotFor: "Add shift slot for {{name}}",
          editShiftTitle: "Edit Shift",
          createShiftTitle: "Create New Shift",
          employeeLabel: "Employee",
          dateLabel: "Date",
          startLabel: "Start",
          endLabel: "End",
          shiftTypeLabel: "Shift Type",
          shiftTypeShift: "Shift",
          shiftTypeOnCall: "On-Call",
          shiftTypeBreak: "Break",
          splitWithBreak: "Split Shift with Break",
          splitWithBreakHint: "Divides into 2 slots with 30m break in between",
          splitButton: "Split (30m)",
          splitTooShort: "Shift must be at least 1.5 hours to insert a break.",
          noteLabel: "Note / Details (optional)",
          notePlaceholder: "e.g. Early reception, Night manager...",
          deleteShiftConfirm: "Delete shift for {{name}}?",
          deleteButton: "Delete",
          contextMenu: {
            title: "Shift actions",
            edit: "Edit",
            duplicate: "Duplicate (tomorrow)",
            toOnCall: "Convert to on-call",
            toShift: "Convert back to shift",
            delete: "Delete",
          },
          cancelButton: "Cancel",
          saveShift: "Save Shift",
          createShiftButton: "Create Shift",
          customisation: "Customisation",
          customisationHint: "Adjust row height, color mode, and custom colors",
          colorCustomisation: "Color Customisation",
          colorCustomisationHint: "Click any swatch to edit color live",
          openColorSettings: "Open color settings to customize employee and shift colors",
          customColorsApplied: "Custom colors applied",
          resetAll: "Reset All",
          resetAllHint: "Reset all {{scope}} colors to defaults",
          scopeShift: "shift",
          scopeEmployee: "employee",
          closePopup: "Close pop-up",
          employeesTab: "Employees",
          shiftTypesTab: "Shift Types",
          filterEmployees: "Filter employees...",
          noEmployeesMatch: "No employees match \"{{query}}\"",
          editColorFor: "Click to edit color for {{name}}",
          locationFilter: "Filter by work location",
          allLocations: "All locations",
          resetToDefault: "Reset {{name}} to default color",
          resetToDefaultShort: "Reset {{name}} to default",
          colorsPersist: "Colors persist in browser",
          done: "Done",
          buckets: {
            early: { label: "Early Shift", desc: "Morning (before 10:00)" },
            day: { label: "Day Shift", desc: "Midday (10:00 – 15:00)" },
            late: { label: "Late Shift", desc: "Afternoon (15:00 – 20:00)" },
            night: { label: "Night Shift", desc: "Overnight (20:00 – 06:00)" },
            onCall: { label: "On-Call Duty", desc: "Standby / Call Duty" },
            break: { label: "Break / Rest", desc: "Rest Period / Break" },
          },
          shiftTitles: {
            early: "Early Shift",
            day: "Day Shift",
            late: "Late Shift",
            night: "Night Shift",
            onCall: "On-Call Duty",
            onCallShort: "On-Call",
            break: "Break",
          },
          bulk: {
            appliedSummary: "{{count}} shifts assigned",
            appliedSummaryWithReplaced: "{{count}} shifts assigned ({{replaced}} overwritten)",
            title: "Bulk Shift Planning & Automation",
            subtitle: "Schedule multi-person shifts, repeat weekly rhythms, or clone entire schedules forward",
            batchTab: "Batch Schedule",
            cloneTab: "Clone / Copy Schedule",
            targetEmployees: "Target Employees",
            selectedCount: "{{count}} selected",
            allFilter: "All ({{count}})",
            searchEmployees: "Search employees by name...",
            selectAllFiltered: "Select all filtered ({{count}})",
            clear: "Clear",
            hoursPerWeek: "{{hours}}h/w",
            dateRangeFirstCycle: "Date Range",
            from: "From",
            to: "To",
            optionalNoEndDate: "Optional (or use buttons below)",
            clearToDate: "Remove To date",
            exceedsToDate: "Exceeds selected To date (max {{weeks}} wks)",
            scheduledViaButtons: "Controlled by duration buttons below",
            manageTab: "Ongoing & Created Shifts",
            ongoingTitle: "Ongoing Shifts (Active Today)",
            ongoingActiveNow: "Active Now",
            noOngoingNow: "No shifts currently active",
            noShiftsToday: "No shifts scheduled for today",
            createdShiftsTitle: "Manage Created Shifts",
            manageSelectAll: "Select All",
            manageDeselectAll: "Clear Selection",
            bulkDelete: "Delete Selected",
            bulkDeleteConfirm: "Are you sure you want to delete {{count}} shifts? This cannot be undone.",
            bulkDeleteSuccess: "Successfully deleted {{count}} shifts",
            deleteError: "Error deleting shifts",
            deleteSingleConfirm: "Delete shift for {{name}} on {{date}}?",
            filterDateAll: "All Dates",
            filterDateToday: "Today",
            filterDateWeek: "This Week",
            filterDate4Weeks: "Next 30 Days",
            ongoingShiftsCount: "Ongoing",
            shiftsTodayCount: "Today",
            totalShiftsCount: "total shifts recorded",
            activeDays: "Active Days of Week",
            monFri: "Mon–Fri",
            allSevenDays: "All 7 Days",
            weekend: "Weekend",
            repeatRecurrence: "Shift Repeat Recurrence",
            singlePeriod: "Single period",
            cyclesTotalDays: "{{cycles}} cycles ({{days}} total days)",
            noRepeat: "No Repeat",
            everyWeek: "Every Week",
            everyTwoWeeks: "Every 2 Weeks",
            repeatForDuration: "Repeat for duration:",
            cycles: "{{count}} cycles",
            weeks: "{{count}} weeks",
            shiftTemplatePresets: "Shift Template & Presets",
            addPreset: "Add Preset",
            createPresetHint: "Create a new preset",
            resetPresetsHint: "Reset to default presets",
            editPresetFor: "Edit preset {{label}}",
            closeEdit: "Close edit",
            editPreset: "Edit Preset:",
            save: "Save",
            presetName: "Preset Name:",
            presetNamePlaceholder: "e.g. Früh (Early)",
            type: "Type:",
            times: "Times:",
            time: "Time:",
            deletePreset: "Delete Preset",
            savedToBrowser: "Saved to your browser presets",
            startTime: "Start Time",
            endTime: "End Time",
            duration: "Duration",
            regularShift: "Regular Shift",
            onCallDuty: "On-Call Duty",
            overtime: "Overtime",
            breakLabel: "Break",
            shiftNote: "Shift Note / Label (optional)",
            shiftNotePlaceholder: "e.g. Standard rhythm, Peak season rotation...",
            smartConflictCheck: "Smart Conflict Check",
            conflictsDetected: "{{count}} conflicts detected",
            smartConflictHint: "Automatically skips dates where an employee already has a scheduled shift or an approved absence (vacation, sick leave).",
            replaceExisting: "Replace existing shifts on target dates (overwrite)",
            replaceExistingHint: "When checked, existing shifts on these dates will be replaced by the new shifts. Approved vacations and sick leave remain protected.",
            willReplace: "Will replace {{count}} existing shift(s):",
            skippedConflicts: "Skipped conflicts preview:",
            absenceDetail: "{{name}} on {{date}} (Absence: {{type}})",
            existingShiftDetail: "{{name}} on {{date}} (Existing shift)",
            cloneEntireWeek: "Clone Entire Week",
            cloneEntireWeekHint: "Copy all shifts from a full 7-day week forward into next week(s)",
            cloneSingleDay: "Clone Single Day",
            cloneSingleDayHint: "Copy a single day's roster forward to the same day in next week(s)",
            sourceWeekStarting: "Source Week Starting (Monday)",
            sourceDate: "Source Date",
            sourcePeriod: "Source period: {{from}} to {{to}} ({{count}} shifts found{{forEmployee}})",
            sourceDateInfo: "Source date: {{date}} ({{count}} shifts found{{forEmployee}})",
            forEmployee: " for {{name}}",
            filterDepartment: "Filter Department",
            singleEmployee: "Single Employee",
            allDepartments: "All Departments ({{count}})",
            allEmployees: "All Employees ({{count}})",
            sourceShiftsPreview: "Source Shifts Preview",
            shiftCount: "{{count}} shift(s)",
            noShiftsOn: "No shifts on {{date}} (Day Off)",
            addShiftOn: "Add Shift on {{date}}:",
            addShiftOnDayHint: "Add shift on this day",
            allocatedPeople: "Allocated People to this Shift:",
            selectedOf: "{{selected}} of {{total}} selected",
            removeEmployee: "Remove employee",
            removeEmployeeNamed: "Remove {{name}}",
            selectPeople: "Select People",
            departmentMembers: "Department Members",
            clearAll: "Clear All",
            selectAll: "Select All",
            removeShift: "Remove Shift",
            editShiftRange: "Edit {{start}} – {{end}} shift",
            deleteShiftRange: "Delete {{start}} – {{end}} shift",
            clearShiftsFor: "Clear shifts for {{day}}",
            editDayShift: "Edit {{day}} shift",
            modified: "Modified",
            clearAllShiftsDay: "Clear all shifts for this day",
            dayOff: "Day Off",
            off: "Off",
            shiftShort: "{{count}} sh",
            copyForwardTo: "Copy Forward To",
            plusWeeks: "+{{count}} Week(s)",
            destinationStarts: "Destination starts: {{date}}",
            through: " through {{date}}",
            skipVacationConflicts: "Skip Vacation / Absence Conflicts",
            conflictsCount: "{{count}} conflicts",
            skipVacationHint: "Employees with approved vacations or sick notes in the target period are automatically excluded from the copy.",
            readyToSchedule: "Ready to schedule:",
            readyToClone: "Ready to clone:",
            shiftsCount: "{{count}} shifts",
            batchSummary: "({{employees}} employees · {{days}} days total)",
            cloneSummary: "(from {{count}} source shifts {{employee}}× {{weeks}} week(s))",
            scheduleShifts: "Schedule {{count}} Shifts",
            cloneShiftsForward: "Clone {{count}} Shifts Forward",
            newPreset: "New Preset",
            dayLabel: "Day",
          },
        },
        absences: {
          vacation: "Vacation",
          sick: "Sick Leave",
          training: "Training",
          other: "Other",
          compensatory: "Compensatory Time",
          submit: "Submit Request",
          myRequests: "My Requests",
          pending: "Pending",
          approved: "Approved",
          rejected: "Rejected",
          from: "From",
          to: "To",
          type: "Type",
          status: "Status",
          noRequests: "No requests found",
          total: "Total",
          taken: "Taken",
          planned: "Planned",
          remaining: "Remaining",
          reduced: "Reduced",
          days: "Days",
          entitlement: "Entitlement",
          nextYear: "Next Year",
          carryover: "Carryover",
          remainingShort: "Remaining",
          newAbsence: "New Absence",
          closeForm: "Close Absence",
          showForm: "Record New Absence",
        },
        admin: {
          title: "Admin Area",
          teamOverview: "Team Overview",
          approve: "Approve",
          reject: "Reject",
          edit: "Edit",
          delete: "Delete",
          addEntry: "Add Entry",
          employeeName: "Employee Name",
          state: "State",
          role: "Role",
          actions: "Actions",
          planner: "Schedule Planner",
          performRollover: "Perform Year-End Rollover",
          editEntitlement: "Edit Entitlement",
          editNextYear: "Edit Next Year",
          editCarryover: "Edit Carryover",
          timesheetsDesc: "Here you can view the exact clock-in and clock-out times...",
        },
        time: {
          manualPause: "Add Manual Break",
          editTime: "Edit Time",
          missingEntry: "Add Missing Entry",
          payoutButton: "Pay Out Overtime",
          payoutModalTitle: "Pay Out Overtime",
          payoutModalSubtitle: "Payout deducts the specified hours from the time balance.",
          payoutHoursLabel: "Hours to pay out",
          payoutCommentLabel: "Comment / Payroll period",
          payoutCommentPlaceholder: "e.g. Paid out with October 2026 payroll",
          payoutNegativeWarning: "Warning: This will push the time balance negative ({{after}}).",
          payoutConfirmButton: "Record Payout",
          payoutSuccessToast: "Overtime payout recorded",
          thresholdWarning: "Time balance outside threshold (±20 h)",
          thresholdHigh: "High overtime balance (≥ +20 h)",
          thresholdHighHint: "Overtime threshold (+50h) exceeded",
          thresholdLowHint: "Negative hours threshold (-10h) exceeded",
          thresholdLow: "High negative balance (≤ −20 h)",
          comment: "Comment",
          hours: "Hours",
          minutes: "Minutes",
          save: "Save",
          cancel: "Cancel",
        },
        payout: {
          title: "Overtime Payout",
          currentBalance: "Current Time Balance",
          amountLabel: "Payout Hours",
          dateLabel: "Payout Date",
          commentLabel: "Purpose / Reason",
          commentPlaceholder: "e.g. Overtime payout monthly payroll",
          deficitWarning: "Warning: This payout exceeds the current time balance and will lead to negative hours on the account.",
          balanceAfter: "Balance after payout",
          submit: "Book Payout",
        },
        loading: "Loading HR...",
        absence: "Absence",
        absenceRequestUpdate: "Absence request updated",
        adminUpdateError: "Error updating: {{message}}",
        employeeAdded: "Employee added",
        employeeAddError: "Error adding employee: {{message}}",
        duplicateEmailError: "A user with this email already exists in this tenant.",
        settingsSaved: "Settings saved",
        settingsSaveError: "Error saving settings: {{message}}",
        newEmployee: "New Employee",
        employeeNumber: "Employee Number",
        department: "Department",
        position: "Position",
        startDate: "Start Date",
        endDate: "End Date",
        contract: "Contract",
        vacation: "Vacation",
        sick: "Sick",
        training: "Training",
        actions: {
          clockIn: "Clock In",
          clockOut: "Clock Out",
          break: "Break",
          manualPause: "Manual Break",
          correction: "Correction",
          other: "Other",
        },
        coverage: {
          understaffed: "Understaffed",
          sufficient: "Sufficient",
          fullCoverage: "Full coverage",
          alertDepts: "Understaffing alert:",
          weekBack: "One week back",
          weekForward: "One week forward",
          hide: "Hide Coverage",
          show: "Show Coverage",
          hideCoverage: "Hide Coverage",
          showCoverage: "Show Coverage",
        },
        permissions: {
          noAccess: "No permission",
          adminOnly: "Admin only",
        },
        addUser: {
          personType: "Person Type",
          personTypeFull: "With Login",
          personTypeHr: "HR Person Only",
          hoursPerDay: "Hours per Day",
        hoursPerWeek: "Hours per Week",
        hoursPerWeekHint: "{{hours}} h/week across {{days}} workdays ≈ {{perDay}} h/day",
        weeklyHours: "Weekly Hours",
        workdaysSplitHint: "{{hours}} h/week across {{days}} workdays ≈ {{perDay}} h/day",
          workdays: "Workdays",
          workdaysHint: "Select primary workdays",
          noLoginWarning: "This person has no login — all actions are performed by a manager.",
        },
        adminClockOnBehalf: "Clock for",
        adminClockOnBehalfHint: "Clock in/out on behalf of this employee",
        dienstplan: {
          title: "Roster",
          readOnlyHint: "Read-only view — click a day cell to leave a comment for the team.",
          commentPlaceholder: "Write a comment for this day...",
          commentSave: "Save comment",
          commentDelete: "Delete comment",
          filterEmployees: "Filter employees",
          allEmployees: "All employees",
        },
        shiftAssign: {
          title: "Assign Shift",
          saved: "Shift saved",
          removed: "Shift removed",
          notFound: "Shift not found — please reload the page",
          startTime: "Start",
          endTime: "End",
          note: "Note (optional)",
        },
      },
      toasts: {
        success: "Success",
        error: "Error",
        saved: "Saved",
        savedLocal: "Saved (Local)",
        kassenbuch: {
          noJournalPermission: "No permission to access the journal",
          noCounterPermission: "No permission to access the cash counter",
          periodLocked: "This period is finalized. Receipts can no longer be modified.",
          periodLockedNewEntry: "This period is finalized. No new entries allowed.",
          receiptUploaded: "Receipt uploaded successfully",
          receiptUploadedLocal: "Receipt uploaded (Local)",
          receiptUploadError: "Error uploading receipt: {{message}}",
          invoiceNotFound: "Invoice not found or access denied.",
          invoiceFetchError: "Error loading invoice: {{message}}",
          confirmDeleteReceipt: "Do you really want to delete this receipt?",
          receiptDeleted: "Receipt deleted successfully",
          receiptDeletedLocal: "Receipt deleted (Local)",
          receiptDeleteError: "Error deleting receipt: {{message}}",
          settingsSaved: "Settings saved successfully",
          settingsSavedLocal: "Settings saved (Local)",
          settingsSaveError: "Error saving settings: {{message}}",
          entryAdded: "Entry added successfully",
          entryAddedLocal: "Entry added (Local)",
          entryAddError: "Error adding entry: {{message}}",
          confirmCancelEntry: "Cancel this entry? A GoBD-compliant counter-entry will be created in the current period. The original entry remains permanently visible in the journal.",
          entryCancelled: "Entry cancelled successfully",
          entryCancelledLocal: "Entry cancelled (Local)",
          entryCancelError: "Error cancelling entry: {{message}}",
          confirmLockPeriod: "Do you really want to finalize this month? After this, NO further entries can be made or cancelled. This is legally irreversible!",
          periodLockedSuccess: "Month finalized successfully",
          periodLockedSuccessLocal: "Month finalized (Local)",
          periodLockError: "Error finalizing period: {{message}}",
          counterUpdatedLocal: "Counter updated (Local)",
          excelExportSuccess: "Excel export successful",
          datevExportSuccess: "DATEV CSV export successful",
          saveError: "Error saving: {{message}}",
        },
        hr: {
          clockError: "Error clocking: {{message}}",
          saved: "Saved",
          savedLocal: "Saved (Local)",
          requestSubmitted: "Request submitted successfully",
          requestSubmitError: "Error submitting request: {{message}}",
          approved: "Request approved",
          rejectConfirm: "Really reject this request?",
          rejected: "Request rejected",
          deleteConfirm: "Really delete this entry?",
          deleted: "Entry deleted",
          deleteError: "Error deleting: {{message}}",
          pauseAdded: "Break added",
          pauseAddError: "Error adding break: {{message}}",
          timeSaved: "Time saved",
          timeSaveError: "Error saving time: {{message}}",
          missingEntryAdded: "Missing entry added",
          missingEntryError: "Error adding entry: {{message}}",
          rolloverDone: "Year-end rollover completed",
          rolloverError: "Error during rollover: {{message}}",
        },
        loginFailed: "Login failed: {{message}}",
      },
      bookingDrawer: {
        newBooking: "New Booking",
        step1Availability: "Step 1: Availability",
        step2GuestData: "Step 2: Guest Data",
        success: "Success!",
        reservationCreatedPrefix: "Reservation",
        reservationCreatedSuffix: "created.",
        cancellationPolicyAndRate: "Cancellation Policy & Rate",
        bookedRate: "Booked Rate",
        conditions: "Conditions",
        loadingCancellationPolicy: "Loading cancellation policy...",
        linkCompany: "Link Company (optional)",
        searchCompany: "Search company...",
        noCompanyFound: "No company found",
        reservationComment: "Reservation Comment",
        commentPlaceholder: "e.g. Late check-in, bringing a dog...",
        saveComment: "Save Comment",
        bookExtrasServices: "Book Extras / Services",
        quantity: "Quantity",
        price: "Price (EUR)",
        addService: "Add Service",
        searchService: "Search service...",
        noServices: "No services",
        closeWindow: "Close Window",
        searchExistingGuest: "Search existing guest (optional)",
        nameOrEmail: "Name or email...",
        crmHistory: "CRM History",
        regularGuest: "Regular Guest",
        apaleoSearch: "Apaleo Search...",
        apaleoHistory: "Apaleo History",
        apaleoGuest: "Apaleo Guest",
        noEmail: "No email",
        external: "External",
        guestBlocked: "Guest Blocked",
        guestBlockedDescription: "This guest is on the internal blacklist. Bookings are not permitted.",
        hotel: "Hotel",
        persons: "Persons",
        arrival: "Arrival",
        departure: "Departure",
        checkAvailability: "Check Availability",
        searchingOffers: "Searching offers...",
        startSearchPrompt: "Start search to see available rooms",
        noOffersFound: "No offers found. Please adjust date range or number of persons.",
        room: "Room",
        companyRates: "Company Rates",
        select: "Select",
        availableCategories: "Available Categories",
        fromPrice: "From {{price}} {{currency}}",
        fromPrice_other: "From {{price}} {{currency}}",
        back: "Back",
        ratesAvailable: "{{count}} Rate available",
        ratesAvailable_other: "{{count}} Rates available",
        selectRate: "Select",
        backToSelection: "Back to selection",
        selectedOffer: "Selected Offer",
        nights: "Nights",
        totalPrice: "Total Price",
        manualPricePerNight: "Manual Price per Night",
        manualPriceDescription: "Override the standard price for this stay",
        newTotalPrice: "New Total Price:",
        confirmGuestData: "Confirm Guest Data",
        internalGuestNote: "Internal Guest Note",
        createTaskFromNote: "Create task from note?",
        department: "Department",
        startFrom: "Start From",
        endBy: "End By",
        firstName: "First Name *",
        lastName: "Last Name *",
        email: "Email Address",
        phone: "Phone Number",
        address: "Address (Optional)",
        street: "Street & Number",
        postalCode: "Postal Code",
        city: "City",
        countryCode: "Country (ISO Code)",
        confirmBooking: "Confirm Booking",
        unknown: "Unknown",
        fillAllFields: "Please fill all required fields",
        offerSearchError: "Error searching offers: {{error}}",
        requiredFields: "First and last name are required!",
        noOfferSelected: "No offer selected",
        bookingCreated: "Booking {{bookingId}} created successfully",
        taskCreated: "Task created for arrival date",
        preferredRoomAssignmentError: "Could not assign preferred room {{preferredRoom}}.",
        bookingError: "Booking error: {{message}}",
        commentSaved: "Comment saved",
        saveError: "Error saving: {{message}}",
        companyLinkedFolioFailed: "Company linked but folio update failed",
        companyLinked: "Company linked successfully",
        linkError: "Error linking: {{message}}",
        serviceBookingError: "Error booking service: {{message}}",
        vip: "VIP",
        blacklist: "Blacklist",
      },
      guestProfile: {
        guestProfile: "Guest Profile",
        reservationDetails: "Reservation Details",
        autoAssign: "Auto assign",
        noRoom: "No Room",
        roomAbbr: "Rm.",
        stays: "Stays",
        noEmail: "No Email",
        noPhone: "No Phone Number",
        copyName: "Copy Name",
        copyResId: "Copy Reservation ID",
        copyNameBtn: "Name",
        copyResIdBtn: "ID",
        nameCopied: "Name copied to clipboard",
        resIdCopied: "Reservation ID copied to clipboard",
        guestStatus: "Guest Status",
        statusRegular: "Regular",
        statusVip: "VIP",
        statusBlacklist: "Blacklist",
        blacklistReasonRequired: "Block Reason (Required) *",
        blacklistReasonPlaceholder: "Why is this guest being blocked?",
        companyRates: "Corporate Rates / Links",
        searchRate: "Search rate...",
        loadingRates: "Loading rate plans...",
        noRatesFound: "No rate plans found.",
        noSearchResults: "Nothing found.",
        general: "General",
        address: "Address",
        street: "Street & Number",
        streetPlaceholder: "Main Street 1",
        postalCode: "ZIP Code",
        postalCodePlaceholder: "12345",
        city: "City",
        cityPlaceholder: "City",
        countryCode: "Country Code",
        countryCodePlaceholder: "DE",
        internalNotes: "Internal Notes",
        notesPlaceholder: "Important notes about the guest...",
        preferredRoom: "Preferred Room",
        preferredRoomDescription: "Enter the preferred room number. This room will be auto-assigned on new bookings.",
        preferredRoomPlaceholder: "e.g. 101",
        cleaningPlanning: "Cleaning Schedule",
        cleaningActive: "Active",
        cleaningDescription: "Select a fixed cleaning day for this stay. The cleaning will automatically appear in the housekeeping plan.",
        history: "Stays",
        noHistory: "No History",
        current: "Current",
        newBooking: "New Booking",
        close: "Close",
        save: "Save",
        cancel: "Cancel",
        blacklistReasonMissing: "Please provide a reason for the blacklist block",
        profileSaved: "Guest profile saved",
        saveError: "Error saving: {{message}}",
        cleaningSaveError: "Error saving cleaning preference",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
        allLocations: "All locations",
        edit: "Edit",
        removeRate: "Remove rate",
        externalIds: "External IDs",
        externalCodeLabel: "External Code",
        extRefGlobalDistributionSystemId: "GDS ID",
        extRefOnlineTravelAgencyId: "OTA ID",
        extRefOnlineBookingToolId: "Online Booking Tool",
        extRefChannelManagerId: "Channel Manager",
        extRefCentralReservationSystemId: "Central Reservation System",
        extRefLegacyId: "Legacy ID",
        resNights: "Nights",
        resCategory: "Category",
        resRatePlan: "Rate Plan",
        resSource: "Source",
        resSourceDirect: "Direct",
        resCityTax: "City Tax",
        resTotalWithTax: "Total incl. City Tax",
        resExtras: "Extras & Add-ons",
        folioTab: "Folio & Invoices",
        folioNoFolios: "No folios exist for this reservation.",
        folioMain: "Main folio",
        folioSecondary: "Sub folio",
        folioBalance: "Balance",
        folioStatusOpen: "Open",
        folioStatusClosed: "Closed",
        folioStatusClosedWithInvoice: "Invoiced",
        folioCharges: "Charges",
        folioNoCharges: "No charges",
        folioAllowances: "Allowances",
        folioPayments: "Payments",
        folioInvoices: "Invoices",
        folioPosted: "Posted",
        folioUnposted: "Unposted",
        folioRoutedTo: "Routed",
        folioMovedTo: "Moved",
        folioAddCharge: "Add charge",
        folioAddPayment: "Record payment",
        folioCreateInvoice: "Create invoice",
        folioCloseFolio: "Close folio",
        folioReopenFolio: "Reopen folio",
        folioChargeName: "Name",
        folioServiceType: "Service type",
        folioVatType: "VAT type",
        folioAmount: "Amount",
        folioQty: "Quantity",
        folioPaymentMethod: "Payment method",
        folioReceipt: "Receipt no. (optional)",
        folioSave: "Post",
        folioCancel: "Cancel",
        folioChargeSuccess: "Charge posted successfully.",
        folioPaymentSuccess: "Payment recorded successfully.",
        folioInvoiceSuccess: "Invoice created.",
        folioCloseSuccess: "Folio closed.",
        folioReopenSuccess: "Folio reopened.",
        folioActionError: "Action failed: {{message}}",
        folioConfirmInvoice: "Create an invoice for this folio?",
        folioConfirmClose: "Really close this folio? This cannot be undone.",
        folioConfirmReopen: "Reopen this folio?",
        folioPdfError: "Could not load the PDF.",
        folioCorrectCharge: "Correct charge",
        folioCorrectChargeAmount: "Correction amount",
        folioCorrectChargeReason: "Reason",
        folioCorrectChargeHint: "An allowance (credit) is posted against this charge. The amount must not exceed the charge.",
        folioCorrectChargePost: "Post credit",
        folioCorrectChargeSuccess: "Correction (allowance) posted successfully.",
        folioEditDebitor: "Edit invoice recipient",
        folioEditDebitorType: "Recipient type",
        folioEditDebitorPerson: "Guest (person)",
        folioEditDebitorCompany: "Company",
        folioEditDebitorCompanyName: "Company name",
        folioEditDebitorFirstName: "First name",
        folioEditDebitorLastName: "Last name",
        folioEditDebitorAddress: "Address",
        folioEditDebitorStreet: "Street & no.",
        folioEditDebitorZip: "ZIP",
        folioEditDebitorCity: "City",
        folioEditDebitorSave: "Save",
        folioEditDebitorSuccess: "Invoice recipient updated.",
        folioEditDebitorNoChanges: "No changes to save.",
        folioBusinessDate: "Business date",
        folioService: "Service",
        folioNoChargesOnFolio: "No charges on this folio.",
        folioHasRoutedOutCharges: "The folio has routed out charges.",
        folioShowAllCharges: "Show all folio charges",
        folioShowMore: "Show more",
        folioShowLess: "Show less",
        folioShownOf: "{{shown}} of {{total}}",
        folioShowN: "Show {{count}}",
        folioShowAllCount: "Show all ({{count}})",
        folioMoveChargeShort: "Move...",
        folioCorrectChargeShort: "Correct...",
        folioBillingDetails: "Billing details",
        folioCustomDetails: "Custom details",
        folioBooker: "Booker",
        folioNoName: "No name",
        folioCountryGermany: "Germany",
        folioEdit: "Edit",
        folioAddBillingDetails: "Add billing details",
        folioNoBillingAddress: "No billing address",
        folioRoutedIn: "Routed in",
        folioRoutedOut: "Routed out",
        folioActions: "Actions",
        folioMustBalance: "Folio must be balanced (0.00 EUR)",
        folioCloseShort: "Close",
        folioDownloadInvoice: "Download invoice",
        folioDocuments: "Documents",
        folioNoDocuments: "No invoice documents available",
        folioPaymentDate: "Payment date",
        folioMethodReceipt: "Method / Receipt",
        folioStatus: "Status",
        folioPaymentsCount: "Payments ({{count}})",
        folioNoPayments: "There are no payments posted to this folio.",
        folioPaymentDefault: "Payment",
        folioRecordPayment: "Record payment",
        folioCorrection: "Correction",
        folioBookerLabel: "Booker",
        folioNotAvailable: "Not available",
        folioTitleMs: "Ms",
        folioTitleMr: "Mr",
        folioTitleDr: "Dr.",
        folioTitleProf: "Prof.",
        folioTitleOther: "Other",
        folioOtherOption: "Other",
        extrasAddTitle: "Add extra",
        extrasEditTitle: "Edit extra",
        extrasPickService: "Pick a service",
        extrasSearchPlaceholder: "Search services…",
        extrasNoServices: "No bookable services found for this property.",
        extrasCount: "Count",
        extrasPricePerUnit: "Price per unit",
        extrasAdd: "Add",
        extrasSave: "Save",
        extrasRemove: "Remove",
        extrasConfirmRemove: "Really remove this extra? This cannot be undone.",
        extrasAdded: "Extra added.",
        extrasUpdated: "Extra updated.",
        extrasRemoved: "Extra removed.",
        extrasRebookFailed: "The extra was removed but re-booking failed — please add it again manually.",
        extrasEmpty: "No extras booked.",
        resCommentEdit: "Edit comment",
        resCommentSaved: "Comment saved.",
        resCommentError: "Could not save comment: {{message}}",
        svcType: {
            Other: "Other",
            Accommodation: "Accommodation",
            FoodAndBeverages: "Food & Beverages",
            CityTax: "City Tax",
            SecondCityTax: "City Tax II",
            CancellationFees: "Cancellation fees",
            NoShow: "No-show",
            LocalTax: "Local tax",
            ConsumptionTax: "Consumption tax",
        },
        vatType: {
            Null: "0 %",
            VeryReduced: "Super reduced",
            Reduced: "Reduced",
            Normal: "Standard",
            Without: "Without",
            Special: "Special",
        },
        payMethod: {
            PaymentAccount: "Payment account",
            Cash: "Cash",
            BankTransfer: "Bank transfer",
            CreditCard: "Credit card",
            VisaCredit: "Visa (credit)",
            VisaDebit: "Visa (debit)",
            MasterCard: "Mastercard",
            Maestro: "Maestro",
            GiroCard: "Girocard",
            PayPal: "PayPal",
            Voucher: "Voucher",
            Cheque: "Cheque",
            Other: "Other",
        },
        folioPayAccount: {
            select: "Payment account",
            selectPlaceholder: "Select payment account…",
            loading: "Loading payment accounts…",
            loadError: "Payment accounts could not be loaded.",
            empty: "No payment account is linked to this reservation.",
            asyncHint: "The payment is processed via the payment account. The folio balance updates once Apaleo confirms the payment (status: Pending).",
            success: "Payment via payment account triggered.",
            error: "Payment via payment account failed. Please try again.",
        },
        payStatus: {
            Pending: "Pending",
            Success: "Success",
            Failure: "Failed",
            Canceled: "Canceled",
        },
        resCompany: "Company",
        resAdults: "Adults",
        resChildren: "Children",
        resPriceDetails: "Price Details",
        resTotalGross: "Total (gross)",
        resTotalNet: "Net",
        resPerNight: "Nightly Breakdown",
        resAdditionalInfo: "Additional Information",
        resId: "Reservation ID",
        resBookingId: "Booking ID",
        resCreatedAt: "Created",
        resCancellation: "Canceled at",
        resCancellationReason: "Cancellation Reason",
        resComment: "Comment",
        resNoPriceData: "No price data available",
      },
      guestPortal: {
        title: "Guest Portal",
        subtitle: "Hotel Guest Services & Loyalty",
        brandSubtitle: "AdaptHub SaaS B2C",
        logIn: "Log In",
        register: "Register",
        dashboardTab: "Dashboard",
        myStays: "My Stays",
        invoices: "Invoices",
        portal: "Portal",
        stays: "Stays",
        receipts: "Receipts",
        greeting: "Hello, {{name}}!",
        guest: "Guest",
        dashboardDescription: "Find your hotel stays, invoices, and current loyalty status here.",
        viewStays: "View Stays",
        loyaltyCard: "Loyalty Club Card",
        totalPoints: "Total Points",
        member: "Guest Member",
        gold: "Gold",
        silver: "Silver",
        bronze: "Bronze",
        nextStay: "Next Stay",
        active: "Active On-Site",
        confirmed: "Confirmed",
        checkIn: "Check-In:",
        checkOut: "Check-Out:",
        room: "Room:",
        assignmentAtArrival: "Assignment at arrival",
        noUpcomingStays: "No upcoming stays booked.",
        wantToBook: "Want to book?",
        toWebsite: "Go to Website",
        pointHistory: "Point History",
        noPointsYet: "No points collected yet. Points are credited after check-out.",
        staysAndBookings: "Stays & Bookings",
        staysDescription: "Historical overview of all stays booked with your email address.",
        refresh: "Refresh",
        searchPlaceholder: "Search Stay ID, Hotel or Room...",
        allStatuses: "All Statuses",
        inhouse: "In-House",
        checkedOut: "Checked Out",
        cancelled: "Cancelled",
        loadingBookings: "Loading bookings...",
        noMatchingStays: "No matching stays found",
        noMatchingStaysDescription: "No entries found matching your current filter and search settings.",
        resetFilters: "Reset Filters",
        code: "Code:",
        arrival: "Arrival:",
        departure: "Departure:",
        na: "n/a",
        totalAmount: "Total Amount",
        viewInvoice: "View Invoice",
        pointsDisplay: "{{points}} points",
        languageLabel: "Language",
        lang_de: "DE",
        lang_en: "EN",
        fallbackHotelName: "Adapt Hotel",
        pointsToNextTier: "{{points}} points to {{tier}}",
        tierMaxed: "Highest tier reached",
        statTotalStays: "Stays",
        statUpcoming: "Upcoming",
        statInvoices: "Invoices",
        pointsUnit: "pts",
        profileTab: "My Data",
        rewardsTab: "Rewards",
        requestsTab: "Requests",
        profileTitle: "My Data",
        profileDescription: "Your stored details. Submit changes via the form below — our reception reviews and applies them. (GDPR Art. 15/16)",
        profileName: "Name",
        profileEmail: "Email",
        profilePhone: "Phone",
        profileAddress: "Address",
        profileNotProvided: "Not provided",
        dataChangeTitle: "Request a change",
        dataChangeDescription: "Enter your requested changes. Empty fields are left unchanged.",
        dataChangeSubmit: "Request change",
        dataChangeSuccess: "Request sent! Our reception will process it shortly.",
        dataChangeEmpty: "Please fill in at least one field.",
        stayRequestTitle: "Early Check-In / Late Check-Out",
        stayRequestNotice: "Important: This is a non-binding request. Approval depends on availability and is decided by our reception.",
        stayRequestType: "Request type",
        earlyCheckin: "Early check-in (earlier arrival)",
        lateCheckout: "Late check-out (later departure)",
        stayRequestReservation: "Reservation",
        stayRequestTime: "Preferred time (optional)",
        stayRequestNotes: "Notes (optional)",
        stayRequestSubmit: "Send request",
        stayRequestSuccess: "Request sent! We will get back to you with a confirmation or denial.",
        stayRequestNoReservations: "No upcoming reservations to request for.",
        rewardsTitle: "Redeem rewards",
        rewardsDescription: "Exchange your points for rewards. Your reward is handed out after verification by our reception.",
        rewardsCost: "points",
        rewardsRedeem: "Redeem",
        rewardsNotEnough: "You need {{missing}} more points for this.",
        rewardsSuccess: "Reward requested! Our reception will have it ready for you.",
        rewardsBalanceChanged: "Your points balance changed — please reload the page and try again.",
        rewardsNewBalance: "New balance: {{points}}",
        rewardsEmpty: "No rewards available.",
        requestsHistoryNote: "Your requests go directly to our reception — you will be informed of the outcome.",
        showingEntries: "Showing {{start}} to {{end}} of {{total}} entries",
        back: "Back",
        forward: "Forward",
        noStaysFound: "No stays found",
        noStaysFoundDescription: "No reservations found linked to the email address <strong>{{email}}</strong>.",
        invoicesAndDocuments: "Invoices & Documents",
        invoicesDescription: "Download invoices or request an official invoice correction here.",
        gobdTitle: "GoBD Compliance Notice:",
        gobdText: "Issued invoices may not be deleted or directly modified per GoBD regulations. For corrections (e.g. changed company name or address), you can conveniently request a correction below. Our reception will issue a cancellation and a corrected new invoice.",
        loadingInvoices: "Loading invoices...",
        invoiceNumber: "Invoice Number",
        date: "Date",
        reservation: "Reservation",
        amount: "Amount",
        actions: "Actions",
        invoicePrefix: "Invoice",
        pdf: "PDF",
        correction: "Correction",
        noInvoices: "No invoices available",
        noInvoicesDescription: "After check-out and invoicing of your stays, your documents will automatically be listed here.",
        requestCorrection: "Request Invoice Correction",
        invoiceLabel: "Invoice:",
        requestSubmitted: "Request Submitted!",
        requestSubmittedDescription: "Your correction request has been submitted to reception. We will send you the corrected version by email.",
        previousName: "Previous Name / Company Name (on document)",
        previousNamePlaceholder: "e.g. Private or wrong company",
        futureName: "Future Recipient Name / Company Name *",
        futureNamePlaceholder: "e.g. Siemens AG",
        street: "Street & Number *",
        streetPlaceholder: "e.g. Main St. 12a",
        zipCode: "Postal Code *",
        zipCodePlaceholder: "10115",
        city: "City *",
        cityPlaceholder: "Berlin",
        vatNumber: "VAT Number (USt-IdNr.) - optional",
        vatNumberPlaceholder: "e.g. DE123456789",
        invoiceLanguage: "Invoice Language",
        german: "German (DE)",
        english: "English (EN)",
        additionalNotes: "Additional Notes",
        additionalNotesPlaceholder: "e.g. Please specify department X...",
        submitCorrection: "Request Correction",
        downloadError: "Error downloading the PDF invoice.",
        correctionSubmitError: "Error submitting correction request.",
      },
      internalResources: {
        title: "Internal Resources",
        subtitle: "Internal checklists & controls",
        namePrompt: "Name of the new check (e.g. Fire-safety weekly check):",
        renamePrompt: "Enter the new name:",
        nameExists: "A check with this name already exists",
        deleteConfirm: "Really delete check \"{{name}}\"? Associated entries remain in the database but become invisible.",
        addCheck: "Add check",
        noChecks: "No checks created yet",
        noChecksHint: "Use \"Add check\" above to create your first check.",
        sperrapartmentsTab: "Blocked Apartments",
      },
      sperrapartments: {
        title: "Blocked Apartments",
        subtitle: "Maintenance windows with history snapshot — deleted windows stay visible",
        refresh: "Refresh list",
        keywordsEdit: "Edit keywords",
        keywordsTitle: "Keywords",
        keywordsDesc: "Only maintenance windows whose reason or description contains one of these keywords (comma-separated) are listed.",
        keywordsPlaceholder: "e.g. renovation, damage",
        keywordsCurrent: "{{count}} keywords active",
        keywordsSaved: "Keywords saved",
        searchPlaceholder: "Search room, reason or description …",
        filterAll: "All",
        filterFrom: "From",
        filterTo: "To",
        filterLocation: "Location",
        filterStatus: "Status",
        pageInfo: "Page {{page}} of {{pages}} · {{count}} entries",
        prevPage: "Previous",
        nextPage: "Next",
        syncError: "Failed to load maintenance windows — the list may be incomplete.",
        keywordsChip: "{{count}} keywords",
        colRoom: "Room",
        colPeriod: "Period",
        colReason: "Reason",
        colStatus: "Status",
        colTrace: "Trace",
        statusActive: "Active",
        statusPast: "Past",
        statusDeleted: "Deleted",
        deletedAt: "Deleted on {{date}}",
        noKeywords: "No keywords configured",
        noKeywordsHint: "Open the settings (gear) and define the keywords for this list.",
        noResults: "No blocked apartments found",
        createWindow: "Create maintenance window",
        traceDone: "Done",
        tracePartial: "Partial ({{done}} of {{total}})",
        traceOpen: "Open ({{total}})",
      },
      haustechnik: {
        title: "Maintenance",
        menuTitle: "Maintenance Menu",
        menuSubtitleV1: "Lists & Checks",
        menuTabs: "Tabs",
        v1Description: "Manage lists, room checks, and maintenance windows.",
        v2Description: "Maintenance & Infrastructure Hub",
        tabs: {
          lists: "Lists",
          zimmercheck: "Room Check",
          freeRooms: "Available Rooms",
          maintenance: "Maintenance Windows",
          projectPlanning: "Project Planning",
          sperrapartments: "Blocked Apartments",
        },
        projectPlanning: {
          title: "Project & Task Planner",
          subtitle: "Break down maintenance traces into phased work steps",
          totalTraces: "Total Traces",
          open: "Open",
          inProgress: "In Progress",
          statusInReview: "In Review",
          completed: "Completed",
          selected: "Selected",
          reviewAndDone: "Review & Done",
          reviewAndDoneAction: "Mark as Done",
          reviewAndDoneTooltip: "Review project and complete as done",
          readyForReviewTitle: "All steps completed — Ready to finalize",
          readyForReviewDesc: "All steps are completed.",
          openProject: "Open Project",
          openTrace: "Open Trace",
          step: "Step",
          overdue: "Overdue",
          area: "Area",
          allAreas: "All Areas",
          allStatuses: "All Statuses",
          searchPlaceholder: "Search by room, title, requester...",
          newTrace: "New HT Trace",
          newProject: "New Project",
          createProjectTitle: "Create New Project",
          createProjectSubtitle: "Create a standalone project for task and workflow planning",
          projectName: "Project Name / Title",
          projectNamePlaceholder: "e.g. 2nd Floor Hallway Renovation, Filter Maintenance...",
          projectArea: "Area",
          projectRooms: "Affected Rooms / Units (optional)",
          projectRoomsPlaceholder: "e.g. 101, 102 or Public Area",
          projectPriority: "Priority",
          projectStartDate: "Start Date",
          projectDueDate: "Target Due Date",
          projectDescription: "Description / Scope (optional)",
          projectDescriptionPlaceholder: "Goals, specifics, or required materials...",
          initialStepTitle: "First Work Step (optional)",
          initialStepPlaceholder: "e.g. Order materials, prepare work area...",
          createAndOpenPlanner: "Create Project & Open Plan",
          projectCreatedSuccess: "Project created successfully and opened in planner",
          titleRequired: "Please enter a project title.",
          emptyState: "No maintenance projects found",
          emptyStateDesc: "There are currently no projects for maintenance.",
          emptyPlannedState: "No planned projects found",
          emptyPlannedStateDesc: "Create a step-by-step project plan in the Planner.",
          emptyHistoryState: "No completed projects yet",
          emptyHistoryStateDesc: "Completed projects and maintenance workflows will be archived here.",
          reopenProject: "Reopen",
          reopenProjectTooltip: "Reopen project back into progress",
          projectReopenedSuccess: "Project reopened successfully!",
          goToPlanner: "Go to Planner",
          addPlanButton: "Add a Plan",
          viewTable: "Table",
          viewKanban: "Kanban",
          viewPlanner: "Project Planner",
          tabPlannedList: "Project List",
          tabPlanner: "Project Planner",
          tabHistory: "History",
          priority: "Priority",
          room: "Room",
          assigned: "Assigned",
          dueDate: "Due",
          actions: "Actions",
          deviceReplaced: "Device replaced",
          quickStatusChange: "Change status",
          selectTrace: "Select a project for planning",
          selectTraceDesc: "Select a project on the left to set up a phased step plan with dates, duration, and assignees.",
          planSteps: "Step-by-step Project Plan",
          roomsScope: "Target Rooms / Units",
          roomsPlaceholder: "e.g. 101, 102 or 105",
          totalDuration: "Total Duration",
          daysUnit: "days",
          dayUnit: "day",
          addStep: "Add Step",
          stepTitlePlaceholder: "e.g. Preparation / Wait 2 days / Execution",
          stepTypeWork: "Work Step",
          stepTypeWait: "Waiting Phase",
          durationDays: "Duration (days)",
          assignee: "Assignee",
          noAssignee: "Unassigned",
          scheduledDate: "Scheduled Date",
          stepStatusPending: "Pending",
          stepStatusProgress: "In Progress",
          stepStatusDone: "Done",
          savePlan: "Save Project Plan",
          planSaved: "Project plan successfully saved",
          noPlanYet: "No step plan created yet",
          createPlanNow: "Create plan now",
          progress: "Progress",
          plannedTraces: "Planned Projects",
          unplannedTraces: "Unplanned Projects",
          allTraces: "All Projects",
          stepCount: "{{completed}} of {{total}} steps",
          stepNumber: "Step {{number}}",
          notes: "Notes / Instructions",
          detailsAndHistory: "Open Project",
          phasesAndSteps: "Phases & Work Steps ({{count}})",
          noPlanDesc: "Add steps for work phases, waiting times, and assignees.",
          moveUp: "Move up",
          moveDown: "Move down",
          deleteStep: "Delete step",
          stepWaitPlaceholder: "e.g. Wait 2 days",
          durationLabel: "Duration:",
          stepsUnit: "steps",
          unplanned: "Unplanned",
          editPlan: "Edit plan ➔",
          editPlanButton: "Edit Plan",
          cancel: "Cancel",
          noUnitsAssigned: "No units assigned",
          notDone: "Not Done",
          markDone: "Done",
          viewSteps: "Steps",
          planAction: "Plan ➔",
          noPlan: "No plan",
          areaLabel: "Area:",
          areaPainting: "Painting",
          areaEmergency: "Emergency / Hazard",
          areaGeneral: "General",
          areaAppliance: "Appliances (Replaced)",
          areaSanitary: "Plumbing",
          areaElectric: "Electrical",
          areaHVAC: "HVAC / Climate",
          plannedShort: "Planned",
          planSavedSuccess: "Project plan successfully saved",
        },
        list: {
          title: "Lists",
          addEntry: "Add Entry",
          entriesCount: "{{count}} entry recorded",
          entriesCount_other: "{{count}} entries recorded",
          egeraeteCount: "{{count}} device recorded",
          egeraeteCount_other: "{{count}} devices recorded",
          selectList: "Please select a list",
          deleteConfirm: "Delete entry?",
          deleteListConfirm: "Really delete this list?",
          newListNamePrompt: "Name of the new list:",
          columnsPrompt: "Column names (comma-separated):",
          columnsDefault: "Project, Status, Notes",
          newList: "New List",
          newListSubtitle: "Create a custom list with individual columns",
          newListTitle: "List Title",
          newListTitlePlaceholder: "e.g. Maintenance Plan",
          newListColumns: "Columns",
          newListColumnPlaceholder: "Column name...",
          newListAddColumn: "Add column",
          newListRemoveColumn: "Remove column",
          newListCreate: "Create",
          newListCancel: "Cancel",
          newListTitleRequired: "Title is required",
          newListMinColumn: "At least one column is required",
          newListSuccess: "List \"{{name}}\" created",
          editList: "Edit List",
          editListSubtitle: "Adjust title and columns",
          editListSubtitleSystem: "Only the title can be adjusted",
          editListSave: "Save",
          editSuccess: "List \"{{name}}\" updated",
          deleteList: "Delete list",
          deleteSuccess: "List \"{{name}}\" deleted",
          deleteSystemBlocked: "System lists cannot be deleted",
          noEntries: "No entries yet",
          trace: "Trace",
          pagePrev: "Previous page",
          pageNext: "Next page",
          pageInfo: "Page {{page}} of {{totalPages}}",
          tracePlaceholder: "Trace...",
          date: "Date",
          location: "Location",
          locationPlaceholder: "Location",
          sortTooltip: "Click to sort (ascending/descending)",
          sortAsc: "Sorted ascending",
          sortDesc: "Sorted descending",
        },
        zimmercheck: {
          title: "Room Check",
          subtitle: "Maintenance Audit",
          room: "Room",
          property: "Property",
          location: "Location",
          lastCheck: "Last Check",
          auditNotes: "Audit Notes",
          auditOk: "Audit OK",
          auditNotesPlaceholder: "Notiz...",
          columnNameExists: "Column name already exists",
          interval: "Interval",
          days: "Days",
          dueWarning: "Due (> {{days}} D.)",
          sortByLastCheck: "Sort by last check",
          sortAlphabetical: "Sort alphabetically",
          column: "Column",
          deleteColumn: "Delete column",
          addCustomColumn: "+ Add Column",
          customColumnNamePrompt: "Column name:",
          maxColumnsReached: "Maximum 3 custom columns per property reached.",
          filterAll: "All",
          filterDue: "Due",
          filterOk: "Audit OK",
          filterPending: "Not Checked",
        },
        freeRooms: {
          title: "Available Rooms",
          subtitleOver: "Capacity Overview",
          subtitle: "Real-Time Occupancy Overview",
          free: "Free",
          available: "Available",
          arrival: "Arrival",
          departure: "Departure",
          noEntries: "No entries found",
          filterAll: "All",
          filterArrival: "Arrival",
          filterDeparture: "Departure",
        },
        maintenance: {
          title: "Maintenance",
          subtitle: "Out-of-Order Management",
          new: "New Maintenance",
          schedule: "Schedule Maintenance",
          scheduleSubtitle: "Block unit for maintenance",
          scheduleApaleoSubtitle: "New OOO notification to Apaleo",
          scheduleButton: "Schedule",
          deleteConfirm: "Delete?",
          deleteConfirmV2: "Really delete this entry?",
          room: "Room",
          roomLabel: "Rm. {{room}}",
          roomOption: "Room {{name}}",
          period: "Period",
          periodSync: "Period (Apaleo Sync)",
          reason: "Reason / Description",
          reasonStatus: "Reason / Status",
          phase: "Phase",
          scheduled: "Scheduled",
          active: "Active",
          archived: "Archived",
          defaultReason: "Maintenance",
          noWindows: "No maintenance windows in the selected period",
          unit: "Room / Unit",
          targetUnit: "Target Unit (Room)",
          selectUnit: "Select unit...",
          start: "Start",
          end: "End",
          from: "From",
          to: "To",
          internalNote: "Internal Note",
          notePlaceholder: "Describe the reason for blocking...",
          reasonNotes: "Reason & Notes",
          repairPlaceholder: "What needs to be repaired?",
          create: "Create",
          searchPlaceholder: "Search room / description...",
        },
        filter: {
          allLocations: "All Locations",
          allOccupancy: "All Statuses (FR/AR/DP/OC)",
          occupied: "Occupied",
          searchRoom: "Search room...",
          searchRoomShort: "ROOM...",
          noResults: "No rooms found",
          collapseFilters: "Collapse filters",
          expandFilters: "Expand filters",
        },
        error: {
          loadFailed: "Error loading",
          prefix: "Error: ",
        },
        exportToExcel: "Export to Excel",
        exportSuccess: "Export successful",
        print: "Print",
        help: "Help",
      },
      traces: {
        menuTitle: "Traces Menu",
        untitled: "Untitled",
        filterAndActions: "Filter & Actions",
        description: "Manage tasks & documentation.",
        import: "Import",
        newTrace: "New Trace",
        title: "Traces",
        syncing: "Syncing Traces...",
        subtitle: "Manage Tasks & Documentation",
        filterLabel: "Filter",
        basisDatumRequired: "Please provide a valid base date.",
        reporter: "Reporter",
        assigned: "Assigned",
        status: {
          open: "Open",
          inProgress: "In Progress",
          done: "Done",
          deleted: "Deleted",
        },
        sort: {
          newest: "Newest First",
          dueDate: "Due Date",
        },
        filter: {
          myTraces: "My Traces",
          myOverdue: "My Overdue",
          deptOpen: "Department Open",
          deptOverdue: "Department Overdue",
          active: "Filter Active",
          department: "Departments",
          searchPlaceholder: "Search traces, guests or rooms",
          roomPlaceholder: "Filter by room number...",
          status: "Status",
          location: "Locations",
          dueFrom: "Due From",
          dueTo: "Due To",
        },
        stats: {
          myTraces: "My Traces",
          myOverdue: "My Overdue",
          deptOpen: "Dept. Open",
          deptOverdue: "Dept. Overdue",
        },
        empty: {
          noTraces: "No traces found",
        },
        overdue: "Overdue",
        room: {
          prefix: "Room ",
        },
        guest: {
          prefix: "Guest: ",
        },
        requester: {
          prefix: "Reporter: ",
        },
        assignedTo: {
          prefix: "Assigned to: ",
        },
        start: "Start",
        dueDate: "Due Date",
        noDate: "No date",
        confirmDone: {
          title: "Complete task?",
          subtitle: "Do you really want to mark this task as done?",
          cancel: "Cancel",
          confirm: "Done",
          cta: "Mark as done",
        },
        details: "Details",
        messages: "{{count}} message",
        messages_plural: "{{count}} messages",
        planTag: "Plan",
        addPlanTag: "Create Plan",
        openPlanButton: "View Plan",
        editPlanInPlanner: "Open Plan in Planner",
        createPlanInPlanner: "Create Step Plan",
        createStepPlan: "Create Step Plan",
        editStepPlan: "Edit Step Plan",
        planAvailableAfterCreate: "Step plan available after trace is created",
      },
      traceModal: {
        editTitle: "Edit Trace",
        details: "Details",
        title: "Title",
        description: "Description / Details",
        noDescription: "No details or description available.",
        preview: "Preview",
        edit: "Edit",
        boldTooltip: "Bold formatting (**text**)",
        bold: "Bold",
        headingTooltip: "Insert heading (### text)",
        heading: "Heading",
        listTooltip: "Insert bullet point (- text)",
        list: "List",
        descriptionPlaceholder: "Enter description or guest details here...",
        invoiceCorrection: "Automated Invoice Correction",
        apaleoReady: "Apaleo API Ready",
        originalInvoice: "Original Invoice",
        guestEmail: "Guest Email",
        languageCode: "Language Code",
        originalName: "Original Name",
        individual: "Individual",
        newRecipient: "New Recipient / Company",
        newAddress: "New Address",
        vatNumber: "VAT Number",
        processing: "Processing...",
        alreadyCancelled: "Already Cancelled Γ£ô",
        executeCorrection: "Execute Correction",
        assignment: "Assignment",
        persons: "Persons",
        requester: "Reporter / Client",
        requesterPlaceholder: "Reporter name",
        department: "Department",
        status: {
          label: "Status",
          open: "Open",
          inProgress: "In Progress",
          done: "Done",
        },
        location: "Location",
        linkGuest: "Link Guest",
        searchGuest: "Search guest...",
        searchingApaleo: "Apaleo...",
        minChars: "At least 3 characters...",
        noResults: "No results found",
        roomAbbr: "Rm.",
        room: "Room",
        start: "Start",
        dueDate: "Due",
        setArrival: "+ Arrival",
        setDeparture: "+ Departure",
        maintenanceSection: "Maintenance",
        selectArea: "Select area",
        area: {
          painting: "Painting",
          damage: "Damage",
          general: "General",
        },
        deviceSwapped: "Device swapped",
        attachment: "Attachment:",
        selected: "Selected",
        change: "Change",
        addMore: "Add more",
        attachments: "Attachments",
        you: "You",
        messagePlaceholder: "Message...",
        justNow: "Just now",
        minutesAgo: "{{count}} minute ago",
        minutesAgo_other: "{{count}} minutes ago",
        hoursAgo: "{{count}} hour ago",
        hoursAgo_other: "{{count}} hours ago",
        daysAgo: "{{count}} day ago",
        daysAgo_other: "{{count}} days ago",
        deleteSeries: "Delete Series",
        confirmCorrection: "Do you really want to execute the invoice correction for Inv. {{invoiceId}}? This will cancel the old invoice, change the folio address, and create a new invoice.",
        folioNotFound: "Could not determine the folio ID of the original invoice.",
        correctionLog: "Invoice correction executed successfully. Old Inv. {{invoiceId}} cancelled. New Inv. {{newInvoiceNumber}} created.",
        correctionSuccess: "Invoice correction executed successfully!",
        correctionError: "Error during invoice correction: {{message}}",
        sendError: "Error sending: {{message}}",
        confirmDelete: 'Really delete trace "{{title}}"?',
        confirmDeleteSimple: "Really delete this trace?",
        noUnit: "No room selected",
      },
      fundsachen: {
        menuTitle: "Lost & Found Menu",
        filterAndActions: "Filter & Actions",
        title: "Lost & Found",
        archiveTitle: "Lost & Found Archive",
        description: "Manage found items.",
        newEntry: "New Entry",
        filter: {
          searchPlaceholder: "Search items, rooms or names",
          status: "Status",
          location: "Locations",
          foundFrom: "Found from",
          foundTo: "Found to",
        },
        empty: {
          noResults: "No lost & found items found",
          archiveEmpty: "Archive is empty",
          noFilterResults: "No entries found for the selected filters",
        },
        room: {
          prefix: "Room ",
        },
        guest: {
          prefix: "Guest: ",
          ref: "Ref: ",
        },
        create: {
          title: "New Lost Item",
          descriptionPlaceholder: "What was found?",
          roomLabel: "Room / Location",
          roomPlaceholder: "Room No.",
          foundDateLabel: "* Date Found",
          locationLabel: "* Location",
          locationMissing: "Please select a location.",
          locationLoadFailed: "Locations could not be loaded. Please reload the page.",
          attachmentLabel: "Documentation (Photo)",
          uploadLabel: "Upload Photo",
        },
        createV2: {
          title: "New Recording",
          subtitle: "Add item to the security system",
          descriptionLabel: "* Description",
          descriptionPlaceholder: "Description...",
          roomLabel: "Location / Room",
          roomPlaceholder: "Room No. / Location",
          foundDateLabel: "* Date Found",
          attachmentLabel: "Attachments",
          uploadLabel: "Start Upload",
          fileHint: "PNG, JPG or PDF ΓÇó Max capacity: 25MB",
          saving: "Syncing data...",
        },
        status: {
          open: "Open",
          contacted: "Guest Contacted",
          sent: "Sent/Done",
        },
        log: {
          created: "created the entry",
          createdAction: "Lost item created",
          edited: "edited details",
          editedAction: "Lost item edited",
          deletedAction: "Lost item deleted",
          fileUploaded: "New attachment uploaded",
          fileRemoved: "Attachment removed",
        },
        change: {
          status: "Status:",
          room: "Room:",
          description: "Description:",
          reference: "Reference:",
          foundDate: "Date found:",
          responsible: "Responsible:",
          requester: "Client:",
        },
        confirmDelete: "Really delete?",
        justNow: "Just now",
        minutesAgo: "{{count}}m ago",
        hoursAgo: "{{count}}h ago",
        daysAgo: "{{count}}d ago",
        noOne: "No one",
        userLoadError: "Could not load user list",
        exportList: "Export List",
        markReturned: "Mark as Returned",
        returned: "Returned",
        returnedOn: "Returned on",
        noResultsForSearch: "No results for search",
      },
      fundModal: {
        editTitle: "Edit Lost Item",
        details: "Details",
        chat: "Chat ({{count}})",
        log: "Log",
        setStatus: "* Set Status",
        roomLabel: "Room / Location",
        roomPlaceholder: "Room No...",
        location: "Location",
        descriptionLabel: "* Item Description",
        descriptionPlaceholder: "What was found? Detailed description...",
        guestReference: "Reference (Guest)",
        searchGuestPlaceholder: "Search for guest in Apaleo...",
        searching: "Searching...",
        noResults: 'No results for "{{term}}"',
        roomAbbr: "Rm.",
        foundDateLabel: "* Date Found",
        responsibility: "Responsibility",
        selectDefault: "Select...",
        requester: "Reporter / Client",
        requesterPlaceholder: "Reporter name...",
        attachments: "Attachments",
        attachment: "Attachment",
        attachmentSubtitle: "Document / Photo",
        removeFile: "Remove File",
        ready: "Ready",
        uploadFile: "Upload File",
        discard: "Discard",
        saving: "Saving...",
        collaboration: "Collaboration",
        collaborationSubtitle: "Activities & Interaction",
        teamChat: "Team Chat ({{count}})",
        noMessages: "No messages",
        logEmpty: "Log is empty",
        messagePlaceholder: "Message...",
        sendError: "Error sending: {{message}}",
      },
      chat: {
        filterAll: "All",
        filterDirect: "Direct",
        filterTeams: "Teams",
        startDirectMessage: "Direct message",
        jumpToPresent: "Jump to present",
        typing: "{{name}} is typing...",
        typingPlural: "{{name}} are typing...",
        searchPlaceholder: "Search messages...",
        searchConversationsPlaceholder: "Search chats…",
        searchNoResults: "No matches in loaded messages",
        searchHistoryHits: "{{count}} match in history",
        searchHistoryHits_other: "{{count}} matches in history",
        searchLoadFailed: "Message could not be loaded",
        loadOlder: "Load older messages",
        attachment: "Attachment",
        fileTooLarge: "File too large (max. {{max}} MB)",
        receiptsAll: "✓✓ Read by all",
        receiptsRead: "✓✓ Read",
        receiptsSent: "✓ Sent",
        readByCount: "read",
        react: "React",
        muteConversation: "Mute notifications",
        conversationMuted: "Muted — click to unmute",
        pinConversation: "Pin chat",
        unpinConversation: "Unpin chat",
        pinForMe: "Pin for me",
        unpinForMe: "Unpin for me",
        pinForEveryone: "Pin for everyone",
        unpinForEveryone: "Unpin for everyone",
        pinnedForMe: "Pinned for me",
        pinnedForEveryone: "Pinned for everyone",
        pinForMeHint: "Only at the top of your list",
        pinForEveryoneHint: "At the top for all members",
        pinChatOptions: "Pin chat",
        pinned: "Pinned",
        pinMessage: "Pin message",
        unpinMessage: "Unpin message",
        pinMessageOptions: "Pin message",
        pinnedMessages: "Pinned messages",
        pinnedMessagesCount: "{{count}} pinned message",
        pinnedMessagesCount_plural: "{{count}} pinned messages",
        pinnedMessagesTooltip: "Show/hide pinned messages",
        pinChatTooltip: "Pin chat to top",
        unpinChatTooltip: "Unpin chat",
        muteTooltip: "Mute chat",
        unmuteTooltip: "Unmute chat",
        groupInfoTooltip: "Chat details & info",
        jumpToMessage: "Jump to message",
        jump: "Jump",
        messageNotInWindow: "Message is outside loaded window",
        groupInfo: "Group info",
        addMember: "Add members",
        memberAdded: "Members added",
        memberRemoved: "Member removed",
        cannotRemoveCreator: "The creator cannot be removed",
        groupFull: "Group is full (max. 50 members)",
        groupCreator: "Creator",
        groupAdmin: "Admin",
        groupMember: "Member",
        promoteAdmin: "Promote to admin",
        demoteAdmin: "Revoke admin rights",
        memberPromoted: "Member promoted to admin",
        memberDemoted: "Admin rights revoked",
        renameGroup: "Rename group",
        renameGroupSuccess: "Group renamed",
        shareEntity: "Insert link",
        entityPending: "{{type}} {{id}} will be attached to your next message",
        shareTypeTrace: "Trace",
        shareTypeOffer: "Offer",
        shareTypeReservation: "Reservation",
        openTrace: "Open trace",
        openOffer: "Open offer",
        openReservation: "Open reservation",
        shareToChat: "Send to chat",
        sharePickConversation: "Attach {{type}} — pick a chat and send",
        typingMultiple: "{{count}} people are typing...",
        online: "Online",
        anonymous: "Unknown",
        readBy: "Read by {{names}}",
        reply: "Reply",
        forward: "Forward",
        forwarded: "Forwarded",
        forwardedFrom: "Forwarded from {{name}}",
        forwardSuccess: "Message forwarded",
        replyTo: "Reply to",
        cancelReply: "Cancel reply",
        replyingTo: "Replying to {{name}}",
        messageNotFound: "Original message not available",
        emojiPicker: "Emoji picker",
        moreEmojis: "More emojis",
        emojiSearchPlaceholder: "Find something fun / Search emoji...",
        emojiSearchResults: "Search results",
        noEmojisFound: "No emojis found",
        emojiCat: {
          popular: "Recent & Popular",
          smileys: "Smileys & Faces",
          gestures: "Gestures & Hands",
          hearts: "Hearts & Love",
          celebration: "Celebration & Party",
          nature: "Nature & Animals",
          food: "Food & Drink",
          symbols: "Symbols & Status",
        },
        title: "Chat",
        newChat: "New chat",
        newDm: "Direct message",
        newGroup: "Create group",
        groupName: "Group name",
        groupNamePlaceholder: "e.g. Reception morning",
        addMembers: "Add members",
        searchCoworkers: "Search coworkers…",
        messagePlaceholder: "Write a message…",
        edited: "edited",
        deleted: "Message deleted",
        empty: "No messages yet",
        emptyList: "No conversations",
        unread: "Unread",
        leaveGroup: "Leave group",
        removeMember: "Remove",
        sendFailed: "Failed to send",
        deleteMessage: "Delete message",
        deletedSuccess: "Message deleted",
        deleteNotPermitted: "Delete not permitted",
        editMessage: "Edit message",
        editingMessage: "Editing message",
        editedSuccess: "Message edited",
        saveEdit: "Save",
        cancelEdit: "Cancel",
        copy: "Copy text",
        copied: "Copied to clipboard",
        you: "You",
        close: "Close",
        backToList: "All chats",
        yesterday: "Yesterday",
        dropImage: "Drop image or file here",
        dropImageHint: "Will be sent as an attachment in chat",
        imageAttached: "Image attached",
        fileAttached: "File attached",
      },
      xrechnung: {
        subtitle: "XML generator with manual & pre-filled form editor",
        step1Source: "1. Choose Source",
        selectLocation: "Select Location",
        fullId: "Full ID:",
        description: "You can load an invoice from apaleo and fill in missing fields manually, or create a compliant XML from scratch with an empty form.",
        loadSuccess: "Invoice loaded successfully and form populated.",
        currencyLabel: "Currency (cbc:DocumentCurrencyCode)",
        dueDateLabel: "Due Date (cbc:DueDate)",
        amountsTitle: "Amounts & Totals",
        streetLabel: "Street & No. (StreetName)",
        customerTitle: "Invoice Recipient (Customer)",
        buyerRefLabel: "Buyer Reference (BuyerReference)",
        deleteRow: "Delete Row",
        noTaxSplit: 'No tax split configured. Click "Add" to create an entry.',
        helpText: "Select a location on the left and enter an invoice number to load data from apaleo, or create a new manual form.",
        blankLoaded: "Blank form loaded. Please enter your data.",
        blankInitError: "Error initializing the form.",
        invoiceNoRequired: "Please enter an invoice number.",
        loadError: "Error loading the invoice.",
        downloadSuccess: "XRechnung downloaded successfully.",
        downloadError: "Error creating the XRechnung.",
        invoiceNo: "Invoice Number",
        invoiceNoPlaceholder: "e.g. 12345",
        invoiceId: "Invoice Number (cbc:ID)",
        issueDate: "Issue Date (cbc:IssueDate)",
        actualDeliveryDate: "Delivery Date (ActualDeliveryDate)",
        netAmount: "Net Amount (€)",
        taxAmount: "Tax Amount (€)",
        grossAmount: "Gross Amount (€)",
        companyName: "Company Name (Name)",
        vatId: "VAT ID (Tax ID / VAT-ID)",
        postalCode: "Postal Code",
        city: "City",
        country: "Country",
        accountHolder: "Account Holder",
        iban: "IBAN",
        bic: "BIC",
        contactName: "Contact (Name)",
        contactPhone: "Contact (Phone)",
        contactEmail: "Contact (Email)",
        nameCompany: "Name / Company (Name)",
        nameCompanyPlaceholder: "e.g. John Doe",
        buyerRefPlaceholder: "e.g. 991-33333-22",
        customerEmail: "Email Address (E-Mail)",
        customerEmailPlaceholder: "e.g. invoice@customer.com",
        customerStreetPlaceholder: "Sample Street 12",
        customerPostalPlaceholder: "12345",
        customerCityPlaceholder: "Sample City",
        customerCountryPlaceholder: "DE",
        netAmountShort: "Net (€)",
        taxAmountShort: "Tax (€)",
      },
      reservations: {
        menuTitleV1: "Reservations Menu",
        menuSubtitleV1: "Filter & Search",
        menuTitleV2: "Reservations Menu",
        menuSubtitleV2: "KPIs & Filter",
        overview: "Overview",
        hotelStatusToday: "Hotel Status Today",
        guests: "Guests",
        occupancy: "Occupancy",
        arrivals: "Arrivals",
        departures: "Departures",
        followUp: "Follow-Up",
        followUpName: "Follow-Up (Name)",
        inRoom: "In Room",
        today: "Today",
        reservations: "Reservations",
        results: "{{count}} Results",
        waitingList: "Waiting List",
        overbookingLocks: "Overbooking Locks",
        mergeProfiles: "Merge Profiles",
        offer: "Offer",
        invoiceCorrection: "Invoice Correction",
        newBooking: "New Booking",
        recalculateCityTax: "Recalculate City Tax",
        searchAllBadge: "Global search",
        searchAllHint: "Searching the entire reservation history (name, email, company, ID, room) — date range and filters are ignored",
        searchPlaceholder: "Search guests, rooms or ID",
        jumpToReservation: "Jump to reservation (by ID)",
        jumpNotFound: "No reservation found with this ID",
        locations: "Locations",
        statusInHouse: "In House",
        statusConfirmed: "Confirmed",
        statusCheckedOut: "Checked Out",
        statusCanceled: "Canceled",
        active: "Active",
        rate: "Rate",
        checkIn: "Check-In",
        checkOut: "Check-Out",
        expected: "Expected",
        planned: "Planned",
        locks: "Locks",
        room: "Room",
        guestDetails: "Guest Details",
        crm: "CRM",
        location: "Location",
        cleaning: "Cleaning",
        arrival: "Arrival",
        departure: "Departure",
        source: "Source",
        sourceDirect: "Direct",
        stayDate: "Stay Date",
        creation: "Creation Date",
        status: "Status",
        allStatuses: "All Statuses",
        allLocations: "All Locations",
        allCrm: "All CRM",
        clearAll: "Clear All",
        noStatus: "No Status",
        statusVip: "VIP",
        statusBlacklist: "Blacklist",
        statusRegular: "Regular",
        statusNoShow: "No Show",
        hideKpis: "Hide KPIs",
        showKpis: "Show KPIs",
        synchronizing: "Synchronizing...",
        noReservationsFound: "No reservations found.",
        idPrefix: "ID: ",
        rotationPrefix: "",
        rowsPerPage: "Rows per page:",
        actions: {
          column: "Actions",
          checkIn: "Check-In",
          checkOut: "Check-Out",
          cancel: "Cancel",
          confirmCheckIn: "Perform check-in for this reservation?",
          confirmCheckOut: "Perform check-out for this reservation?",
          confirmCancel: "Really cancel this reservation?",
          checkInSuccess: "Check-in completed successfully",
          checkOutSuccess: "Check-out completed successfully",
          cancelSuccess: "Reservation successfully canceled",
          checkInError: "Check-in failed",
          checkOutError: "Check-out failed",
          cancelError: "Cancellation failed",
        },
        assignUnit: {
          buttonTitle: "Assign room",
          title: "Assign room",
          currentRoom: "Current room",
          currentLabel: "current",
          searchPlaceholder: "Search rooms...",
          noUnits: "No rooms found",
          occupiedLabel: "occupied",
          uncategorized: "Uncategorized",
          success: "Room assigned successfully",
          logTitle: "Room assigned",
          logBody: "Reservation {{resId}} assigned to room {{unitName}}.",
          // Room-change guard (2026-10-13): cross-category / over-capacity confirmation.
          confirmCrossCategory: "Warning: this reservation is being moved to the \"{{targetCategory}}\" category. Continue?",
          confirmCapacity: "Warning: the \"{{targetCategory}}\" category holds a maximum of {{maxPersons}} people, but the reservation covers {{guestCount}} guests. Continue anyway?",
          confirmCrossCategoryAndCapacity: "Warning: the \"{{targetCategory}}\" category holds a maximum of {{maxPersons}} people, the reservation covers {{guestCount}} guests — and this changes the room category. Continue anyway?",
        },
      },
      housekeeping: {
        roomStatus: {
          dirty: "Dirty",
          clean: "Clean",
          inspected: "Inspection",
        },
        priorityRooms: "Priority Rooms",
        menuTitle: "Housekeeping Menu",
        menuSubtitlePlan: "Planning & Filters",
        menuSubtitleFilter: "Filter & View",
        titlePlan: "Housekeeping & Stayovers",
        titleForecast: "Housekeeping Forecast",
        descriptionPlan: "Plan cleanings and room status.",
        descriptionForecast: "Status overview and cleaning planning.",
        descriptionPlanV2: "Planning & Room Status Management",
        descriptionForecastV2: "Capacity Planning & Analysis",
        cleaningPlan: "Cleaning Plan",
        searchPlaceholder: "Guest, Room...",
        searchPlaceholderV2: "Search guest or room...",
        locations: "Locations",
        location: "Location",
        departures: "Departures",
        arrivals: "Arrivals",
        stayovers: "Stayovers",
        filterFree: "Free",
        clearFilters: "Clear Filters",
        filterLabel: "Filter",
        forecastLabel: "Forecast",
        from: "From",
        to: "To",
        allLocations: "All Locations",
        rooms: "{{count}} Rooms",
        settingsTitle: "Housekeeping Settings",
        settingsDesc: "Define keywords for maintenance blocks. Maintenance blocks containing these words and ending within the selected period will be shown on the cleaning list.",
        keywordsLabel: "Maintenance Keywords (comma-separated)",
        remarkPlaceholder: "Remark...",
        maintenance: "Maintenance",
        newPlan: "New Plan",
        room: "Room",
        status: "Status",
        priority: "Priority",
        assignedTo: "Assigned to",
        export: "Export",
        print: "Print",
        refresh: "Refresh",
        properties: "Properties",
        quickFilters: "Quick Filters",
        stay: "Stay",
        turnover: "Turnover",
        out: "Out",
        in: "In",
      },
      analytics: {
        propertyFilter: "Property Filter",
        allProperties: "All Properties",
        preset: {
          thisMonth: "Month",
          lastMonth: "Last Month",
          "30days": "30 Days",
          next7Days: "Next 7 Days",
          nextMonth: "Next Month",
        },
        noData: "No analytics data available",
        netRevenueLegend: "Net Accommodation Revenue",
        roundedValues: "Values rounded",
        avgDaily: "Ø Daily",
        peakDay: "Peak",
        average: "Average",
        barView: "Bars",
        areaView: "Area Trend",
        weekend: "Weekend",
        dataSource: "Data Source: Live Finance API",
        financeAudit: "Finance Audit",
        cityTaxAudit: "Audit City Tax",
        accessDenied: "Access Denied",
        reportFilter: "Report Filter",
        periodPropertyFilter: "Period & Property Selection",
        tab: {
          revenue: "Revenue & Performance",
          bookingStats: "Booking Statistics",
          heatmaps: "Heatmaps",
          kpiEvolution: "KPI Evolution",
        },
        kpiEvolution: {
          title: "KPI Evolution",
          subtitle: "How your KPIs developed compared to earlier periods",
          vsBefore: "vs.",
          noData: "No snapshot data for the selected period yet. The daily KPI snapshot has just started – values are collected from today on.",
          loading: "Loading snapshots...",
          loadFailed: "Snapshots could not be loaded.",
          metric: {
            netRevenue: "Net Revenue",
            grossRevenue: "Gross Revenue",
            soldUnits: "Room Nights",
            occupancy: "Occupancy",
            adr: "ADR",
            revpar: "RevPAR",
          },
          comparison: "Comparison",
          current: "Current period",
          previous: "{{days}} day(s) earlier",
          modeActual: "Actuals",
          modeForecast: "Forecast",
          forecast: {
            targetLabel: "Target date",
            pickupTitle: "Forecast evolution ({{days}} days)",
            noData: "No forecast snapshots for this date yet. The daily forecast snapshots have to start first (after the migration + first cron run).",
          },
          monthly: {
            tabLabel: "Months",
            title: "Monthly view",
            subtitle: "Monthly figures from actuals and forecasts — the daily-updated overview",
            month: "Month",
            occOoo: "Occ % excl. OOO",
            budget: "Net budget",
            difference: "Difference",
            yearTotal: "Year total",
            badgeActual: "Actual",
            badgeForecast: "Forecast",
            editBudget: "Edit budget",
            pickupTitle: "Evolution {{month}}",
            noPickup: "No forecast progression points for this month yet.",
            compareTitle: "Comparison",
            comparePickSecond: "Tap a second point to compare",
            monthNames: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
          },
          year: {
            previous: "Previous year",
            next: "Next year",
            today: "Current year",
          },
          explorer: {
            tabLabel: "Explorer",
            title: "KPI Explorer",
            subtitle: "Year {{year}} · {{scope}}",
            allProperties: "All properties",
            day: "Day",
            monthTotal: "Month total",
            backToYear: "Back to year",
            drillHint: "Click a month to see its daily values.",
          },
          dayChart: {
            title: "Daily progression ({{days}} days)",
            subtitle: "Daily values over the last days",
            current: "Now",
            past: "Before",
          },
          legend: {
            current: "Current period",
            offset: "Previous period ({{days}} days back)",
          },
        },
        kpiHelp: {
          button: "Guide & metrics",
          buttonShort: "Help",
          modalTitle: "KPI Evolution — Guide & metrics",
          intro:
            "This view shows how the key metrics have developed. Values come from the daily snapshots (06:30) and are frozen once a day has closed. All figures are net, in euro.",
          tabsTitle: "The four sub-tabs",
          tabActualTerm: "Actuals",
          tabActualText:
            "Closed days from the daily snapshots. Compares the selected period with the same-length period before it (1/3/7/14/30 days back) and adds a day-by-day trend chart.",
          tabForecastTerm: "Forecast",
          tabForecastText:
            "The current on-the-books position for future days. Shows how a given arrival date developed over time (pickup). Revenue metrics are unavailable here because the availability query carries no prices.",
          tabMonthlyTerm: "Monthly view",
          tabMonthlyText:
            "One row per month of the calendar year, with the same columns as the previous Google Sheet. Past months show actuals, future months the forecast. Budgets are entered here per month and property (admin/management only).",
          tabExplorerTerm: "Explorer",
          tabExplorerText:
            "For looking things up: year → month → day. Click a month to see its individual days. Best for multi-year comparisons and for checking unusual months.",
          readingTitle: "Display & controls",
          badgeActualTerm: "Green “ACTUAL” badge",
          badgeActualText:
            "The month contains closed days — the figures are final.",
          badgeForecastTerm: "Blue “FORECAST” badge",
          badgeForecastText:
            "The month is wholly or partly in the future — the figures are the current on-the-books position and change daily.",
          yearTerm: "Year selector ‹ 2026 ›",
          yearText:
            "Switches the year in the monthly view and the explorer. Important for budgets: future years (e.g. 2027) can be planned in advance. The “Current year” button jumps back.",
          budgetTerm: "Budget & difference",
          budgetText:
            "The budget is maintained per property and month (pencil icon, admin/management only). The difference is actual revenue minus budget — green when above, red when below. In the “All properties” view the budgets are summed across properties.",
          tooltipTerm: "Charts",
          tooltipText:
            "Hover over a chart (or drag along it on a phone) to see the date, revenue and room nights for that day.",
          metricsTitle: "Metrics & formulas",
          mSoldUnitsText:
            "Room nights sold in the period — the number of overnight stays, not of bookings.",
          mOccupancyText:
            "The occupancy as transmitted by Apaleo. Note: this includes out-of-order rooms, so it reads lower than the occupancy without OOO.",
          mOccOooText:
            "Occupancy excluding out-of-order rooms. This is NOT derived from the transmitted occupancy but calculated directly — which needs the property's fixed room count and the number of days in the period.",
          mNetRevenueText:
            "Net lodging revenue (excl. VAT) for the period.",
          mAdrText:
            "Average net room rate per room night sold.",
          mRevparText:
            "Net revenue per available room night. Important: divided by rooms × days — not by rooms alone. Otherwise it would be the monthly revenue per room and not comparable between months.",
          mBudgetText:
            "Planned net revenue target for the month (per property).",
          mDifferenceText:
            "Deviation of actual revenue from budget.",
          notesTitle: "Notes & limits",
          noteOooTerm: "Occupancy without OOO",
          noteOooText:
            "The physical room counts are configured per property (Berlin 189, Giessen 31, Siegen 102, Wetzlar 33). If the room inventory changes, the value must be updated — otherwise this metric becomes wrong.",
          noteHorizonTerm: "Forecast horizon",
          noteHorizonText:
            "The forecast reaches as far as the daily snapshot looks ahead (currently one year). Months beyond that show no forecast values yet — they fill in as the horizon reaches them.",
          noteHistoryTerm: "History",
          noteHistoryText:
            "Actuals before September 2026 come from the imported Google Sheet (from 2023). The daily snapshots themselves only exist since September 2026.",
        },
        heatmaps: {
          revenueTitle: "Revenue Heatmap",
          revenueSubtitle: "Net revenue by week × weekday",
          metricRevenue: "Revenue",
          metricRns: "Room Nights",
          paceTitle: "Booking Pace & Lead Time",
          paceSubtitle: "Bookings by stay month × lead time",
          stayMonth: "Stay month",
          lead: {
            b1: "1-3 days",
            b2: "4-7 days",
            b3: "8-14 days",
            b4: "15-30 days",
            b5: "31+ days",
          },
          paceExplainer: "Rows = arrival month, columns = lead time between booking and arrival",
          noData: "No heatmap data in the selected period",
          kw: "Wk {{week}}",
        },
        loadingMetrics: "Aggregating metrics...",
        kpi: {
          netRevenue: "Net Revenue",
          adr: "ADR (Net)",
          revPar: "RevPAR",
          occupancy: "Occupancy",
          alos: "ALOS",
          roomNights: "Room Nights",
        },
        chartTitle: "Revenue Development",
        chartSubtitle: "Daily Net Accommodation Revenue",
        expandChart: "Expand chart",
        collapseChart: "Collapse chart",
        realtimeMetrics: "Real-Time Metrics",
        night: "Night",
        nights: "Nights",
        exportButton: "Export",
        exportSuccess: "Data exported successfully",
        devMode: "Dev Mode",
        calculation: {
          sum: "Sum",
          total: "Total",
        },
      },
      anleitungen: {
        noContent: "No content written.",
        title: "Manuals",
        subtitle: "Knowledge base & manuals",
        newFolder: "New folder",
        newManual: "New manual",
        loadingFiles: "Loading files...",
        folderEmpty: "Folder empty",
        folderEmptySubtitle: "No content yet",
        noSearchResults: "No results",
        noSearchResultsSubtitle: "No matches for your search",
        globalSearchPrefix: 'Search results for "',
        createFolderTitle: "Create new folder",
        folderNameLabel: "Folder name",
        cancel: "Cancel",
        create: "Create",
        manualModalSubtitle: "Manual details & content",
        manualTitleLabel: "Title",
        typeLabel: "Type",
        typeMarkdown: "Markdown editor",
        typeUpload: "File upload",
        typeLink: "Web link",
        writeTab: "Edit",
        previewTab: "Preview",
        splitTab: "Split",
        editorTitle: "Editor",
        directDownload: "Direct download",
        currentFile: "Current file",
        uploadConstraints: "PDF, DOC, PNG, JPG ΓÇö max 20 MB",
        uploadProgress: "Upload progress",
        webLinkLabel: "Web link",
        save: "Save",
        operatingManuals: "Operating manuals",
        fileManagement: "File management",
        newEntry: "New entry",
        syncingCatalog: "Syncing catalog...",
        directoryEmpty: "Directory empty",
        directoryEmptySubtitle: "No entries yet",
        noHits: "No hits",
        globalHitsPrefix: 'Global hits for "',
        createDirectoryTitle: "New directory",
        directoryStructureSubtitle: "Manage directory structure",
        directoryNameLabel: "Directory name",
        saveManualSubtitle: "Save manual",
        formatTypeLabel: "Format",
        markdownEditor: "Markdown editor",
        uploadAttachment: "Upload attachment",
        hyperlink: "Hyperlink",
        editorTab: "Editor",
        splitView: "Split view",
        visualEditor: "Visual editor",
        currentUpload: "Current upload",
        uploadConstraintsV2: "PDF, DOC, PNG, JPG ΓÇö max 20 MB",
        uploadProgressV2: "Upload progress",
        openInBrowser: "Open in browser",
        confirmDelete: 'Are you sure you want to delete "{{name}}"?',
        deleteSuccess: "Successfully deleted!",
        deleteError: "Delete error: ",
        delete: "Delete",
        editManual: "Edit manual",
        editorPlaceholder: "# Heading 1...",
        chooseFile: "Choose new file",
        catalogSubtitle: "Catalog & manuals",
        editManualEntry: "Edit manual entry",
        chooseDocument: "Click to select document",
        backToList: "Back to overview",
        saveSuccess: "Saved successfully",
        deleteConfirm: "Really delete?",
        newVersionAvailable: "New version available",
        outdated: "Outdated",
        cannotDeleteSystemManual: "System manuals cannot be deleted",
        close: "Close",
        fileLabel: "File",
        folder: "Folder",
        folderNotEmpty: "Folder is not empty",
        searchPlaceholder: "Search manuals\u2026",
        systemManualTitle: "System Manual",
        noTenant: "No active tenant. Please sign in again.",
      },
      routingManagement: {
        loadGroupsError: "Error loading groups: ",
        loadRoutingsError: "Error loading routing rules: ",
        enterBookingIdError: "Please select or enter a booking ID.",
        enterDestFolioIdError: "Please enter a destination folio ID.",
        createRoutingSuccess: "Billing routing created successfully.",
        createRoutingError: "Error creating routing: ",
        deleteRoutingSuccess: "Routing rule deleted successfully.",
        deleteRoutingError: "Error deleting routing rule: ",
        bookingSelectionTitle: "Booking Selection for Billing Routings",
        searchGroupLabel: "Search / Select Group",
        selectedGroupLabel: "Selected Group",
        groupSearchPlaceholder: "Search group by name, ID or booking ID...",
        searchingRunning: "Searching...",
        searching: "Search...",
        noGroupsFound: "No groups found",
        bookingPrefix: "| Booking:",
        manualBookingIdLabel: "Or enter Booking ID manually",
        manualBookingIdPlaceholder: "e.g. B-101 or PTCUCBDK",
        bookingLabel: "Booking:",
        activeRoutingsTitle: "Active Routings ({{count}})",
        loadingRoutings: "Loading routing rules...",
        noRoutingsTitle: "No routings available",
        noRoutingsDescription: "No automatic billing routings are currently set up for this booking.",
        routeTo: "Route to:",
        to: "to",
        end: "End",
        deleteRuleTitle: "Delete rule",
        newRoutingRuleTitle: "New Routing Rule",
        destFolioIdLabel: "* Destination Folio ID (Target)",
        destFolioIdPlaceholder: "e.g. FOL-MOCK-201 or FOL-Schmidt",
        routingTypeLabel: "* Routing Type",
        serviceTypeOption: "Category (ServiceType)",
        serviceOption: "Article (Service)",
        categoryLabel: "* Category",
        serviceNameLabel: "* Service Name",
        serviceNamePlaceholder: "e.g. Breakfast",
        validFromLabel: "Valid From (Optional)",
        validToLabel: "Valid To (Optional)",
        creating: "Creating...",
        createRoutingButton: "Create Routing",
        noBookingTitle: "No Booking Selected",
        noBookingDescription: "Select a group above or enter a booking ID manually to manage active billing routings or add new refund rules.",
        typeSubAccount: "Sub-Account",
        typeServiceType: "Service Type",
        typeService: "Service",
        typeComplete: "Complete",
        typeAllPostings: "All Postings"
      },
      reservationImporter: {
        loadGroupsError: "Error loading groups: ",
        loadBlocksError: "Error loading blocks: ",
        fileEmptyError: "The uploaded file is empty.",
        readExcelError: "Error reading the Excel file.",
        lastNameMissing: "Last name missing.",
        arrivalMissingDefault: "Arrival missing, default: {{date}}",
        arrivalOutsideRange: "Arrival ({{date}}) outside block period.",
        departureMissingDefault: "Departure missing, default: {{date}}",
        departureOutsideRange: "Departure ({{date}}) outside block period or before arrival.",
        noValidRows: "No valid reservation rows to import.",
        batchError: "Batch from line {{line}}: {{message}}",
        title: "Guestlist Importer",
        subtitle: "Create reservations en bloc from Excel/CSV spreadsheets",
        fileLabel: "File",
        step: "Step {{current}} of {{total}}",
        searchGroupLabel: "* Search / Select Group",
        selectedGroupLabel: "Selected Group",
        groupSearchPlaceholder: "Search group by name, ID or booking ID...",
        searchingRunning: "Searching...",
        searching: "Search...",
        noGroupsFound: "No groups found",
        bookingPrefix: "| Booking:",
        selectBlockLabel: "* Select Allotment (Block)",
        selectBlockOption: "Select block...",
        to: "to",
        activeBlockLabel: "Active Block",
        uploadPrompt: "Click to upload or drag a file here",
        uploadFormats: "Allowed: Excel (.xlsx) or CSV",
        columnMappingDescription: "Column Mapping: Map the Excel columns to Apaleo fields.",
        notMapped: "-- Not mapped --",
        back: "Back",
        previewAndValidate: "Preview & Validate",
        guestNameHeader: "Guest Name",
        emailHeader: "Email",
        arrivalHeader: "Arrival",
        departureHeader: "Departure",
        adultsChildrenHeader: "Adults / Child",
        statusHeader: "Status",
        unknown: "Unknown",
        warning: "Warning",
        ok: "OK",
        error: "Error",
        importStart: "Start Import ({{count}} rows)",
        importingList: "Importing guest list...",
        percentComplete: "{{percent}}% complete",
        importComplete: "Import Complete",
        batchResults: "Batch processing results:",
        successful: "Successful",
        failed: "Failed",
        followingErrors: "The following errors occurred:",
        newImport: "New Import"
      },
      serviceQuickBooking: {
        loadGroupsError: "Error loading groups: ",
        loadBlocksError: "Error loading blocks: ",
        loadReservationsError: "Error loading reservations: ",
        loadServicesError: "Error loading services: ",
        selectServiceError: "Please select a service.",
        selectReservationError: "Please select at least one reservation.",
        title: "Service Quick Booking",
        subtitle: "Book a service en bloc for all or selected reservations in a block.",
        searchGroupLabel: "* Search / Select Group",
        selectedGroupLabel: "Selected Group",
        groupSearchPlaceholder: "Search group by name, ID or booking ID...",
        searchingRunning: "Searching...",
        searching: "Search...",
        noGroupsFound: "No groups found",
        bookingPrefix: "| Booking:",
        selectBlockLabel: "* Select Allotment (Block)",
        selectBlockOption: "Select block...",
        to: "to",
        guestListTitle: "Guest List ({{count}})",
        selectAll: "Select All",
        deselectAll: "Deselect All",
        loadingReservations: "Loading reservations...",
        noActiveReservations: "No active reservations",
        noActiveReservationsDesc: "No active reservations have been created for this block yet.",
        unknownGuest: "Unknown Guest",
        roomUnknown: "Room?",
        adults: "Adults",
        serviceConfigTitle: "Service Configuration",
        selectServiceLabel: "Select Service",
        loadingServicesFor: "Loading services for {{propertyId}}...",
        noServicesFound: "No services found for this hotel.",
        pricePrefix: "Price:",
        overridePriceLabel: "Override Price (EUR)",
        bookingCountLabel: "Booking Post Count",
        countTypeDefault: "Default (Breakfast = Adult count, Otherwise = 1)",
        countTypeCustom: "Set Manually",
        bookServiceButton: "Book service for {{count}} reservations",
        bookingServices: "Booking services...",
        percentComplete: "{{percent}}% complete",
        bookingComplete: "Quick Booking Complete",
        serviceResults: "Service booking results:",
        successfullyBooked: "Successfully Booked",
        failed: "Failed",
        followingErrors: "The following errors occurred:",
        doneNewBooking: "Done / New Booking"
      },
      groupsList: {
        loadGroupsError: "Error loading groups: ",
        loadBlocksError: "Error loading blocks: ",
        fillRequiredFields: "Please fill in all required fields.",
        createGroupSuccess: "Group created successfully.",
        createGroupError: "Error creating group: ",
        createBlockSuccess: "Allotment (Block) created successfully.",
        createBlockError: "Error creating block: ",
        enterLastName: "Please enter a last name.",
        createReservationSuccess: "Reservation created successfully.",
        bookingError: "Error booking: ",
        searchPlaceholder: "Group name, booker, booking ID...",
        arrivalFrom: "Arrival from",
        departureTo: "Departure to",
        bis: "to",
        allLocations: "Location: All",
        createGroupButton: "Create Group",
        groupsTitle: "Group Bookings",
        loadingGroups: "Loading groups...",
        noGroupsTitle: "No groups available",
        noGroupsDescription: "Create a new group or adjust your filters.",
        bookingLabel: "Booking:",
        contactPerson: "Contact Person / Booker",
        properties: "Property(ies)",
        comment: "Comment",
        blocksTitle: "Allotments (Blocks)",
        addBlockButton: "Add Block",
        loadingBlocks: "Loading blocks...",
        noBlocksTitle: "No blocks configured",
        noBlocksDescription: "Create an allotment for this group using \"Add Block\".",
        defaultUnitGroup: "Double Room",
        ratePrefix: "Rate:",
        defaultRatePlan: "Standard Rate",
        perNight: "per Night",
        bookButton: "Book",
        period: "Period",
        bookedBlocked: "Booked / Blocked",
        occupancy: "Occupancy",
        noGroupSelected: "No Group Selected",
        noGroupSelectedDescription: "Select a group booking from the list on the left to view details, set up allotments, and import Excel guest lists.",
        createGroupModalTitle: "Create New Group",
        createGroupModalSubtitle: "Create a new Apaleo group booking",
        groupNameLabel: "* Group Name",
        groupNamePlaceholder: "e.g. Smith Wedding Party",
        bookerFirstNameLabel: "Booker First Name",
        bookerLastNameLabel: "* Booker Last Name",
        bookerEmailLabel: "* Booker Email",
        firstNamePlaceholder: "Max",
        lastNamePlaceholder: "Mustermann",
        emailPlaceholder: "max@example.com",
        propertyLabel: "* Location / Property",
        commentLabel: "Comment / Note",
        commentPlaceholder: "Additional notes...",
        cancel: "Cancel",
        creating: "Creating...",
        saveGroup: "Save Group",
        createBlockModalTitle: "Set Up Allotment",
        createBlockModalSubtitle: "Create block for group: {{name}}",
        ratePlanLabel: "* Rate Plan",
        selectRatePlan: "Select rate plan",
        unitGroupLabel: "* Room Category",
        selectCategory: "Select category",
        arrivalFromLabel: "* Arrival",
        departureToLabel: "* Departure",
        unitsCountLabel: "* Room Count (Block)",
        dailyRateLabel: "* Daily Rate Gross",
        saveBlock: "Create Block",
        editBlockModalTitle: "Edit Allotment",
        editBlockModalSubtitle: "Change period, room count or rate of the allotment.",
        editBlockFixedLabel: "Fixed (not editable): rate plan & room category",
        editBlockButton: "Edit",
        editBlockButtonTitle: "Edit allotment",
        updatingBlock: "Saving...",
        saveBlockEdit: "Save changes",
        updateBlockSuccess: "Allotment updated.",
        updateBlockError: "Error updating the allotment: ",
        quickBookingModalTitle: "Book Room (Pickup)",
        quickBookingModalSubtitle: "Book in block {{blockId}} ({{unitGroup}})",
        guestFirstNameLabel: "Guest First Name",
        guestLastNameLabel: "* Guest Last Name",
        emailLabel: "Email Address",
        personsAdultsLabel: "* Persons / Adults",
        booking: "Booking...",
        completeBooking: "Complete Booking",
        exportExcel: "Export Excel",
        importGuestList: "Import Guest List",
        blockFull: "Block Full",
        noRatesAvailable: "No rates available",
        confirmDeleteBlock: "Really delete this block?",
        bookerInfoLabel: "Booker information",
        subtitle: "Overview of all group reservations",
        title: "Groups",
        addedToQueue: "Guest added to queue.",
        updateEntry: "Update Entry",
        addToQueue: "Add to Queue",
        queueEmpty: "Queue is empty. Please add at least one guest.",
        bookAll: "Book All",
        allBookingsSuccess: "{{count}} reservations created successfully.",
        someBookingsFailed: "{{success}} succeeded, {{failed}} failed.",
        allBookingsFailed: "All bookings failed.",
        queueTitle: "Queue",
        guestCount: "Guest {{index}}",
        remove: "Remove",
        edit: "Edit",
        bookingResults: "Booking Results",
        close: "Close",
        retry: "Retry",
        adultsShort: "Adults",
      },
      supportTicket: {
        header: "Customer Service & Support",
        headerSubtitle: "Manage & create support tickets",
        yourTickets: "Your Tickets ({{count}})",
        newTicket: "New Ticket",
        noActiveTickets: "No active tickets",
        noActiveTicketsDesc: "Have questions or a technical issue? Just create a support ticket.",
        priorityHigh: "High",
        priorityMedium: "Medium",
        priorityLow: "Low",
        statusOpen: "Open",
        statusInProgress: "In Progress",
        statusResolved: "Resolved",
        categoryGeneral: "General Question",
        categoryKassenbuch: "Cash Ledger",
        categoryHr: "HR & Time",
        categoryTechnical: "Technical Error",
        categoryBilling: "Billing",
        categoryUi: "Buttons/User Interface",
        categoryNotification: "Notification",
        createTitle: "Submit New Ticket",
        backToList: "Back to List",
        subjectLabel: "Subject",
        subjectPlaceholder: "What is this about?",
        categoryLabel: "Category",
        priorityLabel: "Priority",
        descriptionLabel: "Description",
        descriptionPlaceholder: "Describe your concern in as much detail as possible...",
        attachmentLabel: "Attachment (Optional, e.g. Screenshot)",
        chooseFile: "Choose File",
        cancel: "Cancel",
        submitTicket: "Submit Ticket",
        tickets: "Tickets",
        priorityPrefix: "Priority: ",
        subjectPrefix: "Subject: ",
        attachment: "Attachment:",
        attachmentsCount: "Attachments ({{count}}):",
        downloadAttachment: "Download Attachment",
        optionalMessage: "Optional message...",
        writeReply: "Write a reply...",
        ticketResolved: "This ticket has been resolved. Replying will reopen the ticket.",
        reopenTicket: "Reopen Ticket",
        employeeFallback: "Employee",
        customerFallback: "Customer",
        toastFillFields: "Please fill in all fields.",
        toastUploadError: "Error uploading file: {{message}}",
        toastCreated: "Support ticket created successfully!",
        toastCreateError: "Error creating ticket: {{message}}",
        toastSendError: "Error sending message.",
        toastFileTooLarge: "The file may be a maximum of 5MB.",
        toastReopened: "Ticket reopened.",
        title: "Title",
        titlePlaceholder: "Brief description of the issue",
        description: "Description",
        category: "Category",
        categoryBug: "Bug",
        categoryFeature: "Feature Request",
        categoryQuestion: "Question",
        categoryOther: "Other",
        priority: "Priority",
        priorityCritical: "Critical",
        department: "Department",
        departmentHousekeeping: "Housekeeping",
        departmentMaintenance: "Maintenance",
        departmentReception: "Reception",
        departmentManagement: "Management",
        replyPlaceholder: "Type a reply...",
        internalNote: "Internal Note",
        customerReply: "Reply to Customer",
        statusClosed: "Closed",
      },
      missingTime: {
        title: "Missing Time Entries",
        subtitle: "Record missing work hours",
        description: "The following days are missing time entries:",
        endTimeLabel: "End Time",
        restoreButton: "Restore",
        footerNote: "Please record the missing time entries.",
      },
      hrAbsence: {
        title: "Record Absence",
        subtitle: "Submit new absence request",
        employeeLabel: "Employee",
        categoryLabel: "Category",
        vacation: "Vacation",
        sick: "Sick Leave",
        compensatory: "Compensatory Time",
        training: "Training",
        other: "Other",
        periodStart: "Start",
        periodEnd: "End",
        statusApproved: "Approved ✓",
        deleteTooltip: "Delete entry",
        cancel: "Cancel",
        save: "Save",
        statusPending: "Pending",
        statusRejected: "Rejected",
      },
      hrEntitlement: {
        title: "Employee Data",
        subtitle: "Personal data and leave entitlement of the employee",
        bulkSelected: "{{count}} employees selected",
        bulkHint: "Only fields you change are saved for ALL selected employees. Empty fields stay unchanged.",
        bulkEditTitle: "Multi-Edit",
        bulkToggleTitle: "Select employee for multi-edit",
        selectAll: "Select all",
        deselectAll: "Deselect all",
        unchangedPlaceholder: "unchanged",
        sortHint: "Click to sort (ascending / descending / reset)",
        hoursPerWeek: "Hours per Week",
        hoursPerWeekHint: "{{hours}} h/week across {{days}} workdays ≈ {{perDay}} h/day",
        weeklyHours: "Weekly Hours",
        workdaysSplitHint: "{{hours}} h/week across {{days}} workdays ≈ {{perDay}} h/day",
        employeeLabel: "Employee",
        holidayStateLabel: "Federal State",
        workLocationLabel: "Work Location",
        workLocationUnassigned: "Unassigned",
        employmentPeriod: "Employment Period",
        entryDate: "Entry Date",
        exitDate: "Exit Date",
        currentYear: "Current Year",
        vacationEntitlement: "Leave Entitlement (Days)",
        currentYearLabel: "Current Year",
        carryoverLabel: "Prev. Year Carryover",
        nextYearStandardLabel: "Next Year Standard",
        vacationEntitlementStandard: "Standard Leave Entitlement (Days)",
        previousYearRemaining: "Remaining Leave from Previous Year (Days)",
        nextYear: "Next Year",
        nextYearDescription: "Preview leave entitlement for next year",
        proRataCalculation: "Pro-rata calculation for mid-year entry/exit",
        applyValue: "Apply Value",
        calculatedTotal: "Calculated Total Entitlement",
        days: "Days",
        workingModel: "Working Model",
        cancel: "Cancel",
        save: "Save",
      },
      holidayStateModal: {
        title: "Assign Federal State",
        subtitle: "Determines the public holidays used for this employee's vacation calculation.",
        currentState: "Current State",
        selectLabel: "New State",
        noState: "No state set",
        clearState: "Clear state",
        cancel: "Cancel",
        save: "Save",
      },
      hrRolloverConfirm: {
        title: "Year-End Rollover",
        subtitle: "Transfer remaining leave days to the new year",
        warningLabel: "Warning",
        warningBullet1: "The year-end rollover can only be performed once per year.",
        warningBullet2: "Non-transferable remaining leave days will expire.",
        warningBullet3: "This action cannot be undone.",
        projectionLabel: "Projection",
        thEmployee: "Employee",
        thCurrentRemaining: "Current Remaining",
        thNextYearEntitlement: "New Entitlement",
        thNewStatus: "Status",
        thFormula: "Formula",
        thEditablePlan: "Plan (editable)",
        thNewEntitlement: "New Entitlement",
        thNewCarryover: "Carryover",
        thNewTotal: "New Total",
        days: "Days",
        pleaseWait: "Please wait...",
        confirmButton: "Confirm Rollover",
        cancel: "Cancel",
        nextYear: "Next year",
        previousYear: "Previous year",
        warningText: "Are you sure you want to perform the year-end rollover for all employees?",
      },
      adminTimesheet: {
        defaultComment: "Correction by HR Admin",
        correctionSuccess: "Correction saved",
        fromPlaceholder: "Start",
        toPlaceholder: "End",
        correctionModule: "Time Correction",
        correctionSub: "Manual correction of working time",
        modeLabel: "Correction mode",
        modeDelta: "Correct hours",
        modeTimes: "Set start/end",
        timesReplaceHint: "Replaces all stamps of this day (start, end, break).",
        endAfterStart: "The end time must be after the start time.",
        ongoingSessionBlocked: "The employee is currently clocked in — have them clock out first.",
        dateLabel: "Date",
        timeDiffLabel: "Difference",
        documentationLabel: "Documentation",
        commentPlaceholder: "Reason for correction...",
        saveCorrection: "Save Correction",
        hoursAbbr: "h",
        minutesAbbr: "min",
        payout: "Payout",
        payoutSuccess: "Payout booked successfully",
        payoutDefaultComment: "Overtime payout",
      },
      historyTable: {
        date: "Date",
        presence: "Pres.",
        break: "Break",
        netWork: "Net",
        diff: "Diff.",
        timeAccount: "Account",
        correctionLog: "Correction",
        noData: "No data",
        pause: "Break",
        active: "Active",
        correctTimeTitle: "Correct Work Hours",
        correctTimeSubtitle: "Adjust clock-in/out times and breaks",
        startTimeLabel: "Clock In",
        endTimeLabel: "Clock Out",
        breakLabel: "Break (Minutes)",
        reasonLabel: "Reason for correction",
        reasonPlaceholder: "e.g. Forgot to clock in...",
      },
      lateCheckout: {
        title: "Book late checkout",
        subtitle: "Late departure as an add-on",
        button: "Late Checkout",
        buttonTitle: "Book late checkout",
        timeLabel: "Requested departure time",
        timeHint: "The time is noted on the reservation so housekeeping sees it.",
        serviceLabel: "Add-on service",
        serviceLoading: "Loading services...",
        serviceMissing: "No late-checkout service is configured for this property. Please create one in Apaleo and try again.",
        info: "The service is posted to the guest folio and the reservation is annotated with \"LCO [time] gebucht\".",
        confirm: "Book",
        booking: "Booking...",
        cancel: "Cancel",
        success: "Late checkout booked for {{time}}",
        commentFailed: "The late checkout was booked, but the reservation note could not be saved. Please add it manually.",
        error: "Late checkout could not be booked",
        unknownGuest: "Unknown guest",
        room: "Room",
        departure: "Departure",
      },
      cleaningPlan: {
        loading: "Loading cleaning plan...",
        lateCheckout: "LCO",
        roomLabel: "Room",
        remarks: "Remarks",
        cleanButton: "Mark Clean",
        dirtyButton: "Mark Dirty",
        statusCheckedOut: "Checked Out",
        statusDeparture: "Due Departure",
        statusInHouse: "Occupied",
        statusConfirmed: "Arrival",
        conditionClean: "Clean",
        conditionDirty: "Dirty",
        conditionInspection: "Inspection",
        conditionUnknown: "Unknown",
        stayover: "Stayover",
        statusFree: "Free",
        noResults: "No cleanings found",
        adultsAbbr: "Ad.",
        child: "Child",
        children: "Children",
        longStayTooltip: "Long-term stayover",
        chooseDay: "Choose day",
        portrait: "Portrait",
        landscape: "Landscape",
        selectRow: "Select for printing",
        deselectRow: "Deselect for printing",
        selectedCount_one: "{{count}} room selected for printing",
        selectedCount_other: "{{count}} rooms selected for printing",
        clearSelection: "Clear selection",
      },
      traceCreate: {
        newTrace: "New Trace",
        traceText: "Trace Text",
        tracePlaceholder: "What needs to be done?",
        property: "Location",
        assignment: "Assignment",
        selectDepartment: "Select department",
        requester: "Reporter / Client",
        requesterPlaceholder: "Reporter name",
        persons: "Persons",
        roomPrefix: "Room",
        roomUnit: "Unit",
        roomPlaceholder: "Rm. No.",
        searchPlaceholder: "Search guest...",
        searchingApaleo: "Apaleo search...",
        minChars: "At least 3 characters",
        noResults: "No results",
        linkGuestReservation: "Link guest / reservation",
        idLabel: "ID",
        arrival: "Arrival",
        departure: "Departure",
        startFrom: "Start From",
        endBy: "End By",
        attachFile: "Attach file",
        addMoreFiles: "Attach more files",
        htDetails: "Maintenance Details",
        htArea: "Maintenance Area",
        noArea: "No area",
        painting: "Painting",
        damage: "Damage",
        general: "General",
        deviceSwappedYes: "Device swapped ✓",
        deviceSwappedNo: "Device swapped?",
        recurringTrace: "Recurring trace?",
        frequency: "Frequency",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        interval: "Interval",
        days: "Days",
        weeks: "Weeks",
        months: "Months",
        endAfter: "End After",
        amount: "Amount",
        endOn: "End On",
        anchor: "Anchor",
        start: "Start",
        due: "Due",
        cancel: "Cancel",
        createTrace: "Create Trace",
        title: "Title",
        titlePlaceholder: "e.g. Restock minibar",
        description: "Description",
        descriptionPlaceholder: "Detailed description of the task",
        priority: "Priority",
        priorityLow: "Low",
        priorityMedium: "Medium",
        priorityHigh: "High",
        priorityUrgent: "Urgent",
        category: "Category",
        categoryHousekeeping: "Housekeeping",
        categoryMaintenance: "Maintenance",
        categoryService: "Service",
        categoryComplaint: "Complaint",
        categoryRequest: "Request",
        notes: "Notes",
        notesPlaceholder: "Internal notes...",
        addAttachment: "Add Attachment",
        removeAttachment: "Remove Attachment",
        notifyByEmail: "Notify by Email",
        notifyByPush: "Notify by Push",
        createAndAssign: "Create & Assign",
        createAndClose: "Create & Close",
        saveAsTemplate: "Save as Template",
        selectTemplate: "Select Template",
        templateName: "Template Name",
        estimatedTime: "Estimated Time (Min.)",
      },
      profileMerge: {
        title: "Sync Profiles",
        subtitle: "Master data cleanup in Apaleo",
        minCharsToast: "Please enter at least 3 characters for the search.",
        minCharsSearch: "At least 3 characters",
        manualSelection: "Manual Selection",
        allHits: 'All hits for "{{term}}"',
        unknownName: "Unknown Name",
        noEmail: "No email stored",
        noPhone: "No phone number stored",
        selectMinOneToast: "Please select at least one additional reservation using the checkboxes.",
        successMsg: "Success! Clean guest data has been transferred to {{count}} reservation(s).",
        search: "Search",
        searchPlaceholder: "Name, Email...",
        grouping: "Grouping",
        all: "All",
        scanning: "Scanning profiles...",
        nothingFound: "Nothing found.",
        startSearch: "Start search",
        noDetails: "No details",
        dataComparison: "Data Comparison",
        selectTarget: "Select the target profile (green) for synchronization",
        collapseAll: "Collapse all",
        expandAll: "Expand all",
        syncingCount: "{{count}} reservations will be synchronized",
        identicalCount: "{{count}} profiles are already identical",
        synchronize: "Synchronize",
        target: "Target",
        sync: "Sync",
        resId: "Res-ID",
        arrival: "Arrival",
        guestData: "Guest Data",
        contact: "Contact",
        ok: "✓ Ok",
        hideDetails: "Hide details",
        showDetails: "Show details",
        address: "Address",
        noAddress: "No address stored",
        company: "Company",
        noCompany: "No company",
        birthday: "Birthday",
        identity: "Identity",
        titleLabel: "Title",
        gender: "Gender",
        nation: "Nationality",
        selectGroup: "Select group",
        selectGroupHint: "Select a group on the left to clean up the profiles.",
      },
      offerConfirmation: {
        invalidLink: "Invalid offer link. Please contact us for a new offer.",
        loadError: "Could not load offer.",
        connectionError: "Connection error. Please try again later.",
        confirmationFailed: "Confirmation failed",
        loading: "Loading offer...",
        notAvailable: "Offer not available",
        expired: "This offer has expired (valid until {{date}}). Please request a new offer.",
        bookingConfirmed: "Booking confirmed!",
        alreadyConfirmed: "Already confirmed",
        thankYouMessage: "Thank you! The booking ({{bookingId}}) has been created successfully. You will receive a confirmation email shortly.",
        alreadyConverted: "This offer has already been confirmed and converted into a booking.",
        bookingId: "Booking ID",
        yourOffer: "Your Offer",
        validUntil: "Valid until",
        location: "Location",
        arrival: "Arrival",
        departure: "Departure",
        guests: "Guests",
        adults: "Adults",
        children: "Children",
        category: "Category",
        notSpecified: "Not specified",
        totalPrice: "Total Price",
        teamMessage: "Message from the team",
        company: "Company",
        cancellationPolicy: "Cancellation Policy",
        expiryNoticeTitle: "Validity notice",
        expiryNotice: "Please note that offered rooms are not blocked until confirmation and offers not confirmed within the specified validity period will automatically expire.",
        booking: "Booking...",
        acceptAndBook: "Accept & Book",
        questions: "Questions about the offer?",
        termsAccept: "By booking you agree to our Terms and Conditions.",
        refresh: "Reload offer",
        summary: "Summary",
        details: "Details",
        servicesBreakdown: "Service breakdown",
        cityTaxIncludedShort: "City tax included",
        perUnit: "per unit",
        perNight: "per night",
        services: "Services",
        servicesCount: "services",
        inPositions: "in",
        positions: "items",
      },
      offerDrawer: {
        discount: "Discount",
        discountPercent: "Discount in %",
        discountAmount: "Discount Amount",
        voucher: "Voucher",
        voucherCode: "Voucher Code",
        voucherApplied: "Voucher applied",
        voucherInvalid: "Invalid voucher code",
        voucherExpired: "Voucher expired",
        addons: "Add-ons",
        addonBreakfast: "Breakfast",
        addonParking: "Parking",
        addonWifi: "WiFi",
        addonSpa: "Spa Access",
        addonPet: "Pet",
        totalWithAddons: "Total price incl. add-ons",
        ratePlan: "Rate Plan",
        mealPlan: "Meal Plan",
        mealBreakfast: "Breakfast included",
        mealHalfBoard: "Half Board",
        mealFullBoard: "Full Board",
        mealNone: "No Meals",
        cancellation: "Cancellation",
        cancellationFree: "Free Cancellation",
        cancellationNonRefundable: "Non-refundable",
        cancellationPolicyShort: "Free cancellation up to 24h before arrival",
        payNow: "Pay Now",
        payOnArrival: "Pay on Arrival",
        payAtHotel: "Pay at Hotel",
        paymentMethod: "Payment Method",
        specialRequests: "Special Requests",
        specialRequestsPlaceholder: "e.g. Allergies, late arrival...",
        arrivalTime: "Arrival Time",
        estimatedArrival: "Estimated Arrival",
        departureTime: "Departure Time",
        sendOfferEmail: "Send Offer by Email",
        offerSent: "Offer sent by email",
        offerSentError: "Error sending email",
        copyOffer: "Duplicate Offer",
        offerDuplicated: "Offer duplicated",
        deleteOffer: "Delete Offer",
        confirmDeleteOffer: "Really delete this offer?",
        offerDeleted: "Offer deleted",
        offerDeletedError: "Error deleting offer",
        expireOffer: "Expire Offer",
        offerExpired: "Offer expired",
        regenerateLink: "Regenerate Link",
        regenerateLinkConfirm: "Previous link will become invalid. Continue?",
        linkRegenerated: "Link regenerated",
        printOffer: "Print Offer",
        pdfDownload: "Download as PDF",
        language: "Language",
        languageDE: "German",
        languageEN: "English",
        editCutoffTitle: "Edit Cut-off Date",
        editCutoffSubtitle: "Only the validity date can still be changed",
        amendNoticeTitle: "Amend offer",
        amendNotice: "This offer has already been sent to the guest. Changes (dates, rooms, prices) are immediately visible on the guest's offer page; inventory is validated only when the guest confirms. Guest details remain unchanged.",
        cutoffEditNotice: "Offer already sent",
        cutoffEditNoticeDescription: "This offer has already been sent to the guest. Offer details can no longer be changed, but the cut-off date can be extended or shortened.",
        cutoffHelp: "Pick a new date and time by which the guest can accept the offer.",
        cutoffSave: "Save new cut-off",
        cutoffUpdated: "Cut-off date updated",
        offerNumber: "Offer Number",
        editOffer: "Edit Offer",
        newOffer: "New Offer",
        step1Availability: "Step 1: Availability",
        step2GuestDataAndPrice: "Step 2: Guest data & price",
        offerUpdated: "Offer updated!",
        offerCreated: "Offer created!",
        copyLink: "Copy link",
        linkCopied: "Link copied!",
        searchExistingGuest: "Search existing guest (optional)",
        nameOrEmail: "Name or email...",
        crmHistory: "CRM history",
        regularGuest: "Regular guest",
        apaleoSearch: "Apaleo search...",
        apaleoHistory: "Apaleo history",
        noEmail: "No email",
        external: "External",
        guestBlocked: "Guest blocked",
        guestBlockedDescription: "This guest is on the internal blacklist.",
        hotel: "Hotel",
        persons: "Persons",
        arrival: "Arrival",
        departure: "Departure",
        children: "Children",
        validUntil: "Valid until",
        checkAvailability: "Check availability",
        searchingOffers: "Searching offers...",
        startSearchPrompt: "Start a search to see available rooms",
        noOffersFound: "No offers found. Please adjust the date range or number of persons.",
        room: "Room",
        companyRates: "Company rates",
        standardRate: "Standard rate",
        standard: "Standard",
        select: "Select",
        availableCategories: "Available categories",
        fromPrice: "From {{price}} {{currency}}",
        fromPrice_other: "From {{price}} {{currency}}",
        back: "Back",
        ratesAvailable: "{{count}} rate available",
        ratesAvailable_other: "{{count}} rates available",
        choose: "Choose",
        backToSelection: "Back to selection",
        selectedCategory: "Selected category",
        nights: "{{count}} night",
        nights_other: "{{count}} nights",
        totalPrice: "Total price",
        netTotal: "Net (excl. VAT)",
        manualPricePerNight: "Manual price per night",
        manualPriceDescription: "Override the standard price for this stay",
        newTotalPrice: "New total price:",
        guestDataAndDetails: "Guest data & details",
        internalGuestNote: "Internal guest note",
        createTaskFromNote: "Create task from note?",
        departmentLabel: "Department",
        department: {
          Rezeption: "Reception",
          Housekeeping: "Housekeeping",
          Haustechnik: "Maintenance",
          Management: "Management",
          Sales: "Sales"
        },
        startFrom: "Complete from",
        endBy: "Complete by",
        firstName: "First name *",
        lastName: "Last name *",
        email: "Email address *",
        phone: "Phone number",
        address: "Address (optional)",
        street: "Street & house number",
        postalCode: "Postal code",
        city: "City",
        countryCode: "Country (ISO code)",
        internalNote: "Internal note",
        internalNotePlaceholder: "Internal notes about the offer...",
        guestMessage: "Message to guest",
        guestMessagePlaceholder: "This message will be shown to the guest in the offer...",
        offerLanguage: "Offer page language",
        languageGerman: "German",
        languageEnglish: "English",
        offerLanguageHint: "Determines in which language the guest sees the offer page.",
        cancellationPolicy: "Cancellation policy",
        linkCompany: "Link company (optional)",
        searchCompany: "Search company...",
        noCompanyFound: "No company found",
        updateOffer: "Update offer",
        createOffer: "Create offer",
        fillAllFields: "Please fill in all fields",
        offerSearchError: "Error searching offers: {{error}}",
        requiredFields: "First name, last name and email are required!",
        noCategorySelected: "No category selected",
        enterValidPrice: "Please enter a valid price",
        selectValidUntil: "Please select a validity date",
        offerCreationError: "Error creating the offer",
        genericError: "Error: {{message}}",
        linkFallback: "Link: {{url}}",
      },
      offersView: {
        title: "Offers",
        subtitle: "Offer management & guest confirmations",
        newOffer: "New offer",
        all: "All",
        searchPlaceholder: "Search by guest, email or offer number...",
        shareLinkPrompt: "Offer sent! Share this link with the guest:",
        copy: "Copy",
        copied: "Copied!",
        noMatchingOffers: "No matching offers",
        noOffersYet: "No offers yet",
        adjustFilters: "Adjust filters",
        createFirstOffer: "Create the first offer",
        send: "Send",
        amendOffer: "Amend offer",
        editCutoff: "Edit cut-off date",
        copyLink: "Copy link",
        bookingError: "Booking error",
        editOffer: "Edit offer",
        arrival: "Arrival",
        departure: "Departure",
        guests: "Guests",
        adults: "Adults",
        children: "Children",
        location: "Location",
        category: "Category",
        rate: "Rate",
        totalPrice: "Total price",
        cityTaxIncluded: "City tax included",
        company: "Company",
        createdAt: "Created on",
        validUntil: "Valid until",
        statusLabel: "Status",
        clockSuffix: "",
        autoExpired: "Auto-detected from the cut-off date",
        messageToGuest: "Message to guest",
        internalNotes: "Internal notes",
        section: {
          stay: "Stay",
          services: "Services",
          guestDetails: "Guest details",
          offerData: "Offer data"
        },
        status: {
          draft: "Draft",
          sent: "Sent",
          expired: "Expired",
          converted: "Booked"
        }
      },
      adminDashboard: {
        title: "Admin Panel",
        subtitle: "Tenants, Webhooks, Tickets & Automations",
        tenants: "Tenants",
        tenantList: "Tenant List",
        addTenant: "Add Tenant",
        tenantName: "Tenant Name",
        tenantId: "Tenant ID",
        tenantStatus: "Status",
        active: "Active",
        inactive: "Inactive",
        suspend: "Suspend",
        unsuspend: "Unsuspend",
        features: "Feature Flags",
        automations: "Automations",
        syncStatus: "Sync Status",
        lastSync: "Last Sync",
        mailSync: "Email Sync",
        runNow: "Run Now",
        webhooks: "Webhooks",
        registerWebhook: "Register Webhook",
        retryWebhook: "Retry",
        webhookLogs: "Webhook Logs",
        webhookEventLog: "Webhook Event Log",
        webhookStatus: "Status",
        eventFilterAll: "All event types",
        eventFilterFrom: "From date",
        eventFilterTo: "To date",
        webhookResult: "Result",
        webhookNoEvents: "No webhook events recorded",
        webhookStepOk: "OK",
        webhookStepIgnored: "Ignored",
        webhookStepSkipped: "Skipped",
        webhookStepFailed: "Failed",
        supportTickets: "Support Tickets",
        createTicket: "Create Ticket",
        ticketSubject: "Subject",
        ticketMessage: "Message",
        submitTicket: "Submit Ticket",
        ticketCount: "{{count}} Tickets",
        search: "Search...",
        filter: "Filter",
        all: "All",
        logs: "Logs",
        success: "Success",
        error: "Error",
        attachFile: "Attach File",
        send: "Send",
        sending: "Sending...",
        cancel: "Cancel",
        priority: "Priority",
        status: "Status",
        onboardingCompleted: "Completed",
        onboardingOpen: "Open",
        liveUsers: "Live",
        liveUsersTitle: "Active Users",
        liveUsersSubtitle: "{{count}} users currently online",
        live: "Live",
        noLiveUsers: "No users online",
        liveUser: "User",
        role: "Role",
        connectedSince: "Online since",
        usage: {
          tab: "Usage",
          totalEvents: "Navigations",
          activeUsers: "Active Users",
          mostUsedMenus: "Most Used Menus",
          leastUsedMenus: "Least Used (UX Priority)",
          subtabBreakdown: "Subtab Usage by Menu",
          dailyActivity: "Daily Activity",
          topUsers: "Most Active Users",
          refresh: "Refresh",
          range7: "7 days",
          range30: "30 days",
          range90: "90 days",
          allTenants: "All tenants",
          noData: "No usage data yet — data accumulates from the next navigation onwards.",
          privacyNote: "Usage analytics: only menu/subtab navigations are recorded (internal user id, role, menu). No search terms, no guest or reservation data. Retention: 180 days.",
        },
      },
      automationBuilder: {
        common: {
          loading: "Loading automations...",
          commaSeparated: "Separate multiple terms with a comma",
          all: "All",
          choose: "Please choose",
          noneSelectedAll: "Nothing selected = no restriction",
        },
        workflowsSubtitle: "Your own when-then rules",
        options: {
          languageDe: "German",
          languageEn: "English",
        },
        statusGroups: {
          open: "Open",
          in_progress: "In progress",
          done: "Done",
          cancelled: "Deleted",
        },
        dueMode: {
          all: "All open traces",
          today: "Due today or earlier",
          overdue: "Overdue only (before today)",
        },
        placeholders: {
          title: "Available placeholders",
          example: "Example",
          booking_arrived: {
            event: "Short trigger summary, e.g. including booked extras",
            property: "The property the rule fired for",
          },
          email_received: {
            event: "Short summary (new email in the mailbox)",
            property: "The property the rule fired for",
          },
          invoice_created: {
            event: "Short summary incl. invoice number",
            property: "The property the rule fired for",
          },
          every_day_at: {
            event: "Short summary incl. the time",
            property: "The property the rule fired for",
          },
          traces_digest_at: {
            count: "Number of open traces",
            overdue: "Number of overdue traces",
            scope: "Short description of the filters (department, property, due date)",
            date: "The date the email was sent",
          },
          overbooking_detected: {
            event: "Short summary incl. worst availability, e.g. Overbooking (-1)",
            dates: "The stay window, e.g. 05.10. and 08.10.",
            property: "The property the rule fired for",
          },
        },
        builder: {
          title: "Automation rules",
          titleTooltip: "Create your own rules here: when something happens, AdaptHub automatically does something for you. No technical knowledge needed.",
          subtitle: "Your own when-then rules — no tech required",
          create: "New rule",
          createTooltip: "Starts a step-by-step guide to create a new automation.",
          templates: "Templates",
          templatesTooltip: "Ready-made examples to try — one click to get started.",
          empty: "No custom rules yet. Start with a template or click \"New rule\".",
        },
        triggers: {
          booking_arrived: {
            label: "A new booking arrives",
            tooltip: "Triggers whenever a new reservation arrives in Apaleo (e.g. from Booking.com or your own website).",
            fields: {
              rateCodeContains: {
                label: "Only bookings with this rate code",
                tooltip: "Enter something here to limit the rule to specific rate codes. Leave empty = all bookings.",
              },
              servicesInclude: {
                label: "Only bookings with one of these extras",
                tooltip: "Comma-separated codes of extras (e.g. BABYBETT, AUFB_ERW). Empty = all bookings.",
              },
              propertyId: {
                label: "Only for this property",
                tooltip: "Optional: limit the rule to one property. Empty = all properties.",
              },
            },
          },
          email_received: {
            label: "A new email arrives",
            tooltip: "Triggers whenever a new email arrives in a monitored mailbox.",
            fields: {
              fromAddressContains: {
                label: "Only emails from this sender",
                tooltip: "Part of the sender address, e.g. \"booking.com\". Empty = any sender.",
              },
              subjectContains: {
                label: "Only emails with this word in the subject",
                tooltip: "Word or text that must appear in the subject. Empty = any subject.",
              },
              mailbox: {
                label: "Only in this mailbox",
                tooltip: "Optional: limit the rule to one mailbox. Empty = all mailboxes.",
              },
            },
          },
          invoice_created: {
            label: "A new invoice is created",
            tooltip: "Triggers whenever a new invoice is generated in Apaleo (e.g. by the night audit).",
            fields: {
              propertyId: {
                label: "Only for this property",
                tooltip: "Optional: limit the rule to one property. Empty = all properties.",
              },
            },
          },
          every_day_at: {
            label: "Daily at a specific time",
            tooltip: "Triggers every day at the set time (server time/UTC). Ideal for morning task overviews.",
            fields: {
              timeOfDay: {
                label: "Time (HH:MM)",
                tooltip: "24-hour format, e.g. 08:00. The rule fires hourly, exactly on the minute.",
              },
            },
          },
          traces_digest_at: {
            label: "Daily reminder for open traces",
            tooltip: "Sends an email every day at the configured time with the number of open traces and a linked list. The time is German local time (Berlin), including daylight saving.",
            fields: {
              timeOfDay: {
                label: "Time (HH:MM)",
                tooltip: "German local time, e.g. 19:00. The scheduler runs hourly, so only the full hour counts (19:15 is sent at 19:00).",
              },
              statusGroups: {
                label: "Which statuses count as open?",
                tooltip: "Nothing selected = open and in progress. Done or deleted traces are then not counted.",
              },
              departments: {
                label: "Only these departments",
                tooltip: "Nothing selected = all departments. Create one rule per department if needed.",
              },
              propertyId: {
                label: "Only this property",
                tooltip: "Nothing selected = all properties. This is how one reminder per house is set up.",
              },
              dueMode: {
                label: "Which due date?",
                tooltip: "All open = every open trace. Due today = today or earlier. Overdue only = before today.",
              },
            },
          },
          overbooking_detected: {
            label: "An overbooking is detected",
            tooltip: "Checks every booking automatically for whether the room type's availability is overbooked for the stay (no free rooms). Fires then.",
            fields: {
              propertyId: {
                label: "Only for this property",
                tooltip: "Optional: limit the rule to one property (e.g. one info@ address per property). Empty = all properties.",
              },
            },
          },
        },
        actions: {
          send_push: {
            label: "Send a notification",
            tooltip: "Sends an in-app notification to a department or person.",
            fields: {
              department: {
                label: "To whom? (department or name)",
                tooltip: "Recipient of the notification, e.g. reception, housekeeping or a person's name. Required.",
              },
              messageTemplate: {
                label: "Message (optional)",
                tooltip: "Notification text. The {{event}} placeholder is replaced with a short trigger summary.",
              },
            },
          },
          create_trace: {
            label: "Create a task (trace)",
            tooltip: "Automatically creates a task in the trace system.",
            fields: {
              title: {
                label: "Task title",
                tooltip: "Text that appears as the task name.",
              },
              department: {
                label: "Responsible department",
                tooltip: "Who the task is assigned to (default: housekeeping).",
              },
              titleFromService: {
                label: "Derive title automatically from the extra",
                tooltip: "When enabled, the matched extra's code becomes the task title.",
              },
            },
          },
          send_email: {
            label: "Send an email",
            tooltip: "Sends a notification email to a staff member.",
            fields: {
              toEmail: {
                label: "To which email address?",
                tooltip: "Recipient email address. Required.",
              },
              subject: {
                label: "Subject (optional)",
                tooltip: "Subject line. The {{event}} placeholder is replaced with a short trigger summary.",
              },
              bodyTemplate: {
                label: "Body (optional)",
                tooltip: "Email body. {{event}} = short trigger summary; for overbooking rules additionally {{dates}} = the stay window (e.g. \"01.10. and 05.10.\").",
              },
            },
          },
          send_trace_digest: {
            label: "Daily trace reminder email",
            tooltip: "Sends an email every day with the number of open traces and a linked list. Requires the Daily reminder for open traces trigger.",
            fields: {
              toEmail: {
                label: "Which email address?",
                tooltip: "Recipient of the reminder, e.g. info@adaptberlin.de. Required.",
              },
              subject: {
                label: "Subject (optional)",
                tooltip: "Subject line. Placeholders: {{count}}, {{overdue}}, {{scope}}, {{date}}.",
              },
              bodyTemplate: {
                label: "Text at the top of the email (optional)",
                tooltip: "Intro above the trace list. Placeholders: {{count}}, {{overdue}}, {{scope}}, {{date}}. Empty = standard wording.",
              },
              statusGroups: {
                label: "Status (overrides the trigger)",
                tooltip: "Optional. Only needed when the reminder should count differently than the trigger.",
              },
              departments: {
                label: "Departments",
                tooltip: "Optional. Nothing selected = all departments.",
              },
              propertyId: {
                label: "Property",
                tooltip: "Optional. Nothing selected = all properties.",
              },
              dueMode: {
                label: "Due date",
                tooltip: "Controls list and counter: all open, due today, or overdue only.",
              },
              includeTitles: {
                label: "Show trace titles in the list",
                tooltip: "Unchecked, the list carries only property, department and links — no titles. Use it when titles could contain guest names.",
              },
              includeBreakdown: {
                label: "Include per-department breakdown",
                tooltip: "Adds a line like Housekeeping: 4; Reception: 2.",
              },
              alwaysSend: {
                label: "Also send when 0 traces are open",
                tooltip: "Without this, no email is sent on days without open traces.",
              },
              language: {
                label: "Email language",
                tooltip: "Default: German.",
              },
            },
          },        },
        wizard: {
          title: "Create automation",
          step1: "When?",
          step2: "Narrow down",
          step3: "What to do?",
          whenQuestion: "When should the automation be triggered?",
          narrowQuestion: "Should it only trigger in certain cases?",
          narrowOptional: "Leave everything empty to cover all cases.",
          whatQuestion: "What should happen?",
          ruleName: "Rule name",
          ruleNamePlaceholder: "e.g. Baby-bed task on new booking",
          ruleNameTooltip: "A clear name so everyone on the team knows what this rule does.",
          defaultName: "{{trigger}} → {{action}}",
          startDisabled: "New rules start disabled. Switch them on with one click once everything looks right.",
          startDisabledTooltip: "This lets you review the settings before the rule runs.",
          next: "Next",
          back: "Back",
          cancel: "Cancel",
          close: "Close",
          save: "Save rule",
          saving: "Saving...",
          saved: "Rule saved (starts disabled)",
          saveError: "Rule could not be saved",
        },
        rule: {
          enabled: "On",
          disabled: "Off",
          enableTooltip: "Switch the rule on — it runs automatically from now on.",
          disableTooltip: "Switch the rule off (kill switch). Nothing happens immediately.",
          history: "History",
          historyTooltip: "Shows when this rule last ran and whether it worked.",
          edit: "Edit",
          editTooltip: "Change the rule.",
          delete: "Delete",
          deleteTooltip: "Permanently delete the rule.",
          deleteConfirm: "Really delete this rule?",
        },
        history: {
          title: "History: {{name}}",
          empty: "This rule has not run yet.",
          emptyTooltip: "Once the rule is active and triggers, runs appear here.",
          status: {
            success: "Success",
            failed: "Failed",
            skipped_throttled: "Skipped (limit)",
          },
        },
        templates: {
          title: "Ready-made templates",
          tracesDigest: {
            name: "Daily trace reminder",
            tooltip: "Sends an email every day at 19:00 with the number of open traces and a linked list. Then set department and property.",
          },
          extraBed: {
            name: "Extra-bed booking → housekeeping task",
            tooltip: "On a new booking with an extra bed, a housekeeping task is created automatically.",
          },
          bookingPush: {
            name: "New booking → notify reception",
            tooltip: "Reception receives an in-app notification for every new booking.",
          },
          emailPush: {
            name: "New email → notify accounting",
            tooltip: "Accounting is notified for every new email in the mailbox.",
          },
          overbookingBerlin: {
            name: "Overbooking Berlin → info@adaptberlin.de",
            tooltip: "When an overbooking is detected for Berlin, an email is sent to info@adaptberlin.de (port of the Make.com scenario).",
          },
          overbookingGiessen: {
            name: "Overbooking Giessen → info@adaptgiessen.de",
            tooltip: "When an overbooking is detected for Giessen, an email is sent to info@adaptgiessen.de.",
          },
          overbookingWetzlar: {
            name: "Overbooking Wetzlar → info@adaptwetzlar.de",
            tooltip: "When an overbooking is detected for Wetzlar, an email is sent to info@adaptwetzlar.de.",
          },
          overbookingSiegen: {
            name: "Overbooking Siegen → info@adaptsiegen.de",
            tooltip: "When an overbooking is detected for Siegen, an email is sent to info@adaptsiegen.de.",
          },
        },
      },
      automations: {
        title: "Automations",
        subtitle: "Manage workflows and rules",
        description: "Configure automatic processes for your hotel",
        addAutomation: "Add Automation",
        noAutomations: "No automations configured",
        enable: "Enable",
        disable: "Disable",
        enabled: "Enabled",
        disabled: "Disabled",
        active: "Active",
        inactive: "Inactive",
        settings: "Settings",
        save: "Save",
        cancel: "Cancel",
        runHistory: "Run History",
        lastRun: "Last Run",
        nextRun: "Next Run",
        success: "Success",
        failed: "Failed",
        serviceCode: "Service Code",
        serviceTitle: "Service Title",
        department: "Department",
        serviceCodeLabel: "Service Code",
        serviceTitleLabel: "Service Title",
        departmentLabel: "Department",
        tabAutomations: "Automations",
      },
  emailScans: {
    title: "E-Mail-Scans",
    description: "Outlook booking scan, D-Edge storno scan and HRS company scan: setups, retry queue and detailed event log.",
    setups: "Setups",
    cronLabel: "Interval",
    automaticOn: "Automatic on",
    automaticOff: "Manual only",
    connectingOutlook: "Connecting to Outlook 365...",
    runFailed: "Scan failed.",

    "queue.title": "HRS queue (waiting for reservation)",
    "queue.noReference": "no reference",
    "queue.attempts": "attempt {{count}}/3",
    eventLog: "Detailed event log",
    loadEvents: "Load events",
    noEvents: "No email-scan events found",
    runEntry: "run completed",
    "setup.outlook.title": "Outlook booking scan",
    "setup.outlook.description": "Scans the D-Edge inbox and links booking references to reservations.",
    "setup.dedge.title": "D-Edge storno scan",
    "setup.dedge.description": "Checks cancellation mails against still-confirmed Apaleo reservations.",
    "setup.hrs.title": "HRS company scan",
    "setup.hrs.description": "Links the invoicing company from HRS booking confirmations to the Apaleo reservation (address match, 3 retries).",
  },
      buchhaltung: {
        title: "Accounting",
        subtitle: "Finances & Reports",
        invoices: "Invoices",
        payments: "Payments",
        allMerchants: "All Merchants",
        apaleoPayInactive: "Apaleo Pay is not activated for this property",
        createdAt: "Created At",
        filterDate: "Filter by Date",
        filterProperties: "Filter Properties",
        merchantAccount: "Merchant Account",
        payoutAmount: "Payout Amount",
        payoutDate: "Payout Date",
        payoutTotal: "Total Payout Amount",
        payoutTotalPending: "{{count}} pending",
        settlementId: "Settlement ID",
        batchNumber: "Batch No.",
        settlements: "Settlements",
        actions: "Actions",
        entries: "Entries",
        deleteFolderConfirm: "Delete folder \"{{name}}\" with {{count}} files?",
        deleteTooDeep: "Folder is nested too deeply ({{depth}} levels) — please delete in parts",
        folderCreated: "Folder Created",
        folderDeleted: "Folder Deleted",
        copyLink: "Copy link",
        linkCopied: "Link copied to clipboard",
        massDelete: "Bulk Delete",
        massDeleteConfirm: "Do you really want to delete {{count}} items?",
        progress: "Progress",
        receiptDeleted: "Receipt Deleted",
        receiptUploaded: "Receipt Uploaded",
        searchReceipts: "Search Receipts",
      },
      folderUpload: {
        title: "File Upload",
        subtitle: "Upload files to folder",
        selectFiles: "Select Files",
        dragDrop: "Drag and drop files here or click",
        maxSize: "Maximum file size: 25MB",
        allowedTypes: "Allowed formats: PDF, JPG, PNG",
        uploading: "Uploading...",
        uploadSuccess: "Upload successful",
        uploadError: "Upload failed",
        folder: "Folder",
        createFolder: "Create Folder",
        folderName: "Folder Name",
        folderNamePlaceholder: "e.g. Invoices 2024",
        cancel: "Cancel",
        create: "Create",
        delete: "Delete",
        deleteConfirm: "Really delete this folder?",
        share: "Share",
        copy: "Copy",
        move: "Move",
        rename: "Rename",
        name: "Name",
        size: "Size",
        type: "Type",
        modified: "Modified",
        created: "Created",
        owner: "Owner",
        download: "Download",
        preview: "Preview",
        view: "View",
        list: "List",
        grid: "Grid",
        sortBy: "Sort by",
        sortName: "Name",
        sortDate: "Date",
        sortSize: "Size",
        ascending: "Ascending",
        descending: "Descending",
        refresh: "Refresh",
        search: "Search...",
        clear: "Clear",
        all: "All",
        files: "Files",
        folders: "Folders",
        itemsSelected: "{{count}} items selected",
        empty: "No files",
        emptyHint: "Upload your first file",
        permission: "Permission",
        permissionRead: "Read",
        permissionWrite: "Write",
        public: "Public",
        private: "Private",
        browserNotSupported: "Your browser does not support folder selection",
        fileFolderCount: "{{files}} files, {{folders}} folders",
        scanning: "Scanning folder\u2026",
        selectFailed: "Selection failed",
        selectFolder: "Select Folder",
        selectFolderHint: "Select a folder containing receipts",
        selectedFolder: "Selected folder",
        someValidationFailed: "Some files could not be validated:\n{{messages}}",
        tooManyFiles: "The folder contains too many files (max. {{count}}) — please upload in several passes",
        nothingSelected: "No files selected — keep at least one folder or file selected",
        excludedCount: "{{count}} files deselected",
        resetSelection: "Reset selection",
                shiftMultiSelectHint: "Click: toggle folder · Shift+click: range from last toggled folder",
                folderNotFound: "Folder path not found — view reset",
        dropHint: "Tip: select multiple folders in Windows Explorer (Ctrl+click) and drop them here",
        droppedItems: "Selected items",
        dropNoFolders: "No folders detected — please drag folders from Windows Explorer here",
        structure: "Structure",
        upload: "Upload",
        uploadFailed: "Upload failed",
        uploadProgress: "{{done}} of {{total}} uploaded",
        validationFailed: "Validation failed",
        loadMore: "Show more ({{shown}} of {{total}})",
        uploadOverwritten: "{{count}} existing file(s) were replaced",
        finalizePartial: "{{count}} file(s) were uploaded but could NOT be registered in the receipts list — please repeat the upload",
      },
      publicOfferConfirmation: {
        title: "Confirm Offer",
        subtitle: "Please verify your booking details",
        bookNow: "Book Now",
        checkIn: "Check-in",
        checkOut: "Check-out",
        guests: "Guests",
        adults: "Adults",
        children: "Children",
        totalPrice: "Total Price",
        pricePerNight: "Price per Night",
        nights: "{{count}} Night",
        nights_other: "{{count}} Nights",
        guest: "Guest",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phone: "Phone",
        specialRequests: "Special Requests",
        specialRequestsPlaceholder: "Allergies, arrival time, etc.",
        terms: "Terms & Conditions",
        accept: "Accept",
        decline: "Decline",
        cancel: "Cancel",
        confirm: "Confirm",
        success: "Booking successful",
        error: "Booking error",
        loading: "Loading offer...",
        secure: "Secure Connection",
        encrypted: "Encrypted",
        privacy: "Privacy",
        offerExpired: "This offer has unfortunately expired",
        contactHotel: "Please contact the hotel for a new offer",
        company: "Company",
        address: "Address",
        street: "Street",
        postalCode: "Postal Code",
        city: "City",
        country: "Country",
        arrival: "Arrival",
        departure: "Departure",
      },
      traceImport: {
        title: "Import Traces",
        subtitle: "Create multiple traces from a file",
        selectFile: "Select File",
        fileFormat: "File Format",
        csv: "CSV",
        json: "JSON",
        xml: "XML",
        dropFile: "Drop file here",
        browse: "Browse",
        upload: "Upload",
        uploading: "Uploading...",
        success: "Import successful",
        error: "Import failed",
        mapping: "Map Columns",
        columns: "Columns",
        source: "Source",
        target: "Target",
        preview: "Preview",
        import: "Import",
        importing: "Importing...",
        importAll: "Import All",
        importSelected: "Import Selected",
        skipDuplicates: "Skip Duplicates",
        updateExisting: "Update Existing",
        validate: "Validate",
        validationError: "Validation Error",
        missingColumns: "Missing Columns",
        invalidData: "Invalid Data",
        complete: "Complete",
        cancelled: "Cancelled",
        next: "Next",
        back: "Back",
        finish: "Finish",
        close: "Close",
        noFileSelected: "No file selected",
        processing: "Processing...",
      },
      bulkOrderDate: {
        title: "Bulk Order",
        subtitle: "Set order date for multiple items",
        selectItems: "Select Items",
        orderDate: "Order Date",
        supplier: "Supplier",
        quantity: "Quantity",
        unit: "Unit",
        price: "Price",
        total: "Total",
        notes: "Notes",
        save: "Save",
        cancel: "Cancel",
        success: "Order date set",
        error: "Error saving",
        loading: "Loading items...",
        noItems: "No items selected",
        selectAll: "Select All",
        deselectAll: "Deselect All",
      },
      customKpi: {
        title: "Custom KPI",
        subtitle: "Define your own metrics",
        name: "Name",
        namePlaceholder: "e.g. Average Room Price",
        description: "Description",
        type: "Type",
        calculation: "Calculation",
        sum: "Sum",
        average: "Average",
        count: "Count",
        max: "Maximum",
        min: "Minimum",
        formula: "Formula",
        field: "Field",
        source: "Source",
        color: "Color",
        icon: "Icon",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        confirmDelete: "Really delete this KPI?",
        error: "Error",
        required: "Required field",
        selectField: "Select field",
        noFields: "No fields available",
        preview: "Preview",
      },
      inventoryImport: {
        title: "Import Wizard (Excel / CSV)",
        subtitle: "Load inventory data from file",
        selectFile: "Select File",
        fileFormat: "Supported formats: .xlsx, .csv. Columns \"Artikel\", \"Bestand Vormonat\", \"Jetziger Bestand\" and \"Mindestbestand\" are expected.",
        csv: "CSV",
        excel: "Excel",
        upload: "Upload",
        uploading: "Uploading...",
        success: "Import Successful!",
        error: "Import failed",
        mapping: "Map Columns",
        columns: "Columns",
        source: "Source",
        target: "Target",
        preview: "Preview & Validation",
        import: "Import",
        importing: "Import running…",
        complete: "Complete",
        cancelled: "Cancelled",
        next: "Next",
        back: "Back",
        finish: "Finish",
        noFileSelected: "No file selected",
        parseError: "Error parsing the file. Please check the format.",
        noValidData: "No valid data found to import.",
        imported: "Inventory imported",
        importSummary: "{{added}} added, {{updated}} updated ({{property}})",
        importError: "Import error: {{message}}",
        location: "Location: ",
        dropFile: "Select or drop a file",
        browse: "Browse file",
        entriesFound: "{{count}} entries found. Existing items (based on name or article number) will be updated, new ones added.",
        entriesProcessed: "{{current}} / {{total}} entries processed",
        article: "Article",
        articleNumber: "Article Number",
        category: "Category",
        prevMonthStock: "Previous Month Stock",
        currentStock: "Current Stock",
        minStock: "Minimum Stock",
        url: "URL",
        missingArticleName: "Missing article name",
        missing: "Missing",
        successDescription: "Your inventory data for location {{property}} was successfully synchronized.",
        added: "Newly Added",
        updated: "Updated",
        closeWizard: "Close wizard",
        restart: "Restart",
        importData: "Import data",
        importRunning: "Import running\u2026",
        previewValidation: "Preview & Validation",
      },
      installPwa: {
        title: "Install App",
        description: "Install AdaptHub as an app on your device",
        install: "Install",
        dismiss: "Dismiss",
        installed: "Installation successful",
      },
      housekeepingForecast: {
        title: "Housekeeping Forecast",
        subtitle: "Capacity Planning & Preview",
        today: "Today",
        tomorrow: "Tomorrow",
        thisWeek: "This Week",
        nextWeek: "Next Week",
        occupancy: "Occupancy",
        staffNeeded: "Staff Needed",
        noData: "No data available",
        error: "Error loading",
        printLandscape: "Print (Landscape)",
        printPortrait: "Print (Portrait)",
        printLandscapeTitle: "Print in Landscape",
        printPortraitTitle: "Print in Portrait",
        date: "Date",
        weekday: "Weekday",
      },
      analyticsChart: {
        title: "Analytics Chart",
        noData: "No data available",
        error: "Error loading",
      },
      reportingStats: {
        title: "Reporting & Statistics",
        period: "Period",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        yearly: "Yearly",
        custom: "Custom",
        export: "Export",
        print: "Print",
        refresh: "Refresh",
        filter: "Filter",
        compareWith: "Compare with",
        previousPeriod: "Previous Period",
        previousYear: "Previous Year",
      },
      roomRackControls: {
        title: "Room Rack Controls",
        refresh: "Refresh",
        filter: "Filter",
        sort: "Sort",
        settings: "Settings",
        export: "Export",
        controlsTitle: "Controls & Keyboard Shortcuts",
        shortcutsTitle: "Keyboard Shortcuts",
        ctrlClick: "Ctrl + Click",
        arrowKeys: "Arrow Keys",
        doubleClick: "Double Click",
        drag: "Drag",
        delete: "Delete",
        esc: "Esc",
        ctrl: "Ctrl",
        mouseWheel: "Mouse wheel",
        leftMouse: "Left mouse button",
        dragEdges: "Drag edges",
        del: "Del",
        modalTitle: "Keyboard Shortcuts & Controls",
        mouseControl: "Mouse Controls",
        keyboardShortcuts: "Keyboard Shortcuts",
        mouse1Action: "Open details (reservation / maintenance)",
        mouse2Action: "Move block to another room or time period",
        mouse3Action: "Change duration of a maintenance window",
        mouse4Action: "Duplicate maintenance window",
        mouse5Action: "Zoom room plan continuously",
        mouse6Action: "Create maintenance window / reservation in empty cells",
        key1Action: "Delete selected maintenance / unlink reservation from room",
        key2Action: "Perform check-in for selected reservation",
        key3Action: "Perform check-out for selected reservation",
        key4Action: "Move selected block one room up or down",
        key5Action: "Move selected maintenance window 1 day forward or backward",
        key6Action: "Zoom room plan timeline in or out",
        key7Action: "Clear selection and close open detail windows",
      },
      multiRoomMaintenance: {
        title: "Create series lock",
        collapseTooltip: "Minimize (show table in background)",
        expand: "Expand",
        seriesLock: "Series lock",
        roomCount: "{{count}} rooms",
        typeOverbooking: "Overbooking protection",
        typeMaintenance: "Maintenance",
        typeLabel: "Lock type *",
        outOfOrder: "Out of Order",
        outOfService: "Out of Service",
        selectRooms: "Select rooms ({{count}} selected) *",
        all: "All",
        none: "None",
        searchRooms: "Search rooms...",
        noRoomsFound: "No rooms found.",
        startDate: "Start date *",
        startTime: "Start time *",
        endDate: "End date *",
        endTime: "End time *",
        description: "Description",
        descriptionPlaceholder: "Lock reason...",
        presetsLabel: "Description presets",
        cancel: "Cancel",
        create: "Create",
        creating: "Creating...",
        noRooms: "Please select at least one room.",
        fillAllFields: "Please fill in all date and time fields.",
        invalidDate: "Invalid date or time.",
        endBeforeStart: "The end date must be after the start date.",
        createError: "Error creating maintenance windows.",
        trace: {
          enable: "Also create a trace",
          enableHint: "Creates one linked trace per room and per department. Without the checkbox only the maintenance window is created.",
          departments: "Departments",
          noDepartment: "Please select at least one department for the trace.",
          fanOutHint: "{{count}} trace(s) will be created ({{rooms}} rooms × {{departments}} departments).",
          text: "Trace text",
          textPlaceholder: "e.g. AB long-stay guest, blocked from 06.11.–08.11.2026",
          textHint: "Suggested from the description and period — fully editable.",
          createdCount: "{{count}} trace(s) created",
        },
      },
      roomRackSettings: {
        statusConfirmed: "Confirmed",
        statusInHouse: "In House",
        statusCheckedOut: "Checked Out",
        statusOutOfOrder: "Out of Order",
        statusOutOfService: "Out of Service",
        saveError: "Error saving colors.",
        title: "Room Plan Colors",
        subtitle: "Customize status colors",
        resetDefaults: "Restore defaults",
        saving: "Saving...",
      },
      roomRack: {
        title: "Room Plan",
        itemMenu: {
          assign: "Change room",
          details: "Open details",
        },
        maintMenu: {
          edit: "Edit maintenance window",
          delete: "Delete maintenance window",
        },
        beta: "Room Rack Beta",
        loadingRoomPlan: "Loading room plan...",
        showControls: "Show controls & keyboard shortcuts",
        roomStatusLegend: "Room Status",
        statusClean: "Clean",
        statusDirty: "Dirty",
        statusInspection: "Inspection",
        conditionUnknown: "Unknown",
        conditionUpdated: "Room status updated",
        conditionUpdateError: "Failed to update room status",
        noConditionPermission: "You do not have permission to change the room status.",
        customizeColors: "Customize colors",
        rooms: "Rooms",
        sortAlphabetical: "Alphabetical",
        sortByCategory: "Room Category",
        allCategories: "All Categories",
        allStatuses: "All Statuses",
        statusConfirmed: "Confirmed",
        statusInHouse: "In House",
        statusCheckedOut: "Checked Out",
        statusMaintenance: "Maintenance",
        seriesLock: "Series Lock",
        newReservation: "Create new reservation",
        createMaintenance: "Create maintenance window",
        editMaintenance: "Edit maintenance window",
        selectedRooms: "Selected Rooms",
        filterMaintenance: "Filter maintenance",
        startDate: "Start Date",
        endDate: "End Date",
        time: "Time",
        lockReason: "Lock reason...",
        description: "Description",
        presetsLabel: "Description presets",
        change: "Change",
        noBookingPermission: "You do not have permission to create reservations.",
        noViewPermission: "You do not have permission to view reservation details.",
        noMovePermission: "You do not have permission to move reservations.",
        cannotDuplicateReservations: "Reservations cannot be duplicated.",
        cannotMoveWithArrows: "Reservation periods cannot be moved with arrow keys.",
        roomAssigned: "Room successfully assigned",
        roomReleased: "Room successfully released",
        roomReleaseError: "Error releasing the room",
        checkInSuccess: "Check-In completed successfully",
        checkInError: "Error during check-in",
        checkOutSuccess: "Check-Out completed successfully",
        checkOutError: "Error during check-out",
        confirmCheckIn: "Perform check-in for this reservation?",
        confirmCheckOut: "Perform check-out for this reservation?",
        confirmReleaseRoom: "Do you really want to release the room for the selected reservation?",
        confirmDeleteMaintenance: "Really delete this maintenance window?",
        confirmDeleteSelectedMaintenance: "Do you really want to delete the {{count}} selected maintenance windows?",
        maintCreated: "Maintenance window successfully created",
        maintUpdated: "Maintenance window successfully updated",
        maintDeleted: "Maintenance window successfully deleted",
        maintDuplicated: "Maintenance window duplicated",
        maintMoved: "Maintenance window moved",
        maintMovedNewRoom: "Maintenance window moved (new room)",
        maintMovedOtherRoom: "Maintenance moved to other room",
        maintPeriodAdjusted: "Maintenance window period adjusted",
        maintCreateError: "Error creating maintenance",
        maintDeleteError: "Error deleting maintenance windows",
        maintenanceDeletedCount: "{{count}} maintenance windows successfully deleted",
        errorMessage: "Error: {{message}}",
        show3Days: "Show 3 days",
        show7Days: "Show 7 days",
        show14Days: "Show 14 days",
        zoomIn: "Zoom in",
        zoomOut: "Zoom out",
        sorting: "Sorting",
        category: "Category",
        status: "Status",
        location: "Location",
        filter: "Filter",
        controls: "Controls & keyboard shortcuts",
        help: "Help",
        done: "Done",
        blocking: "Series lock",
        maintsSelected: "Maintenance window selected",
        clearSelection: "Clear selection",
        selection: "Selection...",
        noPermissionCreate: "You do not have permission to create reservations.",
        noPermissionView: "You do not have permission to view reservation details.",
        noPermissionMove: "You do not have permission to move reservations.",
        cannotDuplicateRes: "Reservations cannot be duplicated.",
        cannotMoveResByArrow: "Reservation periods cannot be moved with the arrow keys.",
        confirmDeleteMaints: "Do you really want to delete the {{count}} selected maintenance windows?",
        maintPeriodMoved: "Maintenance period moved",
        unknownGuest: "Unknown",
        loading: "Loading room plan...",
        actionForRoom: "Action for room",
        deleting: "Deleting...",
        changing: "Changing...",
      },
      autoBlock: {
        title: "Auto-Block Configuration",
        description: "Automatic blocking of availability",
        enable: "Enable",
        disable: "Disable",
        trigger: "Trigger",
        threshold: "Threshold",
        action: "Action",
        time: "Time",
        timezone: "Timezone",
        roomCategories: "Room categories",
        roomCategoriesPlaceholder: "e.g. Standard, Deluxe",
        save: "Save",
        success: "Configuration saved",
        error: "Error saving",
      },
      autoKassenbuch: {
        title: "Auto Cash Ledger Configuration",
        description: "Automatic cash ledger entries",
        enable: "Enable",
        disable: "Disable",
        trigger: "Trigger",
        entryTextPlaceholder: "Entry text",
        save: "Save",
        success: "Configuration saved",
        error: "Error saving",
      },
      guestNameCleanup: {
        title: "Guest Name Cleanup",
        description: "Clean up guest names in reservations",
        enable: "Enable",
        disable: "Disable",
        rules: "Rules",
        splitCombinedName: "Split first and last name",
        removeDuplicateFirstName: "Remove duplicate first name",
        save: "Save",
        success: "Configuration saved",
        error: "Error saving",
      },
      voucherRateEmail: {
        title: "Voucher-Rate Email Copy",
        description: "Copies the booker email into the main guest for confirmed reservations on the \"Voucher-Rate tripz\" rate plan.",
        settings: "Settings",
        ratePlanLabel: "Rate plan (name or code)",
        ratePlanHelp: "Exact rate-plan name or code; case and extra spaces are ignored.",
        fillOnlyNote: "Only empty guest emails are filled. An existing guest email is never overwritten.",
        inactiveHint: "This automation is not active yet. A test run still works; switch it on and save for the hourly schedule.",
        dryRunLabel: "Simulate only (write nothing to Apaleo)",
        dryRunHelp: "When on, the hourly run only counts matches and writes no changes.",
        save: "Save",
        success: "Configuration saved",
        runNow: "Check now (simulation)",
        runWrite: "Write now",
        runWriteConfirm: "The booker email will now be written into the main guest in Apaleo. Continue?",
        runDone: "Check finished",
        runError: "Check failed",
        runSummary: "Scanned: {{scanned}} · Copied: {{copied}} · Skipped: {{skipped}} · Failed: {{failed}}",
        runRatePlans: "Rate plans found: {{count}}",
        runNoRatePlan: "No rate plan matches this name/code.",
        runProperties: "Properties checked: {{count}}",
        runPropertySource: "Property source: {{source}}",
        runReasons: "Reasons: {{reasons}}",
        skipNoProperties: "No properties found — neither the tenant property list nor the Apaleo property list returned one.",
        skipPropertiesUnavailable: "The Apaleo property list could not be loaded. See the server log for details.",
        skipNotConfigured: "The automation is not saved yet.",
        skipDisabled: "The automation is not saved and enabled yet — switch it on (or save) first.",
        skipDisabledPlatform: "The platform (admin dashboard) has not released this automation for this tenant.",
        skipError: "The run stopped with an error.",
      },
      loyaltySync: {
        title: "Loyalty Sync",
        description: "Sync with loyalty programs",
        enable: "Enable",
        disable: "Disable",
        trigger: "Trigger",
        save: "Save",
        success: "Configuration saved",
        error: "Error saving",
        settings: "Loyalty Program Configuration",
        delete: "Delete",
        calculationBasis: "Calculation Basis",
        pointsPerUnit: "Points Per Unit",
        tiers: "Tiers",
        tierName: "Name",
        tierNamePlaceholder: "e.g. Gold",
        thresholdLabel: "Threshold",
        thresholdPlaceholder: "e.g. 10",
        thresholdSuffix: "nights",
        noTiers: "No tiers configured",
        noTiersDescription: "Add loyalty tiers with thresholds",
        moneySpent: "Money Spent",
        nights: "Nights",
        arrivals: "Arrivals",
      },
      extraBedRestore: {
        title: "Extra Bed Restore",
        description: "Restores extras (e.g. extra beds) that the channel manager's sync removed",
        enable: "Enable",
        disable: "Disable",
        rules: "Rules",
        watchClientId: "Watch Client ID",
        watchClientIdDesc: "Channel manager client whose reservation changes trigger the restore check",
        amendmentClientId: "Amendment Client ID",
        amendmentClientIdDesc: "Integration client whose prior amendments should be restored",
        lookbackHours: "Lookback Window (hours)",
        lookbackHoursDesc: "How far back to search reservation logs for amendment events. Default 720 hours (30 days).",
        baseOccupancy: "Base Occupancy",
        baseOccupancyDesc: "Number of guests included in the standard rate. Extra beds are added for each guest above this number (e.g. 3 guests with base 2 = 1 extra bed).",
        extraBedServiceId: "Extra Bed Service ID",
        extraBedServiceIdDesc: "Comma-separated Apaleo service code(s) for extra sleeping capacity at this property (e.g. 'AUFB_ERW, BABYBETT'). All listed codes count toward the existing-capacity total; the first one is used as the booking target. The automation is skipped if this is empty.",
        extraBedServiceIdPlaceholder: "AUFB_ERW, BABYBETT",
        save: "Save",
        success: "Configuration saved",
        error: "Error saving",
      },
      overbookingLocksConfig: {
        title: "Overbooking Locks",
        description: "Manage overbooking locks",
        enable: "Enable",
        disable: "Disable",
        trigger: "Trigger",
        autoBlock: "Auto block availability",
        sendPush: "Send push notifications",
        checkInterval: "Check interval (minutes)",
        save: "Save",
        success: "Configuration saved",
        error: "Error saving",
      },
      roomDateSync: {
        title: "Room Date Sync",
        description: "Sync room data",
        enable: "Enable",
        disable: "Disable",
        trigger: "Trigger",
        syncRoomNumbers: "Sync room numbers",
        syncArrivalDates: "Sync arrival dates",
        autoDeleteOnCancel: "Auto delete on cancel",
        save: "Save",
        success: "Configuration saved",
        error: "Error saving",
      },
      waitingListMonitor: {
        title: "Waiting List Monitor",
        description: "Monitor the waiting list",
        enable: "Enable",
        disable: "Disable",
        trigger: "Trigger",
        sendPush: "Send push notifications",
        checkInterval: "Check interval (minutes)",
        save: "Save",
        success: "Configuration saved",
        error: "Error saving",
      },
      logs: {
        actions: {
          logout: "Log out",
          systemLogin: "System login",
        },
        details: {
          logoutPaymentBlock: "Logged out due to payment block",
          userLoggedIn: "User logged in",
          userLoggedOut: "User logged out",
        },
      },
      notifications: {
        chatReply: "{{from}} replied to your message",
        confirmDeleteAll: "Permanently delete this notification for ALL users?",
        confirmDeleteAllMany: "Permanently delete these {{count}} notifications for ALL users?",
        deleteForAll: "Delete for all",
        deleteForAllAdmin: "Delete for all (Admin)",
        empty: "No notifications available",
        forAllAdmin: "For all (Admin)",
        forMe: "For me",
        hideForMe: "Hide for me",
        justNow: "Just now",
        markAllRead: "Mark all as read",
        newMessage: "New message",
        read: "Read",
        expand: "Show more",
        collapse: "Show less",
        subtitle: "Your mentions & alerts",
        title: "Notifications",
        titleShort: "Notifications",
        activityFilterAll: "All",
        activityFilterTrace: "Traces",
        activityFilterChatReply: "Replies",
        activityFilterLostFound: "Lost & Found",
        activityFilterTicket: "Tickets",
        activityFilterStorno: "Storno",
        activityFilterHr: "HR",
        activityFilterOther: "Other",
        activityFilterToggle: "Filter",
        activityFilterClear: "Clear filter",
      },
      patchNotes: {
        labels: {
          fix: "Fix",
          improvement: "Improvement",
          new: "New",
        },
        showPatchNotes: "Show Patch Notes",
        subtitle: "Updates and system improvements",
        title: "Patch Notes",
        whatsNew: "What's New?",
        whatsNewTooltip: "Click here to read the patch notes",
        changesV161_1: "The room plan received a small interface update and the plan can now be seen and moved properly during a series lock.",
        changesV161_2: "Tickets now correctly display the written text of the message.",
        changesV161_3: "Housekeeping managers can now also view guest details in the room plan menu.",
        changesV161_4: "The sidebar can now be collapsed.",
      },
      systemLogs: {
        actions: "Actions",
        empty: "No log entries",
        loadMore: "Load more",
        searchPlaceholder: "Search logs\u2026",
        subtitle: "System activity",
      },
      subscription: {
        goToApaleoStore: "Go to Apaleo Store",
        suspendedMessage: "Your subscription has been suspended. Please update your payment details.",
        suspendedSubtitle: "Access limited",
        suspendedTitle: "Subscription suspended",
      },
      support: {
        title: "Support & Help",
      },
      fetchProgress: {
        generic: "Loading data…",
        reservations: "Loading reservations…",
        companyRevenue: "Calculating company revenue…",
        pageOf: "Page {{page}}/{{total}}",
        rows: "{{count}} rows",
        elapsed: "{{seconds}} s",
        patience: "Large dataset — this takes a moment",
      },
      utils: {
        dateFormatDE: "DD.MM.YYYY",
        dateFormatUS: "MM/DD/YYYY",
      },
      businessClub: {
        tabTitle: "BusinessClub",
        title: "BusinessClub Members",
        subtitle: "BusinessClub program",
        // Double opt-in confirmation page (audit M-8)
        confirmLoading: "Confirming your sign-up...",
        confirmSuccessTitle: "Sign-up confirmed",
        confirmSuccessBody: "Thank you! Your BusinessClub membership is now active. Your personal promo code has just been sent to you by email.",
        confirmAlready: "This sign-up has already been confirmed. Your promo code was sent to you by email.",
        confirmFailedTitle: "Confirmation failed",
        confirmFailed: "The confirmation link is invalid or expired. Please sign up again or contact our team.",
        confirmMissingParams: "The confirmation link is incomplete. Please use the link from your confirmation email.",
        confirmHint: "If the problem persists, please contact our team.",
        optinPendingTitle: "Almost done: please confirm your email",
        optinPendingText: "We have sent you a confirmation email. Click the link inside — your promo code will be emailed to you right after confirmation. (Not you? Ignore the email; the address is deleted automatically after 14 days.)",
        search: "Search members...",
        filterEmail: "Filter by email...",
        filterCompany: "Filter by company...",
        statsWindow: "Reservations, revenue and roomnights in the selected period. Email mode: own bookings (guest email). Company mode: bookings under the company rate. Both: sum of both attributions (possible double-count when booking personally under the company rate).",
        statsReservations: "Res.",
        statsRevenue: "Revenue",
        statsRoomnights: "RNs",
        searchModeEmail: "Email",
        searchModeCompany: "Company",
        joinedDate: "Joined on",
        joinedDateHint: "Date of membership — can be corrected for imports.",
        searchModeBoth: "Both",
        statsTermEmail: "Search reservations by email...",
        statsTermCompany: "Search reservations by company...",
        statsTermBoth: "Search reservations by email or company...",
        statsFrom: "From",
        statsTo: "To",
        statsSearch: "Search",
        statsClear: "Reset",
        statsRangeInvalid: "Invalid period — From must be before To.",
        noMembers: "No members yet",
        noResults: "No matches",
        name: "Name",
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        company: "Company",
        phone: "Phone",
        source: "Source",
        totalRow: "Total",
        source_public: "Sign-up",
        source_website: "Website",
        source_manual: "Manual",
        locations: "Location(s)",
        locationsPlaceholder: "e.g. Siegen, Wetzlar",
        locationsHint: "Location(s) from the website form",
        memberMessage: "Message",
        memberMessageHint: "Message from the website form",
        created: "Joined",
        actions: "Actions",
        addMember: "Add member",
        editMember: "Edit member",
        deleteMember: "Delete member",
        confirmDelete: "Really delete {{name}}?",
        memberCreated: "Member created",
        memberUpdated: "Changes saved",
        memberDeleted: "Member deleted",
        configSaved: "Promo code saved",
        saveError: "Save failed",
        duplicateMember: "This email is already registered as a member.",
        fieldRequired: "Required field",
        invalidEmail: "Invalid email address",
        emailLocked: "The email address cannot be changed afterwards.",
        marketingConsent: "Consent to marketing communication (GDPR)",
        signUpLink: "Sign-up link:",
        copyLink: "Copy",
        copied: "Copied",
        promoCodeSettings: "Promo code",
        promoCodeHint: "Shared code for all members",
        promoCodeDescription: "This code is shown to new members after sign-up and sent to them by email.",
        promoCodePlaceholder: "e.g. BC2026",
        publicTitle: "BusinessClub",
        publicSubtitle: "Become a member and secure your exclusive benefits.",
        signUpButton: "Sign up now",
        successTitle: "Welcome, {{name}}!",
        successText: "Your sign-up was successful. A confirmation email with your promo code is on its way.",
        alreadyMemberTitle: "You are already a member!",
        alreadyMemberText: "A BusinessClub membership already exists for this email address. Here is your promo code:",
        yourPromoCode: "Your promo code",
        promoCodeUsage: "Enter the code when making your next booking on our website.",
        codePending: "Your promo code will be sent to you by email shortly.",
        consentText: "I would like to receive emails about offers and BusinessClub benefits (optional, revocable at any time).",
        consentRequired: "Please confirm consent",
        languageLabel: "Language",
        lang_de: "DE",
        lang_en: "EN",
        ibeTitle: "Book directly",
        ibeSubtitle: "Redeem your promo code directly when booking.",
        bookNow: "Book now",
        rateLimited: "Too many attempts. Please try again later.",
        signUpError: "Sign-up failed. Please try again.",
      },
      firmenvertraege: {
        // List view
        title: "Company Contracts",
        companyName: "Company",
        contractId: "Contract #",
        status: "Status",
        validFrom: "Valid from",
        validTo: "Valid to",
        ratePlanCount: "Rate plans",
        lastModified: "Last modified",
        noContracts: "No contracts found",
        searchPlaceholder: "Search contracts...",
        filterStatus: "Filter status",
        selectedCount: "{{count}} selected",
        contractsCount: "{{count}} contracts",
        bulkDelete: "Delete selected",
        bulkExport: "Export selected",
        addContract: "New contract",
        importExcel: "Import Excel",
        // Status values
        statusDraft: "Draft",
        statusActive: "Active",
        statusExpired: "Expired",
        statusArchived: "Archived",
        // Detail modal
        contractDetails: "Contract details",
        contactPerson: "Contact person",
        email: "Email",
        phone: "Phone",
        notes: "Notes",
        linkedRatePlans: "Linked rate plans",
        attachedFiles: "Attachments",
        noRatePlans: "No rate plans linked",
        noFiles: "No files attached",
        edit: "Edit",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        archive: "Archive",
        confirmDelete: "Really delete this contract? This action cannot be undone.",
        confirmArchive: "Really archive this contract?",
        // File upload
        uploadPdf: "Upload PDF",
        dragDropHint: "Drop PDF here or click to browse",
        maxFileSize: "Maximum file size: {{max}} MB",
        invalidFileType: "Only PDF files are allowed",
        fileTooLarge: "File is too large (max. {{max}} MB)",
        uploadSuccess: "File uploaded successfully",
        uploadError: "Upload failed: {{message}}",
        version: "Version",
        uploadDate: "Uploaded on",
        download: "Download",
        filePreview: "Preview",
        deleteFile: "Delete file",
        // Import wizard
        importTitle: "Corporate Rates Import",
        stepUpload: "Upload",
        stepMapping: "Mapping",
        stepValidation: "Validation",
        stepConfirmation: "Confirmation",
        stepExecution: "Execution",
        uploadExcel: "Upload Excel file (.xlsx)",
        preview: "Preview",
        mapColumns: "Map columns",
        autoDetected: "Auto-detected",
        validationErrors: "Validation errors",
        validationWarnings: "Warnings",
        companiesWillBeCreated: "Companies to be created",
        ratePlansWillBeCreated: "Rate plans to be created",
        ratePlansWillBeUpdated: "Rate plans to be updated",
        selectContract: "Select existing contract",
        createNewContract: "Create new contract",
        executing: "Executing...",
        successCount: "Succeeded",
        errorCount: "Failed",
        downloadErrorReport: "Download error report",
        // Wizard step 1 (upload)
        browse: "Browse",
        largeFileWarning: "Large file: {{count}} rows detected",
        largeFileHint: "Imports over 500 rows may take a while. Proceed only if the file was prepared by the sales team.",
        rowsFound: "rows found",
        showingFirstN: "Showing first {{shown}} of {{total}} rows",
        parseError: "Failed to parse Excel file",
        // Wizard step 2 (mapping)
        excelColumn: "Excel column",
        targetField: "Target field",
        required: "Required",
        optional: "Optional",
        unmapped: "Unmapped",
        requiredFields: "Required fields",
        optionalFields: "Optional fields",
        unmappedRequiredColumns: "Required columns are not mapped",
        allRequiredMapped: "All required columns are mapped",
        // Wizard step 3 (validation)
        validating: "Validating...",
        validationPassed: "{{count}} rows passed validation",
        validationFailed: "{{count}} valid rows, {{errors}} blocking errors",
        blockingErrorsCount: "{{count}} blocking errors",
        warningsCount: "{{count}} warnings",
        // Wizard step 4 (confirmation)
        propertyLabel: "Apaleo property",
        propertyHint: "Default: {{default}}",
        contractSelector: "Contract",
        attachToExisting: "Attach to existing",
        noEligibleContracts: "No active contracts available. Create a new one first.",
        executeImport: "Execute import",
        // Wizard step 5 (execution)
        executionCreated: "Created",
        executionFailed: "Failed",
        executionCreating: "Creating...",
        executionPending: "Pending",
        executionComplete: "Import finished",
        executionInProgress: "Importing {{current}} of {{total}}",
        executionContract: "Contract",
        kategorieCol: "Category",
        code: "Code",
        resultLabel: "Result",
        retryFailed: "Retry failed rows",
        // Rate editing
        editRate: "Edit rate",
        tier: "LOS tier",
        losRange: "LOS range",
        basePrice: "Base price",
        restrictions: "Restrictions",
        marketSegments: "Market segments",
        channelCodes: "Channel codes",
        corporateCodes: "Corporate codes",
        pushToApaleo: "Push to Apaleo",
        changesPreview: "Change preview",
        noChanges: "No changes",
        pushSuccess: "Changes pushed successfully",
        pushError: "Push failed: {{message}}",
        apaleoLink: "Open in Apaleo",
        rateEditTitle: "Edit rate plan",
        rateEditSubtitle: "Adjust rate details and push changes to Apaleo.",
        minLos: "Min LOS (nights)",
        maxLos: "Max LOS (nights)",
        minAdvance: "Min advance (days)",
        maxAdvance: "Max advance (days)",
        isActive: "Active / bookable",
        isActiveHint: "Toggles the Apaleo isBookable flag.",
        backToEdit: "Back to edit",
        tierChangeWarning: "Changing the tier will change the LOS range and may affect existing bookings.",
        confirmTierChange: "Confirm tier change",
        notFoundHint: "The Apaleo rate plan was not found. The link may have been removed externally.",
        removeLink: "Remove link",
        retry: "Retry",
        patchPreviewTitle: "JSON Patch operations that will be sent to Apaleo",
        immutableHint: "Immutable fields (id, code, propertyId, unitGroupId, timeSliceDefinitionId, accountingConfigs) are not sent.",
        restrictionsEmpty: "No restrictions set",
        diffTitle: "Change summary",
        noChangesHint: "No changes to push.",
        auditing: "This change is recorded in the contract's audit log.",
        fieldLabel: "Field",
        oldValue: "Current",
        newValue: "New",
        previewChanges: "Preview changes",
        tierBadge: "Tier",
        // Audit log
        auditCreated: "Contract created",
        auditEdited: "Contract edited",
        auditImported: "Rate plans imported",
        auditDeleted: "Contract deleted",
        auditArchived: "Contract archived",
        auditRatePushed: "Rate change pushed",
        // Bulk operations (Phase 2.5)
        bulkArchive: "Archive selected",
        bulkHardDelete: "Hard delete selected",
        confirmBulkArchive: "Archive {{count}} contracts?",
        confirmBulkArchiveSubtitle: "This will also deactivate their linked Apaleo rate plans. Archived contracts can be restored later.",
        confirmBulkDelete: "PERMANENTLY DELETE {{count}} contracts?",
        confirmBulkDeleteSubtitle: "This action cannot be undone. Type DELETE below to confirm.",
        typeDeletePlaceholder: "Type DELETE",
        bulkProgress: "{{done}} of {{total}} processed",
        bulkResultArchived: "{{count}} contracts archived",
        bulkResultPartialArchive: "{{count}} archived, {{skipped}} skipped (conflicts)",
        bulkResultDeleted: "{{count}} contracts deleted",
        bulkResultPartialDelete: "{{count}} deleted, {{skipped}} skipped",
        // Export (Phase 2.5)
        exportLoading: "Preparing export...",
        exportLargeWarning: "You are about to export {{count}} contracts. This may take a while. Continue?",
        exportContinue: "Continue",
        exportEmpty: "No contracts to export",
        exportError: "Export failed: {{message}}",
        exportSuccess: "Exported {{count}} contracts",
        exportNoteMissingData: "Some contracts had incomplete rate plan data.",
        exportNoteTimeout: "Rate plan data could not be loaded for some contracts; export includes contract data only.",
        // General
        loading: "Loading...",
        error: "Error",
        success: "Success",
        confirmAction: "Confirm action",
        close: "Close",
        // Link rate plans (Phase 6)
        linkRatePlans: "Link rate plans",
        linkRatePlansSubtitle: "Browse existing Apaleo rate plans and link them to this contract.",
        selectProperty: "Apaleo property",
        searchRatePlans: "Search rate plans (code or name)",
        ratePlanCode: "Code",
        ratePlanName: "Name",
        columnProperty: "Property",
        noRatePlansFound: "No rate plans found",
        noRatePlansForProperty: "No rate plans found for property {{property}}",
        ratePlansTruncated: "Result list was capped at 1000 rate plans for safety. Narrow the search (property or query) to see more.",
        alreadyLinked: "Linked",
        linkSelected: "Link {{count}}",
        linkSelectedCount: "{{count}} selected",
        linkingInProgress: "Linking {{done}}/{{total}}",
        linkSuccess: "{{count}} rate plan(s) linked",
        linkError: "Link failed: {{message}}",
        unlinkRatePlan: "Unlink",
        confirmUnlink: "Unlink this rate plan from the contract? The rate plan will remain in Apaleo and other contracts' links.",
        unlinkSuccess: "Rate plan unlinked",
        unlinkError: "Unlink failed",
        selectAll: "Select",
        clearSelection: "Clear selection",
        pagination: "Page",
        pageOf: "Page {{page}} of {{total}} ({{count}} total)",
      },
    }
  }
};

const savedLanguage = typeof window !== 'undefined' && typeof window.localStorage?.getItem === 'function'
  ? window.localStorage.getItem("i18nextLng") || "de"
  : "de";

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: "de",
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined' && typeof window.localStorage?.setItem === 'function') {
    window.localStorage.setItem("i18nextLng", lng);
  }
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.lang = lng === 'de' ? 'de-DE' : 'en-US';
  }
});
if (typeof document !== 'undefined' && document.documentElement) {
  document.documentElement.lang = savedLanguage === 'de' ? 'de-DE' : 'en-US';
}

export default i18n;

